import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { buildPureLocale } from '../i18n/buildPureLocale';
import TE_NATIVE from '../i18n/locales/te-native';
import KN_NATIVE from '../i18n/locales/kn-native';
import TA_NATIVE from '../i18n/locales/ta-native';
import GU_NATIVE from '../i18n/locales/gu-native';
import BN_NATIVE from '../i18n/locales/bn-native';
import ML_NATIVE from '../i18n/locales/ml-native';
import PA_NATIVE from '../i18n/locales/pa-native';
import OR_NATIVE from '../i18n/locales/or-native';
import AS_NATIVE from '../i18n/locales/as-native';
import NE_NATIVE from '../i18n/locales/ne-native';
import KOK_NATIVE from '../i18n/locales/kok-native';
import SAT_NATIVE from '../i18n/locales/sat-native';
import MAI_NATIVE from '../i18n/locales/mai-native';
import DOI_NATIVE from '../i18n/locales/doi-native';
import BHO_NATIVE from '../i18n/locales/bho-native';
import RAJ_NATIVE from '../i18n/locales/raj-native';
import CG_NATIVE from '../i18n/locales/cg-native';
import HAR_NATIVE from '../i18n/locales/har-native';
import { UI_EXTRAS } from '../i18n/uiExtras';

export const LANGUAGES = [
  { code: 'en', name: 'English', native: 'English', state: 'All India', flag: '🇮🇳' },
  { code: 'hi', name: 'Hindi', native: 'हिंदी', state: 'UP, MP, Bihar, Rajasthan, Delhi', flag: '🗺️' },
  { code: 'mr', name: 'Marathi', native: 'मराठी', state: 'Maharashtra', flag: '🗺️' },
  { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી', state: 'Gujarat', flag: '🗺️' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்', state: 'Tamil Nadu', flag: '🗺️' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు', state: 'Andhra Pradesh, Telangana', flag: '🗺️' },
  { code: 'kn', name: 'Kannada', native: 'ಕನ್ನಡ', state: 'Karnataka', flag: '🗺️' },
  { code: 'ml', name: 'Malayalam', native: 'മലയാളം', state: 'Kerala', flag: '🗺️' },
  { code: 'pa', name: 'Punjabi', native: 'ਪੰਜਾਬੀ', state: 'Punjab, Haryana', flag: '🗺️' },
  { code: 'bn', name: 'Bengali', native: 'বাংলা', state: 'West Bengal', flag: '🗺️' },
  { code: 'or', name: 'Odia', native: 'ଓଡ଼ିଆ', state: 'Odisha', flag: '🗺️' },
  { code: 'as', name: 'Assamese', native: 'অসমীয়া', state: 'Assam', flag: '🗺️' },
  { code: 'ur', name: 'Urdu', native: 'اردو', state: 'J&K, Hyderabad', flag: '🗺️' },
  { code: 'ne', name: 'Nepali', native: 'नेपाली', state: 'Sikkim, Darjeeling', flag: '🗺️' },
  { code: 'kok', name: 'Konkani', native: 'कोंकणी', state: 'Goa', flag: '🗺️' },
  { code: 'sat', name: 'Santali', native: 'ᱥᱟᱱᱛᱟᱲᱤ', state: 'Jharkhand', flag: '🗺️' },
  { code: 'mai', name: 'Maithili', native: 'मैथिली', state: 'Bihar, Jharkhand', flag: '🗺️' },
  { code: 'doi', name: 'Dogri', native: 'डोगरी', state: 'Jammu', flag: '🗺️' },
  { code: 'bho', name: 'Bhojpuri', native: 'भोजपुरी', state: 'UP, Bihar', flag: '🗺️' },
  { code: 'raj', name: 'Rajasthani', native: 'राजस्थानी', state: 'Rajasthan', flag: '🗺️' },
  { code: 'cg', name: 'Chhattisgarhi', native: 'छत्तीसगढ़ी', state: 'Chhattisgarh', flag: '🗺️' },
  { code: 'har', name: 'Haryanvi', native: 'हरियाणवी', state: 'Haryana', flag: '🗺️' },
];

export const TRANSLATIONS = {
  en: {
    // Login
    appName: 'Development Express',
    tagline: 'The Gold Standard of Infrastructure',
    platform: 'Construction Management Platform',
    selectRole: 'SELECT ROLE',
    emailAddress: 'EMAIL ADDRESS',
    password: 'PASSWORD',
    signIn: 'SIGN IN',
    signingIn: 'Signing In...',
    adminRole: 'Admin — Managing Director',
    ownerRole: 'Machine Owner',
    clientRole: 'Client (Contractor)',
    operatorRole: 'Operator',
    // Nav
    dashboard: 'Dashboard',
    myMachines: 'My Machines',
    register: 'Machine Register',
    tracking: 'GPS Tracking',
    reports: 'Reports',
    alerts: 'Needs Attention',
    support: 'Support',
    home: 'Home',
    attendance: 'Attendance',
    machineLog: 'Machine Log',
    issues: 'Issues',
    approvals: 'Approvals',
    dlqMonitor: 'DLQ Monitor',
    auditLogs: 'Audit Logs',
    surveyResponses: 'Survey Responses',
    surveyReview: 'Survey Review',
    adminSurveyPageTitle: 'Survey responses',
    adminSurveyPageSubtitle: 'Field survey data, hot leads, pain ratings and CSV export.',
    adminSurveyReviewPageTitle: 'Survey payment review',
    adminSurveyReviewPageSubtitle: 'Approve or reject freelancer forms before payout (₹30 per approved form).',
    surveyPayout: 'Payout Summary',
    adminSurveyPayoutPageTitle: 'Payout summary',
    adminSurveyPayoutPageSubtitle: 'Freelancer-wise totals, editable rate, CSV export — locks approved forms on export.',
    surveyQr: 'Freelancers',
    adminSurveyQrPageTitle: 'Freelancer registration & approval',
    adminSurveyQrPageSubtitle: 'Approve field team applications, assign unique ID codes, and print survey QR cards.',
    surveyQrOwnerSurvey: 'Machine owner survey',
    surveyQrClientSurvey: 'Client survey',
    surveyQrSurveyorCode: 'Surveyor code',
    surveyQrEnterCode: 'Enter surveyor code',
    surveyQrPrintPack: 'Print pack',
    surveyQrDownloadOwnerPng: 'Download Owner PNG',
    surveyQrDownloadClientPng: 'Download Client PNG',
    surveyQrDownloadPrintCard: 'Download print card (PDF)',
    surveyQrOwnerPng: 'Owner PNG',
    surveyQrClientPng: 'Client PNG',
    surveyQrTrackingHint: 'Admin → Survey Responses → source=qr-card, surveyor=CODE',
    surveyQrCodeHint: 'Field team code (A–Z, 0–9, max 12). QR links use {origin} with src=qr-card.',
    surveyQrCodeLabel: 'Code',
    surveyQrFreelancerName: 'Freelancer name',
    surveyQrFreelancerNameHint: 'Name for tracking — each freelancer gets a unique code.',
    surveyQrUniqueId: 'Unique ID code',
    surveyQrFreelancerPreview: 'Registered as: {name} — ID {code}',
    surveyQrFreelancerActions: 'Actions',
    surveyQrFreelancerOpen: 'Open',
    surveyQrDeleteFreelancer: 'Delete',
    surveyQrDeleting: 'Deleting…',
    surveyQrDeleteConfirm: 'Remove freelancer {name} (ID {code})? They will no longer appear in the list. Old survey responses keep this code.',
    surveyQrFreelancerDeleted: 'Removed: {name} (ID {code})',
    surveyQrDeleteHint: 'Delete inactive freelancers who are not bringing leads. Official codes (OM01, RAJ02, TEST01) cannot be deleted.',
    surveyQrRegistrationTitle: 'Register freelancer (admin)',
    surveyQrRegistrationHint: 'Assign name + unique ID — saved freelancers become active immediately.',
    surveyQrPendingApproval: 'Pending approval',
    surveyQrNoPending: 'No pending applications. Share the registration link with field team.',
    surveyQrNoActiveFreelancers: 'No active freelancers yet.',
    surveyQrActiveFreelancers: 'Active freelancers',
    surveyQrApplyLinkTitle: 'Public registration link (share with field team)',
    surveyQrApplyLinkHint: 'Freelancers apply here — you approve them in the section above.',
    surveyQrMobile: 'Mobile',
    surveyQrApproveFreelancer: 'Approve',
    surveyQrRejectFreelancer: 'Reject',
    surveyQrApproving: 'Approving…',
    surveyQrFreelancerApproved: 'Approved: ID {code} is now active.',
    surveyQrRejectConfirm: 'Reject application from {name} (ID {code})?',
    surveyQrSectionTitle: 'Survey QR print cards',
    surveyQrFreelancerStatus: 'Status',
    surveyQrStatusActive: 'Active',
    surveyQrStatusBlocked: 'Blocked',
    surveyQrBlockFreelancer: 'Block',
    surveyQrUnblockFreelancer: 'Unblock',
    surveyQrBlockConfirm: 'Block freelancer {code}? Their referral link will stop working immediately.',
    surveyQrUnblockConfirm: 'Unblock freelancer {code} and re-enable their referral link?',
    surveyQrFreelancerBlocked: 'Blocked: {code} — referral link disabled.',
    surveyQrFreelancerUnblocked: 'Unblocked: {code} — referral link active.',
    surveyQrSaveFreelancer: 'Save name',
    surveyQrNewFreelancer: 'New freelancer',
    surveyQrFreelancerList: 'Saved freelancers',
    surveyQrFreelancerSaved: 'Saved: {name} ({code})',
    surveyQrCodeInvalid: 'Use letters and numbers only (1–12 chars).',
    surveyQrCodeActive: 'Active: {code}',
    surveyQrOfficialPack: ' — official print pack',
    surveyQrGenerating: ' — generating…',
    surveyQrOwnerTitle: 'Machine Owner',
    surveyQrClientTitle: 'Client',
    surveyQrPresetTitle: 'Pre-made packs: OM01, RAJ02, TEST01',
    surveyQrPresetOfficial: 'Official PNG + PDF files from print-ready assets in repo',
    surveyQrPresetLive: 'Other codes: QR generated live in browser',
    surveyLoading: 'Loading survey responses…',
    surveyReviewIntroTitle: 'Payment review queue',
    surveyReviewIntroHint: 'Only non-legacy submissions appear here. Approve valid forms for ₹30 payout. Red flags = self-survey; yellow = suspicious patterns.',
    surveyReviewFilterPayment: 'Payment status',
    surveyReviewStatusPending: 'Pending',
    surveyReviewStatusApproved: 'Approved',
    surveyReviewStatusRejected: 'Rejected',
    surveyReviewColFlags: 'Fraud flags',
    surveyReviewColPayment: 'Payment',
    surveyReviewApprove: 'Approve',
    surveyReviewReject: 'Reject',
    surveyReviewBulkApprove: 'Approve selected',
    surveyReviewBulkReject: 'Reject selected',
    surveyReviewSelectAll: 'Select all on page',
    surveyReviewRejectTitle: 'Reject submission',
    surveyReviewRejectHint: 'Reject {n} submission(s). Reason is saved for accounting.',
    surveyReviewRejectReason: 'Rejection reason',
    surveyReviewConfirmReject: 'Confirm reject',
    surveyReviewCancel: 'Cancel',
    surveyReviewLocked: 'Payout locked',
    surveyReviewEmpty: 'No submissions match this filter.',
    surveyReviewShowAnswers: 'Show answers ▾',
    surveyReviewHideAnswers: 'Hide answers ▴',
    surveyFraud_self_survey: 'Self-survey',
    surveyFraud_cross_freelancer_duplicate: 'Cross-freelancer duplicate',
    surveyFraud_sequence_pattern: 'Same village pattern',
    surveyPayoutIntroTitle: 'Freelancer payout accounting',
    surveyPayoutIntroHint: 'Payable = Unlocked approved forms × rate (₹30 default). Export CSV locks those rows — already paid forms are excluded.',
    surveyPayoutFrom: 'From date',
    surveyPayoutTo: 'To date',
    surveyPayoutRateLabel: 'Rate per form (INR)',
    surveyPayoutSaveRate: 'Save rate',
    surveyPayoutRateSaved: 'Rate saved: ₹{rate} per form',
    surveyPayoutExportCsv: 'Export CSV & lock payout',
    surveyPayoutExporting: 'Exporting…',
    surveyPayoutExportConfirm: 'Export payout {total} and lock all approved forms in this period? This cannot be undone in the app.',
    surveyPayoutExportDone: 'Exported — {n} forms locked. Total payable: {total}',
    surveyPayoutMissingPaymentTitle: 'Missing Payment Details (skipped)',
    surveyPayoutAddUpiHint: 'Add UPI or bank details in Freelancers tab before export.',
    surveyPayoutTotalSubmitted: 'Total submitted',
    surveyPayoutTotalApproved: 'Total approved',
    surveyPayoutTotalPayable: 'Total payable',
    surveyPayoutRatePerForm: 'Rate / form',
    surveyPayoutColSubmitted: 'Submitted',
    surveyPayoutColApproved: 'Approved',
    surveyPayoutColPendingExport: 'Pending payout',
    surveyPayoutColLocked: 'Already paid',
    surveyPayoutColRejected: 'Rejected',
    surveyPayoutColPending: 'Pending',
    surveyPayoutColPayable: 'Payable',
    surveyPayoutColUpi: 'UPI ID',
    surveyPayoutColBank: 'Bank / IFSC',
    surveyPayoutEmpty: 'No submissions in this period.',
    surveyPayoutDateInvalid: 'From date must be on or before To date.',
    surveyPayoutMissing: 'Missing',
    surveyPayoutSkippedTitle: 'Skipped this export (missing UPI/bank)',
    surveyPayoutSkippedLine: '{code}: {n} forms ({total}) skipped — add UPI/bank to include in next export.',
    surveyPayoutMissingHintNonBlocking: 'These freelancers will be skipped until UPI or bank details are added. Others can still be exported.',
    surveyQrUpiId: 'UPI ID (optional)',
    surveyQrBankAccount: 'Bank account (optional)',
    surveyQrBankIfsc: 'IFSC (optional)',
    surveyLoadFailed: 'Failed to load survey responses',
    surveyRetry: 'Retry',
    surveyStatTotal: 'Total responses',
    surveyStatHotLeads: 'Hot leads',
    surveyStatToday: 'Responses today',
    surveyStatTopSource: 'Top source',
    surveyHotLeadsSection: 'Hot leads',
    surveyNoHotLeads: 'No hot leads match filters.',
    surveyFilterType: 'Type',
    surveyFilterHotLead: 'Hot lead',
    surveyFilterLanguage: 'Language',
    surveyFilterSurveyor: 'Surveyor',
    surveyFilterPayment: 'Payment status',
    surveyPaymentLegacy: 'Legacy',
    surveyAll: 'All',
    surveyOwner: 'Owner',
    surveyClient: 'Client',
    surveyHotOnly: 'Hot leads only',
    surveyCsvExport: 'CSV Export',
    surveyCall: 'Call',
    surveyColDate: 'Date',
    surveyColName: 'Name',
    surveyColPhone: 'Phone',
    surveyColVillage: 'Village',
    surveyColType: 'Type',
    surveyColLang: 'Lang',
    surveyColSource: 'Source',
    surveyColSurveyor: 'Surveyor',
    surveyColHot: 'Hot',
    surveyColTrial: 'Trial',
    surveyNoMatch: 'No responses match filters.',
    surveyShowing: 'Showing {from}–{to} of {total}',
    surveyPrev: 'Prev',
    surveyNextPage: 'Next',
    surveyTimeJustNow: 'Just now',
    surveyTimeMinutesAgo: '{n} min ago',
    surveyTimeHoursAgo: '{n} hr ago',
    surveyTimeDaysAgo: '{n} days ago',
    surveyPainTitle: 'Pain ratings (avg 1–5)',
    surveyPainAvg: 'Average: {avg}',
    surveyPainNoData: 'No rating data for {mode} surveys.',
    surveyPainLocation: 'Location',
    surveyPainSideBooking: 'Side booking',
    surveyPainIdling: 'Idling',
    surveyPainLedger: 'Ledger',
    surveyPainCalls: 'Calls',
    surveyPainPunctuality: 'Punctuality',
    surveyPainRate: 'Rate',
    surveyPainHours: 'Hours',
    surveyPainBill: 'Bill',
    surveyPainReliability: 'Reliability',
    loginAs: 'Logging in as',
    mobileNumber: 'Mobile Number',
    emailAddressLabel: 'Email Address',
    loginPhoneHint: 'Use registered mobile number for Client, Owner and Operator login.',
    loginEmailHint: 'Use registered email for Admin login.',
    loginFailedGeneric: 'Login failed — please try again',
    show: 'Show',
    hide: 'Hide',
    newClientRegister: 'New Client? Register Here',
    joinUsBanner: 'Need machinery on rent?',
    joinUsHint: 'New customer? Register free to book excavators, JCB, cranes & more.',
    joinUsAction: 'Join Us — Register Free',
    loginModePassword: 'Password',
    loginModeOtp: 'OTP Login',
    loginOtpHint: 'We will send a 6-digit code to your registered mobile number.',
    loginSendOtp: 'Send OTP',
    loginSendingOtp: 'Sending OTP...',
    loginVerifyOtp: 'Verify & Sign In',
    loginVerifyingOtp: 'Verifying...',
    loginOtpSentTo: 'OTP sent to',
    loginOtpDevHint: 'Development: check API server logs for the OTP code if SMS is not configured.',
    landingHeroLine1: 'Smarter & Simpler.',
    landingHeroLine2: 'Maharashtra machinery rental, reimagined.',
    landingCtaApp: 'Explore Development Express',
    landingSocialProof: 'Join builders, contractors & fleet owners across Maharashtra.',
    landingStatMachines: 'Machines',
    landingStatRating: 'Rating',
    landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
    landingFeatBook: 'Book in minutes',
    landingFeatBookDesc: 'JCB, excavators, cranes — live availability and instant booking.',
    landingFeatTrack: 'Live GPS tracking',
    landingFeatTrackDesc: 'Know where your machine is, every hour of the hire.',
    landingFeatPay: 'Wallet-only payments',
    landingFeatPayDesc: 'Transparent billing, GST invoices, zero cash confusion.',
    registrationSuccess: 'Registration Successful!',
    registrationPending: 'Admin will activate your account within 24 hours.',
    backToLogin: 'Back to Login',
    newClientRegistration: 'New Client Registration',
    cancelAction: 'Cancel',
    registerAction: 'Register',
    registering: 'Registering...',
    forgotPasswordLink: 'Forgot password?',
    forgotPasswordTitle: 'Reset your password',
    forgotPasswordIntro: 'We will email a secure reset link to your registered email address.',
    forgotPasswordPhoneHint: 'Enter your registered mobile number. Reset link goes to the email on your account.',
    forgotPasswordEmailHint: 'Enter your registered admin email address.',
    forgotPasswordSubmit: 'Send reset link',
    forgotPasswordSending: 'Sending...',
    forgotPasswordSuccess: 'If an account exists, reset instructions were sent to the registered email.',
    forgotPasswordEmailDevHint: 'Local dev: open the API server terminal and copy the “Password reset link (development)” URL.',
    forgotPasswordEmailNextStepTitle: 'Check your email',
    forgotPasswordEmailNextStepBody: 'If an account exists, we sent a reset link to the registered email. Open that link to set a new password.',
    forgotPasswordEmailNextStepSpam: 'Didn’t get it? Check spam or wait a few minutes, then try sending again.',
    forgotPasswordEmailStep1: 'Open your email inbox',
    forgotPasswordEmailStep2: 'Tap the reset password link',
    forgotPasswordEmailStep3: 'Set a new password on the next screen',
    forgotPasswordEmailDevOpenLink: 'Open reset link (development)',
    forgotPasswordSendAgain: 'Send another link',
    forgotPasswordFailed: 'Could not send reset link. Please try again.',
    forgotPasswordInvalidPhone: 'Please enter a valid 10-digit mobile number.',
    forgotPasswordInvalidEmail: 'Please enter a valid email address.',
    resetPasswordTitle: 'Set new password',
    resetPasswordIntro: 'Choose a strong password with at least 8 characters.',
    resetPasswordSubmit: 'Update password',
    resetPasswordUpdating: 'Updating...',
    resetPasswordSuccess: 'Password updated. Redirecting to login...',
    resetPasswordFailed: 'Could not reset password. Request a new link.',
    resetPasswordMissingToken: 'Reset link is missing or invalid. Use Forgot password from login.',
    resetPasswordMinLength: 'Password must be at least 8 characters.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    passwordsMustMatch: 'Password and confirm password must match.',
    forgotPasswordChooseMethod: 'Choose email link or SMS OTP to reset your password.',
    resetMethodEmail: 'Email link',
    resetMethodSms: 'SMS OTP',
    forgotPasswordSmsHint: 'Enter your registered mobile number. A 6-digit OTP will be sent by SMS.',
    forgotPasswordSmsSuccess: 'If an account exists, OTP was sent to the registered mobile number.',
    forgotPasswordSmsFailed: 'Could not send OTP. Please try again.',
    forgotPasswordSmsDevHint: 'SMS not configured in production yet — in development, check server logs for the OTP code.',
    forgotPasswordSendOtp: 'Send OTP',
    forgotPasswordSendingOtp: 'Sending OTP...',
    forgotPasswordInvalidOtp: 'Enter the 6-digit OTP from SMS.',
    forgotPasswordOtpSentTo: 'OTP sent to',
    otpCode: 'OTP code',
    changeMobileNumber: 'Change mobile number',
    dispatched: 'Dispatched',
    pendingDispatch: 'Pending Dispatch',
    awaitingDispatch: 'Awaiting Dispatch',
    cancelBookingPrompt: 'Cancel Booking?',
    confirmCancel: 'Confirm Cancel',
    understoodAction: 'Understood',
    directContactProhibitedText: 'Direct Contact Strictly Prohibited',
    walletOnlyPolicyTitle: 'Wallet-Only Policy',
    walletOnlyPolicyDesc: 'All transactions via Wallet only. No cash accepted.',
    approved: 'Approved',
    pending: 'Pending',
    pendingApproval: 'Pending Approval',
    approveAndDispatch: 'Approve & Dispatch Machine',
    recentAlerts: 'Recent Alerts',
    allAlerts: 'All Alerts',
    contactCompany: 'Contact Development Express',
    running: 'Running',
    stopped: 'Stopped',
    assignedStatus: 'Assigned',
    cancellationFailed: 'Cancellation failed',
    okLabel: 'OK',
    presentLabel: 'Present',
    halfDayLabel: 'Half Day',
    absentLabel: 'Absent',
    paidLeaveLabel: 'Paid Leave',
    unpaidLeaveLabel: 'Unpaid Leave',
    clockInLabel: 'Clock In',
    clockOutLabel: 'Clock Out',
    clockedInAt: 'Clocked in at',
    clockedOutAt: 'Clocked out at',
    durationLabel: 'Duration',
    plQuotaLabel: 'Paid Leave Quota',
    plUsed: 'used',
    plAllowed: 'allowed',
    plRemaining: 'remaining',
    plQuotaUpdated: 'PL quota updated',
    plQuotaExhausted: 'PL quota exhausted — marked as Unpaid Leave',
    plRemainingLabel: 'PL remaining',
    clockInSuccess: 'Clocked in successfully',
    clockOutSuccess: 'Clocked out successfully',
    attendanceClockSection: 'Time tag (Clock In / Out)',
    attendanceStatusSection: 'Mark today status',
    fuelStartCol: 'Fuel Start',
    fuelEndCol: 'Fuel End',
    machineRunningAdmin: 'Machine Running (Admin started)',
    assignedAwaitingStart: 'Assigned — awaiting admin start',
    noActiveBooking: 'No active booking',
    issueMechanical: 'Mechanical',
    issueFuel: 'Fuel Issue',
    issueFuelShort: 'Fuel',
    issueAccident: 'Accident',
    issueElectrical: 'Electrical',
    issueSite: 'Site Issue',
    issueOther: 'Other',
    quickActionsTitle: 'Quick Actions',
    quickWork: 'Work',
    quickBooking: 'Booking',
    quickIssueBtn: 'Issue',
    bookingLabel: 'Booking',
    workSiteLabel: 'Work Site',
    fuelUpdated: 'Fuel Updated',
    fuelUpdateDefault: 'Fuel update',
    operatorByLabel: 'Operator',
    attendanceMarked: 'Attendance Marked!',
    markTodayAttendance: "Mark today's attendance:",
    attendanceHistory: 'Attendance History',
    fuelLevelSensor: 'Fuel Level · Omnicomm Sensor',
    fuelOk: 'Fuel OK',
    fuelLow: 'Fuel Low',
    fuelCritical: 'Critical!',
    fuelCurrentLabel: 'Current:',
    issueReportHint: 'Report any machine issue immediately.',
    issueReportSubmit: 'Issue Report Submit',
    loadingAssignment: 'Loading assignment…',
    noActiveAssignment: 'No active booking assignment.',
    noActiveAssignmentHint: 'Live meter and Mark Work Complete appear after owner dispatch approval and admin start.',
    awaitingAdminStart: 'Awaiting admin machine start',
    startedAtLabel: 'Started:',
    hmrCol: 'HMR',
    cancelText: 'Cancel',
    reportText: 'Report',
    loading: 'Loading...',
    loadingDashboard: 'Loading dashboard...',
    loadMoreBookings: 'Load More Bookings',
    loadMoreAttendance: 'Load More Attendance',
    loadMoreFuelLogs: 'Load More Fuel Logs',
    loadMoreAlerts: 'Load More Alerts',
    loadMoreMachines: 'Load More Machines',
    loadMoreUsers: 'Load More Users',
    loadMoreDlq: 'Load More DLQ',
    loadMoreLogs: 'Load More Logs',
    loadMoreTransactions: 'Load More Transactions',
    retryText: 'Retry',
    confirmRetry: 'Confirm Retry',
    resetText: 'Reset',
    nextText: 'Next',
    exportCsv: 'Export CSV',
    clearAll: 'Clear All',
    todayText: 'Today',
    noDlqItems: 'No DLQ items',
    retryDlqItemTitle: 'Retry DLQ Item',
    retryReasonAuditPlaceholder: 'Retry reason (for audit)',
    retryFailedForDlq: 'Retry failed for DLQ item',
    topSourceIp: 'Top Source IP',
    attemptsLabel: 'attempts',
    noRecentFailedLogins: 'No recent failed login attempts.',
    failedText: 'failed',
    unknownText: 'unknown',
    refreshText: 'Refresh',
    refreshingText: 'Refreshing...',
    lastRefreshed: 'Last refreshed',
    neverText: 'never',
    staleText: 'stale',
    liveText: 'live',
    acknowledgeText: 'Acknowledge',
    acknowledgedText: 'Acknowledged',
    allowedText: 'Allowed',
    blockedText: 'Blocked',
    activeBucketsText: 'Active Buckets',
    blockedRateText: 'Blocked Rate',
    alertText: 'ALERT',
    normalText: 'NORMAL',
    chipAction: 'action',
    chipActor: 'actor',
    chipRole: 'role',
    chipEntity: 'entity',
    chipMeta: 'meta',
    chipFrom: 'from',
    chipTo: 'to',
    noMoreAuditLogs: 'No more audit logs found for current filters.',
    highTrend: 'HIGH Trend',
    mediumTrend: 'MEDIUM Trend',
    hitsText: 'hits',
    burstText: 'BURST',
    loadedDlqItems: 'Loaded DLQ items',
    moreAvailable: 'more available',
    allLoaded: 'all loaded',
    loadedBookings: 'Loaded bookings',
    loadedFuelLogs: 'Loaded fuel logs',
    availableMachinery: 'Available Machinery',
    bookingCostCalculator: 'Booking & Cost Calculator',
    selectedMachineText: 'Selected Machine',
    bookingTypeText: 'Booking Type',
    grandTotalText: 'Grand Total',
    minAdvanceRequired: 'Min Advance Required',
    advanceRequired50Pct: 'Advance required (50%)',
    advance50PctHint: '50% of grand total (incl. GST) is debited from wallet when you confirm.',
    advance50PctShort: '50% adv',
    rechargeShortfall: 'Recharge — ₹{amount} short',
    walletRechargeMinHint: 'UPI/Card from ₹1 (test). NEFT/IMPS minimum ₹5,000.',
    minimumBankRecharge: 'NEFT/IMPS minimum transfer is ₹5,000',
    noBookingsYet: 'No bookings yet',
    bookingScheduleSummary: 'Day & Month Wise Booking Schedule',
    operatorFeedbackTitle: 'Operator Feedback',
    rateOperatorWork: 'Rate operator work (1–5 stars)',
    operatorSatisfactionQuestion: 'Are you satisfied with the operator?',
    satisfiedYes: 'Yes, satisfied',
    satisfiedNo: 'Not satisfied',
    operatorSuggestionPlaceholder: 'Suggestion or feedback (optional)',
    submitOperatorFeedback: 'Submit Feedback',
    operatorFeedbackSubmitted: 'Your feedback',
    operatorFeedbackSaved: 'Thank you! Your feedback has been saved.',
    feedbackAfterDispatch: 'Operator rating will be available after machine dispatch.',
    monthMachineSummary: 'Machines this month',
    monthTotalLabel: 'Month total',
    dayMachinesLabel: 'Machines',
    tableMonth: 'Month',
    tableDay: 'Day',
    totalAdvanceLabel: 'Advance Paid',
    advancePaidLabel: 'Advance',
    machineLabel: 'Machine',
    operatorFeedbackColumn: 'Operator Feedback',
    feedbackStatusAfterDispatch: 'After dispatch',
    feedbackStatusRateNow: 'Rate operator ↓',
    expandBookingHint: 'Expand the month/day section below for full booking details, cancel option, and operator rating form.',
    clientFeedbackLabel: 'Client Feedback',
    awaitingClientFeedback: 'Awaiting client feedback',
    clientRatingsTitle: 'Client Ratings & Suggestions',
    noClientFeedbackYet: 'No client ratings yet. Ratings appear here after clients submit feedback on dispatched bookings.',
    myClientRating: 'My Client Rating',
    scheduleColType: 'Type',
    scheduleColQty: 'Qty',
    duration: 'Duration',
    cycles: 'Cycles',
    bookingClosed: 'Closed',
    sectionNew: 'New',
    sectionAccepted: 'Accepted',
    sectionActive: 'Active',
    sectionDispatched: 'Dispatched',
    sectionCompleting: 'Completing',
    sectionDisputed: 'Disputed',
    sectionCompleted: 'Completed',
    sectionClosed: 'Closed',
    scheduleColTotal: 'Total',
    scheduleColFeedback: 'Feedback',
    bookMachineAction: 'Book Machine',
    bookingReportTitle: 'Booking Report',
    transactionHistoryTitle: 'Transaction History',
    walletRechargeTitle: 'Wallet Recharge',
    payNowText: 'Pay Now',
    dailyWorkReport: 'Daily Work Report',
    issueReportTitle: 'Issue Report',
    pastIssuesTitle: 'Past Issues',
    fuelLevelUpdate: 'Fuel Level Update',
    quickIssueReport: 'Quick Issue Report',
    tableId: 'ID',
    tableIn: 'In',
    tableOut: 'Out',
    tableLevel: 'Level',
    tableChange: 'Change',
    tableNote: 'Note',
    tableAtt: 'Att',
    tableStart: 'Start',
    tableEnd: 'End',
    tableHrs: 'Hrs',
    totalSpent: 'Total Spent',
    machineHours: 'Machine Hours',
    totalBookingsText: 'Total Bookings',
    gstInvoices: 'GST Invoices',
    confirmBookingAction: 'Confirm Booking',
    updateText: 'Update',
    updateFuel: 'Update Fuel',
    ownerPortal: 'Owner Portal',
    clientPortal: 'Client Portal',
    operatorPortal: 'Operator Portal',
    portalWelcome: 'Welcome',
    portalWelcomeHint: 'Tap your portal to continue',
    portalClient: 'Client',
    portalClientSub: 'Book machinery',
    portalOwner: 'Owner',
    portalOwnerSub: 'Manage fleet',
    portalNewClientRegister: 'New client? Register',
    portalNewOwnerRegister: 'New owner? Register',
    portalStaffOperator: 'Operator',
    portalStaffAdmin: 'Admin',
    portalBackLink: 'Portals',
    loginRoleClientShort: 'Client',
    loginRoleOwnerShort: 'Owner',
    loginTabPassword: 'Password',
    loginTabOtp: 'OTP',
    loginSignInShort: 'Sign in',
    loginNewHereRegister: 'New here? Register',
    loginChangeRole: 'Change role',
    loginClientPortalSubtitle: 'Sign in to book construction machinery',
    loginOwnerPortalSubtitle: 'Sign in to manage your fleet & registrations',
    regMachineInfoTitle: 'Machine Information',
    regMachineIntro: 'Construction heavy equipment only — no trucks or transport. Wheeled plant (e.g. JCB 3DX) needs RTO; crawler plant (Poclain, dozer) is site-only with no RTO passing.',
    regMachineCategory: 'Machine category *',
    regEquipmentCategory: 'Equipment category *',
    regSelectType: 'Select type…',
    regMachineNameModel: 'Machine name / model',
    regRtoNumber: 'RTO registration number *',
    regFleetIdOptional: 'Fleet / chassis ID (optional)',
    regYearManufacture: 'Year of manufacture *',
    regCapacitySpecs: 'Capacity / specs',
    machineFinancialSection: 'Machine Purchase Details (Optional)',
    machineOwnershipType: 'Ownership Type',
    machineOwnershipNew: 'New Machine',
    machineOwnershipUsed: 'Original Owner',
    machineOwnershipSecondHand: 'Pre-Owned',
    machinePurchasePrice: 'Purchase Price (₹)',
    machinePurchasePriceHint: 'Amount you paid for this machine',
    machinePurchaseDate: 'Purchase Date',
    machineYearOfManufacture: 'Year of Manufacture',
    machineLoanSection: 'I have a loan on this machine',
    machineLoanAmount: 'Loan Amount (₹)',
    machineLoanEmi: 'Monthly EMI (₹)',
    machineLoanTenure: 'Loan Tenure (months)',
    machineLoanStartDate: 'Loan Start Date',
    machineFuelConsumption: 'Fuel Consumption (L/hr)',
    machineMonthlyOperatingExpenses: 'Monthly Operating Expenses',
    machineOperatorMonthlySalary: 'Operator Monthly Salary',
    machineServiceMonthly: 'Service / Maintenance (Monthly)',
    machineBreakdownMonthly: 'Breakdown / Repair (Monthly Avg)',
    machineMaterialsMonthly: 'Materials / Consumables (Monthly)',
    recoveryPlan: 'Recovery Plan',
    recoveryOnTrack: 'On Track',
    recoveryNeedsAttention: 'Needs Attention',
    recoveryActionRequired: 'Action Required',
  recoveryAddPrice: 'Add purchase price to see recovery plan',
  recoveryProgress: 'Investment Recovered',
  recoveryDailyNet: 'Daily Net Income',
  recoveryDays: 'Recovery Period',
  recoveryProjectedDate: 'Projected Recovery Date',
  recoveryRoi: 'Annual Return',
  recoveryCurrentValue: 'Current Machine Value',
  recoveryBackfillNudge: 'Add purchase details to {{count}} machine(s) to unlock recovery tracking',
  editFinancialDetails: 'Edit Financial Details',
  financialDetailsSaved: 'Financial details saved',
  dieselPriceTitle: 'Diesel Price',
  dieselPriceUpdate: 'Update Diesel Price',
  dieselPriceLatest: 'Latest Price',
  dieselPriceNoRecord: 'No diesel price recorded',
  dieselPricePerLitre: 'Price per litre (₹)',
  dieselQuantity: 'Quantity filled (litres)',
  dieselTaluka: 'City / Area',
  dieselFuelCostPerHour: 'Fuel cost per hour',
  dieselPercentOfRate: 'of your hourly rate',
  dieselPriceSaved: 'Diesel price saved',
  dieselRateSuggestion: 'Rate Suggestion',
  dieselRateIncrease: 'Diesel up — consider increasing rate by',
  dieselRateDecrease: 'Diesel down — lower rate by to attract more bookings',
  dieselSuggestedRate: 'Suggested rate',
  dieselHistory: 'Price History',
  dieselNoHistory: 'No diesel price history yet',
  dieselColDate: 'Date',
  dieselColPrice: 'Price/litre',
  dieselColQty: 'Quantity',
  dieselColSource: 'Source',
  dieselUploadReceipt: 'Upload Receipt',
  dieselExtractSuccess: 'Extracted from receipt',
  dieselExtractFailed: 'Could not extract — please enter manually',
  applyRateSuggestion: 'Apply ₹{{rate}}/hr',
  rateSuggestionApplied: 'Rate updated successfully',
  marketPosition: 'Market Position',
  marketBelowMarket: 'Below Market',
  marketCompetitive: 'Competitive',
  marketAboveMarket: 'Above Market',
  marketNoData: 'No market data for your area yet',
  marketSubmitRate: 'Submit Market Rate',
  marketCity: 'City / Area',
  marketMinRate: 'Min rate in your area (₹/hr)',
  marketMaxRate: 'Max rate in your area (₹/hr)',
  marketRateSubmitted: 'Market rate submitted — thank you!',
  marketDataPoints: 'Based on {{count}} submission(s)',
  marketRange: 'Market in {{city}}',
  marketSourceLocal: 'Based on {{city}} area rates',
  marketSourcePlatform: 'Based on platform-wide rates',
  regPremiumOnboarding: 'Premium onboarding',
    regMobilityWheeled: 'Wheeled',
    regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — construction plant with RTO (RC)',
    regMobilityTracked: 'Crawler',
    regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — site plant, no RTO passing',
    regTagRto: 'RTO',
    regTagNoRto: 'No RTO',
    sinceExcellence: 'Since 2011 · 15 Yrs Excellence',
    machineStatusTitle: 'Machine Status',
    machineRegistrationTitle: 'Machine Registration',
    paymentHistoryTitle: 'Payment History',
    callNow: 'Call Now',
    officeLabel: 'Office',
    securitySignalsTitle: 'Security Signals',
    rateLimitTelemetryTitle: 'Rate Limit Telemetry',
    apiSloAlertsTitle: 'API SLO Alerts',
    noRecentApiSloBreach: 'No recent API SLO breach signals.',
    apiHealthTitle: 'API Health',
    sloHealthy: 'SLO HEALTHY',
    sloBreachRisk: 'SLO BREACH RISK',
    recentFailedLoginsTitle: 'Recent Failed Logins',
    noSecuritySignalsFound: 'No security signals found.',
    machineRegistrationSubmitted: 'Machine Registration Submitted! DE Team will verify within 24 hrs.',
    issueReportedSuccess: 'Issue reported successfully!',
    paymentSuccess: 'Payment Successful!',
    paymentFailed: 'Payment failed! Please try again.',
    minimumRecharge: 'Minimum amount is ₹1 for UPI, Card & dynamic QR.',
    bookMachine: 'Book Machine',
    newBooking: 'New Booking',
    bookingStepChoose: 'Choose Machine',
    bookingStepCost: 'Cost & Dates',
    bookingStepConfirm: 'Confirm & Pay',
    changeMachine: 'Change Machine',
    bookingSelectMachineFirst: 'Select a machine from the fleet to continue.',
    costCalculator: 'Cost & Booking',
    myBookings: 'My Bookings',
    liveTracking: 'Live Tracking',
    wallet: 'Wallet',
    overview: 'Overview',
    machines: 'Machines',
    clients: 'Clients',
    owners: 'Owners',
    operators: 'Operators',
    billingWallet: 'Wallet & Billing',
    iot: 'IoT & GPS',
    logout: 'Logout',
    // Common
    active: 'Active',
    idle: 'Idle',
    available: 'Available',
    busy: 'Busy',
    locked: 'Locked',
    live: 'LIVE',
    totalMachines: 'Total Machines',
    activeToday: 'Active Today',
    walletBalance: 'Wallet Balance',
    activeBookings: 'Active Bookings',
    recharge: 'Recharge',
    rechargeWallet: '+ Recharge Wallet',
    payNow: 'Pay Now',
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Go Back',
    download: 'Download',
    submit: 'Submit',
    save: 'Save',
    perHour: 'Per Hour',
    perDay: 'Per Day',
    perWeek: 'Per Week',
    perMonth: 'Per Month',
    advance: 'Advance',
    commission: 'Commission',
    netPayable: 'Net Payable',
    grossBilling: 'Gross Billing',
    bookNow: 'BOOK NOW',
    confirmBooking: 'Confirm Booking',
    cancelBooking: 'Cancel Booking',
    machineStatus: 'Machine Status',
    fuelLevel: 'Fuel Level',
    condition: 'Condition',
    location: 'Location',
    operator: 'Operator',
    experience: 'Experience',
    rating: 'Rating',
    hours: 'Hours',
    days: 'Days',
    weeks: 'Weeks',
    months: 'Months',
    gstInvoice: 'GST Invoice',
    bookingHistory: 'Booking History',
    paymentHistory: 'Payment History',
    noAlerts: 'No Alerts!',
    allMachinesOk: 'All machines running fine.',
    lockMachine: 'Lock Machine',
    machineReg: 'Machine Registration Form',
    ownerInfo: 'Owner Information',
    machineInfo: 'Machine Information',
    pdiInfo: 'PDI Inspection',
    documents: 'Documents Upload',
    agreement: 'Terms & Agreement',
    selectFile: 'Choose File',
    walletOnly: 'WALLET-ONLY · NO CASH ACCEPTED',
    noRefund: 'No Refund Policy',
    cancelPolicy: 'Cancellation Policy',
    whatsapp: 'WhatsApp',
    email: 'Email Support',
    send: 'Send',
    year: 'Year',
    total: 'TOTAL',
    tax: 'Tax',
    status: 'Status',
    type: 'Type',
    date: 'Date',
    machine: 'Machine',
    client: 'Client',
    hmrToday: 'HMR Today',
    hmrTotal: 'Total HMR',
    earnings: 'Earnings',
    amount: 'Amount',
    ref: 'Reference No.',
    fuel: 'Fuel',
    ignition: 'Ignition',
    speed: 'Speed',
    completedBookings: 'Completed Bookings',
    instantCost: 'Instant Cost Calculator',
    baseAmount: 'Base Amount',
    gst18: 'GST (18%)',
    grandTotal: 'Grand Total',
    minimumAdvance: '50% ADVANCE REQUIRED (of grand total)',
    selectMachineFirst: 'Please select a machine first',
    viewMachines: '→ View Machines',
    bookingConfirm: 'Confirm Booking',
    walletDeduct: '50% advance from wallet · No cash · GST invoice after work completion',
    noBookings: 'No active bookings',
    goBook: '→ Book a Machine',
    completeBookings: 'Completed Bookings',
    transactions: 'Transaction History',
    customAmount: 'Custom amount (from ₹1 for UPI/Card)',
    paymentMethods: 'Payment Methods',
    alertLog: 'Alert Log History',
    sendWhatsapp: 'Send on WhatsApp',
    sendEmail: 'Send Email',
    yourMessage: 'Write your question or issue...',
    importantInfo: 'Important Information for Machine Owners',
    machineDetails: 'Machine & Operator Details',
    liveCamera: '360° Live Camera — Post Booking',
    liveBookAvail: 'Live Feed Available After Booking',
    rateCard: 'Rate Card (Inclusive of Operator)',
    selectBook: 'Book This Machine →',
    selectCalc: '📋 Select & Calculate Cost →',
    bookingType: 'Select Booking Type',
    selectQty: 'Select Quantity',
    walletSufficient: '✅ Proceed',
    walletInsufficient: '❌ Insufficient',
    rechargeFirst: '⚡ Recharge Wallet First',
    cancelWarning: 'Are you sure you want to cancel?',
    noBankRefund: '❌ No Bank Refund — Wallet Credit Only',
    walletCredit: 'Wallet Credit',
    penaltyDeduct: 'Cancellation Penalty (1 hr)',
    blacklistWarning: '⛔ BLACKLIST WARNING',
    directContactProhibited: 'Direct Contact Strictly Prohibited',
    understood: '✅ Understood — Will use Platform',
    lockWarning: 'Machine ignition will be disabled remotely via Teltonika GPS.',
    lockConfirm: '🔒 Confirm Lock',
    allStats: 'Complete Statistics',
    marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
    marketingNavServices: 'Services',
    marketingNavTech: 'Technology',
    marketingNavContact: 'Contact',
    marketingNavLogin: 'Login to platform →',
    marketingHeadline: "Maharashtra's Leading Machinery Rental Platform",
    marketingLead:
      'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
    marketingCtaLogin: 'Open Development Express — Login',
    marketingCtaBook: 'Book a machine',
    marketingCtaWhatsApp: 'WhatsApp us',
    marketingStatYears: 'Years experience',
    marketingStatFleet: 'Machines live',
    marketingStatDigital: 'Digital payments',
    marketingServicesTitle: 'What we offer',
    marketingSvcTrack: 'GPS & live status',
    marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
    marketingSvcPay: 'Wallet-only settlements',
    marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
    marketingSvcOps: 'Full operations stack',
    marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
    marketingTechLead:
      'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
    marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
    marketingBackHome: 'Website home',
    changeLanguage: 'Change language',
    drawerMenu: 'Menu',
    fullName: 'Full Name',
    phone: 'Phone',
    netEarnedMonth: 'Net Earned (Month)',
    netReceived: 'Net Received',
    commission15: 'Platform Commission',
    tdsGstTcs: 'TDS 2% + GST TCS 1%',
    netReceivedCaps: 'NET RECEIVED',
    commissionPaid: 'Commission Paid',
    settlements: 'Settlements',
    receiptId: 'Receipt ID',
    gross: 'Gross',
    tdsTcs: 'TDS+TCS',
    netPaid: 'Net Paid',
    bank: 'Bank',
    accountNumber: 'A/C Number',
    ifsc: 'IFSC',
    paymentMode: 'Payment Mode',
    neftRtgs: 'NEFT/RTGS',
    company: 'Company',
    md: 'MD',
    gstin: 'GSTIN',
    sinceLabel: 'Since',
    paymentCycle: 'Payment Cycle',
    commissionRate: 'Platform Fee on Gross Billing',
    threeWorkingDays: '3 Working Days',
    pdiTitle: 'Pre-Delivery Inspection (PDI)',
    pdiCrawlerHint: 'Crawler plant: pollution (PUC) not required — machine is not RTO road-registered.',
    documentUploadTitle: 'Document Upload',
    regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC and ID required (max 5MB each).',
    regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo and ID required. Insurance optional.',
    optionalLabel: '(optional)',
    noFileSelected: 'No file selected',
    replaceFile: 'Replace',
    uploadFile: 'Upload',
    platformAgreement: 'Platform Agreement',
    agreeTermsCheckbox: 'I have read and accept all Terms & Conditions',
    termCommission: 'Development Express platform fee on gross billing',
    termTds: 'TDS deduction: 2% as per Income Tax Act',
    termGstTcs: 'GST TCS: 1% as per GST regulations',
    termPaymentDays: 'Payment within 3 working days of client settlement',
    termFuel: 'Machine must maintain 40%+ fuel at all times',
    termGps: 'GPS device (Teltonika) mandatory — installed by DE',
    termNoDirectContact: 'Direct client contact = immediate contract termination',
    regFileTypeError: 'Only PDF, JPG, PNG or WEBP files are allowed',
    regFileSizeError: 'Each document must be 5MB or smaller',
    regFailed: 'Registration failed. Please try again.',
    crawlerNoRto: 'Crawler (no RTO)',
    remoteLockAlert: 'Remote lock will be enabled after Teltonika GPS device is installed on this machine. Contact DE support.',
    hmrHrs: 'hrs',
    on: 'ON',
    off: 'OFF',
    formLabel: 'Form',
    revenue: 'Revenue',
    docRcBook: 'RC Book (RTO Registration Certificate)',
    docInsurance: 'Insurance Certificate',
    docPollution: 'Pollution Certificate (PUC)',
    docIdentity: 'PAN Card / Aadhaar',
    docChassisPlate: 'Chassis / Serial Plate Photo (no RTO RC)',
    docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
    docEquipmentPhoto: 'Full Machine Photo (side view)',
    docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
    pdiCompleted: '✅ PDI / Safety inspection completed',
    pdiInsuranceValid: '✅ Insurance valid & up to date',
    pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
    pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
    valOwnerName: 'Owner name is required',
    valPhone: 'Valid phone number is required',
    valEmail: 'Valid email is required',
    valMobility: 'Please select wheeled or crawler construction equipment type',
    valMachineName: 'Machine name / model is required',
    valMachineType: 'Please select equipment category',
    valRto: 'RTO registration number is required for wheeled machines',
    valYear: 'Valid year (YYYY) is required',
    valPdiChecks: 'Please confirm all required checks',
    valPdiRequired: 'PDI confirmation is required',
    valUploadMissing: 'Please upload: {docs}',
    acceptTermsRequired: 'Please accept terms and conditions',
    registerMachine: 'Register Your Machine',
    noMachinesYet: 'No machines registered yet',
    noMachinesDashboard: 'No machines yet. Use Register Machine to add your fleet.',
    bookingsScheduleHint: 'Day-wise schedule will appear here when clients book your machines.',
    paymentBreakdownTitle: 'Payment Breakdown — April 2026',
    bankDetailsTitle: 'Bank Details',
    companyDetailsTitle: 'Company Details',
    remoteLockMachine: '🔒 Remote Lock Machine',
    gpsLiveLabel: '🟢 GPS Live',
    noMachinesTrack: 'No machines to track',
    noMachinesTrackHint: 'Register a machine to enable GPS tracking.',
    submittedRegistrations: 'Submitted Registrations',
    regSubmitBtn: '✅ Submit Registration',
  },

  hi: {
    appName: 'डेवलपमेंट एक्सप्रेस',
    tagline: 'बुनियादी ढांचे का स्वर्णिम मानक',
    platform: 'निर्माण प्रबंधन प्लेटफॉर्म',
    selectRole: 'भूमिका चुनें',
    emailAddress: 'ईमेल पता',
    password: 'पासवर्ड',
    signIn: 'साइन इन करें',
    signingIn: 'लॉगिन हो रहा है...',
    adminRole: 'एडमिन — प्रबंध निदेशक',
    ownerRole: 'मशीन मालिक',
    clientRole: 'क्लाइंट (ठेकेदार)',
    operatorRole: 'ऑपरेटर',
    dashboard: 'डैशबोर्ड',
    myMachines: 'मेरी मशीनें',
    register: 'मशीन पंजीकरण',
    tracking: 'GPS ट्रैकिंग',
    reports: 'रिपोर्ट',
    alerts: 'ध्यान दें',
    support: 'सहायता',
    home: 'होम',
    attendance: 'उपस्थिति',
    machineLog: 'मशीन लॉग',
    issues: 'समस्याएं',
    approvals: 'अनुमोदन',
    dlqMonitor: 'DLQ मॉनिटर',
    auditLogs: 'ऑडिट लॉग्स',
    surveyResponses: 'सर्वे उत्तर',
    surveyReview: 'Survey Review',
    surveyPayout: 'Payout Summary',
    adminSurveyPayoutPageTitle: 'Payout summary',
    adminSurveyPayoutPageSubtitle: 'Freelancer-wise totals, rate, CSV export — export locks approved forms.',
    surveyQr: 'Freelancers',
    adminSurveyPageTitle: 'सर्वे उत्तर',
    adminSurveyPageSubtitle: 'फील्ड सर्वे डेटा, हॉट लीड, pain रेटिंग और CSV export.',
    adminSurveyReviewPageTitle: 'Survey payment review',
    adminSurveyReviewPageSubtitle: 'Payout से पहले forms approve/reject करें (₹30 per approved).',
    adminSurveyQrPageTitle: 'Freelancer registration & approval',
    adminSurveyQrPageSubtitle: 'Field team approve करें, unique ID दें, survey QR print करें.',
    surveyQrOwnerSurvey: 'मशीन मालिक सर्वे',
    surveyQrClientSurvey: 'ग्राहक सर्वे',
    surveyQrSurveyorCode: 'सर्वेयर कोड',
    surveyQrEnterCode: 'सर्वेयर कोड दर्ज करें',
    surveyQrPrintPack: 'प्रिंट पैक',
    surveyQrDownloadOwnerPng: 'Owner PNG डाउनलोड',
    surveyQrDownloadClientPng: 'Client PNG डाउनलोड',
    surveyQrDownloadPrintCard: 'प्रिंट कार्ड PDF डाउनलोड',
    surveyQrOwnerPng: 'Owner PNG',
    surveyQrClientPng: 'Client PNG',
    surveyQrTrackingHint: 'Admin → सर्वे उत्तर → source=qr-card, surveyor=CODE',
    surveyQrCodeHint: 'Field team code (A–Z, 0–9, max 12). QR links {origin} पर src=qr-card के साथ।',
    surveyQrCodeLabel: 'कोड',
    surveyQrFreelancerName: 'Freelancer नाम',
    surveyQrFreelancerNameHint: 'Tracking के लिए नाम — हर freelancer का अलग code.',
    surveyQrUniqueId: 'Unique ID code',
    surveyQrFreelancerPreview: 'Registered: {name} — ID {code}',
    surveyQrFreelancerActions: 'Actions',
    surveyQrFreelancerOpen: 'Open',
    surveyQrDeleteFreelancer: 'Delete',
    surveyQrDeleting: 'Deleting…',
    surveyQrDeleteConfirm: 'Freelancer {name} (ID {code}) हटाएं? List से निकल जाएगा। पुराने survey responses में code रहेगा।',
    surveyQrFreelancerDeleted: 'हटाया: {name} (ID {code})',
    surveyQrDeleteHint: 'जो lead नहीं ला रहे, उन्हें delete करें। OM01, RAJ02, TEST01 delete नहीं हो सकते।',
    surveyQrRegistrationTitle: 'Freelancer register (admin)',
    surveyQrRegistrationHint: 'Name + unique ID — save करते ही active.',
    surveyQrPendingApproval: 'Pending approval',
    surveyQrNoPending: 'कोई pending application नहीं। Registration link field team को share करें।',
    surveyQrNoActiveFreelancers: 'अभी कोई active freelancer नहीं।',
    surveyQrActiveFreelancers: 'Active freelancers',
    surveyQrApplyLinkTitle: 'Public registration link',
    surveyQrApplyLinkHint: 'Freelancers यहाँ apply करें — ऊपर approve करें।',
    surveyQrMobile: 'Mobile',
    surveyQrApproveFreelancer: 'Approve',
    surveyQrRejectFreelancer: 'Reject',
    surveyQrApproving: 'Approving…',
    surveyQrFreelancerApproved: 'Approved: ID {code} active है।',
    surveyQrRejectConfirm: '{name} (ID {code}) reject करें?',
    surveyQrSectionTitle: 'Survey QR print cards',
    surveyQrSaveFreelancer: 'नाम सेव करें',
    surveyQrNewFreelancer: 'नया freelancer',
    surveyQrFreelancerList: 'सेव किए freelancer',
    surveyQrFreelancerSaved: 'सेव: {name} ({code})',
    surveyQrCodeInvalid: 'केवल अक्षर और अंक (1–12)।',
    surveyQrCodeActive: 'सक्रिय: {code}',
    surveyQrOfficialPack: ' — official print pack',
    surveyQrGenerating: ' — generating…',
    surveyQrOwnerTitle: 'Machine Owner',
    surveyQrClientTitle: 'Client',
    surveyQrPresetTitle: 'Pre-made packs: OM01, RAJ02, TEST01',
    surveyQrPresetOfficial: 'Repo में print-ready assets से official PNG + PDF',
    surveyQrPresetLive: 'अन्य codes: browser में live QR generate',
    surveyLoading: 'सर्वे उत्तर लोड हो रहे हैं…',
    surveyReviewIntroTitle: 'Payment review queue',
    surveyReviewIntroHint: 'Approve valid forms for ₹30 payout. Red = self-survey; yellow = suspicious.',
    surveyReviewFilterPayment: 'Payment status',
    surveyReviewStatusPending: 'Pending',
    surveyReviewStatusApproved: 'Approved',
    surveyReviewStatusRejected: 'Rejected',
    surveyReviewColFlags: 'Fraud flags',
    surveyReviewColPayment: 'Payment',
    surveyReviewApprove: 'Approve',
    surveyReviewReject: 'Reject',
    surveyReviewBulkApprove: 'Approve selected',
    surveyReviewBulkReject: 'Reject selected',
    surveyReviewSelectAll: 'Select all',
    surveyReviewRejectTitle: 'Reject submission',
    surveyReviewRejectHint: 'Reject {n} submission(s).',
    surveyReviewRejectReason: 'Rejection reason',
    surveyReviewConfirmReject: 'Confirm reject',
    surveyReviewCancel: 'Cancel',
    surveyReviewLocked: 'Payout locked',
    surveyReviewEmpty: 'No submissions match.',
    surveyReviewShowAnswers: 'Show answers ▾',
    surveyReviewHideAnswers: 'Hide answers ▴',
    surveyFraud_self_survey: 'Self-survey',
    surveyFraud_cross_freelancer_duplicate: 'Cross duplicate',
    surveyFraud_sequence_pattern: 'Village pattern',
    surveyPayoutIntroTitle: 'Freelancer payout accounting',
    surveyPayoutIntroHint: 'Payable = Unlocked approved × rate (₹30 default). Export CSV locks those rows.',
    surveyPayoutFrom: 'From date',
    surveyPayoutTo: 'To date',
    surveyPayoutRateLabel: 'Rate per form (INR)',
    surveyPayoutSaveRate: 'Save rate',
    surveyPayoutRateSaved: 'Rate saved: ₹{rate} per form',
    surveyPayoutExportCsv: 'Export CSV & lock payout',
    surveyPayoutExporting: 'Exporting…',
    surveyPayoutExportConfirm: 'Export {total} and lock approved forms in this period? Cannot be undone.',
    surveyPayoutExportDone: 'Exported — {n} forms locked. Total: {total}',
    surveyPayoutMissingPaymentTitle: 'Missing Payment Details (skipped)',
    surveyPayoutAddUpiHint: 'Add UPI or bank in Freelancers tab before export.',
    surveyPayoutTotalSubmitted: 'Total submitted',
    surveyPayoutTotalApproved: 'Total approved',
    surveyPayoutTotalPayable: 'Total payable',
    surveyPayoutRatePerForm: 'Rate / form',
    surveyPayoutColSubmitted: 'Submitted',
    surveyPayoutColApproved: 'Approved',
    surveyPayoutColPendingExport: 'Pending payout',
    surveyPayoutColLocked: 'Already paid',
    surveyPayoutColRejected: 'Rejected',
    surveyPayoutColPending: 'Pending',
    surveyPayoutColPayable: 'Payable',
    surveyPayoutColUpi: 'UPI ID',
    surveyPayoutColBank: 'Bank / IFSC',
    surveyPayoutEmpty: 'No submissions in this period.',
    surveyPayoutDateInvalid: 'From date must be on or before To date.',
    surveyPayoutMissing: 'Missing',
    surveyPayoutSkippedTitle: 'Skipped this export (missing UPI/bank)',
    surveyPayoutSkippedLine: '{code}: {n} forms ({total}) skipped — add UPI/bank to include in next export.',
    surveyPayoutMissingHintNonBlocking: 'These freelancers will be skipped until UPI or bank details are added. Others can still be exported.',
    surveyQrUpiId: 'UPI ID (optional)',
    surveyQrBankAccount: 'Bank account (optional)',
    surveyQrBankIfsc: 'IFSC (optional)',
    surveyLoadFailed: 'सर्वे उत्तर लोड नहीं हो सके',
    surveyRetry: 'पुनः प्रयास',
    surveyStatTotal: 'कुल उत्तर',
    surveyStatHotLeads: 'हॉट लीड',
    surveyStatToday: 'आज के उत्तर',
    surveyStatTopSource: 'शीर्ष स्रोत',
    surveyHotLeadsSection: 'हॉट लीड',
    surveyNoHotLeads: 'फ़िल्टर से कोई हॉट लीड नहीं मिली।',
    surveyFilterType: 'प्रकार',
    surveyFilterHotLead: 'हॉट लीड',
    surveyFilterLanguage: 'भाषा',
    surveyFilterSurveyor: 'सर्वेयर',
    surveyFilterPayment: 'Payment status',
    surveyPaymentLegacy: 'Legacy',
    surveyAll: 'सभी',
    surveyOwner: 'Owner',
    surveyClient: 'Client',
    surveyHotOnly: 'केवल हॉट लीड',
    surveyCsvExport: 'CSV Export',
    surveyCall: 'कॉल',
    surveyColDate: 'तारीख',
    surveyColName: 'नाम',
    surveyColPhone: 'फोन',
    surveyColVillage: 'गाँव',
    surveyColType: 'प्रकार',
    surveyColLang: 'भाषा',
    surveyColSource: 'स्रोत',
    surveyColSurveyor: 'सर्वेयर',
    surveyColHot: 'Hot',
    surveyColTrial: 'Trial',
    surveyNoMatch: 'फ़िल्टर से कोई उत्तर नहीं मिला।',
    surveyShowing: '{from}–{to} / {total} दिखा रहे हैं',
    surveyPrev: 'पिछला',
    surveyNextPage: 'अगला',
    surveyTimeJustNow: 'अभी',
    surveyTimeMinutesAgo: '{n} मिनट पहले',
    surveyTimeHoursAgo: '{n} घंटे पहले',
    surveyTimeDaysAgo: '{n} दिन पहले',
    surveyPainTitle: 'Pain ratings (औसत 1–5)',
    surveyPainAvg: 'औसत: {avg}',
    surveyPainNoData: '{mode} सर्वे के लिए कोई rating डेटा नहीं।',
    surveyPainLocation: 'Location',
    surveyPainSideBooking: 'Side booking',
    surveyPainIdling: 'Idling',
    surveyPainLedger: 'हिसाब',
    surveyPainCalls: 'कॉल',
    surveyPainPunctuality: 'समय',
    surveyPainRate: 'दर',
    surveyPainHours: 'घंटे',
    surveyPainBill: 'Bill',
    surveyPainReliability: 'विश्वास',
    loginAs: 'लॉगिन हो रहे हैं',
    mobileNumber: 'मोबाइल नंबर',
    emailAddressLabel: 'ईमेल पता',
    loginPhoneHint: 'क्लाइंट, ओनर और ऑपरेटर लॉगिन के लिए रजिस्टर्ड मोबाइल नंबर इस्तेमाल करें।',
    loginEmailHint: 'एडमिन लॉगिन के लिए रजिस्टर्ड ईमेल इस्तेमाल करें।',
    loginFailedGeneric: 'लॉगिन असफल — कृपया फिर से प्रयास करें',
    show: 'दिखाएं',
    hide: 'छुपाएं',
    newClientRegister: 'नया क्लाइंट? यहां रजिस्टर करें',
    joinUsBanner: 'मशीन किराए पर चाहिए?',
    joinUsHint: 'नए ग्राहक? JCB, excavator, crane बुक करने के लिए मुफ्त रजिस्टर करें।',
    joinUsAction: 'Join Us — मुफ्त रजिस्टर करें',
    loginModePassword: 'पासवर्ड',
    loginModeOtp: 'OTP लॉगिन',
    loginOtpHint: 'रजिस्टर्ड मोबाइल पर 6 अंकों का OTP भेजा जाएगा।',
    loginSendOtp: 'OTP भेजें',
    loginSendingOtp: 'OTP भेज रहे हैं...',
    loginVerifyOtp: 'Verify करें',
    loginVerifyingOtp: 'Verify हो रहा है...',
    loginOtpSentTo: 'OTP भेजा:',
    loginOtpDevHint: 'Development: SMS न हो तो server log में OTP देखें।',
    landingHeroLine1: 'Smarter & Simpler.',
    landingHeroLine2: 'महाराष्ट्र का smart machinery rental.',
    landingCtaApp: 'Development Express खोलें',
    landingSocialProof: 'महाराष्ट्र भर के builders और contractors जुड़े हैं।',
    landingStatMachines: 'मशीनें',
    landingStatRating: 'रेटिंग',
    landingTrustLine: 'Wallet-only · GST · Secured',
    landingFeatBook: 'मिनटों में बुकिंग',
    landingFeatBookDesc: 'JCB, excavator, crane — live availability.',
    landingFeatTrack: 'Live GPS',
    landingFeatTrackDesc: 'हर घंटे machine location पता करें।',
    landingFeatPay: 'Wallet payments',
    landingFeatPayDesc: 'GST invoice, transparent billing.',
    registrationSuccess: 'रजिस्ट्रेशन सफल!',
    registrationPending: 'एडमिन 24 घंटे के भीतर आपका अकाउंट सक्रिय करेगा।',
    backToLogin: 'लॉगिन पर वापस जाएं',
    newClientRegistration: 'नया क्लाइंट पंजीकरण',
    cancelAction: 'रद्द करें',
    registerAction: 'रजिस्टर करें',
    registering: 'रजिस्टर हो रहा है...',
    dispatched: 'भेजा गया',
    pendingDispatch: 'डिस्पैच प्रतीक्षेत',
    awaitingDispatch: 'डिस्पैच की प्रतीक्षा',
    cancelBookingPrompt: 'बुकिंग रद्द करें?',
    confirmCancel: 'रद्दीकरण पुष्टि करें',
    understoodAction: 'समझ गया',
    directContactProhibitedText: 'सीधा संपर्क सख्त प्रतिबंधित',
    walletOnlyPolicyTitle: 'केवल वॉलेट नीति',
    walletOnlyPolicyDesc: 'सभी लेनदेन केवल वॉलेट से। नकद स्वीकार नहीं।',
    approved: 'स्वीकृत',
    pending: 'लंबित',
    pendingApproval: 'स्वीकृति लंबित',
    approveAndDispatch: 'स्वीकृत करें और मशीन भेजें',
    recentAlerts: 'हाल की चेतावनियाँ',
    allAlerts: 'सभी चेतावनियाँ',
    contactCompany: 'डेवलपमेंट एक्सप्रेस से संपर्क करें',
    running: 'चालू',
    stopped: 'बंद',
    assignedStatus: 'नियुक्त',
    cancellationFailed: 'रद्दीकरण विफल',
    okLabel: 'ठीक है',
    presentLabel: 'उपस्थित',
    halfDayLabel: 'आधा दिन',
    absentLabel: 'अनुपस्थित',
    paidLeaveLabel: 'वेतन सह अवकाश',
    unpaidLeaveLabel: 'बिन वेतन अवकाश',
    clockInLabel: 'क्लॉक इन',
    clockOutLabel: 'क्लॉक आउट',
    clockedInAt: 'क्लॉक इन समय',
    clockedOutAt: 'क्लॉक आउट समय',
    durationLabel: 'अवधि',
    plQuotaLabel: 'वेतन सह अवकाश कोटा',
    plUsed: 'उपयोग',
    plAllowed: 'अनुमत',
    plRemaining: 'शेष',
    plQuotaUpdated: 'PL कोटा अपडेट',
    plQuotaExhausted: 'PL कोटा समाप्त — बिन वेतन अवकाश के रूप में दर्ज',
    plRemainingLabel: 'शेष PL',
    clockInSuccess: 'क्लॉक इन यशस्वी',
    clockOutSuccess: 'क्लॉक आउट यशस्वी',
    attendanceClockSection: 'समय टैग (क्लॉक इन / आउट)',
    attendanceStatusSection: 'आज की स्थिति चुनें',
    fuelStartCol: 'ईंधन प्रारंभ',
    fuelEndCol: 'ईंधन अंत',
    machineRunningAdmin: 'मशीन चालू (एडमिन ने शुरू किया)',
    assignedAwaitingStart: 'नियुक्त — एडमिन शुरू करने की प्रतीक्षा',
    noActiveBooking: 'कोई सक्रिय बुकिंग नहीं',
    issueMechanical: 'मैकेनिकल',
    issueFuel: 'ईंधन समस्या',
    issueFuelShort: 'ईंधन',
    issueAccident: 'दुर्घटना',
    issueElectrical: 'इलेक्ट्रिकल',
    issueSite: 'साइट समस्या',
    issueOther: 'अन्य',
    quickActionsTitle: 'त्वरित कार्य',
    quickWork: 'काम',
    quickBooking: 'बुकिंग',
    quickIssueBtn: 'समस्या',
    bookingLabel: 'बुकिंग',
    workSiteLabel: 'कार्य स्थल',
    fuelUpdated: 'ईंधन अपडेट',
    fuelUpdateDefault: 'ईंधन अपडेट',
    operatorByLabel: 'ऑपरेटर',
    attendanceMarked: 'उपस्थिति दर्ज!',
    markTodayAttendance: 'आज की उपस्थिति दर्ज करें:',
    attendanceHistory: 'उपस्थिति इतिहास',
    fuelLevelSensor: 'ईंधन स्तर · Omnicomm सेंसर',
    fuelOk: 'ईंधन ठीक',
    fuelLow: 'ईंधन कम',
    fuelCritical: 'गंभीर!',
    fuelCurrentLabel: 'वर्तमान:',
    issueReportHint: 'कोई भी मशीन समस्या तुरंत रिपोर्ट करें।',
    issueReportSubmit: 'समस्या रिपोर्ट जमा करें',
    loadingAssignment: 'असाइनमेंट लोड हो रहा है…',
    noActiveAssignment: 'कोई सक्रिय बुकिंग असाइनमेंट नहीं।',
    noActiveAssignmentHint: 'मालिक डिस्पैच और एडमिन स्टार्ट के बाद लाइव मीटर और Mark Work Complete दिखेगा।',
    awaitingAdminStart: 'एडमिन मशीन स्टार्ट की प्रतीक्षा',
    startedAtLabel: 'शुरू:',
    hmrCol: 'HMR',
    cancelText: 'रद्द करें',
    reportText: 'रिपोर्ट',
    loading: 'लोड हो रहा है...',
    loadingDashboard: 'डैशबोर्ड लोड हो रहा है...',
    loadMoreBookings: 'और बुकिंग लोड करें',
    loadMoreAttendance: 'और उपस्थिति लोड करें',
    loadMoreFuelLogs: 'और फ्यूल लॉग लोड करें',
    loadMoreAlerts: 'और अलर्ट लोड करें',
    loadMoreMachines: 'और मशीनें लोड करें',
    loadMoreUsers: 'और यूजर्स लोड करें',
    loadMoreDlq: 'और DLQ लोड करें',
    loadMoreLogs: 'और लॉग लोड करें',
    loadMoreTransactions: 'और ट्रांजैक्शन लोड करें',
    retryText: 'पुनः प्रयास',
    confirmRetry: 'पुनः प्रयास की पुष्टि करें',
    resetText: 'रीसेट',
    nextText: 'आगे',
    exportCsv: 'CSV एक्सपोर्ट',
    clearAll: 'सभी साफ करें',
    todayText: 'आज',
    noDlqItems: 'कोई DLQ आइटम नहीं',
    retryDlqItemTitle: 'DLQ आइटम पुनः प्रयास',
    retryReasonAuditPlaceholder: 'पुनः प्रयास का कारण (ऑडिट हेतु)',
    retryFailedForDlq: 'DLQ आइटम के लिए पुनः प्रयास विफल',
    topSourceIp: 'शीर्ष स्रोत IP',
    attemptsLabel: 'प्रयास',
    noRecentFailedLogins: 'हाल में कोई असफल लॉगिन प्रयास नहीं।',
    failedText: 'असफल',
    unknownText: 'अज्ञात',
    refreshText: 'रिफ्रेश',
    refreshingText: 'रिफ्रेश हो रहा है...',
    lastRefreshed: 'अंतिम रिफ्रेश',
    neverText: 'कभी नहीं',
    staleText: 'पुराना',
    liveText: 'लाइव',
    acknowledgeText: 'स्वीकारें',
    acknowledgedText: 'स्वीकार किया',
    allowedText: 'अनुमत',
    blockedText: 'ब्लॉक्ड',
    activeBucketsText: 'सक्रिय बकेट',
    blockedRateText: 'ब्लॉक दर',
    alertText: 'अलर्ट',
    normalText: 'सामान्य',
    chipAction: 'क्रिया',
    chipActor: 'कर्ता',
    chipRole: 'भूमिका',
    chipEntity: 'एंटिटी',
    chipMeta: 'मेटा',
    chipFrom: 'से',
    chipTo: 'तक',
    noMoreAuditLogs: 'वर्तमान फिल्टर के लिए और ऑडिट लॉग नहीं मिले।',
    highTrend: 'HIGH ट्रेंड',
    mediumTrend: 'MEDIUM ट्रेंड',
    hitsText: 'हिट्स',
    burstText: 'बर्स्ट',
    loadedDlqItems: 'लोडेड DLQ आइटम',
    moreAvailable: 'और उपलब्ध',
    allLoaded: 'सभी लोड',
    loadedBookings: 'लोड की गई बुकिंग',
    loadedFuelLogs: 'लोड किए गए फ्यूल लॉग',
    availableMachinery: 'उपलब्ध मशीनरी',
    bookingCostCalculator: 'बुकिंग और लागत कैलकुलेटर',
    selectedMachineText: 'चयनित मशीन',
    bookingTypeText: 'बुकिंग प्रकार',
    grandTotalText: 'कुल योग',
    minAdvanceRequired: 'न्यूनतम अग्रिम आवश्यक',
    advanceRequired50Pct: 'अग्रिम आवश्यक (50%)',
    advance50PctHint: 'कुल राशि (GST सहित) का 50% पुष्टि पर वॉलेट से काटा जाएगा।',
    advance50PctShort: '50% अग्रिम',
    rechargeShortfall: 'रिचार्ज — ₹{amount} कम',
    walletRechargeMinHint: 'UPI/कार्ड ₹1 से। NEFT/IMPS न्यूनतम ₹5,000।',
    minimumBankRecharge: 'NEFT/IMPS न्यूनतम ट्रांसफर ₹5,000',
    noBookingsYet: 'अभी तक कोई बुकिंग नहीं',
    bookingScheduleSummary: 'दिन और महीने अनुसार बुकिंग शेड्यूल',
    operatorFeedbackTitle: 'ऑपरेटर फीडबैक',
    rateOperatorWork: 'ऑपरेटर का काम रेट करें (1–5 स्टार)',
    operatorSatisfactionQuestion: 'क्या आप ऑपरेटर से संतुष्ट हैं?',
    satisfiedYes: 'हाँ, संतुष्ट',
    satisfiedNo: 'संतुष्ट नहीं',
    operatorSuggestionPlaceholder: 'सुझाव या फीडबैक (वैकल्पिक)',
    submitOperatorFeedback: 'फीडबैक भेजें',
    operatorFeedbackSubmitted: 'आपका फीडबैक',
    operatorFeedbackSaved: 'धन्यवाद! आपका फीडबैक सेव हो गया।',
    feedbackAfterDispatch: 'मशीन डिस्पैच के बाद ऑपरेटर रेटिंग उपलब्ध होगी।',
    monthMachineSummary: 'इस महीने की मशीनें',
    monthTotalLabel: 'महीने का कुल',
    dayMachinesLabel: 'मशीनें',
    tableMonth: 'महीना',
    tableDay: 'दिन',
    totalAdvanceLabel: 'अग्रिम भुगतान',
    advancePaidLabel: 'अग्रिम',
    machineLabel: 'मशीन',
    operatorFeedbackColumn: 'ऑपरेटर फीडबैक',
    feedbackStatusAfterDispatch: 'डिस्पैच के बाद',
    feedbackStatusRateNow: 'ऑपरेटर रेट करें ↓',
    expandBookingHint: 'पूरी बुकिंग, रद्द करें और ऑपरेटर रेटिंग के लिए नीचे महीना/दिन सेक्शन expand करें।',
    clientFeedbackLabel: 'क्लाइंट फीडबैक',
    awaitingClientFeedback: 'क्लाइंट फीडबैक की प्रतीक्षा',
    clientRatingsTitle: 'क्लाइंट रेटिंग और सुझाव',
    noClientFeedbackYet: 'अभी कोई क्लाइंट रेटिंग नहीं। डिस्पैच के बाद क्लाइंट फीडबैक यहाँ दिखेगा।',
    myClientRating: 'मेरी क्लाइंट रेटिंग',
    scheduleColType: 'प्रकार',
    scheduleColQty: 'Qty',
    duration: 'अवधि',
    cycles: 'चक्र',
    bookingClosed: 'बंद',
    sectionNew: 'नई',
    sectionAccepted: 'स्वीकृत',
    sectionActive: 'सक्रिय',
    sectionDispatched: 'डिस्पैच',
    sectionCompleting: 'पूर्ण हो रहा',
    sectionDisputed: 'विवादित',
    sectionCompleted: 'पूर्ण',
    sectionClosed: 'बंद',
    scheduleColTotal: 'कुल',
    scheduleColFeedback: 'फीडबैक',
    bookMachineAction: 'मशीन बुक करें',
    bookingReportTitle: 'बुकिंग रिपोर्ट',
    transactionHistoryTitle: 'लेनदेन इतिहास',
    walletRechargeTitle: 'वॉलेट रिचार्ज',
    payNowText: 'अभी भुगतान करें',
    dailyWorkReport: 'दैनिक कार्य रिपोर्ट',
    issueReportTitle: 'समस्या रिपोर्ट',
    pastIssuesTitle: 'पिछली समस्याएं',
    fuelLevelUpdate: 'फ्यूल स्तर अपडेट',
    quickIssueReport: 'त्वरित समस्या रिपोर्ट',
    tableId: 'आईडी',
    tableIn: 'इन',
    tableOut: 'आउट',
    tableLevel: 'स्तर',
    tableChange: 'बदलाव',
    tableNote: 'नोट',
    tableAtt: 'उप',
    tableStart: 'शुरू',
    tableEnd: 'समाप्त',
    tableHrs: 'घं',
    totalSpent: 'कुल खर्च',
    machineHours: 'मशीन घंटे',
    totalBookingsText: 'कुल बुकिंग',
    gstInvoices: 'GST इनवॉइस',
    confirmBookingAction: 'बुकिंग की पुष्टि करें',
    updateText: 'अपडेट करें',
    updateFuel: 'फ्यूल अपडेट करें',
    ownerPortal: 'ओनर पोर्टल',
    clientPortal: 'क्लाइंट पोर्टल',
    operatorPortal: 'ऑपरेटर पोर्टल',
    portalWelcome: 'स्वागत है',
    portalWelcomeHint: 'जारी रखने के लिए अपना पोर्टल चुनें',
    portalClient: 'क्लाइंट',
    portalClientSub: 'मशीनरी बुक करें',
    portalOwner: 'ओनर',
    portalOwnerSub: 'फ्लीट प्रबंधन',
    portalNewClientRegister: 'नए क्लाइंट? रजिस्टर करें',
    portalNewOwnerRegister: 'नए ओनर? रजिस्टर करें',
    portalStaffOperator: 'ऑपरेटर',
    portalStaffAdmin: 'एडमिन',
    portalBackLink: 'पोर्टल',
    loginRoleClientShort: 'क्लाइंट',
    loginRoleOwnerShort: 'ओनर',
    loginTabPassword: 'पासवर्ड',
    loginTabOtp: 'OTP',
    loginSignInShort: 'साइन इन',
    loginNewHereRegister: 'नए हैं? रजिस्टर करें',
    loginChangeRole: 'भूमिका बदलें',
    loginClientPortalSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन करें',
    loginOwnerPortalSubtitle: 'अपनी फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन करें',
    regMachineInfoTitle: 'मशीन जानकारी',
    regMachineIntro: 'केवल निर्माण heavy equipment — कोई ट्रक/ट्रांसपोर्ट नहीं। व्हील्ड (JCB 3DX) के लिए RTO; क्रॉलर (Poclain) साइट पर — RTO passing नहीं।',
    regMachineCategory: 'मशीन श्रेणी *',
    regEquipmentCategory: 'उपकरण श्रेणी *',
    regSelectType: 'प्रकार चुनें…',
    regMachineNameModel: 'मशीन नाम / मॉडल',
    regRtoNumber: 'RTO पंजीकरण संख्या *',
    regFleetIdOptional: 'फ्लीट / चेसिस ID (वैकल्पिक)',
    regYearManufacture: 'निर्माण वर्ष *',
    regCapacitySpecs: 'क्षमता / विवरण',
    machineFinancialSection: 'मशीन खरीद विवरण (वैकल्पिक)',
    machineOwnershipType: 'स्वामित्व प्रकार',
    machineOwnershipNew: 'नई मशीन',
    machineOwnershipUsed: 'पहले मालक',
    machineOwnershipSecondHand: 'पूर्व-स्वामित्व',
    machinePurchasePrice: 'खरीद मूल्य (₹)',
    machinePurchasePriceHint: 'इस मशीन के लिए आपने जो राशि चुकाई',
    machinePurchaseDate: 'खरीद तिथि',
    machineYearOfManufacture: 'निर्माण वर्ष',
    machineLoanSection: 'इस मशीन पर मेरा loan है',
    machineLoanAmount: 'Loan राशि (₹)',
    machineLoanEmi: 'मासिक EMI (₹)',
    machineLoanTenure: 'Loan अवधि (महीने)',
    machineLoanStartDate: 'Loan शुरू तिथि',
    machineFuelConsumption: 'ईंधन खपत (L/hr)',
    machineMonthlyOperatingExpenses: 'मासिक परिचालन व्यय',
    machineOperatorMonthlySalary: 'ऑपरेटर मासिक वेतन',
    machineServiceMonthly: 'सर्विस / रखरखाव (मासिक)',
    machineBreakdownMonthly: 'ब्रेकडाउन / मरम्मत (मासिक औसत)',
    machineMaterialsMonthly: 'सामग्री / उपभोग्य (मासिक)',
    recoveryPlan: 'रिकवरी प्लान',
    recoveryOnTrack: 'सही रास्ते पर',
    recoveryNeedsAttention: 'ध्यान दें',
    recoveryActionRequired: 'कार्रवाई जरूरी',
    recoveryAddPrice: 'रिकवरी प्लान देखने के लिए खरीद मूल्य जोड़ें',
    recoveryProgress: 'निवेश वसूली',
    recoveryDailyNet: 'दैनिक शुद्ध आय',
    recoveryDays: 'वसूली अवधि',
    recoveryProjectedDate: 'अनुमानित वसूली तिथि',
    recoveryRoi: 'वार्षिक प्रतिफल',
    recoveryCurrentValue: 'वर्तमान मशीन मूल्य',
    recoveryBackfillNudge: 'रिकवरी ट्रैकिंग अनलॉक करने के लिए {{count}} मशीन(ों) में खरीद विवरण जोड़ें',
    editFinancialDetails: 'वित्तीय विवरण संपादित करें',
    financialDetailsSaved: 'वित्तीय विवरण सहेजे गए',
    dieselPriceTitle: 'डीजल की कीमत',
    dieselPriceUpdate: 'डीजल कीमत अपडेट करें',
    dieselPriceLatest: 'नवीनतम कीमत',
    dieselPriceNoRecord: 'कोई डीजल कीमत दर्ज नहीं',
    dieselPricePerLitre: 'प्रति लीटर कीमत (₹)',
    dieselQuantity: 'भरी गई मात्रा (लीटर)',
    dieselTaluka: 'शहर / क्षेत्र',
    dieselFuelCostPerHour: 'प्रति घंटा ईंधन लागत',
    dieselPercentOfRate: 'आपकी प्रति घंटा दर का',
    dieselPriceSaved: 'डीजल कीमत सहेजी गई',
    dieselRateSuggestion: 'दर सुझाव',
    dieselRateIncrease: 'डीजल बढ़ा — दर बढ़ाने पर विचार करें',
    dieselRateDecrease: 'डीजल घटा — बुकिंग के लिए दर कम करें',
    dieselSuggestedRate: 'सुझाई गई दर',
    dieselHistory: 'कीमत इतिहास',
    dieselNoHistory: 'अभी तक कोई डीजल कीमत इतिहास नहीं',
    dieselColDate: 'तारीख',
    dieselColPrice: 'कीमत/लीटर',
    dieselColQty: 'मात्रा',
    dieselColSource: 'स्रोत',
    dieselUploadReceipt: 'रसीद अपलोड करें',
    dieselExtractSuccess: 'रसीद से निकाला गया',
    dieselExtractFailed: 'निकाल नहीं सके — कृपया मैन्युअल दर्ज करें',
    applyRateSuggestion: '₹{{rate}}/घंटा लागू करें',
    rateSuggestionApplied: 'दर सफलतापूर्वक अपडेट हुई',
    marketPosition: 'बाजार स्थिति',
    marketBelowMarket: 'बाजार से नीचे',
    marketCompetitive: 'प्रतिस्पर्धी',
    marketAboveMarket: 'बाजार से ऊपर',
    marketNoData: 'आपके क्षेत्र के लिए अभी कोई बाजार डेटा नहीं',
    marketSubmitRate: 'बाजार दर जमा करें',
    marketCity: 'शहर / क्षेत्र',
    marketMinRate: 'आपके क्षेत्र की न्यूनतम दर (₹/घंटा)',
    marketMaxRate: 'आपके क्षेत्र की अधिकतम दर (₹/घंटा)',
    marketRateSubmitted: 'बाजार दर जमा हो गई — धन्यवाद!',
    marketDataPoints: '{{count}} जमा पर आधारित',
    marketRange: '{{city}} में बाजार',
    marketSourceLocal: '{{city}} क्षेत्र की दरों पर आधारित',
    marketSourcePlatform: 'प्लेटफ़ॉर्म-व्यापी दरों पर आधारित',
    regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
    regMobilityWheeled: 'व्हील्ड',
    regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) वाला निर्माण उपकरण',
    regMobilityTracked: 'क्रॉलर',
    regMobilityTrackedHint: 'Poclain / chain excavator, dozer — साइट उपकरण, RTO passing नहीं',
    regTagRto: 'RTO',
    regTagNoRto: 'RTO नहीं',
    sinceExcellence: '2011 से · 15 वर्ष उत्कृष्टता',
    machineStatusTitle: 'मशीन स्थिति',
    machineRegistrationTitle: 'मशीन पंजीकरण',
    paymentHistoryTitle: 'भुगतान इतिहास',
    callNow: 'अभी कॉल करें',
    officeLabel: 'ऑफिस',
    securitySignalsTitle: 'सुरक्षा संकेत',
    rateLimitTelemetryTitle: 'रेट लिमिट टेलीमेट्री',
    apiSloAlertsTitle: 'API SLO अलर्ट',
    noRecentApiSloBreach: 'हाल में कोई API SLO breach संकेत नहीं।',
    apiHealthTitle: 'API स्वास्थ्य',
    sloHealthy: 'SLO स्वस्थ',
    sloBreachRisk: 'SLO breach जोखिम',
    recentFailedLoginsTitle: 'हाल की असफल लॉगिन',
    noSecuritySignalsFound: 'कोई सुरक्षा संकेत नहीं मिले।',
    machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत पडताळणी करेल.',
    issueReportedSuccess: 'इश्यू यशस्वीरित्या नोंदवला!',
    paymentSuccess: 'पेमेंट यशस्वी!',
    paymentFailed: 'पेमेंट अयशस्वी! कृपया पुन्हा प्रयत्न करा.',
    minimumRecharge: 'UPI/कार्ड/QR के लिए न्यूनतम ₹1।',
    bookMachine: 'मशीन बुक करें',
    newBooking: 'नई बुकिंग',
    bookingStepChoose: 'मशीन चुनें',
    bookingStepCost: 'लागत और तारीख',
    bookingStepConfirm: 'पुष्टि और भुगतान',
    changeMachine: 'मशीन बदलें',
    bookingSelectMachineFirst: 'जारी रखने के लिए फ्लीट से मशीन चुनें।',
    costCalculator: 'लागत कैलकुलेटर',
    myBookings: 'मेरी बुकिंग',
    liveTracking: 'लाइव ट्रैकिंग',
    wallet: 'वॉलेट',
    overview: 'अवलोकन',
    machines: 'मशीनें',
    clients: 'ग्राहक',
    owners: 'मालिक',
    operators: 'ऑपरेटर',
    billingWallet: 'वॉलेट और बिलिंग',
    iot: 'IoT और GPS',
    logout: 'लॉगआउट',
    active: 'सक्रिय',
    idle: 'निष्क्रिय',
    available: 'उपलब्ध',
    busy: 'व्यस्त',
    locked: 'लॉक',
    live: 'लाइव',
    totalMachines: 'कुल मशीनें',
    activeToday: 'आज सक्रिय',
    walletBalance: 'वॉलेट बैलेंस',
    activeBookings: 'सक्रिय बुकिंग',
    recharge: 'रिचार्ज',
    rechargeWallet: '+ वॉलेट रिचार्ज',
    payNow: 'अभी भुगतान करें',
    confirm: 'पुष्टि करें',
    cancel: 'रद्द करें',
    back: 'वापस जाएं',
    download: 'डाउनलोड',
    submit: 'जमा करें',
    save: 'सहेजें',
    perHour: 'प्रति घंटा',
    perDay: 'प्रति दिन',
    perWeek: 'प्रति सप्ताह',
    perMonth: 'प्रति माह',
    advance: 'अग्रिम',
    commission: 'कमीशन',
    netPayable: 'शुद्ध देय',
    grossBilling: 'सकल बिलिंग',
    bookNow: 'अभी बुक करें',
    confirmBooking: 'बुकिंग पुष्टि करें',
    cancelBooking: 'बुकिंग रद्द करें',
    machineStatus: 'मशीन स्थिति',
    fuelLevel: 'ईंधन स्तर',
    condition: 'स्थिति',
    location: 'स्थान',
    operator: 'ऑपरेटर',
    experience: 'अनुभव',
    rating: 'रेटिंग',
    hours: 'घंटे',
    days: 'दिन',
    weeks: 'सप्ताह',
    months: 'महीने',
    gstInvoice: 'GST इनवॉइस',
    bookingHistory: 'बुकिंग इतिहास',
    paymentHistory: 'भुगतान इतिहास',
    noAlerts: 'कोई अलर्ट नहीं!',
    allMachinesOk: 'सभी मशीनें ठीक चल रही हैं।',
    lockMachine: 'मशीन लॉक करें',
    machineReg: 'मशीन पंजीकरण फॉर्म',
    ownerInfo: 'मालिक की जानकारी',
    machineInfo: 'मशीन की जानकारी',
    pdiInfo: 'PDI निरीक्षण',
    documents: 'दस्तावेज़ अपलोड',
    agreement: 'नियम और समझौता',
    selectFile: 'फ़ाइल चुनें',
    walletOnly: 'केवल वॉलेट · नकद स्वीकार नहीं',
    noRefund: 'नो रिफंड नीति',
    cancelPolicy: 'रद्दीकरण नीति',
    whatsapp: 'WhatsApp',
    email: 'ईमेल सहायता',
    send: 'भेजें',
    year: 'वर्ष',
    total: 'कुल',
    tax: 'कर',
    status: 'स्थिति',
    type: 'प्रकार',
    date: 'दिनांक',
    machine: 'मशीन',
    client: 'ग्राहक',
    hmrToday: 'आज का HMR',
    hmrTotal: 'कुल HMR',
    earnings: 'कमाई',
    amount: 'राशि',
    ref: 'संदर्भ संख्या',
    fuel: 'ईंधन',
    ignition: 'इग्निशन',
    speed: 'गति',
    completedBookings: 'पूर्ण बुकिंग',
    instantCost: 'त्वरित लागत कैलकुलेटर',
    baseAmount: 'मूल राशि',
    gst18: 'GST (18%)',
    grandTotal: 'कुल योग',
    minimumAdvance: 'न्यूनतम अग्रिम आवश्यक',
    selectMachineFirst: 'पहले मशीन चुनें',
    viewMachines: '→ मशीनें देखें',
    bookingConfirm: 'बुकिंग पुष्टि करें',
    walletDeduct: '50% अग्रिम वॉलेट से · नकद नहीं · काम पूर्ण होने पर GST चालान',
    noBookings: 'कोई सक्रिय बुकिंग नहीं',
    goBook: '→ मशीन बुक करें',
    completeBookings: 'पूर्ण बुकिंग',
    transactions: 'लेनदेन इतिहास',
    customAmount: 'कस्टम राशि (UPI/कार्ड ₹1 से)',
    paymentMethods: 'भुगतान के तरीके',
    alertLog: 'अलर्ट लॉग',
    sendWhatsapp: 'WhatsApp पर भेजें',
    sendEmail: 'ईमेल भेजें',
    yourMessage: 'अपना प्रश्न या समस्या लिखें...',
    importantInfo: 'मशीन मालिकों के लिए महत्वपूर्ण जानकारी',
    machineDetails: 'मशीन और ऑपरेटर विवरण',
    liveCamera: '360° लाइव कैमरा — बुकिंग के बाद',
    liveBookAvail: 'बुकिंग के बाद लाइव फीड उपलब्ध',
    rateCard: 'दर पत्रक (ऑपरेटर सहित)',
    selectBook: 'यह मशीन बुक करें →',
    selectCalc: '📋 चुनें और लागत देखें →',
    bookingType: 'बुकिंग प्रकार चुनें',
    selectQty: 'मात्रा चुनें',
    walletSufficient: '✅ आगे बढ़ें',
    walletInsufficient: '❌ अपर्याप्त',
    rechargeFirst: '⚡ पहले वॉलेट रिचार्ज करें',
    cancelWarning: 'क्या आप रद्द करना चाहते हैं?',
    noBankRefund: '❌ बैंक रिफंड नहीं — केवल वॉलेट क्रेडिट',
    walletCredit: 'वॉलेट क्रेडिट',
    penaltyDeduct: 'रद्दीकरण दंड (1 घंटा)',
    blacklistWarning: '⛔ ब्लैकलिस्ट चेतावनी',
    directContactProhibited: 'सीधा संपर्क सख्त वर्जित',
    understood: '✅ समझ गया — प्लेटफॉर्म उपयोग करूंगा',
    lockWarning: 'Teltonika GPS के जरिए मशीन का इग्निशन दूर से बंद हो जाएगा।',
    lockConfirm: '🔒 लॉक पुष्टि करें',
    allStats: 'पूर्ण आंकड़े',
    marketingBadge: 'लाइव ऑपरेशन · कराड, सातारा',
    marketingNavServices: 'सेवाएँ',
    marketingNavTech: 'प्रौद्योगिकी',
    marketingNavContact: 'संपर्क',
    marketingNavLogin: 'प्लेटफॉर्म लॉगिन →',
    marketingHeadline: 'महाराष्ट्र का अग्रणी मशीनरी रेंटल प्लेटफॉर्म',
    marketingLead:
      'रीयल-टाइम GPS, डिजिटल वॉलेट भुगतान, और निर्माण मशीनरी के लिए स्वचालित संचालन। 2011 से सेवा में।',
    marketingCtaLogin: 'Development Express खोलें — लॉगिन',
    marketingCtaBook: 'मशीन बुक करें',
    marketingCtaWhatsApp: 'WhatsApp करें',
    marketingStatYears: 'वर्षों का अनुभव',
    marketingStatFleet: 'लाइव मशीनें',
    marketingStatDigital: 'डिजिटल भुगतान',
    marketingServicesTitle: 'हम क्या देते हैं',
    marketingSvcTrack: 'GPS और लाइव स्थिति',
    marketingSvcTrackSub: 'Teltonika से जुड़ी फ्लीट दृश्यता।',
    marketingSvcPay: 'केवल वॉलेट निपटान',
    marketingSvcPaySub: 'GST इनवॉइस — साइट पर नकद नहीं।',
    marketingSvcOps: 'पूर्ण संचालन सूट',
    marketingSvcOpsSub: 'मालिक, ऑपरेटर, क्लाइंट — एक प्लेटफॉर्म।',
    marketingTechLead:
      'Development Express बुकिंग, अनुपालन और फील्ड टेलीमेट्री को एक ही वर्कफ़्लो में जोड़ता है।',
    marketingFooterRights: '2026 डेवलपमेंट एक्सप्रेस · कराड, सातारा',
    marketingBackHome: 'वेबसाइट होम',
    drawerMenu: 'मेनू',
    fullName: 'पूरा नाम',
    phone: 'फ़ोन',
    netEarnedMonth: 'नेट कमाई (माह)',
    netReceived: 'नेट प्राप्त',
    commission15: 'प्लेटफॉर्म कमीशन',
    tdsGstTcs: 'TDS 2% + GST TCS 1%',
    netReceivedCaps: 'नेट प्राप्त',
    commissionPaid: 'कमीशन भुगतान',
    settlements: 'निपटान',
    receiptId: 'रसीद ID',
    gross: 'सकल',
    tdsTcs: 'TDS+TCS',
    netPaid: 'नेट भुगतान',
    bank: 'बैंक',
    accountNumber: 'खाता संख्या',
    ifsc: 'IFSC',
    paymentMode: 'भुगतान मोड',
    neftRtgs: 'NEFT/RTGS',
    company: 'कंपनी',
    md: 'MD',
    gstin: 'GSTIN',
    sinceLabel: 'से',
    paymentCycle: 'भुगतान चक्र',
    commissionRate: 'सकल बिलिंग पर प्लेटफॉर्म शुल्क',
    threeWorkingDays: '3 कार्य दिवस',
    pdiTitle: 'प्री-डिलीवरी निरीक्षण (PDI)',
    pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) आवश्यक नहीं — RTO पंजीकृत नहीं।',
    documentUploadTitle: 'दस्तावेज़ अपलोड',
    regDocWheeledHint: 'व्हील्ड: RC (RTO), बीमा, PUC और ID (अधिकतम 5MB प्रत्येक)।',
    regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरीद इनवॉइस, फोटो और ID। बीमा वैकल्पिक।',
    optionalLabel: '(वैकल्पिक)',
    noFileSelected: 'कोई फ़ाइल नहीं',
    replaceFile: 'बदलें',
    uploadFile: 'अपलोड',
    platformAgreement: 'प्लेटफॉर्म समझौता',
    agreeTermsCheckbox: 'मैंने सभी नियम और शर्तें पढ़ी हैं और स्वीकार की हैं',
    termCommission: 'Development Express प्लेटफॉर्म शुल्क: सकल बिलिंग पर',
    termTds: 'TDS कटौती: आयकर अधिनियम के अनुसार 2%',
    termGstTcs: 'GST TCS: GST नियमों के अनुसार 1%',
    termPaymentDays: 'क्लाइंट निपटान के 3 कार्य दिवसों में भुगतान',
    termFuel: 'मशीन में हमेशा 40%+ ईंधन रखें',
    termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारा स्थापित',
    termNoDirectContact: 'सीधा क्लाइंट संपर्क = तत्काल अनुबंध समाप्ति',
    regFileTypeError: 'केवल PDF, JPG, PNG या WEBP अनुमत',
    regFileSizeError: 'प्रत्येक दस्तावेज़ अधिकतम 5MB',
    regFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
    crawlerNoRto: 'क्रॉलर (RTO नहीं)',
    remoteLockAlert: 'Teltonika GPS स्थापित होने के बाद रिमोट लॉक सक्षम होगा। DE सपोर्ट से संपर्क करें।',
    hmrHrs: 'घंटे',
    on: 'चालू',
    off: 'बंद',
    formLabel: 'फॉर्म',
    revenue: 'राजस्व',
    docRcBook: 'RC बुक (RTO पंजीकरण प्रमाणपत्र)',
    docInsurance: 'बीमा प्रमाणपत्र',
    docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
    docIdentity: 'PAN / आधार',
    docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नहीं)',
    docMachineInvoice: 'मशीन खरीद / इनवॉइस',
    docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड व्यू)',
    docInsuranceOptional: 'बीमा / उपकरण कवर (यदि उपलब्ध)',
    pdiCompleted: '✅ PDI / सुरक्षा निरीक्षण पूर्ण',
    pdiInsuranceValid: '✅ बीमा वैध और अद्यतन',
    pdiInsuranceApplicable: '✅ बीमा / कवर (यदि लागू)',
    pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
    valOwnerName: 'मालिक का नाम आवश्यक',
    valPhone: 'वैध फ़ोन नंबर आवश्यक',
    valEmail: 'वैध ईमेल आवश्यक',
    valMobility: 'व्हील्ड या क्रॉलर उपकरण प्रकार चुनें',
    valMachineName: 'मशीन नाम / मॉडल आवश्यक',
    valMachineType: 'उपकरण श्रेणी चुनें',
    valRto: 'व्हील्ड मशीनों के लिए RTO नंबर आवश्यक',
    valYear: 'वैध वर्ष (YYYY) आवश्यक',
    valPdiChecks: 'सभी आवश्यक जांचें पुष्टि करें',
    valPdiRequired: 'PDI पुष्टि आवश्यक',
    valUploadMissing: 'अपलोड करें: {docs}',
    acceptTermsRequired: 'कृपया नियम और शर्तें स्वीकार करें',
    registerMachine: 'अपनी मशीन पंजीकृत करें',
    noMachinesYet: 'अभी कोई मशीन पंजीकृत नहीं',
    noMachinesDashboard: 'अभी कोई मशीन नहीं। फ्लीट जोड़ने के लिए मशीन पंजीकरण करें।',
    bookingsScheduleHint: 'क्लाइंट बुकिंग करने पर दिनवार शेड्यूल यहाँ दिखेगा।',
    paymentBreakdownTitle: 'भुगतान विवरण — अप्रैल 2026',
    bankDetailsTitle: 'बैंक विवरण',
    companyDetailsTitle: 'कंपनी विवरण',
    remoteLockMachine: '🔒 रिमोट लॉक मशीन',
    gpsLiveLabel: '🟢 GPS लाइव',
    noMachinesTrack: 'ट्रैक करने के लिए कोई मशीन नहीं',
    noMachinesTrackHint: 'GPS ट्रैकिंग के लिए मशीन पंजीकृत करें।',
    submittedRegistrations: 'जमा पंजीकरण',
    regSubmitBtn: '✅ पंजीकरण जमा करें',
    changeLanguage: 'भाषा बदलें',
  },

  mr: {
    appName: 'डेव्हलपमेंट एक्सप्रेस',
    tagline: 'पायाभूत सुविधांचा सुवर्ण दर्जा',
    platform: 'बांधकाम व्यवस्थापन प्लॅटफॉर्म',
    selectRole: 'भूमिका निवडा',
    emailAddress: 'ईमेल पत्ता',
    password: 'पासवर्ड',
    signIn: 'साइन इन करा',
    signingIn: 'लॉगिन होत आहे...',
    adminRole: 'ॲडमिन — व्यवस्थापकीय संचालक',
    ownerRole: 'मशीन मालक',
    clientRole: 'ग्राहक (कंत्राटदार)',
    operatorRole: 'ऑपरेटर',
    dashboard: 'डॅशबोर्ड',
    myMachines: 'माझ्या मशीन',
    register: 'मशीन नोंदणी',
    tracking: 'GPS ट्रॅकिंग',
    reports: 'अहवाल',
    alerts: 'लक्ष द्या',
    support: 'मदत',
    home: 'होम',
    attendance: 'हजेरी',
    machineLog: 'मशीन लॉग',
    issues: 'समस्या',
    approvals: 'मंजुरी',
    dlqMonitor: 'DLQ मॉनिटर',
    auditLogs: 'ऑडिट लॉग्स',
    surveyResponses: 'सर्वे उत्तरे',
    surveyReview: 'Survey Review',
    surveyPayout: 'Payout Summary',
    adminSurveyPayoutPageTitle: 'Payout summary',
    adminSurveyPayoutPageSubtitle: 'Freelancer-wise totals, rate, CSV export — export locks approved forms.',
    surveyQr: 'Freelancers',
    adminSurveyPageTitle: 'सर्वे उत्तरे',
    adminSurveyPageSubtitle: 'फील्ड सर्वे डेटा, उत्सुक ग्राहक, ratings आणि CSV export.',
    adminSurveyReviewPageTitle: 'Survey payment review',
    adminSurveyReviewPageSubtitle: 'Payout आधी forms approve/reject (₹30 per approved).',
    adminSurveyQrPageTitle: 'Freelancer registration & approval',
    adminSurveyQrPageSubtitle: 'Field team approve करा, unique ID द्या, survey QR print करा.',
    surveyQrOwnerSurvey: 'मशीन मालक सर्वे',
    surveyQrClientSurvey: 'ग्राहक सर्वे',
    surveyQrSurveyorCode: 'सर्वेयर कोड',
    surveyQrEnterCode: 'सर्वेयर कोड टाका',
    surveyQrPrintPack: 'प्रिंट पॅक',
    surveyQrDownloadOwnerPng: 'मालक PNG डाउनलोड',
    surveyQrDownloadClientPng: 'ग्राहक PNG डाउनलोड',
    surveyQrDownloadPrintCard: 'Print card PDF डाउनलोड',
    surveyQrOwnerPng: 'मालक PNG',
    surveyQrClientPng: 'ग्राहक PNG',
    surveyQrTrackingHint: 'Admin → सर्वे उत्तरे → source=qr-card, surveyor=CODE',
    surveyQrCodeHint: 'Field team code (A–Z, 0–9, max 12). QR links {origin} वर src=qr-card सह.',
    surveyQrCodeLabel: 'कोड',
    surveyQrFreelancerName: 'Freelancer नाव',
    surveyQrFreelancerNameHint: 'Tracking साठी नाव — प्रत्येक freelancer ला वेगळा code.',
    surveyQrUniqueId: 'Unique ID code',
    surveyQrFreelancerPreview: 'नोंद: {name} — ID {code}',
    surveyQrFreelancerActions: 'कृती',
    surveyQrFreelancerOpen: 'उघडा',
    surveyQrDeleteFreelancer: 'Delete',
    surveyQrDeleting: 'Deleting…',
    surveyQrDeleteConfirm: 'Freelancer {name} (ID {code}) काढायचा? List मधून निघेल. जुने survey responses मध्यe code राहील.',
    surveyQrFreelancerDeleted: 'काढले: {name} (ID {code})',
    surveyQrDeleteHint: 'Lead आणत नसलेल्या freelancer ला delete करा. OM01, RAJ02, TEST01 delete होत नाहीत.',
    surveyQrRegistrationTitle: 'Freelancer register (admin)',
    surveyQrRegistrationHint: 'Name + unique ID — save केल्यावर active.',
    surveyQrPendingApproval: 'Pending approval',
    surveyQrNoPending: 'Pending application नाही. Registration link field team ला share करा.',
    surveyQrNoActiveFreelancers: 'अजून active freelancer नाहीत.',
    surveyQrActiveFreelancers: 'Active freelancers',
    surveyQrApplyLinkTitle: 'Public registration link',
    surveyQrApplyLinkHint: 'Freelancers इथे apply करतात — वर approve करा.',
    surveyQrMobile: 'Mobile',
    surveyQrApproveFreelancer: 'Approve',
    surveyQrRejectFreelancer: 'Reject',
    surveyQrApproving: 'Approving…',
    surveyQrFreelancerApproved: 'Approved: ID {code} active झाला.',
    surveyQrRejectConfirm: '{name} (ID {code}) reject करायचा?',
    surveyQrSectionTitle: 'Survey QR print cards',
    surveyQrSaveFreelancer: 'नाव जतन करा',
    surveyQrNewFreelancer: 'नवीन freelancer',
    surveyQrFreelancerList: 'जतन केलेले freelancer',
    surveyQrFreelancerSaved: 'जतन: {name} ({code})',
    surveyQrCodeInvalid: 'फक्त अक्षरे आणि अंक (1–12).',
    surveyQrCodeActive: 'सक्रिय: {code}',
    surveyQrOfficialPack: ' — official print pack',
    surveyQrGenerating: ' — generating…',
    surveyQrOwnerTitle: 'मशीन मालक',
    surveyQrClientTitle: 'ग्राहक',
    surveyQrPresetTitle: 'Pre-made packs: OM01, RAJ02, TEST01',
    surveyQrPresetOfficial: 'Repo मधील print-ready assets — official PNG + PDF',
    surveyQrPresetLive: 'इतर codes: browser मध्यe live QR generate',
    surveyLoading: 'सर्वे उत्तरे लोड होत आहेत…',
    surveyReviewIntroTitle: 'Payment review queue',
    surveyReviewIntroHint: 'Approve valid forms for ₹30 payout. Red = self-survey; yellow = suspicious.',
    surveyReviewFilterPayment: 'Payment status',
    surveyReviewStatusPending: 'Pending',
    surveyReviewStatusApproved: 'Approved',
    surveyReviewStatusRejected: 'Rejected',
    surveyReviewColFlags: 'Fraud flags',
    surveyReviewColPayment: 'Payment',
    surveyReviewApprove: 'Approve',
    surveyReviewReject: 'Reject',
    surveyReviewBulkApprove: 'Approve selected',
    surveyReviewBulkReject: 'Reject selected',
    surveyReviewSelectAll: 'Select all',
    surveyReviewRejectTitle: 'Reject submission',
    surveyReviewRejectHint: 'Reject {n} submission(s).',
    surveyReviewRejectReason: 'Rejection reason',
    surveyReviewConfirmReject: 'Confirm reject',
    surveyReviewCancel: 'Cancel',
    surveyReviewLocked: 'Payout locked',
    surveyReviewEmpty: 'No submissions match.',
    surveyReviewShowAnswers: 'Show answers ▾',
    surveyReviewHideAnswers: 'Hide answers ▴',
    surveyFraud_self_survey: 'Self-survey',
    surveyFraud_cross_freelancer_duplicate: 'Cross duplicate',
    surveyFraud_sequence_pattern: 'Village pattern',
    surveyPayoutIntroTitle: 'Freelancer payout accounting',
    surveyPayoutIntroHint: 'Payable = Unlocked approved × rate (₹30 default). Export CSV locks those rows.',
    surveyPayoutFrom: 'From date',
    surveyPayoutTo: 'To date',
    surveyPayoutRateLabel: 'Rate per form (INR)',
    surveyPayoutSaveRate: 'Save rate',
    surveyPayoutRateSaved: 'Rate saved: ₹{rate} per form',
    surveyPayoutExportCsv: 'Export CSV & lock payout',
    surveyPayoutExporting: 'Exporting…',
    surveyPayoutExportConfirm: 'Export {total} and lock approved forms in this period? Cannot be undone.',
    surveyPayoutExportDone: 'Exported — {n} forms locked. Total: {total}',
    surveyPayoutMissingPaymentTitle: 'Missing Payment Details (skipped)',
    surveyPayoutAddUpiHint: 'Add UPI or bank in Freelancers tab before export.',
    surveyPayoutTotalSubmitted: 'Total submitted',
    surveyPayoutTotalApproved: 'Total approved',
    surveyPayoutTotalPayable: 'Total payable',
    surveyPayoutRatePerForm: 'Rate / form',
    surveyPayoutColSubmitted: 'Submitted',
    surveyPayoutColApproved: 'Approved',
    surveyPayoutColPendingExport: 'Pending payout',
    surveyPayoutColLocked: 'Already paid',
    surveyPayoutColRejected: 'Rejected',
    surveyPayoutColPending: 'Pending',
    surveyPayoutColPayable: 'Payable',
    surveyPayoutColUpi: 'UPI ID',
    surveyPayoutColBank: 'Bank / IFSC',
    surveyPayoutEmpty: 'No submissions in this period.',
    surveyPayoutDateInvalid: 'From date must be on or before To date.',
    surveyPayoutMissing: 'Missing',
    surveyPayoutSkippedTitle: 'Skipped this export (missing UPI/bank)',
    surveyPayoutSkippedLine: '{code}: {n} forms ({total}) skipped — add UPI/bank to include in next export.',
    surveyPayoutMissingHintNonBlocking: 'These freelancers will be skipped until UPI or bank details are added. Others can still be exported.',
    surveyQrUpiId: 'UPI ID (optional)',
    surveyQrBankAccount: 'Bank account (optional)',
    surveyQrBankIfsc: 'IFSC (optional)',
    surveyLoadFailed: 'सर्वे उत्तरे लोड होऊ शकले नाहीत',
    surveyRetry: 'पुन्हा प्रयत्न',
    surveyStatTotal: 'एकूण उत्तरे',
    surveyStatHotLeads: 'उत्सुक ग्राहक',
    surveyStatToday: 'आजची उत्तरे',
    surveyStatTopSource: 'सर्वाधिक स्रोत',
    surveyHotLeadsSection: 'उत्सुक ग्राहक',
    surveyNoHotLeads: 'फिल्टरनुसार उत्सुक ग्राहक नाहीत.',
    surveyFilterType: 'प्रकार',
    surveyFilterHotLead: 'उत्सुक ग्राहक',
    surveyFilterLanguage: 'भाषा',
    surveyFilterSurveyor: 'सर्वेयर',
    surveyFilterPayment: 'Payment status',
    surveyPaymentLegacy: 'Legacy',
    surveyAll: 'सर्व',
    surveyOwner: 'मालक',
    surveyClient: 'ग्राहक',
    surveyHotOnly: 'फक्त उत्सुक ग्राहक',
    surveyCsvExport: 'CSV डाउनलोड',
    surveyCall: 'कॉल',
    surveyColDate: 'तारीख',
    surveyColName: 'नाव',
    surveyColPhone: 'फोन',
    surveyColVillage: 'गाव',
    surveyColType: 'प्रकार',
    surveyColLang: 'भाषा',
    surveyColSource: 'स्रोत',
    surveyColSurveyor: 'सर्वेयर',
    surveyColHot: 'उत्सुक',
    surveyColTrial: 'चाचणी',
    surveyNoMatch: 'फिल्टरनुसार उत्तरे नाहीत.',
    surveyShowing: '{from}–{to} / {total} दाखवत आहे',
    surveyPrev: 'मागे',
    surveyNextPage: 'पुढे',
    surveyTimeJustNow: 'आत्ताच',
    surveyTimeMinutesAgo: '{n} मिनिटांपूर्वी',
    surveyTimeHoursAgo: '{n} तासांपूर्वी',
    surveyTimeDaysAgo: '{n} दिवसांपूर्वी',
    surveyPainTitle: 'Pain ratings (सरासरी 1–5)',
    surveyPainAvg: 'सरासरी: {avg}',
    surveyPainNoData: '{mode} सर्वेसाठी rating डेटा नाही.',
    surveyPainLocation: 'Location',
    surveyPainSideBooking: 'Side booking',
    surveyPainIdling: 'Idling',
    surveyPainLedger: 'हिशोब',
    surveyPainCalls: 'कॉल',
    surveyPainPunctuality: 'वेळ',
    surveyPainRate: 'दर',
    surveyPainHours: 'तास',
    surveyPainBill: 'Bill',
    surveyPainReliability: 'विश्वास',
    loginAs: 'लॉगिन करत आहात',
    mobileNumber: 'मोबाईल नंबर',
    emailAddressLabel: 'ईमेल पत्ता',
    loginPhoneHint: 'Client, Owner आणि Operator लॉगिनसाठी registered mobile number वापरा.',
    loginEmailHint: 'Admin लॉगिनसाठी registered email वापरा.',
    loginFailedGeneric: 'लॉगिन अयशस्वी — कृपया पुन्हा प्रयत्न करा',
    show: 'दाखवा',
    hide: 'लपवा',
    newClientRegister: 'नवीन ग्राहक? येथे नोंदणी करा',
    joinUsBanner: 'मशिनरी भाड्याने हवी आहे?',
    joinUsHint: 'नवीन ग्राहक? JCB, excavator, crane बुक करण्यासाठी विनामूल्य नोंदणी करा.',
    joinUsAction: 'Join Us — विनामूल्य नोंदणी',
    loginModePassword: 'Password',
    loginModeOtp: 'OTP Login',
    loginOtpHint: 'Registered mobile वर 6 अंकी OTP पाठवला जाईल.',
    loginSendOtp: 'OTP पाठवा',
    loginSendingOtp: 'OTP पाठवत आहे...',
    loginVerifyOtp: 'Verify & Sign In',
    loginVerifyingOtp: 'Verify होत आहे...',
    loginOtpSentTo: 'OTP पाठवला:',
    loginOtpDevHint: 'Development: SMS नसेल तर API server log मध्ये OTP पहा.',
    landingHeroLine1: 'Smarter & Simpler.',
    landingHeroLine2: 'महाराष्ट्राचे smart machinery rental.',
    landingCtaApp: 'Development Express Explore करा',
    landingSocialProof: 'Maharashtra मधील builders, contractors आणि fleet owners.',
    landingStatMachines: 'Machines',
    landingStatRating: 'Rating',
    landingTrustLine: 'Wallet-only · GST compliant · Secured',
    landingFeatBook: 'Book in minutes',
    landingFeatBookDesc: 'JCB, excavators, cranes — live availability.',
    landingFeatTrack: 'Live GPS tracking',
    landingFeatTrackDesc: 'Machine location प्रत्येक तास update.',
    landingFeatPay: 'Wallet-only payments',
    landingFeatPayDesc: 'GST invoice, transparent billing.',
    registrationSuccess: 'नोंदणी यशस्वी!',
    registrationPending: 'Admin तुमचे account 24 तासांच्या आत activate करेल.',
    backToLogin: 'लॉगिनकडे परत जा',
    newClientRegistration: 'नवीन ग्राहक नोंदणी',
    cancelAction: 'रद्द करा',
    registerAction: 'नोंदणी करा',
    registering: 'नोंदणी सुरू आहे...',
    forgotPasswordLink: 'पासवर्ड विसरलात?',
    forgotPasswordTitle: 'पासवर्ड रीसेट करा',
    forgotPasswordIntro: 'नोंदणीकृत ईमेलवर सुरक्षित रीसेट लिंक पाठवली जाईल.',
    forgotPasswordPhoneHint: 'नोंदणीकृत मोबाईल नंबर टाका. लिंक खात्यावरील ईमेलवर जाईल.',
    forgotPasswordEmailHint: 'नोंदणीकृत Admin ईमेल टाका.',
    forgotPasswordSubmit: 'रीसेट लिंक पाठवा',
    forgotPasswordSending: 'पाठवत आहे...',
    forgotPasswordSuccess: 'खाते असल्यास, नोंदणीकृत ईमेलवर सूचना पाठवली आहे.',
    forgotPasswordEmailDevHint: 'Local dev: API server च्या terminal मध्ये “Password reset link (development)” URL कॉपी करा.',
    forgotPasswordEmailNextStepTitle: 'ईमेल तपासा',
    forgotPasswordEmailNextStepBody: 'खाते असल्यास, नोंदणीकृत ईमेलवर रीसेट लिंक पाठवली आहे. ती लिंक उघडून नवीन पासवर्ड ठेवा.',
    forgotPasswordEmailNextStepSpam: 'ईमेल आला नाही? Spam folder तपासा किंवा काही मिनिटांनी पुन्हा पाठवा.',
    forgotPasswordEmailStep1: 'ईमेल inbox उघडा',
    forgotPasswordEmailStep2: 'Reset password लिंकवर टॅप करा',
    forgotPasswordEmailStep3: 'पुढच्या स्क्रीनवर नवीन पासवर्ड ठेवा',
    forgotPasswordEmailDevOpenLink: 'रीसेट लिंक उघडा (development)',
    forgotPasswordSendAgain: 'पुन्हा लिंक पाठवा',
    forgotPasswordFailed: 'रीसेट लिंक पाठवता आली नाही. पुन्हा प्रयत्न करा.',
    forgotPasswordInvalidPhone: 'वैध १० अंकी मोबाईल नंबर टाका.',
    forgotPasswordInvalidEmail: 'वैध ईमेल पत्ता टाका.',
    resetPasswordTitle: 'नवीन पासवर्ड ठेवा',
    resetPasswordIntro: 'किमान ८ अक्षरांचा मजबूत पासवर्ड निवडा.',
    resetPasswordSubmit: 'पासवर्ड अपडेट करा',
    resetPasswordUpdating: 'अपडेट होत आहे...',
    resetPasswordSuccess: 'पासवर्ड बदलला. लॉगिनकडे जात आहे...',
    resetPasswordFailed: 'पासवर्ड बदलता आला नाही. नवीन लिंक मागवा.',
    resetPasswordMissingToken: 'रीसेट लिंक चुकीची आहे. लॉगिनवरून Forgot password वापरा.',
    resetPasswordMinLength: 'पासवर्ड किमान ८ अक्षरे असावा.',
    newPassword: 'नवीन पासवर्ड',
    confirmPassword: 'पासवर्ड पुन्हा टाका',
    passwordsMustMatch: 'दोन्ही पासवर्ड एकसारखे असावेत.',
    forgotPasswordChooseMethod: 'पासवर्ड रीसेटसाठी Email link किंवा SMS OTP निवडा.',
    resetMethodEmail: 'Email link',
    resetMethodSms: 'SMS OTP',
    forgotPasswordSmsHint: 'नोंदणीकृत मोबाईल नंबर टाका. ६ अंकी OTP SMS वर येईल.',
    forgotPasswordSmsSuccess: 'खाते असल्यास, नोंदणीकृत मोबाईलवर OTP पाठवला आहे.',
    forgotPasswordSmsFailed: 'OTP पाठवता आला नाही. पुन्हा प्रयत्न करा.',
    forgotPasswordSmsDevHint: 'Development मध्ये OTP server log मध्ये दिसेल (Twilio SMS सेटअप नसेल तर).',
    forgotPasswordSendOtp: 'OTP पाठवा',
    forgotPasswordSendingOtp: 'OTP पाठवत आहे...',
    forgotPasswordInvalidOtp: 'SMS मधला ६ अंकी OTP टाका.',
    forgotPasswordOtpSentTo: 'OTP पाठवला:',
    otpCode: 'OTP कोड',
    changeMobileNumber: 'मोबाईल नंबर बदला',
    dispatched: 'डिस्पॅच झाले',
    pendingDispatch: 'डिस्पॅच प्रलंबित',
    awaitingDispatch: 'डिस्पॅचची प्रतीक्षा',
    cancelBookingPrompt: 'बुकिंग रद्द करायचे?',
    confirmCancel: 'रद्द करणे पुष्टी करा',
    understoodAction: 'समजले',
    directContactProhibitedText: 'थेट संपर्क कडकपणे निषिद्ध',
    walletOnlyPolicyTitle: 'फक्त वॉलेट धोरण',
    walletOnlyPolicyDesc: 'सर्व व्यवहार फक्त वॉलेटद्वारे. रोख स्वीकारले जाणार नाही.',
    approved: 'मंजूर',
    pending: 'प्रलंबित',
    pendingApproval: 'मंजुरी प्रलंबित',
    approveAndDispatch: 'मंजूर करा आणि मशीन डिस्पॅच करा',
    recentAlerts: 'अलीकडील सूचना',
    allAlerts: 'सर्व सूचना',
    contactCompany: 'डेव्हलपमेंट एक्सप्रेसशी संपर्क',
    running: 'चालू',
    stopped: 'बंद',
    assignedStatus: 'नियुक्त',
    cancellationFailed: 'रद्दीकरण अयशस्वी',
    okLabel: 'ठीक आहे',
    presentLabel: 'उपस्थित',
    halfDayLabel: 'अर्धा दिवस',
    absentLabel: 'अनुपस्थित',
    paidLeaveLabel: 'पगारी सुट्टी',
    unpaidLeaveLabel: 'बिनपगारी सुट्टी',
    clockInLabel: 'क्लॉक इन',
    clockOutLabel: 'क्लॉक आउट',
    clockedInAt: 'क्लॉक इन वेळ',
    clockedOutAt: 'क्लॉक आउट वेळ',
    durationLabel: 'कालावधी',
    plQuotaLabel: 'पगारी सुट्टी कोटा',
    plUsed: 'वापरले',
    plAllowed: 'मंजूर',
    plRemaining: 'उरले',
    plQuotaUpdated: 'PL कोटा अद्यतन',
    plQuotaExhausted: 'PL कोटा संपला — बिनपगारी सुट्टी म्हणून नोंद',
    plRemainingLabel: 'उरलेले PL',
    clockInSuccess: 'क्लॉक इन यशस्वी',
    clockOutSuccess: 'क्लॉक आउट यशस्वी',
    attendanceClockSection: 'वेळ टॅग (क्लॉक इन / आउट)',
    attendanceStatusSection: 'आजची स्थिती निवडा',
    fuelStartCol: 'इंधन सुरुवात',
    fuelEndCol: 'इंधन शेवट',
    machineRunningAdmin: 'मशीन चालू (अॅडमिनने सुरू केले)',
    assignedAwaitingStart: 'नियुक्त — अॅडमिन सुरू करण्याची वाट',
    noActiveBooking: 'सक्रिय बुकिंग नाही',
    issueMechanical: 'मेकॅनिकल',
    issueFuel: 'इंधन समस्या',
    issueFuelShort: 'इंधन',
    issueAccident: 'अपघात',
    issueElectrical: 'इलेक्ट्रिकल',
    issueSite: 'साइट समस्या',
    issueOther: 'इतर',
    quickActionsTitle: 'त्वरित क्रिया',
    quickWork: 'काम',
    quickBooking: 'बुकिंग',
    quickIssueBtn: 'समस्या',
    bookingLabel: 'बुकिंग',
    workSiteLabel: 'कामाची साइट',
    fuelUpdated: 'इंधन अपडेट',
    fuelUpdateDefault: 'इंधन अपडेट',
    operatorByLabel: 'ऑपरेटर',
    attendanceMarked: 'हजेरी नोंदली!',
    markTodayAttendance: 'आजची हजेरी नोंदवा:',
    attendanceHistory: 'हजेरी इतिहास',
    fuelLevelSensor: 'इंधन पातळी · Omnicomm सेन्सर',
    fuelOk: 'इंधन ठीक',
    fuelLow: 'इंधन कमी',
    fuelCritical: 'गंभीर!',
    fuelCurrentLabel: 'सध्याचे:',
    issueReportHint: 'कोणतीही मशीन समस्या लगेच रिपोर्ट करा.',
    issueReportSubmit: 'समस्या रिपोर्ट सबमिट',
    loadingAssignment: 'असाइनमेंट लोड होत आहे…',
    noActiveAssignment: 'सक्रिय बुकिंग असाइनमेंट नाही.',
    noActiveAssignmentHint: 'Owner dispatch + Admin Start झाल्यावर live meter आणि Mark Work Complete दिसेल.',
    awaitingAdminStart: 'Admin machine start ची वाट',
    startedAtLabel: 'सुरू:',
    hmrCol: 'HMR',
    cancelText: 'रद्द करा',
    reportText: 'रिपोर्ट',
    loading: 'लोड होत आहे...',
    loadingDashboard: 'डॅशबोर्ड लोड होत आहे...',
    loadMoreBookings: 'अजून बुकिंग लोड करा',
    loadMoreAttendance: 'अजून हजेरी लोड करा',
    loadMoreFuelLogs: 'अजून फ्यूल लॉग लोड करा',
    loadMoreAlerts: 'अजून alerts लोड करा',
    loadMoreMachines: 'अजून machines लोड करा',
    loadMoreUsers: 'अजून users लोड करा',
    loadMoreDlq: 'अजून DLQ लोड करा',
    loadMoreLogs: 'अजून logs लोड करा',
    loadMoreTransactions: 'अजून transactions लोड करा',
    retryText: 'पुन्हा प्रयत्न',
    confirmRetry: 'पुन्हा प्रयत्न पुष्टी करा',
    resetText: 'रीसेट',
    nextText: 'पुढे',
    exportCsv: 'CSV एक्सपोर्ट',
    clearAll: 'सर्व साफ करा',
    todayText: 'आज',
    noDlqItems: 'DLQ items नाहीत',
    retryDlqItemTitle: 'DLQ आयटम पुन्हा प्रयत्न',
    retryReasonAuditPlaceholder: 'पुन्हा प्रयत्न कारण (ऑडिटसाठी)',
    retryFailedForDlq: 'DLQ आयटमसाठी पुन्हा प्रयत्न अयशस्वी',
    topSourceIp: 'टॉप सोर्स IP',
    attemptsLabel: 'प्रयत्न',
    noRecentFailedLogins: 'अलीकडे failed login प्रयत्न नाहीत.',
    failedText: 'अयशस्वी',
    unknownText: 'अज्ञात',
    refreshText: 'रिफ्रेश',
    refreshingText: 'रिफ्रेश होत आहे...',
    lastRefreshed: 'शेवटचा रिफ्रेश',
    neverText: 'कधीच नाही',
    staleText: 'जुने',
    liveText: 'लाइव्ह',
    acknowledgeText: 'स्वीकारा',
    acknowledgedText: 'स्वीकारले',
    allowedText: 'परवानगी',
    blockedText: 'ब्लॉक',
    activeBucketsText: 'अॅक्टिव्ह बकेट्स',
    blockedRateText: 'ब्लॉक रेट',
    alertText: 'अलर्ट',
    normalText: 'नॉर्मल',
    chipAction: 'action',
    chipActor: 'actor',
    chipRole: 'role',
    chipEntity: 'entity',
    chipMeta: 'meta',
    chipFrom: 'from',
    chipTo: 'to',
    noMoreAuditLogs: 'सध्याच्या filters साठी आणखी audit logs नाहीत.',
    highTrend: 'HIGH ट्रेंड',
    mediumTrend: 'MEDIUM ट्रेंड',
    hitsText: 'हिट्स',
    burstText: 'बर्स्ट',
    loadedDlqItems: 'लोड झालेले DLQ items',
    moreAvailable: 'अजून उपलब्ध',
    allLoaded: 'सर्व लोड झाले',
    loadedBookings: 'लोड झालेल्या बुकिंग्स',
    loadedFuelLogs: 'लोड झालेले फ्यूल लॉग्स',
    availableMachinery: 'उपलब्ध मशिनरी',
    bookingCostCalculator: 'बुकिंग आणि खर्च कॅल्क्युलेटर',
    selectedMachineText: 'निवडलेली मशीन',
    bookingTypeText: 'बुकिंग प्रकार',
    grandTotalText: 'एकूण रक्कम',
    minAdvanceRequired: 'किमान अग्रिम आवश्यक',
    advanceRequired50Pct: 'अग्रिम आवश्यक (50%)',
    advance50PctHint: 'एकूण रकमेच्या (GST सह) 50% पुष्टी केल्यावर वॉलेटमधून वजा होईल.',
    advance50PctShort: '50% अग्रिम',
    rechargeShortfall: 'रिचार्ज — ₹{amount} कमी',
    walletRechargeMinHint: 'UPI/कार्ड ₹1 पासून. NEFT/IMPS किमान ₹5,000.',
    minimumBankRecharge: 'NEFT/IMPS किमान हस्तांतरण ₹5,000',
    noBookingsYet: 'अजून बुकिंग नाही',
    bookingScheduleSummary: 'दिवस आणि महिन्यानुसार बुकिंग शेड्यूल',
    operatorFeedbackTitle: 'ऑपरेटर फीडबॅक',
    rateOperatorWork: 'ऑपरेटरचे काम रेट करा (1–5 तारे)',
    operatorSatisfactionQuestion: 'ऑपरेटरच्या कामाने तुम्ही समाधानी आहात का?',
    satisfiedYes: 'होय, समाधानी',
    satisfiedNo: 'समाधानी नाही',
    operatorSuggestionPlaceholder: 'सूचना किंवा फीडबॅक (पर्यायी)',
    submitOperatorFeedback: 'फीडबॅक पाठवा',
    operatorFeedbackSubmitted: 'तुमचा फीडबॅक',
    operatorFeedbackSaved: 'धन्यवाद! तुमचा फीडबॅक जतन झाला.',
    feedbackAfterDispatch: 'मशीन डिस्पॅच झाल्यानंतर ऑपरेटर रेटिंग उपलब्ध होईल.',
    monthMachineSummary: 'या महिन्यातील मशीन',
    monthTotalLabel: 'महिन्याचे एकूण',
    dayMachinesLabel: 'मशीन',
    tableMonth: 'महिना',
    tableDay: 'दिवस',
    totalAdvanceLabel: 'अग्रिम भरले',
    advancePaidLabel: 'अग्रिम',
    machineLabel: 'मशीन',
    operatorFeedbackColumn: 'ऑपरेटर फीडबॅक',
    feedbackStatusAfterDispatch: 'डिस्पॅच नंतर',
    feedbackStatusRateNow: 'ऑपरेटर रेट करा ↓',
    expandBookingHint: 'संपूर्ण बुकिंग, cancel आणि ऑपरेटर रेटिंगसाठी खाली महिना/दिवस विभाग expand करा.',
    clientFeedbackLabel: 'ग्राहक फीडबॅक',
    awaitingClientFeedback: 'ग्राहक फीडबॅकची प्रतीक्षा',
    clientRatingsTitle: 'ग्राहक रेटिंग आणि सूचना',
    noClientFeedbackYet: 'अजून ग्राहक रेटिंग नाही. डिस्पॅच नंतर ग्राहक फीडबॅक येथे दिसेल.',
    myClientRating: 'माझी ग्राहक रेटिंग',
    scheduleColType: 'प्रकार',
    scheduleColQty: 'Qty',
    duration: 'कालावधी',
    cycles: 'सायकल',
    bookingClosed: 'बंद',
    sectionNew: 'नवीन',
    sectionAccepted: 'स्वीकृत',
    sectionActive: 'सक्रिय',
    sectionDispatched: 'डिस्पॅच',
    sectionCompleting: 'पूर्ण होत आहे',
    sectionDisputed: 'विवादित',
    sectionCompleted: 'पूर्ण',
    sectionClosed: 'बंद',
    scheduleColTotal: 'एकूण',
    scheduleColFeedback: 'फीडबॅक',
    bookMachineAction: 'मशीन बुक करा',
    bookingReportTitle: 'बुकिंग रिपोर्ट',
    transactionHistoryTitle: 'व्यवहार इतिहास',
    walletRechargeTitle: 'वॉलेट रिचार्ज',
    payNowText: 'आता पेमेंट करा',
    dailyWorkReport: 'दैनिक कामाचा रिपोर्ट',
    issueReportTitle: 'इश्यू रिपोर्ट',
    pastIssuesTitle: 'मागील इश्यूज',
    fuelLevelUpdate: 'फ्यूल लेव्हल अपडेट',
    quickIssueReport: 'क्विक इश्यू रिपोर्ट',
    tableId: 'आयडी',
    tableIn: 'इन',
    tableOut: 'आउट',
    tableLevel: 'लेव्हल',
    tableChange: 'बदल',
    tableNote: 'नोट',
    tableAtt: 'अट',
    tableStart: 'सुरू',
    tableEnd: 'समाप्त',
    tableHrs: 'तास',
    totalSpent: 'एकूण खर्च',
    machineHours: 'मशीन तास',
    totalBookingsText: 'एकूण बुकिंग्स',
    gstInvoices: 'GST इन्वॉइस',
    confirmBookingAction: 'बुकिंगची पुष्टी करा',
    updateText: 'अपडेट करा',
    updateFuel: 'फ्यूल अपडेट करा',
    ownerPortal: 'ओनर पोर्टल',
    clientPortal: 'ग्राहक पोर्टल',
    operatorPortal: 'ऑपरेटर पोर्टल',
    portalWelcome: 'स्वागत',
    portalWelcomeHint: 'पुढे जाण्यासाठी तुमचा पोर्टल निवडा',
    portalClient: 'ग्राहक',
    portalClientSub: 'मशिनरी बुक करा',
    portalOwner: 'मालक',
    portalOwnerSub: 'फ्लीट व्यवस्थापन',
    portalNewClientRegister: 'नवीन ग्राहक? नोंदणी',
    portalNewOwnerRegister: 'नवीन मालक? नोंदणी',
    portalStaffOperator: 'ऑपरेटर',
    portalStaffAdmin: 'ॲडमिन',
    portalBackLink: 'पोर्टल',
    loginRoleClientShort: 'ग्राहक',
    loginRoleOwnerShort: 'मालक',
    loginTabPassword: 'पासवर्ड',
    loginTabOtp: 'OTP',
    loginSignInShort: 'साइन इन',
    loginNewHereRegister: 'नवीन? नोंदणी करा',
    loginChangeRole: 'भूमिका बदला',
    loginClientPortalSubtitle: 'बांधकाम मशिनरी बुक करण्यासाठी साइन इन',
    loginOwnerPortalSubtitle: 'फ्लीट आणि नोंदणी व्यवस्थापनासाठी साइन इन',
    regMachineInfoTitle: 'मशीन माहिती',
    regMachineIntro: 'फक्त बांधकाम heavy equipment — truck/transport नाही. Wheeled (JCB 3DX) साठी RTO; Crawler (Poclain/excavator) साइटवर — RTO passing नाही.',
    regMachineCategory: 'मशीन प्रकार *',
    regEquipmentCategory: 'उपकरणाचा प्रकार *',
    regSelectType: 'प्रकार निवडा…',
    regMachineNameModel: 'मशीन नाव / मॉडेल',
    regRtoNumber: 'RTO नोंदणी क्रमांक *',
    regFleetIdOptional: 'Fleet / chassis ID (ऐच्छिक)',
    regYearManufacture: 'उत्पादन वर्ष *',
    regCapacitySpecs: 'क्षमता / तपशील',
    machineFinancialSection: 'मशीन खरेदी तपशील (ऐच्छिक)',
    machineOwnershipType: 'मालकी प्रकार',
    machineOwnershipNew: 'नवीन मशीन',
    machineOwnershipUsed: 'मूळ मालक',
    machineOwnershipSecondHand: 'पूर्व-स्वामित्व',
    machinePurchasePrice: 'खरेदी किंमत (₹)',
    machinePurchasePriceHint: 'या मशीनसाठी तुम्ही भरलेली रक्कम',
    machinePurchaseDate: 'खरेदी तारीख',
    machineYearOfManufacture: 'उत्पादन वर्ष',
    machineLoanSection: 'या मशीनवर माझे loan आहे',
    machineLoanAmount: 'Loan रक्कम (₹)',
    machineLoanEmi: 'मासिक EMI (₹)',
    machineLoanTenure: 'Loan कालावधी (महिने)',
    machineLoanStartDate: 'Loan सुरू तारीख',
    machineFuelConsumption: 'इंधन वापर (L/hr)',
    machineMonthlyOperatingExpenses: 'मासिक परिचालन खर्च',
    machineOperatorMonthlySalary: 'ऑपरेटर मासिक पगार',
    machineServiceMonthly: 'सर्व्हिस / देखभाल (मासिक)',
    machineBreakdownMonthly: 'बिघाड / दुरुस्ती (मासिक सरासरी)',
    machineMaterialsMonthly: 'साहित्य / उपभोग्य वस्तू (मासिक)',
    recoveryPlan: 'रिकव्हरी प्लॅन',
    recoveryOnTrack: 'योग्य मार्गावर',
    recoveryNeedsAttention: 'लक्ष द्या',
    recoveryActionRequired: 'कारवाई आवश्यक',
    recoveryAddPrice: 'रिकव्हरी प्लॅन पाहण्यासाठी खरेदी किंमत जोडा',
    recoveryProgress: 'गुंतवणूक परतफेड',
    recoveryDailyNet: 'दैनिक निव्वळ उत्पन्न',
    recoveryDays: 'परतावा कालावधी',
    recoveryProjectedDate: 'अपेक्षित परतावा तारीख',
    recoveryRoi: 'वार्षिक परतावा',
    recoveryCurrentValue: 'सध्याचे यंत्र मूल्य',
    recoveryBackfillNudge: 'रिकव्हरी ट्रॅकिंग अनलॉक करण्यासाठी {{count}} मशीन(ना) मध्ये खरेदी तपशील जोडा',
    editFinancialDetails: 'आर्थिक तपशील संपादित करा',
    financialDetailsSaved: 'आर्थिक तपशील जतन केले',
    dieselPriceTitle: 'डिझेल किंमत',
    dieselPriceUpdate: 'डिझेल किंमत अपडेट करा',
    dieselPriceLatest: 'नवीनतम किंमत',
    dieselPriceNoRecord: 'डिझेल किंमत नोंदवलेली नाही',
    dieselPricePerLitre: 'प्रति लिटर किंमत (₹)',
    dieselQuantity: 'भरलेले प्रमाण (लिटर)',
    dieselTaluka: 'शहर / भाग',
    dieselFuelCostPerHour: 'प्रति तास इंधन खर्च',
    dieselPercentOfRate: 'तुमच्या तासाच्या दराचा',
    dieselPriceSaved: 'डिझेल किंमत जतन केली',
    dieselRateSuggestion: 'दर सूचना',
    dieselRateIncrease: 'डिझेल वाढले — दर वाढवण्याचा विचार करा',
    dieselRateDecrease: 'डिझेल कमी — बुकिंगसाठी दर कमी करा',
    dieselSuggestedRate: 'सुचवलेली दर',
    dieselHistory: 'किंमत इतिहास',
    dieselNoHistory: 'अद्याप डिझेल किंमत इतिहास नाही',
    dieselColDate: 'तारीख',
    dieselColPrice: 'किंमत/लिटर',
    dieselColQty: 'प्रमाण',
    dieselColSource: 'स्रोत',
    dieselUploadReceipt: 'पावती अपलोड करा',
    dieselExtractSuccess: 'पावतीवरून काढले',
    dieselExtractFailed: 'काढता आले नाही — कृपया स्वहस्ते प्रविष्ट करा',
    applyRateSuggestion: '₹{{rate}}/तास लागू करा',
    rateSuggestionApplied: 'दर यशस्वीरित्या अपडेट झाली',
    marketPosition: 'बाजार स्थिती',
    marketBelowMarket: 'बाजारपेक्षा कमी',
    marketCompetitive: 'स्पर्धात्मक',
    marketAboveMarket: 'बाजारपेक्षा जास्त',
    marketNoData: 'तुमच्या भागासाठी अद्याप बाजार डेटा नाही',
    marketSubmitRate: 'बाजार दर सादर करा',
    marketCity: 'शहर / भाग',
    marketMinRate: 'तुमच्या भागात किमान दर (₹/तास)',
    marketMaxRate: 'तुमच्या भागात कमाल दर (₹/तास)',
    marketRateSubmitted: 'बाजार दर सादर झाली — धन्यवाद!',
    marketDataPoints: '{{count}} सादरांवर आधारित',
    marketRange: '{{city}} मध्ये बाजार',
    marketSourceLocal: '{{city}} भागातील दरांवर आधारित',
    marketSourcePlatform: 'प्लॅटफॉर्म-व्यापी दरांवर आधारित',
    regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
    regMobilityWheeled: 'व्हील्ड (चाकांवर)',
    regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — बांधकाम उपकरण, RTO (RC) लागते',
    regMobilityTracked: 'क्रॉलर (चेन)',
    regMobilityTrackedHint: 'Poclain (chain excavator), dozer — साइटवर, RTO passing नाही',
    regTagRto: 'RTO',
    regTagNoRto: 'RTO नाही',
    sinceExcellence: '2011 पासून · 15 वर्षे उत्कृष्टता',
    machineStatusTitle: 'मशीन स्थिती',
    machineRegistrationTitle: 'मशीन नोंदणी',
    paymentHistoryTitle: 'पेमेंट इतिहास',
    callNow: 'आता कॉल करा',
    officeLabel: 'ऑफिस',
    securitySignalsTitle: 'सुरक्षा सिग्नल्स',
    rateLimitTelemetryTitle: 'रेट लिमिट टेलिमेट्री',
    apiSloAlertsTitle: 'API SLO अलर्ट्स',
    noRecentApiSloBreach: 'अलीकडे API SLO breach सिग्नल नाहीत.',
    apiHealthTitle: 'API हेल्थ',
    sloHealthy: 'SLO हेल्दी',
    sloBreachRisk: 'SLO breach धोका',
    recentFailedLoginsTitle: 'अलीकडील failed logins',
    noSecuritySignalsFound: 'सुरक्षा सिग्नल्स सापडले नाहीत.',
    machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत verify करेल.',
    issueReportedSuccess: 'Issue यशस्वीपणे report झाला!',
    paymentSuccess: 'Payment यशस्वी!',
    paymentFailed: 'Payment अयशस्वी! पुन्हा प्रयत्न करा.',
    minimumRecharge: 'UPI/कार्ड/QR साठी किमान ₹1.',
    bookMachine: 'मशीन बुक करा',
    newBooking: 'नवीन बुकिंग',
    bookingStepChoose: 'मशीन निवडा',
    bookingStepCost: 'खर्च आणि तारीख',
    bookingStepConfirm: 'Confirm आणि Pay',
    changeMachine: 'मशीन बदला',
    bookingSelectMachineFirst: 'पुढे जाण्यासाठी fleet मधून machine निवडा.',
    costCalculator: 'खर्च कॅल्क्युलेटर',
    myBookings: 'माझ्या बुकिंग',
    liveTracking: 'लाइव्ह ट्रॅकिंग',
    wallet: 'वॉलेट',
    overview: 'आढावा',
    machines: 'मशीन्स',
    clients: 'ग्राहक',
    owners: 'मालक',
    operators: 'ऑपरेटर',
    billingWallet: 'वॉलेट आणि बिलिंग',
    iot: 'IoT आणि GPS',
    logout: 'लॉगआउट',
    active: 'कार्यरत',
    idle: 'निष्क्रिय',
    available: 'उपलब्ध',
    busy: 'व्यस्त',
    locked: 'लॉक',
    live: 'लाइव्ह',
    totalMachines: 'एकूण मशीन',
    activeToday: 'आज कार्यरत',
    walletBalance: 'वॉलेट शिल्लक',
    activeBookings: 'सक्रिय बुकिंग',
    recharge: 'रिचार्ज',
    rechargeWallet: '+ वॉलेट रिचार्ज',
    payNow: 'आता पैसे द्या',
    confirm: 'पुष्टी करा',
    cancel: 'रद्द करा',
    back: 'मागे जा',
    download: 'डाउनलोड',
    submit: 'सबमिट करा',
    save: 'जतन करा',
    perHour: 'प्रति तास',
    perDay: 'प्रति दिवस',
    perWeek: 'प्रति आठवडा',
    perMonth: 'प्रति महिना',
    advance: 'अग्रिम',
    commission: 'कमिशन',
    netPayable: 'निव्वळ देय',
    grossBilling: 'एकूण बिलिंग',
    bookNow: 'आत्ता बुक करा',
    confirmBooking: 'बुकिंग पुष्टी करा',
    cancelBooking: 'बुकिंग रद्द करा',
    machineStatus: 'मशीन स्थिती',
    fuelLevel: 'इंधन पातळी',
    condition: 'स्थिती',
    location: 'स्थान',
    operator: 'ऑपरेटर',
    experience: 'अनुभव',
    rating: 'रेटिंग',
    hours: 'तास',
    days: 'दिवस',
    weeks: 'आठवडे',
    months: 'महिने',
    gstInvoice: 'GST बीजक',
    bookingHistory: 'बुकिंग इतिहास',
    paymentHistory: 'देयक इतिहास',
    noAlerts: 'कोणती सूचना नाही!',
    allMachinesOk: 'सर्व मशीन व्यवस्थित चालू आहेत.',
    lockMachine: 'मशीन लॉक करा',
    machineReg: 'मशीन नोंदणी फॉर्म',
    ownerInfo: 'मालकाची माहिती',
    machineInfo: 'मशीनची माहिती',
    pdiInfo: 'PDI तपासणी',
    documents: 'कागदपत्रे अपलोड',
    agreement: 'अटी आणि करार',
    selectFile: 'फाइल निवडा',
    walletOnly: 'फक्त वॉलेट · रोख स्वीकारले जाणार नाही',
    noRefund: 'परतावा नाही नीती',
    cancelPolicy: 'रद्दीकरण नीती',
    whatsapp: 'WhatsApp',
    email: 'ईमेल मदत',
    send: 'पाठवा',
    year: 'वर्ष',
    total: 'एकूण',
    tax: 'कर',
    status: 'स्थिती',
    type: 'प्रकार',
    date: 'तारीख',
    machine: 'मशीन',
    client: 'ग्राहक',
    hmrToday: 'आजचे HMR',
    hmrTotal: 'एकूण HMR',
    earnings: 'कमाई',
    amount: 'रक्कम',
    ref: 'संदर्भ क्रमांक',
    fuel: 'इंधन',
    ignition: 'इग्निशन',
    speed: 'वेग',
    completedBookings: 'पूर्ण बुकिंग',
    instantCost: 'त्वरित खर्च कॅल्क्युलेटर',
    baseAmount: 'मूळ रक्कम',
    gst18: 'GST (१८%)',
    grandTotal: 'एकूण बेरीज',
    minimumAdvance: 'किमान अग्रिम आवश्यक',
    selectMachineFirst: 'आधी मशीन निवडा',
    viewMachines: '→ मशीन बघा',
    bookingConfirm: 'बुकिंग पुष्टी करा',
    walletDeduct: '50% अग्रिम वॉलेटमधून · रोख नाही · काम पूर्ण झाल्यावर GST बीजक',
    noBookings: 'कोणतीही सक्रिय बुकिंग नाही',
    goBook: '→ मशीन बुक करा',
    completeBookings: 'पूर्ण झालेल्या बुकिंग',
    transactions: 'व्यवहार इतिहास',
    customAmount: 'कस्टम रक्कम (UPI/कार्ड ₹1 पासून)',
    paymentMethods: 'देयक पद्धती',
    alertLog: 'अलर्ट लॉग',
    sendWhatsapp: 'WhatsApp वर पाठवा',
    sendEmail: 'ईमेल पाठवा',
    yourMessage: 'तुमचा प्रश्न किंवा अडचण लिहा...',
    importantInfo: 'मशीन मालकांसाठी महत्त्वाची माहिती',
    machineDetails: 'मशीन आणि ऑपरेटर तपशील',
    liveCamera: '३६०° लाइव्ह कॅमेरा — बुकिंगनंतर',
    liveBookAvail: 'बुकिंगनंतर लाइव्ह फीड उपलब्ध',
    rateCard: 'दर पत्रक (ऑपरेटरसह)',
    selectBook: 'ही मशीन बुक करा →',
    selectCalc: '📋 निवडा आणि खर्च बघा →',
    bookingType: 'बुकिंग प्रकार निवडा',
    selectQty: 'प्रमाण निवडा',
    walletSufficient: '✅ पुढे जा',
    walletInsufficient: '❌ अपुरी शिल्लक',
    rechargeFirst: '⚡ आधी वॉलेट रिचार्ज करा',
    cancelWarning: 'तुम्हाला रद्द करायचे आहे का?',
    noBankRefund: '❌ बँक परतावा नाही — फक्त वॉलेट क्रेडिट',
    walletCredit: 'वॉलेट क्रेडिट',
    penaltyDeduct: 'रद्दीकरण दंड (१ तास)',
    blacklistWarning: '⛔ ब्लॅकलिस्ट चेतावणी',
    directContactProhibited: 'थेट संपर्क कठोरपणे निषिद्ध',
    understood: '✅ समजले — प्लॅटफॉर्म वापरेन',
    lockWarning: 'Teltonika GPS द्वारे मशीनचे इग्निशन रिमोटली बंद होईल.',
    lockConfirm: '🔒 लॉक पुष्टी करा',
    allStats: 'संपूर्ण आकडेवारी',
    marketingBadge: 'लाइव ऑपरेशन्स · कराड, सातारा',
    marketingNavServices: 'सेवा',
    marketingNavTech: 'तंत्रज्ञान',
    marketingNavContact: 'संपर्क',
    marketingNavLogin: 'प्लॅटफॉर्म लॉगिन →',
    marketingHeadline: 'महाराष्ट्रातील अग्रगण्य मशीनरी भाडे प्लॅटफॉर्म',
    marketingLead:
      'रिअल-टाइम GPS, डिजिटल वॉलेट देयके आणि बांधकाम मशीनरीसाठी स्वयंचलित ऑपरेशन्स. २०११ पासून सेवेत.',
    marketingCtaLogin: 'Development Express उघडा — लॉगिन',
    marketingCtaBook: 'मशीन बुक करा',
    marketingCtaWhatsApp: 'WhatsApp',
    marketingStatYears: 'वर्षे अनुभव',
    marketingStatFleet: 'लाइव्ह मशीन',
    marketingStatDigital: 'डिजिटल देयके',
    marketingServicesTitle: 'आम्ही काय देतो',
    marketingSvcTrack: 'GPS आणि लाइव्ह स्थिती',
    marketingSvcTrackSub: 'Teltonika शी जोडलेली फ्लीट दृश्यता.',
    marketingSvcPay: 'फक्त वॉलेट पेमेंट',
    marketingSvcPaySub: 'GST बीजक — साइटवर रोख नाही.',
    marketingSvcOps: 'पूर्ण ऑपरेशन्स',
    marketingSvcOpsSub: 'मालक, ऑपरेटर, ग्राहक — एकच प्लॅटफॉर्म.',
    marketingTechLead:
      'Development Express बुकिंग, अनुपालन आणि फील्ड टेलिमेट्री एकाच वर्कफ्लोमध्ये जोडते.',
    marketingFooterRights: '२०२६ डेव्हलपमेंट एक्सप्रेस · कराड, सातारा',
    marketingBackHome: 'वेबसाइट मुखपृष्ठ',
    drawerMenu: 'मेनू',
    fullName: 'पूर्ण नाव',
    phone: 'फोन',
    netEarnedMonth: 'नेट कमाई (महिना)',
    netReceived: 'नेट प्राप्त',
    commission15: 'प्लॅटफॉर्म कमिशन',
    tdsGstTcs: 'TDS 2% + GST TCS 1%',
    netReceivedCaps: 'नेट प्राप्त',
    commissionPaid: 'कमिशन भरले',
    settlements: 'सेटलमेंट',
    receiptId: 'पावती ID',
    gross: 'एकूण',
    tdsTcs: 'TDS+TCS',
    netPaid: 'नेट भरले',
    bank: 'बँक',
    accountNumber: 'खाते क्रमांक',
    ifsc: 'IFSC',
    paymentMode: 'पेमेंट मोड',
    neftRtgs: 'NEFT/RTGS',
    company: 'कंपनी',
    md: 'MD',
    gstin: 'GSTIN',
    sinceLabel: 'पासून',
    paymentCycle: 'पेमेंट चक्र',
    commissionRate: 'एकूण बिलिंगवरील प्लॅटफॉर्म शुल्क',
    threeWorkingDays: '3 कार्य दिवस',
    pdiTitle: 'प्री-डिलिव्हरी तपासणी (PDI)',
    pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) लागत नाही — RTO नोंदणी नाही.',
    documentUploadTitle: 'कागदपत्रे अपलोड',
    regDocWheeledHint: 'व्हील्ड: RC (RTO), विमा, PUC आणि ID (जास्तीत जास्त 5MB).',
    regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरेदी इन्वॉइस, फोटो आणि ID. विमा ऐच्छिक.',
    optionalLabel: '(ऐच्छिक)',
    noFileSelected: 'फाइल निवडलेली नाही',
    replaceFile: 'बदला',
    uploadFile: 'अपलोड',
    platformAgreement: 'प्लॅटफॉर्म करार',
    agreeTermsCheckbox: 'मी सर्व अटी वाचल्या आहेत आणि मान्य आहेत',
    termCommission: 'Development Express प्लॅटफॉर्म शुल्क: एकूण बिलिंगवर',
    termTds: 'TDS कपात: आयकर कायद्यानुसार 2%',
    termGstTcs: 'GST TCS: GST नियमांनुसार 1%',
    termPaymentDays: 'ग्राहक सेटलमेंटनंतर 3 कार्य दिवसांत पेमेंट',
    termFuel: 'मशीनमध्ये नेहमी 40%+ इंधन ठेवा',
    termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारे बसवले',
    termNoDirectContact: 'थेट ग्राहक संपर्क = त्वरित करार रद्द',
    regFileTypeError: 'फक्त PDF, JPG, PNG किंवा WEBP परवानगी',
    regFileSizeError: 'प्रत्येक दस्तावेज जास्तीत जास्त 5MB',
    regFailed: 'नोंदणी अयशस्वी. पुन्हा प्रयत्न करा.',
    crawlerNoRto: 'क्रॉलर (RTO नाही)',
    remoteLockAlert: 'Teltonika GPS बसवल्यानंतर रिमोट लॉक सक्षम होईल. DE सपोर्टशी संपर्क करा.',
    hmrHrs: 'तास',
    on: 'चालू',
    off: 'बंद',
    formLabel: 'फॉर्म',
    revenue: 'उत्पन्न',
    docRcBook: 'RC बुक (RTO नोंदणी प्रमाणपत्र)',
    docInsurance: 'विमा प्रमाणपत्र',
    docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
    docIdentity: 'PAN / आधार',
    docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नाही)',
    docMachineInvoice: 'मशीन खरेदी / इन्वॉइस',
    docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड)',
    docInsuranceOptional: 'विमा / उपकरण कव्हर (उपलब्ध असल्यास)',
    pdiCompleted: '✅ PDI / सुरक्षा तपासणी पूर्ण',
    pdiInsuranceValid: '✅ विमा वैध आणि अद्ययावत',
    pdiInsuranceApplicable: '✅ विमा / कव्हर (लागू असल्यास)',
    pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
    valOwnerName: 'मालकाचे नाव आवश्यक',
    valPhone: 'वैध फोन नंबर आवश्यक',
    valEmail: 'वैध ईमेल आवश्यक',
    valMobility: 'व्हील्ड किंवा क्रॉलर उपकरण प्रकार निवडा',
    valMachineName: 'मशीन नाव / मॉडेल आवश्यक',
    valMachineType: 'उपकरण श्रेणी निवडा',
    valRto: 'व्हील्ड मशीनसाठी RTO नंबर आवश्यक',
    valYear: 'वैध वर्ष (YYYY) आवश्यक',
    valPdiChecks: 'सर्व आवश्यक तपासण्या पुष्टी करा',
    valPdiRequired: 'PDI पुष्टी आवश्यक',
    valUploadMissing: 'अपलोड करा: {docs}',
    acceptTermsRequired: 'कृपया अटी स्वीकारा',
    registerMachine: 'तुमची मशीन नोंदवा',
    noMachinesYet: 'अजून मशीन नोंदणी झालेली नाही',
    noMachinesDashboard: 'अजून मशीन नाही. फ्लीट जोडण्यासाठी मशीन नोंदणी करा.',
    bookingsScheduleHint: 'ग्राहक बुकिंग केल्यावर दिवसानुसार वेळापत्रक येथे दिसेल.',
    paymentBreakdownTitle: 'पेमेंट तपशील — एप्रिल 2026',
    bankDetailsTitle: 'बँक तपशील',
    companyDetailsTitle: 'कंपनी तपशील',
    remoteLockMachine: '🔒 रिमोट लॉक मशीन',
    gpsLiveLabel: '🟢 GPS लाइव्ह',
    noMachinesTrack: 'ट्रॅक करण्यासाठी मशीन नाही',
    noMachinesTrackHint: 'GPS ट्रॅकिंगसाठी मशीन नोंदणी करा.',
    submittedRegistrations: 'सबमिट केलेली नोंदणी',
    regSubmitBtn: '✅ नोंदणी सबमिट करा',
    changeLanguage: 'भाषा बदला',
  },

  gu: {
    appName: 'ડેવલપમેન્ટ એક્સપ્રેસ',
    tagline: 'ઈન્ફ્રાસ્ટ્રક્ચરનો સુવર્ણ ધોરણ',
    platform: 'બાંધકામ વ્યવસ્થાપન પ્લેટફોર્મ',
    selectRole: 'ભૂમિકા પસંદ કરો',
    emailAddress: 'ઈ-મેઈલ સરનામું',
    password: 'પાસવર્ડ',
    signIn: 'સાઈન ઈન કરો',
    signingIn: 'લૉગિન થઈ રહ્યું છે...',
    adminRole: 'એડમિન — મેનેજિંગ ડિરેક્ટર',
    ownerRole: 'મશીન માલિક',
    clientRole: 'ક્લાઈન્ટ (કોન્ટ્રાક્ટર)',
    operatorRole: 'ઓપરેટર',
    sinceLabel: 'થી',
    dashboard: 'ડેશબોર્ડ',
    myMachines: 'મારી મશીનો',
    register: 'મશીન નોંધણી',
    tracking: 'GPS ટ્રેકિંગ',
    reports: 'રિપોર્ટ',
    alerts: 'સૂચનાઓ',
    support: 'સહાય',
    bookMachine: 'મશીન બુક કરો',
    costCalculator: 'ખર્ચ કૅલ્ક્યુલેટર',
    myBookings: 'મારી બુકિંગ',
    liveTracking: 'લાઈવ ટ્રેકિંગ',
    wallet: 'વૉલેટ',
    overview: 'ઝાંખી',
    machines: 'મશીનો',
    clients: 'ગ્રાહકો',
    owners: 'માલિકો',
    operators: 'ઓપરેટરો',
    billingWallet: 'વૉલેટ અને બિલિંગ',
    iot: 'IoT અને GPS',
    logout: 'લૉગઆઉટ',
    active: 'સક્રિય',
    idle: 'નિષ્ક્રિય',
    available: 'ઉપલબ્ધ',
    busy: 'વ્યસ્ત',
    locked: 'લૉક',
    live: 'લાઈવ',
    totalMachines: 'કુલ મશીનો',
    activeToday: 'આજે સક્રિય',
    walletBalance: 'વૉલેટ બૅલેન્સ',
    activeBookings: 'સક્રિય બુકિંગ',
    recharge: 'રિચાર્જ',
    rechargeWallet: '+ વૉલેટ રિચાર્જ',
    payNow: 'હવે ચૂકવો',
    confirm: 'પુષ્ટિ કરો',
    cancel: 'રદ કરો',
    back: 'પાછા જાઓ',
    download: 'ડાઉનલોડ',
    submit: 'સબમિટ કરો',
    save: 'સાચવો',
    perHour: 'દર કલાક',
    perDay: 'દરરોજ',
    perWeek: 'દર અઠવાડિયે',
    perMonth: 'દર મહિને',
    advance: 'એડવાન્સ',
    commission: 'કમિશન',
    netPayable: 'ચોખ્ખી ચૂકવણી',
    grossBilling: 'કુલ બિલિંગ',
    bookNow: 'હવે બુક કરો',
    confirmBooking: 'બુકિંગ પુષ્ટિ કરો',
    cancelBooking: 'બુકિંગ રદ કરો',
    machineStatus: 'મશીન સ્થિતિ',
    fuelLevel: 'ઇંધણ સ્તર',
    condition: 'સ્થિતિ',
    location: 'સ્થાન',
    operator: 'ઓપરેટર',
    experience: 'અનુભવ',
    rating: 'રેટિંગ',
    hours: 'કલાક',
    days: 'દિવસ',
    weeks: 'અઠવાડિયા',
    months: 'મહિના',
    gstInvoice: 'GST ઈન્વૉઈસ',
    bookingHistory: 'બુકિંગ ઈતિહાસ',
    paymentHistory: 'ચુકવણી ઈતિહાસ',
    noAlerts: 'કોઈ સૂચના નથી!',
    allMachinesOk: 'બધી મશીનો સારી ચાલે છે.',
    lockMachine: 'મશીન લૉક કરો',
    machineReg: 'મશીન નોંધણી ફોર્મ',
    ownerInfo: 'માલિકની માહિતી',
    machineInfo: 'મશીનની માહિતી',
    pdiInfo: 'PDI તપાસ',
    documents: 'દસ્તાવેજ અપલોડ',
    agreement: 'નિયમો અને કરાર',
    selectFile: 'ફાઈલ પસંદ કરો',
    walletOnly: 'માત્ર વૉલેટ · રોકડ સ્વીકારાશે નહીં',
    noRefund: 'નો રિફન્ડ નીતિ',
    cancelPolicy: 'રદ કરવાની નીતિ',
    whatsapp: 'WhatsApp',
    email: 'ઈ-મેઈલ સહાય',
    send: 'મોકલો',
    year: 'વર્ષ',
    total: 'કુલ',
    tax: 'કર',
    status: 'સ્થિતિ',
    type: 'પ્રકાર',
    date: 'તારીખ',
    machine: 'મશીન',
    client: 'ગ્રાહક',
    hmrToday: 'આજનું HMR',
    hmrTotal: 'કુલ HMR',
    earnings: 'કમાણી',
    amount: 'રકમ',
    ref: 'સંદર્ભ નંબર',
    fuel: 'ઇંધણ',
    ignition: 'ઇગ્નિશન',
    speed: 'ઝડપ',
    completedBookings: 'પૂર્ણ બુકિંગ',
    instantCost: 'તાત્કાલિક ખર્ચ કૅલ્ક્યુલેટર',
    baseAmount: 'મૂળ રકમ',
    gst18: 'GST (18%)',
    grandTotal: 'કુલ સરવાળો',
    minimumAdvance: 'ઓછામાં ઓછો એડવાન્સ જરૂરી',
    selectMachineFirst: 'પહેલા મશીન પસંદ કરો',
    viewMachines: '→ મશીન જુઓ',
    bookingConfirm: 'બુકિંગ પુષ્ટિ કરો',
    walletDeduct: 'એડવાન્સ વૉલેટથી કપાશે · રોકડ નહીં · GST ઈન્વૉઈસ આપોઆપ બનશે',
    noBookings: 'કોઈ સક્રિય બુકિંગ નથી',
    goBook: '→ મશીન બુક કરો',
    completeBookings: 'પૂર્ણ બુકિંગ',
    transactions: 'વ્યવહાર ઈતિહાસ',
    customAmount: 'કસ્ટમ રકમ (ઓછામાં ઓછી ₹5,000)',
    paymentMethods: 'ચુકવણી પદ્ધતિ',
    alertLog: 'અલર્ટ લૉગ',
    sendWhatsapp: 'WhatsApp પર મોકલો',
    sendEmail: 'ઈ-મેઈલ મોકલો',
    yourMessage: 'તમારો પ્રશ્ન અથવા સમસ્યા લખો...',
    importantInfo: 'મશીન માલિકો માટે મહત્વની માહિતી',
    machineDetails: 'મશીન અને ઓપરેટર વિગતો',
    liveCamera: '360° લાઈવ કૅમેરા — બુકિંગ પછી',
    liveBookAvail: 'બુકિંગ પછી લાઈવ ફીડ ઉપલ',
    rateCard: 'દર કાર્ડ (ઓપરેટર સહિત)',
    selectBook: 'આ મશીન બુક કરો →',
    selectCalc: '📋 પસંદ કરો અને ખર્ચ જુઓ →',
    bookingType: 'બુકિંગ પ્રકાર પસંદ કરો',
    selectQty: 'જથ્થો પસંદ કરો',
    walletSufficient: '✅ આગળ વધો',
    walletInsufficient: '❌ અપૂરતું',
    rechargeFirst: '⚡ પહેલા વૉલેટ રિચાર્જ કરો',
    cancelWarning: 'શું તમે રદ કરવા ઈચ્છો છો?',
    noBankRefund: '❌ બૅન્ક રિફન્ડ નહીં — માત્ર વૉલેટ ક્રેડિટ',
    walletCredit: 'વૉલેટ ક્રેડિટ',
    penaltyDeduct: 'રદ કરવાનો દંડ (1 કલાક)',
    blacklistWarning: '⛔ બ્લૅકલિસ્ટ ચેતવણી',
    directContactProhibited: 'સીધો સંપર્ક સખ્ત પ્રતિબંધિત',
    understood: '✅ સમજ્યો — પ્લેટફોર્મ વાપરીશ',
    lockWarning: 'Teltonika GPS દ્વારા મશીનનું ઈગ્નિશન દૂરથી બંધ થઈ જશે.',
    lockConfirm: '🔒 લૉક પુષ્ટિ કરો',
    allStats: 'સંપૂર્ણ આંકડા',
    changeLanguage: 'ભાષા બદલો',
  },

  ta: {
    appName: 'டெவலப்மென்ட் எக்ஸ்பிரஸ்',
    tagline: 'உள்கட்டமைப்பின் தங்க தரம்',
    platform: 'கட்டுமான மேலாண்மை தளம்',
    selectRole: 'பங்கு தேர்வு செய்யுங்கள்',
    emailAddress: 'மின்னஞ்சல் முகவரி',
    password: 'கடவுச்சொல்',
    signIn: 'உள்நுழைக',
    signingIn: 'உள்நுழைகிறது...',
    adminRole: 'நிர்வாகி — மேலாண்மை இயக்குனர்',
    ownerRole: 'இயந்திர உரிமையாளர்',
    clientRole: 'வாடிக்கையாளர் (ஒப்பந்தக்காரர்)',
    operatorRole: 'ஆபரேட்டர்',
    sinceLabel: 'முதல்',
    dashboard: 'டாஷ்போர்டு',
    myMachines: 'என் இயந்திரங்கள்',
    register: 'இயந்திர பதிவு',
    tracking: 'GPS கண்காணிப்பு',
    reports: 'அறிக்கைகள்',
    alerts: 'எச்சரிக்கைகள்',
    support: 'ஆதரவு',
    bookMachine: 'இயந்திரம் முன்பதிவு',
    costCalculator: 'செலவு கணக்கீடு',
    myBookings: 'என் முன்பதிவுகள்',
    liveTracking: 'நேரடி கண்காணிப்பு',
    wallet: 'வாலட்',
    overview: 'கண்ணோட்டம்',
    machines: 'இயந்திரங்கள்',
    clients: 'வாடிக்கையாளர்கள்',
    owners: 'உரிமையாளர்கள்',
    operators: 'ஆபரேட்டர்கள்',
    billingWallet: 'வாலட் & பில்லிங்',
    iot: 'IoT & GPS',
    logout: 'வெளியேறு',
    active: 'செயலில்',
    idle: 'செயலற்று',
    available: 'கிடைக்கிறது',
    busy: 'பிஸி',
    locked: 'பூட்டப்பட்டது',
    live: 'நேரடி',
    totalMachines: 'மொத்த இயந்திரங்கள்',
    activeToday: 'இன்று செயலில்',
    walletBalance: 'வாலட் இருப்பு',
    activeBookings: 'செயலில் உள்ள முன்பதிவுகள்',
    recharge: 'ரீசார்ஜ்',
    rechargeWallet: '+ வாலட் ரீசார்ஜ்',
    payNow: 'இப்போது செலுத்துங்கள்',
    confirm: 'உறுதிப்படுத்துங்கள்',
    cancel: 'ரத்து செய்யுங்கள்',
    back: 'திரும்பு',
    download: 'பதிவிறக்கம்',
    submit: 'சமர்ப்பிக்கவும்',
    save: 'சேமிக்கவும்',
    perHour: 'மணிக்கு',
    perDay: 'நாளுக்கு',
    perWeek: 'வாரத்திற்கு',
    perMonth: 'மாதத்திற்கு',
    advance: 'முன்பணம்',
    commission: 'கமிஷன்',
    netPayable: 'நிகர செலுத்த வேண்டியது',
    grossBilling: 'மொத்த பில்லிங்',
    bookNow: 'இப்போது பதிவு செய்யுங்கள்',
    confirmBooking: 'முன்பதிவு உறுதிப்படுத்துங்கள்',
    cancelBooking: 'முன்பதிவு ரத்து செய்யுங்கள்',
    machineStatus: 'இயந்திர நிலை',
    fuelLevel: 'எரிபொருள் அளவு',
    condition: 'நிலை',
    location: 'இடம்',
    operator: 'ஆபரேட்டர்',
    experience: 'அனுபவம்',
    rating: 'மதிப்பீடு',
    hours: 'மணிநேரம்',
    days: 'நாட்கள்',
    weeks: 'வாரங்கள்',
    months: 'மாதங்கள்',
    gstInvoice: 'GST இன்வாய்ஸ்',
    bookingHistory: 'முன்பதிவு வரலாறு',
    paymentHistory: 'கட்டண வரலாறு',
    noAlerts: 'எச்சரிக்கை இல்லை!',
    allMachinesOk: 'அனைத்து இயந்திரங்களும் சரியாக இயங்குகின்றன.',
    lockMachine: 'இயந்திரத்தை பூட்டுங்கள்',
    machineReg: 'இயந்திர பதிவு படிவம்',
    ownerInfo: 'உரிமையாளர் தகவல்',
    machineInfo: 'இயந்திர தகவல்',
    pdiInfo: 'PDI ஆய்வு',
    documents: 'ஆவணங்கள் பதிவேற்றம்',
    agreement: 'விதிமுறைகள் & ஒப்பந்தம்',
    selectFile: 'கோப்பை தேர்வு செய்யுங்கள்',
    walletOnly: 'வாலட் மட்டுமே · பணம் ஏற்கப்படாது',
    noRefund: 'திரும்ப செலுத்த மாட்டோம்',
    cancelPolicy: 'ரத்து கொள்கை',
    whatsapp: 'WhatsApp',
    email: 'மின்னஞ்சல் ஆதரவு',
    send: 'அனுப்புங்கள்',
    year: 'ஆண்டு',
    total: 'மொத்தம்',
    tax: 'வரி',
    status: 'நிலை',
    type: 'வகை',
    date: 'தேதி',
    machine: 'இயந்திரம்',
    client: 'வாடிக்கையாளர்',
    hmrToday: 'இன்றைய HMR',
    hmrTotal: 'மொத்த HMR',
    earnings: 'வருமானம்',
    amount: 'தொகை',
    ref: 'குறிப்பு எண்',
    fuel: 'எரிபொருள்',
    ignition: 'இக்னிஷன்',
    speed: 'வேகம்',
    completedBookings: 'முடிந்த முன்பதிவுகள்',
    instantCost: 'உடனடி செலவு கணக்கீடு',
    baseAmount: 'அடிப்படை தொகை',
    gst18: 'GST (18%)',
    grandTotal: 'மொத்த தொகை',
    minimumAdvance: 'குறைந்தபட்ச முன்பணம் தேவை',
    selectMachineFirst: 'முதலில் இயந்திரம் தேர்வு செய்யுங்கள்',
    viewMachines: '→ இயந்திரங்களை பாருங்கள்',
    bookingConfirm: 'முன்பதிவு உறுதிப்படுத்துங்கள்',
    walletDeduct: 'முன்பணம் வாலட்டிலிருந்து கழிக்கப்படும் · பணம் இல்லை · GST தானாக உருவாகும்',
    noBookings: 'செயலில் உள்ள முன்பதிவுகள் இல்லை',
    goBook: '→ இயந்திரம் பதிவு செய்யுங்கள்',
    completeBookings: 'முடிந்த முன்பதிவுகள்',
    transactions: 'பரிவர்த்தனை வரலாறு',
    customAmount: 'தனிப்பயன் தொகை (குறைந்தது ₹5,000)',
    paymentMethods: 'கட்டண முறைகள்',
    alertLog: 'எச்சரிக்கை பதிவு',
    sendWhatsapp: 'WhatsApp-ல் அனுப்புங்கள்',
    sendEmail: 'மின்னஞ்சல் அனுப்புங்கள்',
    yourMessage: 'உங்கள் கேள்வி அல்லது பிரச்சனை எழுதுங்கள்...',
    importantInfo: 'இயந்திர உரிமையாளர்களுக்கு முக்கியமான தகவல்',
    machineDetails: 'இயந்திரம் & ஆபரேட்டர் விவரங்கள்',
    liveCamera: '360° நேரடி கேமரா — பதிவிற்கு பின்',
    liveBookAvail: 'பதிவிற்கு பின் நேரடி ஃபீட் கிடைக்கும்',
    rateCard: 'கட்டண அட்டை (ஆபரேட்டர் உட்பட)',
    selectBook: 'இந்த இயந்திரத்தை பதிவு செய்யுங்கள் →',
    selectCalc: '📋 தேர்வு செய்து செலவு பாருங்கள் →',
    bookingType: 'முன்பதிவு வகை தேர்வு செய்யுங்கள்',
    selectQty: 'அளவு தேர்வு செய்யுங்கள்',
    walletSufficient: '✅ தொடரலாம்',
    walletInsufficient: '❌ போதுமான இல்லை',
    rechargeFirst: '⚡ முதலில் வாலட் ரீசார்ஜ் செய்யுங்கள்',
    cancelWarning: 'நீங்கள் ரத்து செய்ய விரும்புகிறீர்களா?',
    noBankRefund: '❌ வங்கி திரும்ப இல்லை — வாலட் கிரெடிட் மட்டுமே',
    walletCredit: 'வாலட் கிரெடிட்',
    penaltyDeduct: 'ரத்து அபராதம் (1 மணி)',
    blacklistWarning: '⛔ பிளாக்லிஸ்ட் எச்சரிக்கை',
    directContactProhibited: 'நேரடி தொடர்பு கண்டிப்பாக தடை',
    understood: '✅ புரிந்தது — தளத்தை பயன்படுத்துவேன்',
    lockWarning: 'Teltonika GPS மூலம் இயந்திரத்தின் இக்னிஷன் தொலைவிலிருந்து முடக்கப்படும்.',
    lockConfirm: '🔒 பூட்டு உறுதிப்படுத்துங்கள்',
    allStats: 'முழுமையான புள்ளிவிவரங்கள்',
    changeLanguage: 'மொழி மாற்றுங்கள்',
  },

  te: {
    appName: 'డెవలప్‌మెంట్ ఎక్స్‌ప్రెస్',
    tagline: 'మౌలిక సదుపాయాల స్వర్ణ ప్రమాణం',
    platform: 'నిర్మాణ నిర్వహణ వేదిక',
    selectRole: 'పాత్రను ఎంచుకోండి',
    emailAddress: 'ఇమెయిల్ చిరునామా',
    password: 'పాస్‌వర్డ్',
    signIn: 'సైన్ ఇన్ చేయండి',
    signingIn: 'లాగిన్ అవుతోంది...',
    adminRole: 'అడ్మిన్ — మేనేజింగ్ డైరెక్టర్',
    ownerRole: 'మెషీన్ యజమాని',
    clientRole: 'గ్రాహకుడు (కాంట్రాక్టర్)',
    operatorRole: 'ఆపరేటర్',
    sinceLabel: 'నుండి',
    dashboard: 'డాష్‌బోర్డ్',
    myMachines: 'నా మెషీన్‌లు',
    register: 'మెషీన్ నమోదు',
    tracking: 'GPS ట్రాకింగ్',
    reports: 'నివేదికలు',
    alerts: 'హెచ్చరికలు',
    support: 'మద్దతు',
    bookMachine: 'మెషీన్ బుక్ చేయండి',
    costCalculator: 'ఖర్చు కాలిక్యులేటర్',
    myBookings: 'నా బుకింగ్‌లు',
    liveTracking: 'లైవ్ ట్రాకింగ్',
    wallet: 'వాలెట్',
    overview: 'అవలోకనం',
    machines: 'మెషీన్‌లు',
    clients: 'గ్రాహకులు',
    owners: 'యజమానులు',
    operators: 'ఆపరేటర్‌లు',
    billingWallet: 'వాలెట్ & బిల్లింగ్',
    iot: 'IoT & GPS',
    logout: 'లాగ్అవుట్',
    active: 'చురుకైన',
    idle: 'నిష్క్రియ',
    available: 'అందుబాటులో',
    busy: 'బిజీ',
    locked: 'లాక్ చేయబడింది',
    live: 'లైవ్',
    totalMachines: 'మొత్తం మెషీన్‌లు',
    activeToday: 'నేడు చురుకైన',
    walletBalance: 'వాలెట్ బ్యాలెన్స్',
    activeBookings: 'చురుకైన బుకింగ్‌లు',
    recharge: 'రీఛార్జ్',
    rechargeWallet: '+ వాలెట్ రీఛార్జ్',
    payNow: 'ఇప్పుడు చెల్లించండి',
    confirm: 'నిర్ధారించండి',
    cancel: 'రద్దు చేయండి',
    back: 'వెనుకకు',
    download: 'డౌన్లోడ్',
    submit: 'సమర్పించండి',
    save: 'సేవ్ చేయండి',
    perHour: 'గంటకు',
    perDay: 'రోజుకు',
    perWeek: 'వారానికి',
    perMonth: 'నెలకు',
    advance: 'అడ్వాన్స్',
    commission: 'కమీషన్',
    netPayable: 'నికర చెల్లించవలసిన',
    grossBilling: 'స్థూల బిల్లింగ్',
    bookNow: 'ఇప్పుడే బుక్ చేయండి',
    confirmBooking: 'బుకింగ్ నిర్ధారించండి',
    cancelBooking: 'బుకింగ్ రద్దు చేయండి',
    machineStatus: 'మెషీన్ స్థితి',
    fuelLevel: 'ఇంధన స్థాయి',
    condition: 'స్థితి',
    location: 'స్థానం',
    operator: 'ఆపరేటర్',
    experience: 'అనుభవం',
    rating: 'రేటింగ్',
    hours: 'గంటలు',
    days: 'రోజులు',
    weeks: 'వారాలు',
    months: 'నెలలు',
    gstInvoice: 'GST ఇన్వాయిస్',
    bookingHistory: 'బుకింగ్ చరిత్ర',
    paymentHistory: 'చెల్లింపు చరిత్ర',
    noAlerts: 'హెచ్చరికలు లేవు!',
    allMachinesOk: 'అన్ని మెషీన్‌లు సరిగ్గా పని చేస్తున్నాయి.',
    lockMachine: 'మెషీన్ లాక్ చేయండి',
    machineReg: 'మెషీన్ నమోదు ఫారం',
    ownerInfo: 'యజమాని సమాచారం',
    machineInfo: 'మెషీన్ సమాచారం',
    pdiInfo: 'PDI తనిఖీ',
    documents: 'పత్రాలు అప్‌లోడ్',
    agreement: 'నిబంధనలు & ఒప్పందం',
    selectFile: 'ఫైల్ ఎంచుకోండి',
    walletOnly: 'వాలెట్ మాత్రమే · నగదు అంగీకరించబడదు',
    noRefund: 'రీఫండ్ లేదు విధానం',
    cancelPolicy: 'రద్దు విధానం',
    whatsapp: 'WhatsApp',
    email: 'ఇమెయిల్ మద్దతు',
    send: 'పంపండి',
    year: 'సంవత్సరం',
    total: 'మొత్తం',
    tax: 'పన్ను',
    status: 'స్థితి',
    type: 'రకం',
    date: 'తేదీ',
    machine: 'మెషీన్',
    client: 'గ్రాహకుడు',
    hmrToday: 'నేటి HMR',
    hmrTotal: 'మొత్తం HMR',
    earnings: 'ఆదాయం',
    amount: 'మొత్తం',
    ref: 'రెఫరెన్స్ నంబర్',
    fuel: 'ఇంధనం',
    ignition: 'ఇగ్నిషన్',
    speed: 'వేగం',
    completedBookings: 'పూర్తయిన బుకింగ్‌లు',
    instantCost: 'తక్షణ ఖర్చు కాలిక్యులేటర్',
    baseAmount: 'ప్రాథమిక మొత్తం',
    gst18: 'GST (18%)',
    grandTotal: 'మొత్తం మొత్తం',
    minimumAdvance: 'కనీస అడ్వాన్స్ అవసరం',
    selectMachineFirst: 'ముందు మెషీన్ ఎంచుకోండి',
    viewMachines: '→ మెషీన్‌లు చూడండి',
    bookingConfirm: 'బుకింగ్ నిర్ధారించండి',
    walletDeduct: 'అడ్వాన్స్ వాలెట్ నుండి తీసివేయబడుతుంది · నగదు లేదు · GST స్వయంచాలకంగా రూపొందుతుంది',
    noBookings: 'చురుకైన బుకింగ్‌లు లేవు',
    goBook: '→ మెషీన్ బుక్ చేయండి',
    completeBookings: 'పూర్తయిన బుకింగ్‌లు',
    transactions: 'లావాదేవీ చరిత్ర',
    customAmount: 'కస్టమ్ మొత్తం (కనీసం ₹5,000)',
    paymentMethods: 'చెల్లింపు పద్ధతులు',
    alertLog: 'హెచ్చరిక లాగ్',
    sendWhatsapp: 'WhatsApp లో పంపండి',
    sendEmail: 'ఇమెయిల్ పంపండి',
    yourMessage: 'మీ ప్రశ్న లేదా సమస్య రాయండి...',
    importantInfo: 'మెషీన్ యజమానులకు ముఖ్యమైన సమాచారం',
    machineDetails: 'మెషీన్ & ఆపరేటర్ వివరాలు',
    liveCamera: '360° లైవ్ కెమెరా — బుకింగ్ తర్వాత',
    liveBookAvail: 'బుకింగ్ తర్వాత లైవ్ ఫీడ్ అందుబాటులో',
    rateCard: 'రేట్ కార్డ్ (ఆపరేటర్ సహా)',
    selectBook: 'ఈ మెషీన్ బుక్ చేయండి →',
    selectCalc: '📋 ఎంచుకోండి & ఖర్చు చూడండి →',
    bookingType: 'బుకింగ్ రకం ఎంచుకోండి',
    selectQty: 'పరిమాణం ఎంచుకోండి',
    walletSufficient: '✅ కొనసాగండి',
    walletInsufficient: '❌ సరిపోదు',
    rechargeFirst: '⚡ ముందు వాలెట్ రీఛార్జ్ చేయండి',
    cancelWarning: 'మీరు రద్దు చేయాలనుకుంటున్నారా?',
    noBankRefund: '❌ బ్యాంక్ రీఫండ్ లేదు — వాలెట్ క్రెడిట్ మాత్రమే',
    walletCredit: 'వాలెట్ క్రెడిట్',
    penaltyDeduct: 'రద్దు జరిమానా (1 గంట)',
    blacklistWarning: '⛔ బ్లాక్‌లిస్ట్ హెచ్చరిక',
    directContactProhibited: 'ప్రత్యక్ష సంప్రదింపులు కఠినంగా నిషేధించబడ్డాయి',
    understood: '✅ అర్థమైంది — వేదికను ఉపయోగిస్తాను',
    lockWarning: 'Teltonika GPS ద్వారా మెషీన్ ఇగ్నిషన్ దూరంగా నిలిపివేయబడుతుంది.',
    lockConfirm: '🔒 లాక్ నిర్ధారించండి',
    allStats: 'పూర్తి గణాంకాలు',
    ownerPortal: 'యజమాని పోర్టల్',
    clientPortal: 'గ్రాహకుల పోర్టల్',
    operatorPortal: 'ఆపరేటర్ పోర్టల్',
    portalWelcome: 'స్వాగతం',
    portalWelcomeHint: 'కొనసాగడానికి మీ పోర్టల్ ఎంచుకోండి',
    portalClient: 'గ్రాహకుడు',
    portalClientSub: 'మెషినరీ బుక్ చేయండి',
    portalOwner: 'యజమాని',
    portalOwnerSub: 'ఫ్లీట్ నిర్వహణ',
    portalNewClientRegister: 'కొత్త గ్రాహకుడు? నమోదు',
    portalNewOwnerRegister: 'కొత్త యజమాని? నమోదు',
    portalStaffOperator: 'ఆపరేటర్',
    portalStaffAdmin: 'అడ్మిన్',
    portalBackLink: 'పోర్టల్',
    loginRoleClientShort: 'గ్రాహకుడు',
    loginRoleOwnerShort: 'యజమాని',
    loginTabPassword: 'పాస్‌వర్డ్',
    loginTabOtp: 'OTP',
    loginSignInShort: 'సైన్ ఇన్',
    loginNewHereRegister: 'కొత్తవారా? నమోదు',
    loginChangeRole: 'పాత్ర మార్చండి',
    loginClientPortalSubtitle: 'నిర్మాణ మెషినరీ బుక్ చేయడానికి సైన్ ఇన్',
    loginOwnerPortalSubtitle: 'ఫ్లీట్ & నమోదు నిర్వహించడానికి సైన్ ఇన్',
    marketingBackHome: 'వెబ్‌సైట్‌కు తిరిగి',
    drawerMenu: 'మెనూ',
    pendingApproval: 'ఆమోదం పెండింగ్',
    approved: 'ఆమోదించబడింది',
    noBookingsYet: 'ఇంకా బుకింగ్‌లు లేవు',
    bookingsScheduleHint: 'క్లయింట్‌లు బుక్ చేసినప్పుడు రోజువారీ షెడ్యూల్ ఇక్కడ కనిపిస్తుంది.',
    regSubmitBtn: '✅ నమోదు సమర్పించండి',
    changeLanguage: 'భాషను మార్చండి',
  },

  kn: {
    appName: 'ಡೆವಲಪ್‌ಮೆಂಟ್ ಎಕ್ಸ್‌ಪ್ರೆಸ್',
    tagline: 'ಮೂಲಸೌಕರ್ಯದ ಚಿನ್ನದ ಮಾನದಂಡ',
    platform: 'ನಿರ್ಮಾಣ ನಿರ್ವಹಣಾ ವೇದಿಕೆ',
    selectRole: 'ಪಾತ್ರ ಆಯ್ಕೆ ಮಾಡಿ',
    emailAddress: 'ಇಮೇಲ್ ವಿಳಾಸ',
    password: 'ಪಾಸ್‌ವರ್ಡ್',
    signIn: 'ಸೈನ್ ಇನ್ ಮಾಡಿ',
    signingIn: 'ಲಾಗಿನ್ ಆಗುತ್ತಿದೆ...',
    adminRole: 'ಅಡ್ಮಿನ್ — ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕ',
    ownerRole: 'ಯಂತ್ರ ಮಾಲೀಕ',
    clientRole: 'ಗ್ರಾಹಕ (ಗುತ್ತಿಗೆದಾರ)',
    operatorRole: 'ಆಪರೇಟರ್',
    sinceLabel: 'ಇಂದ',
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    myMachines: 'ನನ್ನ ಯಂತ್ರಗಳು',
    register: 'ಯಂತ್ರ ನೋಂದಣಿ',
    tracking: 'GPS ಟ್ರ್ಯಾಕಿಂಗ್',
    reports: 'ವರದಿಗಳು',
    alerts: 'ಎಚ್ಚರಿಕೆಗಳು',
    support: 'ಬೆಂಬಲ',
    bookMachine: 'ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ',
    costCalculator: 'ವೆಚ್ಚ ಕ್ಯಾಲ್ಕುಲೇಟರ್',
    myBookings: 'ನನ್ನ ಬುಕಿಂಗ್‌ಗಳು',
    liveTracking: 'ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್',
    wallet: 'ವಾಲೆಟ್',
    overview: 'ಅವಲೋಕನ',
    machines: 'ಯಂತ್ರಗಳು',
    clients: 'ಗ್ರಾಹಕರು',
    owners: 'ಮಾಲೀಕರು',
    operators: 'ಆಪರೇಟರ್‌ಗಳು',
    billingWallet: 'ವಾಲೆಟ್ & ಬಿಲ್ಲಿಂಗ್',
    iot: 'IoT & GPS',
    logout: 'ಲಾಗ್ ಔಟ್',
    active: 'ಸಕ್ರಿಯ',
    idle: 'ನಿಷ್ಕ್ರಿಯ',
    available: 'ಲಭ್ಯ',
    busy: 'ಬ್ಯುಸಿ',
    locked: 'ಲಾಕ್',
    live: 'ಲೈವ್',
    totalMachines: 'ಒಟ್ಟು ಯಂತ್ರಗಳು',
    activeToday: 'ಇಂದು ಸಕ್ರಿಯ',
    walletBalance: 'ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್',
    activeBookings: 'ಸಕ್ರಿಯ ಬುಕಿಂಗ್‌ಗಳು',
    recharge: 'ರೀಚಾರ್ಜ್',
    rechargeWallet: '+ ವಾಲೆಟ್ ರೀಚಾರ್ಜ್',
    payNow: 'ಈಗ ಪಾವತಿಸಿ',
    confirm: 'ದೃಢೀಕರಿಸಿ',
    cancel: 'ರದ್ದು ಮಾಡಿ',
    back: 'ಹಿಂದೆ ಹೋಗಿ',
    download: 'ಡೌನ್‌ಲೋಡ್',
    submit: 'ಸಲ್ಲಿಸಿ',
    save: 'ಉಳಿಸಿ',
    perHour: 'ಗಂಟೆಗೆ',
    perDay: 'ದಿನಕ್ಕೆ',
    perWeek: 'ವಾರಕ್ಕೆ',
    perMonth: 'ತಿಂಗಳಿಗೆ',
    advance: 'ಮುಂಗಡ',
    commission: 'ಕಮಿಷನ್',
    netPayable: 'ನಿವ್ವಳ ಪಾವತಿಸಬೇಕಾದ',
    grossBilling: 'ಒಟ್ಟು ಬಿಲ್ಲಿಂಗ್',
    bookNow: 'ಈಗ ಬುಕ್ ಮಾಡಿ',
    confirmBooking: 'ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿ',
    cancelBooking: 'ಬುಕಿಂಗ್ ರದ್ದು ಮಾಡಿ',
    machineStatus: 'ಯಂತ್ರ ಸ್ಥಿತಿ',
    fuelLevel: 'ಇಂಧನ ಮಟ್ಟ',
    condition: 'ಸ್ಥಿತಿ',
    location: 'ಸ್ಥಳ',
    operator: 'ಆಪರೇಟರ್',
    experience: 'ಅನುಭವ',
    rating: 'ರೇಟಿಂಗ್',
    hours: 'ಗಂಟೆಗಳು',
    days: 'ದಿನಗಳು',
    weeks: 'ವಾರಗಳು',
    months: 'ತಿಂಗಳುಗಳು',
    gstInvoice: 'GST ಇನ್‌ವಾಯ್ಸ್',
    bookingHistory: 'ಬುಕಿಂಗ್ ಇತಿಹಾಸ',
    paymentHistory: 'ಪಾವತಿ ಇತಿಹಾಸ',
    noAlerts: 'ಯಾವುದೇ ಎಚ್ಚರಿಕೆಗಳಿಲ್ಲ!',
    allMachinesOk: 'ಎಲ್ಲಾ ಯಂತ್ರಗಳು ಸರಿಯಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿವೆ.',
    lockMachine: 'ಯಂತ್ರ ಲಾಕ್ ಮಾಡಿ',
    machineReg: 'ಯಂತ್ರ ನೋಂದಣಿ ಫಾರ್ಮ್',
    ownerInfo: 'ಮಾಲೀಕ ಮಾಹಿತಿ',
    machineInfo: 'ಯಂತ್ರ ಮಾಹಿತಿ',
    pdiInfo: 'PDI ತಪಾಸಣೆ',
    documents: 'ದಾಖಲೆಗಳು ಅಪ್‌ಲೋಡ್',
    agreement: 'ನಿಯಮಗಳು & ಒಪ್ಪಂದ',
    selectFile: 'ಫೈಲ್ ಆಯ್ಕೆ ಮಾಡಿ',
    walletOnly: 'ವಾಲೆಟ್ ಮಾತ್ರ · ನಗದು ಸ್ವೀಕರಿಸಲಾಗದು',
    noRefund: 'ರಿಫಂಡ್ ಇಲ್ಲ ನೀತಿ',
    cancelPolicy: 'ರದ್ದು ನೀತಿ',
    whatsapp: 'WhatsApp',
    email: 'ಇಮೇಲ್ ಬೆಂಬಲ',
    send: 'ಕಳುಹಿಸಿ',
    year: 'ವರ್ಷ', total: 'ಒಟ್ಟು', tax: 'ತೆರಿಗೆ', status: 'ಸ್ಥಿತಿ',
    type: 'ವಿಧ', date: 'ದಿನಾಂಕ', machine: 'ಯಂತ್ರ', client: 'ಗ್ರಾಹಕ',
    hmrToday: 'ಇಂದಿನ HMR', hmrTotal: 'ಒಟ್ಟು HMR', earnings: 'ಆದಾಯ',
    amount: 'ಮೊತ್ತ', ref: 'ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ', fuel: 'ಇಂಧನ', ignition: 'ಇಗ್ನಿಷನ್',
    speed: 'ವೇಗ', completedBookings: 'ಪೂರ್ಣ ಬುಕಿಂಗ್‌ಗಳು',
    instantCost: 'ತಕ್ಷಣದ ವೆಚ್ಚ ಕ್ಯಾಲ್ಕುಲೇಟರ್', baseAmount: 'ಮೂಲ ಮೊತ್ತ',
    gst18: 'GST (18%)', grandTotal: 'ಒಟ್ಟು ಮೊತ್ತ',
    minimumAdvance: 'ಕನಿಷ್ಠ ಮುಂಗಡ ಅಗತ್ಯ', selectMachineFirst: 'ಮೊದಲು ಯಂತ್ರ ಆಯ್ಕೆ ಮಾಡಿ',
    viewMachines: '→ ಯಂತ್ರಗಳು ನೋಡಿ', bookingConfirm: 'ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿ',
    walletDeduct: 'ಮುಂಗಡ ವಾಲೆಟ್‌ನಿಂದ ಕಡಿತಗೊಳ್ಳುತ್ತದೆ · ನಗದು ಇಲ್ಲ · GST ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಲ್ಪಡುತ್ತದೆ',
    noBookings: 'ಸಕ್ರಿಯ ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ', goBook: '→ ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ',
    completeBookings: 'ಪೂರ್ಣ ಬುಕಿಂಗ್‌ಗಳು', transactions: 'ವಹಿವಾಟು ಇತಿಹಾಸ',
    customAmount: 'ಕಸ್ಟಮ್ ಮೊತ್ತ (ಕನಿಷ್ಠ ₹5,000)', paymentMethods: 'ಪಾವತಿ ವಿಧಾನಗಳು',
    alertLog: 'ಎಚ್ಚರಿಕೆ ಲಾಗ್', sendWhatsapp: 'WhatsApp ನಲ್ಲಿ ಕಳುಹಿಸಿ',
    sendEmail: 'ಇಮೇಲ್ ಕಳುಹಿಸಿ', yourMessage: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ ಅಥವಾ ಸಮಸ್ಯೆ ಬರೆಯಿರಿ...',
    importantInfo: 'ಯಂತ್ರ ಮಾಲೀಕರಿಗೆ ಮುಖ್ಯ ಮಾಹಿತಿ',
    machineDetails: 'ಯಂತ್ರ & ಆಪರೇಟರ್ ವಿವರಗಳು',
    liveCamera: '360° ಲೈವ್ ಕ್ಯಾಮೆರಾ — ಬುಕಿಂಗ್ ನಂತರ',
    liveBookAvail: 'ಬುಕಿಂಗ್ ನಂತರ ಲೈವ್ ಫೀಡ್ ಲಭ್ಯ',
    rateCard: 'ದರ ಕಾರ್ಡ್ (ಆಪರೇಟರ್ ಸೇರಿ)', selectBook: 'ಈ ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ →',
    selectCalc: '📋 ಆಯ್ಕೆ ಮಾಡಿ & ವೆಚ್ಚ ನೋಡಿ →',
    bookingType: 'ಬುಕಿಂಗ್ ವಿಧ ಆಯ್ಕೆ ಮಾಡಿ', selectQty: 'ಪ್ರಮಾಣ ಆಯ್ಕೆ ಮಾಡಿ',
    walletSufficient: '✅ ಮುಂದುವರಿಯಿರಿ', walletInsufficient: '❌ ಸಾಕಾಗದು',
    rechargeFirst: '⚡ ಮೊದಲು ವಾಲೆಟ್ ರೀಚಾರ್ಜ್ ಮಾಡಿ',
    cancelWarning: 'ನೀವು ರದ್ದು ಮಾಡಲು ಬಯಸುತ್ತೀರಾ?',
    noBankRefund: '❌ ಬ್ಯಾಂಕ್ ರಿಫಂಡ್ ಇಲ್ಲ — ವಾಲೆಟ್ ಕ್ರೆಡಿಟ್ ಮಾತ್ರ',
    walletCredit: 'ವಾಲೆಟ್ ಕ್ರೆಡಿಟ್', penaltyDeduct: 'ರದ್ದು ದಂಡ (1 ಗಂಟೆ)',
    blacklistWarning: '⛔ ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್ ಎಚ್ಚರಿಕೆ',
    directContactProhibited: 'ನೇರ ಸಂಪರ್ಕ ಕಟ್ಟುನಿಟ್ಟಾಗಿ ನಿಷೇಧಿಸಲಾಗಿದೆ',
    understood: '✅ ಅರ್ಥಮಾಡಿಕೊಂಡೆ — ವೇದಿಕೆ ಬಳಸುತ್ತೇನೆ',
    lockWarning: 'Teltonika GPS ಮೂಲಕ ಯಂತ್ರದ ಇಗ್ನಿಷನ್ ದೂರದಿಂದ ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗುತ್ತದೆ.',
    lockConfirm: '🔒 ಲಾಕ್ ದೃಢೀಕರಿಸಿ',
    allStats: 'ಸಂಪೂರ್ಣ ಅಂಕಿಅಂಶಗಳು',
    ownerPortal: 'ಮಾಲೀಕರ ಪೋರ್ಟಲ್',
    clientPortal: 'ಗ್ರಾಹಕರ ಪೋರ್ಟಲ್',
    operatorPortal: 'ಆಪರೇಟರ್ ಪೋರ್ಟಲ್',
    portalWelcome: 'ಸ್ವಾಗತ',
    portalWelcomeHint: 'ಮುಂದುವರಿಯಲು ನಿಮ್ಮ ಪೋರ್ಟಲ್ ಆಯ್ಕೆ ಮಾಡಿ',
    portalClient: 'ಗ್ರಾಹಕ',
    portalClientSub: 'ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಿ',
    portalOwner: 'ಮಾಲೀಕ',
    portalOwnerSub: 'ಫ್ಲೀಟ್ ನಿರ್ವಹಣೆ',
    portalNewClientRegister: 'ಹೊಸ ಗ್ರಾಹಕ? ನೋಂದಣಿ',
    portalNewOwnerRegister: 'ಹೊಸ ಮಾಲೀಕ? ನೋಂದಣಿ',
    portalStaffOperator: 'ಆಪರೇಟರ್',
    portalStaffAdmin: 'ಅಡ್ಮಿನ್',
    portalBackLink: 'ಪೋರ್ಟಲ್',
    loginRoleClientShort: 'ಗ್ರಾಹಕ',
    loginRoleOwnerShort: 'ಮಾಲೀಕ',
    loginTabPassword: 'ಪಾಸ್‌ವರ್ಡ್',
    loginTabOtp: 'OTP',
    loginSignInShort: 'ಸೈನ್ ಇನ್',
    loginNewHereRegister: 'ಹೊಸರಾ? ನೋಂದಣಿ',
    loginChangeRole: 'ಪಾತ್ರ ಬದಲಿಸಿ',
    loginClientPortalSubtitle: 'ನಿರ್ಮಾಣ ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಲು ಸೈನ್ ಇನ್',
    loginOwnerPortalSubtitle: 'ಫ್ಲೀಟ್ ಮತ್ತು ನೋಂದಣಿ ನಿರ್ವಹಿಸಲು ಸೈನ್ ಇನ್',
    marketingBackHome: 'ವೆಬ್‌ಸೈಟ್‌ಗೆ ಹಿಂತಿರುಗಿ',
    drawerMenu: 'ಮೆನು',
    pendingApproval: 'ಅನುಮೋದನೆ ಬಾಕಿ',
    approved: 'ಅನುಮೋದಿಸಲಾಗಿದೆ',
    noBookingsYet: 'ಇನ್ನೂ ಬುಕಿಂಗ್ ಇಲ್ಲ',
    bookingsScheduleHint: 'ಗ್ರಾಹಕರು ಬುಕ್ ಮಾಡಿದ ನಂತರ ದಿನದ ಷೆಡ್ಯೂಲ್ ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.',
    regSubmitBtn: '✅ ನೋಂದಣಿ ಸಲ್ಲಿಸಿ',
    changeLanguage: 'ಭಾಷೆ ಬದಲಿಸಿ',
  },

  ml: {
    appName: 'ഡെവലപ്‌മെന്റ് എക്‌സ്‌പ്രസ്',
    tagline: 'അടിസ്ഥാന സൗകര്യത്തിന്റെ സ്വർണ്ണ നിലവാരം',
    platform: 'നിർമ്മാണ മാനേജ്‌മെന്റ് പ്ലാറ്റ്‌ഫോം',
    selectRole: 'റോൾ തിരഞ്ഞെടുക്കൂ',
    emailAddress: 'ഇമെയിൽ വിലാസം',
    password: 'പാസ്‌വേഡ്',
    signIn: 'സൈൻ ഇൻ ചെയ്യൂ',
    signingIn: 'ലോഗിൻ ആകുന്നു...',
    adminRole: 'അഡ്മിൻ — മാനേജിംഗ് ഡയറക്ടർ',
    ownerRole: 'മെഷീൻ ഉടമ',
    clientRole: 'ക്ലയന്റ് (കോൺട്രാക്ടർ)',
    operatorRole: 'ഓപ്പറേറ്റർ',
    sinceLabel: 'മുതൽ',
    dashboard: 'ഡാഷ്‌ബോർഡ്', myMachines: 'എന്റെ മെഷീനുകൾ',
    register: 'മെഷീൻ രജിസ്ട്രേഷൻ', tracking: 'GPS ട്രാക്കിംഗ്',
    reports: 'റിപ്പോർട്ടുകൾ', alerts: 'അലർട്ടുകൾ',
    support: 'പിന്തുണ', bookMachine: 'മെഷീൻ ബുക്ക് ചെയ്യൂ',
    costCalculator: 'ചെലവ് കാൽക്കുലേറ്റർ', myBookings: 'എന്റെ ബുക്കിംഗ്',
    liveTracking: 'തൽസമയ ട്രാക്കിംഗ്', wallet: 'വാലറ്റ്',
    overview: 'അവലോകനം', machines: 'മെഷീനുകൾ', clients: 'ക്ലയന്റുകൾ',
    owners: 'ഉടമകൾ', operators: 'ഓപ്പറേറ്റർമാർ',
    billingWallet: 'വാലറ്റ് & ബില്ലിംഗ്', iot: 'IoT & GPS', logout: 'ലോഗ്ഔട്ട്',
    active: 'സജീവം', idle: 'നിഷ്‌ക്രിയം', available: 'ലഭ്യം', busy: 'തിരക്ക്',
    locked: 'ലോക്ക്', live: 'തൽസമയം', totalMachines: 'ആകെ മെഷീനുകൾ',
    activeToday: 'ഇന്ന് സജീവം', walletBalance: 'വാലറ്റ് ബാലൻസ്',
    activeBookings: 'സജീവ ബുക്കിംഗ്', recharge: 'റീചാർജ്',
    rechargeWallet: '+ വാലറ്റ് റീചാർജ്', payNow: 'ഇപ്പോൾ പേ ചെയ്യൂ',
    confirm: 'സ്ഥിരീകരിക്കൂ', cancel: 'റദ്ദാക്കൂ', back: 'തിരിച്ചു പോകൂ',
    download: 'ഡൗൺലോഡ്', submit: 'സമർപ്പിക്കൂ', save: 'സേവ് ചെയ്യൂ',
    perHour: 'മണിക്കൂറിന്', perDay: 'ദിവസത്തിന്', perWeek: 'ആഴ്ചയ്ക്ക്',
    perMonth: 'മാസത്തിന്', advance: 'അഡ്വാൻസ്', commission: 'കമ്മീഷൻ',
    netPayable: 'നെറ്റ് നൽകേണ്ടത്', grossBilling: 'മൊത്തം ബില്ലിംഗ്',
    bookNow: 'ഇപ്പോൾ ബുക്ക് ചെയ്യൂ', confirmBooking: 'ബുക്കിംഗ് സ്ഥിരീകരിക്കൂ',
    cancelBooking: 'ബുക്കിംഗ് റദ്ദാക്കൂ', machineStatus: 'മെഷീൻ സ്ഥിതി',
    fuelLevel: 'ഇന്ധന നില', condition: 'അവസ്ഥ', location: 'സ്ഥാനം',
    operator: 'ഓപ്പറേറ്റർ', experience: 'പരിചയം', rating: 'റേറ്റിംഗ്',
    hours: 'മണിക്കൂർ', days: 'ദിവസം', weeks: 'ആഴ്ചകൾ', months: 'മാസങ്ങൾ',
    gstInvoice: 'GST ഇൻവോയ്സ്', bookingHistory: 'ബുക്കിംഗ് ചരിത്രം',
    paymentHistory: 'പേയ്‌മെന്റ് ചരിത്രം', noAlerts: 'അലർട്ടുകൾ ഇല്ല!',
    allMachinesOk: 'എല്ലാ മെഷീനുകളും ശരിയായി പ്രവർത്തിക്കുന്നു.',
    lockMachine: 'മെഷീൻ ലോക്ക് ചെയ്യൂ', machineReg: 'മെഷീൻ രജിസ്ട്രേഷൻ ഫോം',
    ownerInfo: 'ഉടമ വിവരങ്ങൾ', machineInfo: 'മെഷീൻ വിവരങ്ങൾ',
    pdiInfo: 'PDI പരിശോധന', documents: 'രേഖകൾ അപ്‌ലോഡ്',
    agreement: 'നിബന്ധനകൾ & കരാർ', selectFile: 'ഫയൽ തിരഞ്ഞെടുക്കൂ',
    walletOnly: 'വാലറ്റ് മാത്രം · പണം സ്വീകരിക്കില്ല',
    noRefund: 'റീഫണ്ട് ഇല്ല നയം', cancelPolicy: 'റദ്ദാക്കൽ നയം',
    whatsapp: 'WhatsApp', email: 'ഇമെയിൽ പിന്തുണ', send: 'അയയ്ക്കൂ',
    year: 'വർഷം', total: 'ആകെ', tax: 'നികുതി', status: 'സ്ഥിതി',
    type: 'തരം', date: 'തീയതി', machine: 'മെഷീൻ', client: 'ക്ലയന്റ്',
    hmrToday: 'ഇന്നത്തെ HMR', hmrTotal: 'ആകെ HMR', earnings: 'വരുമാനം',
    amount: 'തുക', ref: 'റഫറൻസ് നം.', fuel: 'ഇന്ധനം', ignition: 'ഇഗ്നിഷൻ',
    speed: 'വേഗത', completedBookings: 'പൂർത്തിയായ ബുക്കിംഗ്',
    instantCost: 'തൽക്ഷണ ചെലവ് കാൽക്കുലേറ്റർ', baseAmount: 'അടിസ്ഥാന തുക',
    gst18: 'GST (18%)', grandTotal: 'മൊത്തം തുക',
    minimumAdvance: 'ഏറ്റവും കുറഞ്ഞ അഡ്വാൻസ് ആവശ്യം',
    selectMachineFirst: 'ആദ്യം മെഷീൻ തിരഞ്ഞെടുക്കൂ',
    viewMachines: '→ മെഷീനുകൾ കാണൂ', bookingConfirm: 'ബുക്കിംഗ് സ്ഥിരീകരിക്കൂ',
    walletDeduct: 'അഡ്വാൻസ് വാലറ്റിൽ നിന്ന് കുറയ്ക്കും · പണം ഇല്ല · GST സ്വയം സൃഷ്ടിക്കും',
    noBookings: 'സജീവ ബുക്കിംഗ് ഇല്ല', goBook: '→ മെഷീൻ ബുക്ക് ചെയ്യൂ',
    completeBookings: 'പൂർത്തിയായ ബുക്കിംഗ്', transactions: 'ഇടപാട് ചരിത്രം',
    customAmount: 'ഇഷ്ടാനുസൃത തുക (കുറഞ്ഞത് ₹5,000)',
    paymentMethods: 'പേയ്‌മെന്റ് രീതികൾ', alertLog: 'അലർട്ട് ലോഗ്',
    sendWhatsapp: 'WhatsApp-ൽ അയയ്ക്കൂ', sendEmail: 'ഇമെയിൽ അയയ്ക്കൂ',
    yourMessage: 'നിങ്ങളുടെ ചോദ്യം അല്ലെങ്കിൽ പ്രശ്നം എഴുതൂ...',
    importantInfo: 'മെഷീൻ ഉടമകൾക്ക് പ്രധാന വിവരം',
    machineDetails: 'മെഷീൻ & ഓപ്പറേറ്റർ വിശദാംശങ്ങൾ',
    liveCamera: '360° തൽസമയ ക്യാമറ — ബുക്കിംഗ് ശേഷം',
    liveBookAvail: 'ബുക്കിംഗ് ശേഷം തൽസമയ ഫീഡ് ലഭ്യം',
    rateCard: 'നിരക്ക് കാർഡ് (ഓപ്പറേറ്റർ ഉൾപ്പെടെ)',
    selectBook: 'ഈ മെഷീൻ ബുക്ക് ചെയ്യൂ →',
    selectCalc: '📋 തിരഞ്ഞെടുക്കൂ & ചെലവ് കാണൂ →',
    bookingType: 'ബുക്കിംഗ് തരം തിരഞ്ഞെടുക്കൂ',
    selectQty: 'അളവ് തിരഞ്ഞെടുക്കൂ',
    walletSufficient: '✅ തുടരൂ', walletInsufficient: '❌ അപര്യാപ്തം',
    rechargeFirst: '⚡ ആദ്യം വാലറ്റ് റീചാർജ് ചെയ്യൂ',
    cancelWarning: 'നിങ്ങൾ റദ്ദാക്കണമോ?',
    noBankRefund: '❌ ബാങ്ക് റീഫണ്ട് ഇല്ല — വാലറ്റ് ക്രെഡിറ്റ് മാത്രം',
    walletCredit: 'വാലറ്റ് ക്രെഡിറ്റ്', penaltyDeduct: 'റദ്ദാക്കൽ പിഴ (1 മണിക്കൂർ)',
    blacklistWarning: '⛔ ബ്ലാക്ക്‌ലിസ്റ്റ് മുന്നറിയിപ്പ്',
    directContactProhibited: 'നേരിട്ടുള്ള ബന്ധപ്പെടൽ കർശനമായി നിരോധിച്ചിരിക്കുന്നു',
    understood: '✅ മനസ്സിലായി — പ്ലാറ്റ്‌ഫോം ഉപയോഗിക്കും',
    lockWarning: 'Teltonika GPS വഴി മെഷീൻ ഇഗ്നിഷൻ വിദൂരമായി പ്രവർത്തനരഹിതമാക്കും.',
    lockConfirm: '🔒 ലോക്ക് സ്ഥിരീകരിക്കൂ', allStats: 'പൂർണ്ണ കണക്കുകൾ',
    changeLanguage: 'ഭാഷ മാറ്റൂ',
  },

  pa: {
    appName: 'ਡਿਵੈਲਪਮੈਂਟ ਐਕਸਪ੍ਰੈਸ',
    tagline: 'ਬੁਨਿਆਦੀ ਢਾਂਚੇ ਦਾ ਸੋਨੇ ਦਾ ਮਿਆਰ',
    platform: 'ਨਿਰਮਾਣ ਪ੍ਰਬੰਧਨ ਪਲੇਟਫਾਰਮ',
    selectRole: 'ਭੂਮਿਕਾ ਚੁਣੋ',
    emailAddress: 'ਈਮੇਲ ਪਤਾ',
    password: 'ਪਾਸਵਰਡ',
    signIn: 'ਸਾਈਨ ਇਨ ਕਰੋ',
    signingIn: 'ਲੌਗਿਨ ਹੋ ਰਿਹਾ ਹੈ...',
    adminRole: 'ਐਡਮਿਨ — ਪ੍ਰਬੰਧਕੀ ਨਿਰਦੇਸ਼ਕ',
    ownerRole: 'ਮਸ਼ੀਨ ਮਾਲਕ',
    clientRole: 'ਕਲਾਇੰਟ (ਠੇਕੇਦਾਰ)',
    operatorRole: 'ਆਪਰੇਟਰ',
    sinceLabel: 'ਤੋਂ',
    dashboard: 'ਡੈਸ਼ਬੋਰਡ', myMachines: 'ਮੇਰੀਆਂ ਮਸ਼ੀਨਾਂ',
    register: 'ਮਸ਼ੀਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ', tracking: 'GPS ਟਰੈਕਿੰਗ',
    reports: 'ਰਿਪੋਰਟਾਂ', alerts: 'ਚੇਤਾਵਨੀਆਂ',
    support: 'ਸਹਾਇਤਾ', bookMachine: 'ਮਸ਼ੀਨ ਬੁੱਕ ਕਰੋ',
    costCalculator: 'ਲਾਗਤ ਕੈਲਕੁਲੇਟਰ', myBookings: 'ਮੇਰੀਆਂ ਬੁਕਿੰਗਾਂ',
    liveTracking: 'ਲਾਈਵ ਟਰੈਕਿੰਗ', wallet: 'ਵਾਲੇਟ',
    overview: 'ਸੰਖੇਪ ਜਾਣਕਾਰੀ', machines: 'ਮਸ਼ੀਨਾਂ', clients: 'ਗਾਹਕ',
    owners: 'ਮਾਲਕ', operators: 'ਆਪਰੇਟਰ',
    billingWallet: 'ਵਾਲੇਟ & ਬਿਲਿੰਗ', iot: 'IoT & GPS', logout: 'ਲੌਗਆਉਟ',
    active: 'ਸਰਗਰਮ', idle: 'ਅਕਿਰਿਆਸ਼ੀਲ', available: 'ਉਪਲਬਧ', busy: 'ਰੁੱਝਿਆ',
    locked: 'ਲੌਕ', live: 'ਲਾਈਵ', totalMachines: 'ਕੁੱਲ ਮਸ਼ੀਨਾਂ',
    activeToday: 'ਅੱਜ ਸਰਗਰਮ', walletBalance: 'ਵਾਲੇਟ ਬੈਲੈਂਸ',
    activeBookings: 'ਸਰਗਰਮ ਬੁਕਿੰਗਾਂ', recharge: 'ਰੀਚਾਰਜ',
    rechargeWallet: '+ ਵਾਲੇਟ ਰੀਚਾਰਜ', payNow: 'ਹੁਣ ਭੁਗਤਾਨ ਕਰੋ',
    confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ', cancel: 'ਰੱਦ ਕਰੋ', back: 'ਵਾਪਸ ਜਾਓ',
    download: 'ਡਾਊਨਲੋਡ', submit: 'ਜਮ੍ਹਾਂ ਕਰੋ', save: 'ਸੇਵ ਕਰੋ',
    perHour: 'ਪ੍ਰਤੀ ਘੰਟਾ', perDay: 'ਪ੍ਰਤੀ ਦਿਨ', perWeek: 'ਪ੍ਰਤੀ ਹਫ਼ਤਾ',
    perMonth: 'ਪ੍ਰਤੀ ਮਹੀਨਾ', advance: 'ਅਡਵਾਂਸ', commission: 'ਕਮਿਸ਼ਨ',
    netPayable: 'ਸ਼ੁੱਧ ਦੇਣਯੋਗ', grossBilling: 'ਕੁੱਲ ਬਿਲਿੰਗ',
    bookNow: 'ਹੁਣੇ ਬੁੱਕ ਕਰੋ', confirmBooking: 'ਬੁਕਿੰਗ ਪੁਸ਼ਟੀ ਕਰੋ',
    cancelBooking: 'ਬੁਕਿੰਗ ਰੱਦ ਕਰੋ', machineStatus: 'ਮਸ਼ੀਨ ਸਥਿਤੀ',
    fuelLevel: 'ਬਾਲਣ ਪੱਧਰ', condition: 'ਸਥਿਤੀ', location: 'ਸਥਾਨ',
    operator: 'ਆਪਰੇਟਰ', experience: 'ਤਜਰਬਾ', rating: 'ਰੇਟਿੰਗ',
    hours: 'ਘੰਟੇ', days: 'ਦਿਨ', weeks: 'ਹਫ਼ਤੇ', months: 'ਮਹੀਨੇ',
    gstInvoice: 'GST ਇਨਵੌਇਸ', bookingHistory: 'ਬੁਕਿੰਗ ਇਤਿਹਾਸ',
    paymentHistory: 'ਭੁਗਤਾਨ ਇਤਿਹਾਸ', noAlerts: 'ਕੋਈ ਚੇਤਾਵਨੀ ਨਹੀਂ!',
    allMachinesOk: 'ਸਾਰੀਆਂ ਮਸ਼ੀਨਾਂ ਠੀਕ ਚੱਲ ਰਹੀਆਂ ਹਨ।',
    lockMachine: 'ਮਸ਼ੀਨ ਲੌਕ ਕਰੋ', machineReg: 'ਮਸ਼ੀਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫਾਰਮ',
    ownerInfo: 'ਮਾਲਕ ਦੀ ਜਾਣਕਾਰੀ', machineInfo: 'ਮਸ਼ੀਨ ਦੀ ਜਾਣਕਾਰੀ',
    pdiInfo: 'PDI ਜਾਂਚ', documents: 'ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ',
    agreement: 'ਸ਼ਰਤਾਂ & ਸਮਝੌਤਾ', selectFile: 'ਫਾਈਲ ਚੁਣੋ',
    walletOnly: 'ਸਿਰਫ਼ ਵਾਲੇਟ · ਨਕਦ ਸਵੀਕਾਰ ਨਹੀਂ',
    noRefund: 'ਰਿਫੰਡ ਨਹੀਂ ਨੀਤੀ', cancelPolicy: 'ਰੱਦ ਕਰਨ ਦੀ ਨੀਤੀ',
    whatsapp: 'WhatsApp', email: 'ਈਮੇਲ ਸਹਾਇਤਾ', send: 'ਭੇਜੋ',
    year: 'ਸਾਲ', total: 'ਕੁੱਲ', tax: 'ਟੈਕਸ', status: 'ਸਥਿਤੀ',
    type: 'ਕਿਸਮ', date: 'ਮਿਤੀ', machine: 'ਮਸ਼ੀਨ', client: 'ਗਾਹਕ',
    hmrToday: 'ਅੱਜ ਦਾ HMR', hmrTotal: 'ਕੁੱਲ HMR', earnings: 'ਕਮਾਈ',
    amount: 'ਰਾਸ਼ੀ', ref: 'ਹਵਾਲਾ ਨੰ.', fuel: 'ਬਾਲਣ', ignition: 'ਇਗਨੀਸ਼ਨ',
    speed: 'ਗਤੀ', completedBookings: 'ਪੂਰੀਆਂ ਬੁਕਿੰਗਾਂ',
    instantCost: 'ਤੁਰੰਤ ਲਾਗਤ ਕੈਲਕੁਲੇਟਰ', baseAmount: 'ਅਧਾਰ ਰਾਸ਼ੀ',
    gst18: 'GST (18%)', grandTotal: 'ਕੁੱਲ ਜੋੜ',
    minimumAdvance: 'ਘੱਟੋ-ਘੱਟ ਅਡਵਾਂਸ ਲੋੜੀਂਦਾ',
    selectMachineFirst: 'ਪਹਿਲਾਂ ਮਸ਼ੀਨ ਚੁਣੋ', viewMachines: '→ ਮਸ਼ੀਨਾਂ ਦੇਖੋ',
    bookingConfirm: 'ਬੁਕਿੰਗ ਪੁਸ਼ਟੀ ਕਰੋ',
    walletDeduct: 'ਅਡਵਾਂਸ ਵਾਲੇਟ ਤੋਂ ਕੱਟਿਆ ਜਾਵੇਗਾ · ਨਕਦ ਨਹੀਂ · GST ਆਟੋ ਬਣੇਗਾ',
    noBookings: 'ਕੋਈ ਸਰਗਰਮ ਬੁਕਿੰਗ ਨਹੀਂ', goBook: '→ ਮਸ਼ੀਨ ਬੁੱਕ ਕਰੋ',
    completeBookings: 'ਪੂਰੀਆਂ ਬੁਕਿੰਗਾਂ', transactions: 'ਲੈਣ-ਦੇਣ ਇਤਿਹਾਸ',
    customAmount: 'ਕਸਟਮ ਰਾਸ਼ੀ (ਘੱਟੋ-ਘੱਟ ₹5,000)',
    paymentMethods: 'ਭੁਗਤਾਨ ਦੇ ਤਰੀਕੇ', alertLog: 'ਚੇਤਾਵਨੀ ਲੌਗ',
    sendWhatsapp: 'WhatsApp ਤੇ ਭੇਜੋ', sendEmail: 'ਈਮੇਲ ਭੇਜੋ',
    yourMessage: 'ਆਪਣਾ ਸਵਾਲ ਜਾਂ ਸਮੱਸਿਆ ਲਿਖੋ...',
    importantInfo: 'ਮਸ਼ੀਨ ਮਾਲਕਾਂ ਲਈ ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ',
    machineDetails: 'ਮਸ਼ੀਨ & ਆਪਰੇਟਰ ਵੇਰਵੇ',
    liveCamera: '360° ਲਾਈਵ ਕੈਮਰਾ — ਬੁਕਿੰਗ ਤੋਂ ਬਾਅਦ',
    liveBookAvail: 'ਬੁਕਿੰਗ ਤੋਂ ਬਾਅਦ ਲਾਈਵ ਫੀਡ ਉਪਲਬਧ',
    rateCard: 'ਦਰ ਕਾਰਡ (ਆਪਰੇਟਰ ਸਮੇਤ)',
    selectBook: 'ਇਹ ਮਸ਼ੀਨ ਬੁੱਕ ਕਰੋ →',
    selectCalc: '📋 ਚੁਣੋ & ਲਾਗਤ ਦੇਖੋ →',
    bookingType: 'ਬੁਕਿੰਗ ਕਿਸਮ ਚੁਣੋ', selectQty: 'ਮਾਤਰਾ ਚੁਣੋ',
    walletSufficient: '✅ ਅੱਗੇ ਵਧੋ', walletInsufficient: '❌ ਨਾਕਾਫ਼ੀ',
    rechargeFirst: '⚡ ਪਹਿਲਾਂ ਵਾਲੇਟ ਰੀਚਾਰਜ ਕਰੋ',
    cancelWarning: 'ਕੀ ਤੁਸੀਂ ਰੱਦ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?',
    noBankRefund: '❌ ਬੈਂਕ ਰਿਫੰਡ ਨਹੀਂ — ਸਿਰਫ਼ ਵਾਲੇਟ ਕ੍ਰੈਡਿਟ',
    walletCredit: 'ਵਾਲੇਟ ਕ੍ਰੈਡਿਟ', penaltyDeduct: 'ਰੱਦ ਕਰਨ ਦਾ ਜੁਰਮਾਨਾ (1 ਘੰਟਾ)',
    blacklistWarning: '⛔ ਬਲੈਕਲਿਸਟ ਚੇਤਾਵਨੀ',
    directContactProhibited: 'ਸਿੱਧਾ ਸੰਪਰਕ ਸਖ਼ਤੀ ਨਾਲ ਵਰਜਿਤ',
    understood: '✅ ਸਮਝ ਗਿਆ — ਪਲੇਟਫਾਰਮ ਵਰਤਾਂਗਾ',
    lockWarning: 'Teltonika GPS ਰਾਹੀਂ ਮਸ਼ੀਨ ਦਾ ਇਗਨੀਸ਼ਨ ਦੂਰੋਂ ਬੰਦ ਕੀਤਾ ਜਾਵੇਗਾ।',
    lockConfirm: '🔒 ਲੌਕ ਪੁਸ਼ਟੀ ਕਰੋ', allStats: 'ਪੂਰੇ ਅੰਕੜੇ',
    changeLanguage: 'ਭਾਸ਼ਾ ਬਦਲੋ',
  },

  bn: {
    appName: 'ডেভেলপমেন্ট এক্সপ্রেস',
    tagline: 'অবকাঠামোর স্বর্ণ মান',
    platform: 'নির্মাণ ব্যবস্থাপনা প্ল্যাটফর্ম',
    selectRole: 'ভূমিকা নির্বাচন করুন',
    emailAddress: 'ইমেইল ঠিকানা',
    password: 'পাসওয়ার্ড',
    signIn: 'সাইন ইন করুন',
    signingIn: 'লগইন হচ্ছে...',
    adminRole: 'অ্যাডমিন — ব্যবস্থাপনা পরিচালক',
    ownerRole: 'মেশিন মালিক',
    clientRole: 'ক্লায়েন্ট (ঠিকাদার)',
    operatorRole: 'অপারেটর',
    sinceLabel: 'থেকে',
    dashboard: 'ড্যাশবোর্ড', myMachines: 'আমার মেশিন',
    register: 'মেশিন নিবন্ধন', tracking: 'GPS ট্র্যাকিং',
    reports: 'রিপোর্ট', alerts: 'সতর্কতা',
    support: 'সহায়তা', bookMachine: 'মেশিন বুক করুন',
    costCalculator: 'খরচ ক্যালকুলেটর', myBookings: 'আমার বুকিং',
    liveTracking: 'লাইভ ট্র্যাকিং', wallet: 'ওয়ালেট',
    overview: 'পর্যালোচনা', machines: 'মেশিন', clients: 'ক্লায়েন্ট',
    owners: 'মালিক', operators: 'অপারেটর',
    billingWallet: 'ওয়ালেট ও বিলিং', iot: 'IoT ও GPS', logout: 'লগআউট',
    active: 'সক্রিয়', idle: 'নিষ্ক্রিয়', available: 'উপলব্ধ', busy: 'ব্যস্ত',
    locked: 'লক', live: 'লাইভ', totalMachines: 'মোট মেশিন',
    activeToday: 'আজ সক্রিয়', walletBalance: 'ওয়ালেট ব্যালেন্স',
    activeBookings: 'সক্রিয় বুকিং', recharge: 'রিচার্জ',
    rechargeWallet: '+ ওয়ালেট রিচার্জ', payNow: 'এখন পেমেন্ট করুন',
    confirm: 'নিশ্চিত করুন', cancel: 'বাতিল করুন', back: 'পিছনে যান',
    download: 'ডাউনলোড', submit: 'জমা দিন', save: 'সংরক্ষণ করুন',
    perHour: 'প্রতি ঘন্টা', perDay: 'প্রতি দিন', perWeek: 'প্রতি সপ্তাহ',
    perMonth: 'প্রতি মাস', advance: 'অগ্রিম', commission: 'কমিশন',
    netPayable: 'নিট পরিশোধযোগ্য', grossBilling: 'মোট বিলিং',
    bookNow: 'এখনই বুক করুন', confirmBooking: 'বুকিং নিশ্চিত করুন',
    cancelBooking: 'বুকিং বাতিল করুন', machineStatus: 'মেশিন অবস্থা',
    fuelLevel: 'জ্বালানি স্তর', condition: 'অবস্থা', location: 'অবস্থান',
    operator: 'অপারেটর', experience: 'অভিজ্ঞতা', rating: 'রেটিং',
    hours: 'ঘন্টা', days: 'দিন', weeks: 'সপ্তাহ', months: 'মাস',
    gstInvoice: 'GST ইনভয়েস', bookingHistory: 'বুকিং ইতিহাস',
    paymentHistory: 'পেমেন্ট ইতিহাস', noAlerts: 'কোনো সতর্কতা নেই!',
    allMachinesOk: 'সব মেশিন ঠিকমতো চলছে।',
    lockMachine: 'মেশিন লক করুন', machineReg: 'মেশিন নিবন্ধন ফর্ম',
    ownerInfo: 'মালিকের তথ্য', machineInfo: 'মেশিনের তথ্য',
    pdiInfo: 'PDI পরিদর্শন', documents: 'নথি আপলোড',
    agreement: 'শর্তাবলী ও চুক্তি', selectFile: 'ফাইল নির্বাচন করুন',
    walletOnly: 'শুধুমাত্র ওয়ালেট · নগদ গ্রহণযোগ্য নয়',
    noRefund: 'নো রিফান্ড নীতি', cancelPolicy: 'বাতিলকরণ নীতি',
    whatsapp: 'WhatsApp', email: 'ইমেইল সহায়তা', send: 'পাঠান',
    year: 'বছর', total: 'মোট', tax: 'কর', status: 'অবস্থা',
    type: 'ধরন', date: 'তারিখ', machine: 'মেশিন', client: 'ক্লায়েন্ট',
    hmrToday: 'আজকের HMR', hmrTotal: 'মোট HMR', earnings: 'আয়',
    amount: 'পরিমাণ', ref: 'রেফারেন্স নং', fuel: 'জ্বালানি',
    ignition: 'ইগনিশন', speed: 'গতি', completedBookings: 'সম্পন্ন বুকিং',
    instantCost: 'তাৎক্ষণিক খরচ ক্যালকুলেটর', baseAmount: 'মূল পরিমাণ',
    gst18: 'GST (18%)', grandTotal: 'মোট যোগফল',
    minimumAdvance: 'ন্যূনতম অগ্রিম প্রয়োজন',
    selectMachineFirst: 'প্রথমে মেশিন নির্বাচন করুন',
    viewMachines: '→ মেশিন দেখুন', bookingConfirm: 'বুকিং নিশ্চিত করুন',
    walletDeduct: 'অগ্রিম ওয়ালেট থেকে কাটা হবে · নগদ নয় · GST স্বয়ংক্রিয় তৈরি হবে',
    noBookings: 'সক্রিয় বুকিং নেই', goBook: '→ মেশিন বুক করুন',
    completeBookings: 'সম্পন্ন বুকিং', transactions: 'লেনদেন ইতিহাস',
    customAmount: 'কাস্টম পরিমাণ (ন্যূনতম ₹5,000)',
    paymentMethods: 'পেমেন্ট পদ্ধতি', alertLog: 'সতর্কতা লগ',
    sendWhatsapp: 'WhatsApp-এ পাঠান', sendEmail: 'ইমেইল পাঠান',
    yourMessage: 'আপনার প্রশ্ন বা সমস্যা লিখুন...',
    importantInfo: 'মেশিন মালিকদের জন্য গুরুত্বপূর্ণ তথ্য',
    machineDetails: 'মেশিন ও অপারেটর বিবরণ',
    liveCamera: '360° লাইভ ক্যামেরা — বুকিংয়ের পরে',
    liveBookAvail: 'বুকিংয়ের পরে লাইভ ফিড পাওয়া যাবে',
    rateCard: 'রেট কার্ড (অপারেটর সহ)', selectBook: 'এই মেশিন বুক করুন →',
    selectCalc: '📋 নির্বাচন করুন ও খরচ দেখুন →',
    bookingType: 'বুকিং ধরন নির্বাচন করুন', selectQty: 'পরিমাণ নির্বাচন করুন',
    walletSufficient: '✅ এগিয়ে যান', walletInsufficient: '❌ অপর্যাপ্ত',
    rechargeFirst: '⚡ প্রথমে ওয়ালেট রিচার্জ করুন',
    cancelWarning: 'আপনি কি বাতিল করতে চান?',
    noBankRefund: '❌ ব্যাংক রিফান্ড নেই — শুধু ওয়ালেট ক্রেডিট',
    walletCredit: 'ওয়ালেট ক্রেডিট', penaltyDeduct: 'বাতিলকরণ জরিমানা (১ ঘন্টা)',
    blacklistWarning: '⛔ ব্ল্যাকলিস্ট সতর্কতা',
    directContactProhibited: 'সরাসরি যোগাযোগ কঠোরভাবে নিষিদ্ধ',
    understood: '✅ বুঝেছি — প্ল্যাটফর্ম ব্যবহার করব',
    lockWarning: 'Teltonika GPS-এর মাধ্যমে মেশিনের ইগনিশন দূরবর্তীভাবে নিষ্ক্রিয় করা হবে।',
    lockConfirm: '🔒 লক নিশ্চিত করুন', allStats: 'সম্পূর্ণ পরিসংখ্যান',
    changeLanguage: 'ভাষা পরিবর্তন করুন',
  },
};

// Fallback: languages without native files start from Hindi bundle
['ur'].forEach((code) => {
  TRANSLATIONS[code] = { ...TRANSLATIONS.hi };
});

// Urdu overrides (RTL)
TRANSLATIONS.ur = {
  ...TRANSLATIONS.hi,
  appName: 'ڈیولپمنٹ ایکسپریس',
  tagline: 'بنیادی ڈھانچے کا سنہری معیار',
  platform: 'تعمیرات مینجمنٹ پلیٹ فارم',
  selectRole: 'کردار منتخب کریں',
  emailAddress: 'ای میل پتہ',
  password: 'پاس ورڈ',
  signIn: 'سائن ان کریں',
  logout: 'لاگ آؤٹ',
  sessionRevokedAlert: 'آپ کسی دوسرے آلے پر لاگ ان ہیں۔ براہِ کرم دوبارہ لاگ ان کریں۔',
  changeLanguage: 'زبان تبدیل کریں',
  // --- Recent feature strings ---
  monthlySalaryLabel: 'ماہانہ تنخواہ (₹/مہینہ)',
  monthlySalaryPlaceholder: 'مثلاً 25000',
  dailyPayrollHint: 'روزانہ تنخواہ کی شرح = ماہانہ تنخواہ ÷ 26 کام کے دن',
  monthlySalaryRequired: 'ماہانہ تنخواہ درکار (صفر سے زیادہ)',
  advanceBalance: 'ایڈوانس بیلنس',
  closeAdvance: 'ایڈوانس بند کریں',
  giveAdvance: 'ایڈوانس دیں',
  validAdvanceRequired: 'درست ایڈوانس رقم درکار (صفر سے زیادہ)',
  failedToRecordAdvance: 'ایڈوانس درج کرنے میں ناکام',
  amountLabel: 'رقم (₹)',
  amountPlaceholder: 'مثلاً 5000',
  noteOptional: 'نوٹ (اختیاری)',
  advanceNotePlaceholder: 'مثلاً تہوار ایڈوانس',
  outstandingBalance: 'باقی بیلنس',
  saving: 'محفوظ ہو رہا ہے...',
  recordAdvance: 'ایڈوانس درج کریں',
  recentTransactions: 'حالیہ لین دین',
  noAdvancesYet: 'ابھی تک کوئی ایڈوانس درج نہیں۔',
  advanceTxnLabel: '+ ایڈوانس',
  deductionTxnLabel: '− کٹوتی',
  perMonthSuffix: '/مہینہ',
  perDaySuffix: '/دن',
  failedToMarkAttendance: 'حاضری درج کرنے میں ناکام',
  failedToClockIn: 'کلاک ان ناکام',
  failedToClockOut: 'کلاک آؤٹ ناکام',
  loadedAttendanceRows: '{{count}} حاضری قطاریں لوڈ',
  hoursShort: 'گ',
  payrollPreview: 'پیرول پیش نظارہ',
  payrollRun: 'پیرول چلائیں',
  payrollAlreadyRun: 'اس مہینے کے لیے پیرول پہلے ہی چل چکا ہے',
  payrollGross: 'کل واجب الادا',
  payrollNet: 'خالص واجب الادا',
  payrollAdvanceDeducted: 'ایڈوانس کٹوتی',
  payrollRunSuccess: 'پیرول کامیابی سے چل گیا',
  payrollNoAmount: 'اس مہینے کے لیے کوئی واجب رقم نہیں',
  payrollMonth: 'پیرول مہینہ',
  exportPayrollCsv: 'پے رول CSV برآمد',
  payrollExportMonth: 'پے رول برآمد مہینہ',
  payrollDailyRate: 'روزانہ شرح',
  payrollHistory: 'پیرول تاریخ',
  payrollNoHistory: 'ابھی تک کوئی پیرول نہیں چلا',
  payrollColMonth: 'مہینہ',
  payrollColGross: 'کل',
  payrollColDeduction: 'ایڈوانس کٹوتی',
  payrollColNet: 'خالص تنخواہ',
  payrollColDate: 'تاریخ',
  downloadPayslip: 'پے سلپ ڈاؤن لوڈ',
  payslipTitle: 'ماہانہ پے سلپ',
  payslipEarnings: 'آمدنی',
  payslipDeductions: 'کٹوتیاں',
  payslipDaysWorked: 'کام کے دن',
  payslipGeneratedBy: 'Development Express کے ذریعے تیار',
  operatorPayrollTitle: 'میرا پیرول',
  payrollMonthlySalary: 'ماہانہ تنخواہ',
  payrollCurrentMonth: 'موجودہ مہینہ',
  payrollPreviousMonth: 'پچھلا مہینہ',
  ownerAttendanceTitle: 'حاضری',
  ownerAttendanceEdit: 'ترمیم',
  ownerAttendanceSave: 'محفوظ کریں',
  ownerAttendanceNoRecords: 'اس مہینے کے لیے کوئی حاضری ریکارڈ نہیں',
  ownerAttendanceOverrideSuccess: 'حاضری اپ ڈیٹ ہو گئی',
  ownerSalaryUpdated: 'تنخواہ کامیابی سے اپ ڈیٹ ہو گئی',
  ownerSalaryEditBtn: 'تنخواہ ترمیم',
  ownerSalaryNotSet: 'تنخواہ سیٹ نہیں — پیرول کے لیے تنخواہ سیٹ کریں',
  durationLabel: 'مدت',
  plQuotaLabel: 'تنخواہی چھٹی کوٹہ',
  plUsed: 'استعمال',
  plAllowed: 'اجازت',
  plRemaining: 'باقی',
  plQuotaUpdated: 'PL کوٹہ اپ ڈیٹ',
  plQuotaExhausted: 'PL کوٹہ ختم — تنخواہ کے بغیر چھٹی کے طور پر درج',
  plRemainingLabel: 'باقی PL',
  retryLabel: 'دوبارہ کوشش کریں',
  noAttendanceRecords: 'ابھی تک حاضری کے ریکارڈ نہیں',
  noFuelLogs: 'ابھی تک ایندھن کے لاگ نہیں',
  noIssuesYet: 'ابھی تک کوئی مسئلہ درج نہیں',
  failedToLoad: 'ڈیٹا لوڈ کرنے میں ناکام',
  failedToLoadReport: 'رپورٹ لوڈ کرنے میں ناکام',
  failedToLoadIssues: 'مسائل لوڈ کرنے میں ناکام',
  failedToLoadAlerts: 'الرٹس لوڈ کرنے میں ناکام',
  noRecordsMonth: 'اس مہینے کے لیے کوئی ریکارڈ نہیں',
  underReview: 'زیرِ جائزہ',
  issueResolved: 'حل ہو گیا',
  presentDaysLabel: 'حاضری کے دن',
  halfDaysLabel: 'آدھے دن',
  absentDaysLabel: 'غیر حاضر دن',
  totalHmrLabel: 'کل HMR',
  noActiveBookingIdle: 'کوئی فعال بکنگ نہیں — مشین بیکار',
  siteLocationNotCaptured: 'سائٹ کا مقام درج نہیں',
  siteLocationNotAvailable: 'سائٹ کا مقام دستیاب نہیں',
  bookingRefLabel: 'بکنگ Ref',
  alertPendingBookings: 'زیرِ التوا بکنگ',
  alertPendingPayouts: 'زیرِ التوا ادائیگیاں',
  alertLowFuel: 'کم ایندھن',
  alertOpenIssues: 'کھلے مسائل',
  alertComplianceExpiring: 'تعمیل ختم ہو رہی',
  alertServiceDue: 'سروس واجب',
  noMachineRunning: 'فی الحال کوئی مشین چل نہیں رہی',
  trackingEmptyHint: 'مشین بھیجنے کے بعد آپ کی فعال بکنگ یہاں ظاہر ہوگی۔',
  trackingUpdatedEvery5s: 'ہر 5 سیکنڈ میں اپ ڈیٹ',
  fuelLastOperatorUpdate: '(آپریٹر کا آخری اپ ڈیٹ)',
  alertExtensionPending: 'بکنگ توسیع زیرِ التوا',
  alertConfirmCompletion: 'براہِ کرم کام مکمل ہونے کی تصدیق کریں',
  alertWalletCredited: 'والٹ میں شامل',
  alertFeedbackRequest: 'کام مکمل — اپنی رائے شیئر کریں',
  noLogsYet: 'ابھی تک کوئی سرگرمی درج نہیں',
  todayActivityLog: 'آج کی سرگرمی کا لاگ',
  machineLogSubtitle: 'ایندھن، حاضری، مسائل — مقامی سیشن لاگ',
  timerPaused: 'Timer روکا گیا',
  liveBookingTitle: 'لائیو بکنگ',
  machineLogTimerHint: 'Timer Admin شروع کرتا ہے۔ نیچے اپنا اصل کام کا وقت درج کریں — مکمل ہونے پر Mark Work Complete پر کلک کریں۔',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'حاضری',
  ownerAlertBookingPending: 'نئی بکنگ آپ کی منظوری کے لیے زیرِ التوا —',
  ownerAlertBookingHours: 'گھنٹے',
  ownerAlertPayoutPending: '₹{{amount}} کی ادائیگی منتقلی کے لیے زیرِ التوا',
  ownerAlertFuelLow: 'ایندھن کم',
  ownerAlertFuelRemaining: 'باقی',
  ownerAlertIssue: 'مسئلہ درج',
  iotGpsDevicesActive: 'GPS آلات فعال',
  iotDashcamsOnline: 'ڈیش کیم آن لائن',
  iotFuelSensorsActive: 'فیول سینسر فعال',
  iotMachinesLocked: 'مشینیں لاک',
  iotDeviceStatus: 'IoT آلہ کی حیثیت',
  iotColMachine: 'مشین',
  iotColGps: 'GPS',
  iotColLocation: 'مقام',
  iotColFuel: 'فیول %',
  iotColDashcam: 'ڈیش کیم',
  iotColIgnition: 'اگنیشن',
  iotColAction: 'کارروائی',
  iotStatusOnline: 'آن لائن',
  iotStatusNotConnected: 'منسلک نہیں',
  iotStatusLive: 'لائیو',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'لاک',
  iotNotConnectedBanner: 'IoT ہارڈویئر ابھی نصب نہیں ہے۔ Teltonika آلہ کی تنصیب کے بعد GPS، ڈیش کیم اور ریموٹ لاک کی سہولیات دستیاب ہوں گی۔',
  fuelUpdateTitle: 'فیول اپ ڈیٹ',
  fuelSensorAccuracyNote: 'آپریٹر نے فیول کی سطح درج کی · دستی اندراج',
  bookingsTab: 'بکنگ',
  unknownLabel: 'نامعلوم',
  naLabel: 'N/A',
  baseLabel: 'بنیاد',
  qtyLabel: 'مقدار',
  actualHrsLabel: 'اصل گھنٹے',
  auditStatTotal: 'کل',
  auditStatSecurity: 'سیکیورٹی',
  auditStatActors: 'اداکار',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'غیر-Admin',
  kycDocLicense: 'لائسنس',
  kycDocAadhaarFront: 'Aadhaar سامنے',
  kycDocAadhaarBack: 'Aadhaar پیچھے',
  kycDocPoliceVerification: 'پولیس تصدیق',
  kycVerification: 'KYC تصدیق',
  kycNotSubmitted: 'KYC جمع نہیں',
  kycUnderReview: 'KYC زیرِ جائزہ',
  kycVerified: 'KYC تصدیق شدہ',
  kycRejected: 'KYC مسترد',
  kycAadhaarFront: 'Aadhaar سامنے',
  kycAadhaarBack: 'Aadhaar پیچھے',
  kycSelfie: 'سیلفی',
  kycSubmitBtn: 'KYC دستاویزات جمع کریں',
  kycSubmitSuccess: 'دستاویزات جمع — زیرِ جائزہ',
  kycResubmit: 'دوبارہ دستاویزات جمع کریں',
  adminKycTitle: 'کلائنٹ KYC جائزے',
  adminKycAllFilter: 'سب',
  adminKycNoSubmissions: 'ابھی تک کوئی KYC جمع نہیں',
  adminOwnerKycTitle: 'مالک KYC جائزے',
  adminOwnerKycNoSubmissions: 'ابھی تک کوئی مالک KYC جمع نہیں',
  adminOperatorKycTitle: 'آپریٹر KYC جائزے',
  adminOperatorKycNoSubmissions: 'ابھی تک کوئی آپریٹر KYC جمع نہیں',
  kycRejectedWarning: 'آپ کا KYC مسترد ہو گیا۔ براہ کرم دستاویزات دوبارہ جمع کریں۔',
  kycNotSubmittedHint: 'قابلِ اعتماد تجربے کے لیے KYC مکمل کریں۔',
  kycPendingHint: 'آپ کا KYC زیرِ جائزہ ہے۔',
  kycGoToTab: 'KYC پر جائیں',
  adminKycApproveBtn: 'منظور',
  adminKycRejectBtn: 'مسترد',
  adminKycViewDocs: 'دستاویزات دیکھیں',
  adminKycRejectReason: 'مسترد کرنے کی وجہ',
  adminKycRereviewBtn: 'دوبارہ جائزہ',
  kycPan: 'PAN کارڈ',
  kycOwnerSubmitSuccess: 'دستاویزات جمع — آپ کا KYC زیرِ جائزہ ہے',
  kycLicense: 'ڈرائیونگ لائسنس',
  kycPoliceVerification: 'پولیس تصدیق',
  kycOperatorSubmitSuccess: 'دستاویزات جمع — آپ کا KYC زیرِ جائزہ ہے',
  operatorKycRejectedAssign: 'اس آپریٹر کا KYC مسترد ہو گیا — دوبارہ منظور ہونے تک انہیں تفویض نہیں کیا جا سکتا۔',
  operatorsColOperator: 'آپریٹر',
  operatorsColEmail: 'ای میل',
  operatorsColPhone: 'فون',
  operatorsColDocuments: 'دستاویزات',
  operatorsColStatus: 'حالت',
  operatorsDocumentsBtn: 'دستاویزات ({{count}})',
  operatorsNoResults: 'کوئی آپریٹر نہیں ملا',
  operatorsAllTitle: 'تمام آپریٹر ({{count}})',
  operatorsKycDialogDesc: 'KYC دستاویزات',
  bookingsCountLabel: '{{count}} بکنگ',
  complianceDates: 'تعمیل کی تاریخیں',
  complianceInsurance: 'انشورنس',
  complianceRcBook: 'RC بک',
  compliancePuc: 'PUC',
  complianceNotSet: 'سیٹ نہیں',
  complianceExpired: 'میعاد ختم',
  complianceExpiringSoon: 'جلد ختم ہو رہا ہے',
  complianceExpiringCritical: '7 دن میں ختم',
  complianceValid: 'درست',
  complianceUpdateBtn: 'تعمیل کی تاریخیں اپڈیٹ کریں',
  complianceSaveBtn: 'محفوظ کریں',
  complianceAlertsTitle: 'تعمیل الرٹس',
  complianceAllCompliant: 'تمام مشینیں تعمیل شدہ ✅',
  complianceColMachine: 'مشین',
  complianceColOwner: 'مالک',
  complianceColInsurance: 'انشورنس',
  complianceColRcBook: 'RC بک',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'شروع کی تاریخ',
  complianceEndDate: 'اختتام کی تاریخ',
  complianceExtractBtn: 'تاریخیں خود بھرنے کے لیے دستاویز اپلوڈ کریں',
  complianceExtractSuccess: 'تاریخیں نکال لی گئیں — محفوظ کرنے سے پہلے تصدیق کریں',
  complianceExtractError: 'تاریخیں نکال نہیں سکیں — براہ کرم دستی درج کریں',
  complianceExtracting: 'دستاویز پڑھ رہے ہیں...',
  serviceHistory: 'سروس کی تاریخ',
  serviceLastService: 'آخری سروس',
  serviceNoRecords: 'ابھی تک کوئی سروس ریکارڈ نہیں',
  serviceNextDue: 'اگلی سروس واجب',
  serviceNextHmr: 'اگلی سروس پر',
  serviceAddLog: 'سروس لاگ شامل کریں',
  serviceDate: 'سروس کی تاریخ',
  serviceType: 'سروس کی قسم',
  serviceHmr: 'سروس پر HMR',
  serviceNextDate: 'اگلی سروس کی تاریخ',
  serviceWorkDone: 'کام مکمل',
  serviceNotes: 'نوٹس',
  serviceTypeRoutine: 'معمول',
  serviceTypeMajor: 'بڑی',
  serviceTypeBreakdown: 'خرابی',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'دیگر',
  serviceOverdue: 'تاخیر شدہ',
  serviceDueSoon: 'جلد واجب',
  fleetAnalytics: 'فلیٹ تجزیات',
  analyticsRevenue: 'کل آمدنی',
  analyticsBookings: 'کل بکنگ',
  analyticsHours: 'کل گھنٹے',
  analyticsActiveMachines: 'فعال مشینیں',
  analyticsMonthlyTrend: 'ماہانہ آمدنی کا رجحان',
  analyticsMachineTable: 'مشین کے لحاظ سے آمدنی',
  analyticsNoData: 'اس مدت میں کوئی مکمل بکنگ نہیں',
  analyticsLastBooking: 'آخری بکنگ',
  analytics3Months: '3 ماہ',
  analytics6Months: '6 ماہ',
  analytics12Months: '12 ماہ',
  adminAnalytics: 'تجزیات',
  adminFleetTitle: 'فلیٹ تجزیات',
  adminFleetPlatformRevenue: 'پلیٹ فارم آمدنی',
  adminFleetActiveOwners: 'فعال مالکان',
  adminFleetOwnerCol: 'مالک',
  adminFleetMonthlyTrend: 'ماہانہ آمدنی کا رجحان',
  adminFleetMachineTable: 'مشین کے لحاظ سے آمدنی',
  adminFleetNoData: 'اس مدت میں کوئی مکمل بکنگ نہیں',
  adminFinancialIntelligence: 'مشین مالی ذہانت',
  adminTotalInvested: 'کل سرمایہ کاری',
  adminTotalEarned: 'کل آمدنی',
  adminAvgRecovery: 'اوسط بحالی',
  adminBreakEvenRate: 'بریک ایون ریٹ',
  adminProfitMargin: 'منافع کا مارجن',
  adminNoFinancialData: 'ابھی تک مالی ڈیٹا والے مشینیں نہیں',
  adminMachineDetail: 'مشین کی تفصیل',
  adminCallOwner: 'مالک کو کال کریں',
  adminWhatsappOwner: 'WhatsApp مالک',
  marketPosition: 'مارکیٹ پوزیشن',
  marketBelowMarket: 'مارکیٹ سے نیچے',
  marketCompetitive: 'مسابقتی',
  marketAboveMarket: 'مارکیٹ سے اوپر',
  marketNoData: 'آپ کے علاقے کے لیے ابھی مارکیٹ ڈیٹا نہیں',
  marketSubmitRate: 'مارکیٹ ریٹ جمع کریں',
  marketCity: 'شہر / علاقہ',
  dieselTaluka: 'شہر / علاقہ',
  bookingAttachment: 'اٹیچمنٹ منتخب کریں',
  bookingAttachmentNone: 'کوئی مخصوص اٹیچمنٹ نہیں',
  bookingWorkDescription: 'کام کی تفصیل',
  bookingWorkDescriptionPlaceholder: 'مثلاً بنیاد کھدائی، ٹرینچنگ، پائپ لائن کام',
  bookingAttachmentLabel: 'اٹیچمنٹ',
  bookingSiteLabel: 'سائٹ',
  bookingWorkLabel: 'کام',
  termsAccept: 'میں شرائط و ضوابط سے اتفاق کرتا/کرتی ہوں',
  termsRequired: 'رجسٹریشن کے لیے شرائط و ضوابط قبول کرنا ضروری ہے',
  termsLink: 'شرائط و ضوابط',
  clientBlacklisted: 'بلیک لسٹ',
  clientBlacklistReason: 'بلیک لسٹ کی وجہ',
  clientBlacklistConfirm: 'اس کلائنٹ کو بلیک لسٹ کریں؟',
  clientUnblacklist: 'بلیک لسٹ سے ہٹائیں',
  blacklistedClients: 'بلیک لسٹ کلائنٹس',
  blacklistedClientsEmpty: 'کوئی بلیک لسٹ کلائنٹ نہیں',
  managerAccessRestricted: 'مالی رسائی محدود ہے۔ اوم چوان سے رابطہ کریں۔',
  managerSection: 'مینیجرز',
  managerAdd: 'مینیجر شامل کریں',
  managerName: 'مینیجر کا نام',
  managerEmail: 'مینیجر ای میل',
  managerPassword: 'عارضی پاس ورڈ',
  managerCreated: 'مینیجر اکاؤنٹ بن گیا',
  managerCredentialsTitle: 'مینیجر لاگ ان تفصیلات',
  managerCredentialsSubtitle: 'یہ تفصیلات اب محفوظ کریں — پاس ورڈ بعد میں حاصل نہیں ہو سکتا',
  managerCredentialsSaved: 'میں نے تفصیلات محفوظ کر لی ہیں',
  managerLoginUrl: 'لاگ ان URL',
  managerActivity: 'مینیجر سرگرمی',
  managerActivityEmpty: 'ابھی تک کوئی سرگرمی درج نہیں',
  managerActivityViewAll: 'تمام سرگرمی دیکھیں',
  onboardingTitle: 'شروع کریں',
  onboardingAccountApproved: 'اکاؤنٹ منظور',
  onboardingKycComplete: 'KYC تصدیق مکمل',
  onboardingKycPending: 'KYC تصدیق مکمل کریں',
  onboardingKycRejected: 'KYC مسترد — دوبارہ جمع کروائیں',
  onboardingWalletFunded: 'والٹ بھری ہوئی ہے',
  onboardingWalletEmpty: 'بکنگ کے لیے والٹ میں رقم شامل کریں',
  pushEnablePrompt: 'فوری اپڈیٹس کے لیے پش نوٹیفکیشنز آن کریں',
  downloadDisputeStatement: 'تنازعہ بیان ڈاؤن لوڈ کریں',
  downloadInvoice: 'انوائس ڈاؤن لوڈ کریں',
  bookAgain: 'دوبارہ بک کریں',
  machineNoLongerAvailable: 'مشین اب دستیاب نہیں ہے',
  downloadHistoryPdf: 'ہسٹری PDF ڈاؤن لوڈ کریں',
  onboardingFirstBooking: 'اپنی پہلی بکنگ کریں',
  onboardingAllDone: 'آپ تیار ہیں!',
  onboardingTrackerTitle: 'آن بورڈنگ پیش رفت',
  onboardingTrackerTarget: 'آن بورڈنگ ہدف: 48 گھنٹے',
  onboardingTrackerInProgress: 'جاری ہے',
  onboardingTrackerActionRequired: 'کارروائی درکار',
  onboardingTrackerComplete: 'مکمل',
  onboardingTrackerPending: 'زیر التوا',
  onboardingTrackerPhase1: 'رجسٹریشن',
  onboardingTrackerPhase2: 'KYC تصدیق',
  onboardingTrackerPhase3: 'مشین رجسٹریشن',
  onboardingTrackerPhase4: 'پہلی بکنگ تیار',
  onboardingTrackerHelper1: 'مشین رجسٹریشن کھولنے کے لیے آدھار + سیلفی اپ لوڈ کریں',
  onboardingTrackerHelper2: 'KYC جائزے میں — عام طور پر 24 گھنٹوں میں',
  onboardingTrackerHelper3: 'KYC مسترد — دستاویزات دوبارہ جمع کروائیں',
  onboardingTrackerHelper4: 'KYC منظور — اپنی پہلی مشین شامل کریں',
  onboardingTrackerHelper5: 'مشین ایڈمن جائزے میں',
  onboardingTrackerHelper6: 'مشین لائیو — پہلی بکنگ کا انتظار',
  onboardingTrackerPhaseLabel: 'مرحلہ',
  alertsAndNotifications: 'الرٹس اور اطلاعات',
  marketMinRate: 'آپ کے علاقے میں کم از کم ریٹ (₹/گھنٹہ)',
  marketMaxRate: 'آپ کے علاقے میں زیادہ سے زیادہ ریٹ (₹/گھنٹہ)',
  marketRateSubmitted: 'مارکیٹ ریٹ جمع ہو گئی — شکریہ!',
  marketDataPoints: '{{count}} جمع پر مبنی',
  marketRange: '{{city}} میں مارکیٹ',
  marketSourceLocal: '{{city}} علاقے کی ریٹس پر مبنی',
  marketSourcePlatform: 'پلیٹ فارم بھر کی ریٹس پر مبنی',
  adminMarketRates: 'مارکیٹ ریٹ جمع',
  adminMarketRateDelete: 'حذف',
  adminMarketRateDeleteConfirm: 'کیا اس مارکیٹ ریٹ جمع کو حذف کریں؟',
  adminMarketRateDeleted: 'مارکیٹ ریٹ حذف ہو گئی',
  adminMarketRateNoData: 'ابھی تک کوئی مارکیٹ ریٹ جمع نہیں',
  marketRateApprove: 'منظور کریں',
  marketRateReject: 'مسترد کریں',
  marketRateApproved: 'منظور',
  marketRateRejected: 'مسترد',
  marketRatePending: 'زیر التوا',
  marketRateReviewed: 'مارکیٹ ریٹ کا جائزہ ہو گیا',
  marketRatePendingReview: 'آپ کا ریٹ جمع ہو گیا ہے اور ایڈمن جائزے کے لیے زیر التوا ہے۔',
  marketRateEditApprove: 'ترمیم کریں اور منظور کریں',
  marketRateEditMin: 'درست کم از کم ریٹ (₹/گھنٹہ)',
  marketRateEditMax: 'درست زیادہ سے زیادہ ریٹ (₹/گھنٹہ)',
  adminPayrollOverview: 'پے رول جائزہ',
  adminPayrollTotalOperators: 'کل آپریٹرز',
  adminPayrollTotalGross: 'کل واجب الادا',
  adminPayrollTotalNet: 'کل خالص واجب الادا',
  adminPayrollNoData: 'اس مہینے کے لیے کوئی پے رول ڈیٹا نہیں',
  subTabSchedule: 'شیڈول',
  subTabHistory: 'تاریخ',
  subTabAnalytics: 'تجزیات',
  clientAnalyticsTitle: 'بکنگ تجزیات',
  clientAnalyticsSpend: 'کل خرچ',
  clientAnalyticsHours: 'کل گھنٹے',
  clientAnalyticsBookings: 'مکمل بکنگ',
  clientAnalyticsMachines: 'استعمال شدہ مشینیں',
  clientAnalyticsAvgSpend: 'فی بکنگ اوسط',
  clientAnalyticsMonthlyTrend: 'ماہانہ خرچ کا رجحان',
  clientAnalyticsTopMachines: 'سرفہرست مشینیں',
  clientAnalyticsNoData: 'اس مدت میں کوئی مکمل بکنگ نہیں',
  operatorAnalyticsTitle: 'کام کی تجزیات',
  operatorAnalyticsPresentDays: 'حاضر دن',
  operatorAnalyticsHalfDays: 'آدھے دن',
  operatorAnalyticsHmr: 'کل HMR',
  operatorAnalyticsJobs: 'مکمل کام',
  operatorAnalyticsIssues: 'رپورٹ شدہ مسائل',
  operatorAnalyticsAvgHmr: 'اوسط HMR/دن',
  operatorAnalyticsMonthlyTrend: 'ماہانہ کام کا رجحان',
  operatorAnalyticsIssueBreakdown: 'قسم کے لحاظ سے مسائل',
  operatorAnalyticsRecentJobs: 'حالیہ کام',
  operatorAnalyticsNoData: 'اس مدت میں کوئی کام ریکارڈ نہیں',
  adminServiceAlertsTitle: 'سروس الرٹس',
  adminServiceAllOk: 'تمام مشینوں کی سروس ریکارڈز اپ ٹو ڈیٹ ہیں ✅',
  adminServiceNoRecord: 'کوئی ریکارڈ نہیں',
  adminServiceColLastService: 'آخری سروس',
  adminServiceColNextDue: 'اگلی واجب',
  adminServiceColServiceStatus: 'سروس کی حالت',
  adminMachinesColMinHrs: 'کم از کم گھنٹے',
  adminMachinesColRateDay: 'شرح/دن',
  adminClientName: 'کلائنٹ کا نام',
  adminOwnerName: 'مالک کا نام',
  adminPayoutWallet: 'ادائیگی والٹ',
  adminFooterMachines: 'مشینیں',
  adminFooterClients: 'کلائنٹس',
  adminFooterOwners: 'مالکان',
  auditIntroBanner: 'لاگ ان، ایڈمن کارروائیاں اور سیکیورٹی واقعات۔ فلٹرز لوڈ شدہ نتائج پر لاگو ہوتے ہیں؛ پرانی قطاروں کے لیے مزید لوڈ کریں۔',
  auditLoaded: 'لوڈ شدہ',
  auditMoreAvailable: 'مزید دستیاب',
  auditEndOfList: 'فہرست کا اختتام',
  auditFilterActive: 'فلٹر فعال',
  auditFiltersActive: 'فلٹرز فعال',
  auditSeverityBreakdown: 'شدت کی تفصیل (موجودہ فہرست)',
  auditPressSlash: 'ایکشن فلٹر پر فوکس کرنے کے لیے / دبائیں',
  auditFilters: 'فلٹرز',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'تمام کردار',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'میٹا ڈیٹا JSON تلاش کریں',
  auditFilterFromPlaceholder: 'تاریخ اور وقت سے',
  auditFilterToPlaceholder: 'تاریخ اور وقت تک',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'ٹائم زون:',
  auditTimezoneSuffix: '(مقامی)',
  auditHideCsvOptions: 'CSV کالم اختیارات چھپائیں',
  auditShowCsvOptions: 'CSV کالم اختیارات دکھائیں',
  auditCsvColCreatedAt: 'تخلیق کی تاریخ',
  auditCsvColAction: 'کارروائی',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'میٹا ڈیٹا',
  auditFooterLoaded: 'لوڈ شدہ',
  auditFooterLogs: 'آڈٹ لاگز',
  auditFooterMoreAvailable: '(مزید دستیاب)',
  auditFooterAllLoaded: '(تمام لوڈ شدہ)',
  auditActor: 'ایکٹر',
  auditEntity: 'انٹیٹی',
  auditSeverityCritical: 'انتہائی',
  auditSeverityHigh: 'زیادہ',
  auditSeverityMedium: 'درمیانہ',
  auditSeverityNormal: 'عام',
  auditCopyEvent: 'ایونٹ کاپی کریں',
  auditViewDetails: 'تفصیل دیکھیں',
  auditHideDetails: 'تفصیل چھپائیں',
  auditCopyJson: 'JSON کاپی کریں',
  auditNoLogs: 'کوئی آڈٹ لاگ نہیں',
  auditEventLog: 'ایونٹ لاگ',
  notificationCenter: 'اطلاعات',
  notifChannelAll: 'سب',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ای میل',
  notifChannelPush: 'پش',
  notifChannelSms: 'SMS',
  notifStatusSent: 'بھیجا گیا',
  notifStatusFailed: 'ناکام',
  notifStatusPending: 'زیرِ التوا',
  notifEmpty: 'ابھی کوئی اطلاع نہیں',
  notifLoadMore: 'مزید لوڈ کریں',
  adminNotifLog: 'اطلاعات لاگ',
  adminNotifColUser: 'صارف',
  adminNotifColRole: 'کردار',
  adminNotifNoData: 'ابھی تک کوئی اطلاع لاگ نہیں',
  duration: 'مدت',
  cycles: 'سائیکل',
  txRecharge: 'والٹ ریچارج',
  txBookingAdvance: 'بکنگ ایڈوانس',
  txBookingPayment: 'بکنگ ادائیگی',
  txSettlement: 'سیٹلمنٹ',
  txRefund: 'ریفنڈ',
  txPenalty: 'جرمانہ',
  txCommission: 'کمیشن',
  filterAll: 'سب',
  filterCompleted: 'مکمل',
  filterCancelled: 'بند',
  filterPending: 'زیر التوا',
  filterDisputed: 'تنازعہ',
  tacTitle: 'شرائط و ضوابط',
  tacPrivacy: 'رازداری کی پالیسی',
  tacRefund: 'ریفنڈ پالیسی',
  tacCancellation: 'منسوخی کی پالیسی',
  tacServiceDelivery: 'سروس ڈیلیوری پالیسی',
  tacIntro: 'بکنگ سے پہلے ہماری پالیسیاں دیکھیں',
  tacBannerTitle: 'شرائط کی تازہ کاری دستیاب',
  tacBannerOpen: 'شرائط کھولیں',
  tacBannerAgree: 'میں نے پڑھ لیا ہے اور متفق ہوں',
  tacBannerLater: 'بعد میں',
  clientPoliciesTitle: 'کلائنٹ پالیسیاں',
  machineGroupAvailable: 'دستیاب',
  machineGroupBusy: 'مصروف',
  dewateringReferral: 'ڈی واٹرنگ (پمپ) سروس چاہیے؟ MachineOS جلد پمپ ٹھیکیدار خدمات شامل کرے گا۔ ریفرل کے لیے سپورٹ سے رابطہ کریں۔',
  noActiveWork: 'اس مہینے کوئی فعال کام نہیں',
  accountTab: 'اکاؤنٹ',
  recentActivity: 'حالیہ سرگرمی',
  goodMorning: 'صبح بخیر',
  goodAfternoon: 'دوپہر بخیر',
  goodEvening: 'شام بخیر',
  bookingClosed: 'بند',
  sectionNew: 'نیا',
  sectionAccepted: 'منظور شدہ',
  sectionActive: 'فعال',
  sectionDispatched: 'ڈسپیچ',
  sectionCompleting: 'تکمیل',
  sectionDisputed: 'تنازعہ',
  sectionCompleted: 'مکمل',
  sectionClosed: 'بند',
  machineMonthlyOperatingExpenses: 'ماہانہ آپریٹنگ اخراجات',
  machineOperatorMonthlySalary: 'آپریٹر ماہانہ تنخواہ',
  machineServiceMonthly: 'سروس / دیکھ بھال (ماہانہ)',
  machineBreakdownMonthly: 'بریک ڈاؤن / مرمت (ماہانہ اوسط)',
  machineMaterialsMonthly: 'مواد / قابل استعمال (ماہانہ)',
};
/*
 * gu/ta/ml/pa/bn only defined ~150 keys; newer portal/owner keys were missing
 * so t() fell back to English. Merge: English base → Hindi fill → locale overrides.
 * mr stays Marathi-first (English only for gaps).
 * te/kn/ta/gu/bn: pure native — English only for gaps, never Hindi.
 */
const EN_BASE = {
  ...TRANSLATIONS.en,
  // Client
  activeBookingWarning: 'This machine already has an active booking (#{{ref}}). Complete it before making a new booking.',
  confirmDuplicateActiveBooking: 'This machine already has an active booking (#{{ref}}). Book again anyway?',
  experienceNotAvailable: 'Experience N/A',
  yearsExpShort: '{{n}} yrs exp',
  walletStatusOk: 'OK',
  walletStatusLow: 'Low',
  liveBadge: 'LIVE',
  // Owner
  ownerBankDetailsIncomplete: 'Bank details incomplete',
  ownerPayoutBlockedNoBank: 'Payout will be blocked — please add bank details',
  ownerAddBankDetailsBtn: 'Add bank details →',
  noAlertsNow: 'No alerts at this time.',
  notificationCenter: 'Message Log',
  navSectionMachineManagement: 'Machine Management',
  navSectionFinance: 'Finance',
  navSectionOperations: 'Operations',
  navSectionAccount: 'Account',
  notifChannelAll: 'All',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'Email',
  notifChannelPush: 'Push',
  notifChannelSms: 'SMS',
  notifStatusSent: 'Sent',
  notifStatusFailed: 'Failed',
  notifStatusPending: 'Pending',
  notifEmpty: 'No notifications yet',
  notifLoadMore: 'Load more',
  machineUpdateFailed: 'Update failed. Try again.',
  editMachineRatesTitle: 'Edit machine rates',
  ratePerHourLabel: 'Rate per hour (₹)',
  minimumHoursLabel: 'Minimum hours',
  ratePerDayLabel: 'Rate per day (₹)',
  fuelCapacityLabel: 'Fuel capacity (L)',
  machineFinancialSection: 'Machine Purchase Details (Optional)',
  machineOwnershipType: 'Ownership Type',
  machineOwnershipNew: 'New Machine',
  machineOwnershipUsed: 'Original Owner',
  machineOwnershipSecondHand: 'Pre-Owned',
  machinePurchasePrice: 'Purchase Price (₹)',
  machinePurchasePriceHint: 'Amount you paid for this machine',
  machinePurchaseDate: 'Purchase Date',
  machineYearOfManufacture: 'Year of Manufacture',
  machineLoanSection: 'I have a loan on this machine',
  machineLoanAmount: 'Loan Amount (₹)',
  machineLoanEmi: 'Monthly EMI (₹)',
  machineLoanTenure: 'Loan Tenure (months)',
  machineLoanStartDate: 'Loan Start Date',
  machineFuelConsumption: 'Fuel Consumption (L/hr)',
  machineMonthlyOperatingExpenses: 'Monthly Operating Expenses',
  machineOperatorMonthlySalary: 'Operator Monthly Salary',
  machineServiceMonthly: 'Service / Maintenance (Monthly)',
  machineBreakdownMonthly: 'Breakdown / Repair (Monthly Avg)',
  machineMaterialsMonthly: 'Materials / Consumables (Monthly)',
  recoveryPlan: 'Recovery Plan',
  recoveryOnTrack: 'On Track',
  recoveryNeedsAttention: 'Needs Attention',
  recoveryActionRequired: 'Action Required',
  recoveryAddPrice: 'Add purchase price to see recovery plan',
  recoveryProgress: 'Investment Recovered',
  recoveryDailyNet: 'Daily Net Income',
  recoveryDays: 'Recovery Period',
  recoveryProjectedDate: 'Projected Recovery Date',
  recoveryRoi: 'Annual Return',
  recoveryCurrentValue: 'Current Machine Value',
  recoveryBackfillNudge: 'Add purchase details to {{count}} machine(s) to unlock recovery tracking',
  editFinancialDetails: 'Edit Financial Details',
  financialDetailsSaved: 'Financial details saved',
  dieselPriceTitle: 'Diesel Price',
  dieselPriceUpdate: 'Update Diesel Price',
  dieselPriceLatest: 'Latest Price',
  dieselPriceNoRecord: 'No diesel price recorded',
  dieselPricePerLitre: 'Price per litre (₹)',
  dieselQuantity: 'Quantity filled (litres)',
  dieselTaluka: 'City / Area',
  dieselFuelCostPerHour: 'Fuel cost per hour',
  dieselPercentOfRate: 'of your hourly rate',
  dieselPriceSaved: 'Diesel price saved',
  dieselRateSuggestion: 'Rate Suggestion',
  dieselRateIncrease: 'Diesel up — consider increasing rate by',
  dieselRateDecrease: 'Diesel down — lower rate by to attract more bookings',
  dieselSuggestedRate: 'Suggested rate',
  dieselHistory: 'Price History',
  dieselNoHistory: 'No diesel price history yet',
  dieselColDate: 'Date',
  dieselColPrice: 'Price/litre',
  dieselColQty: 'Quantity',
  dieselColSource: 'Source',
  dieselUploadReceipt: 'Upload Receipt',
  dieselExtractSuccess: 'Extracted from receipt',
  dieselExtractFailed: 'Could not extract — please enter manually',
  applyRateSuggestion: 'Apply ₹{{rate}}/hr',
  rateSuggestionApplied: 'Rate updated successfully',
  marketPosition: 'Market Position',
  marketBelowMarket: 'Below Market',
  marketCompetitive: 'Competitive',
  marketAboveMarket: 'Above Market',
  marketNoData: 'No market data for your area yet',
  marketSubmitRate: 'Submit Market Rate',
  marketCity: 'City / Area',
  marketMinRate: 'Min rate in your area (₹/hr)',
  marketMaxRate: 'Max rate in your area (₹/hr)',
  marketRateSubmitted: 'Market rate submitted — thank you!',
  marketDataPoints: 'Based on {{count}} submission(s)',
  marketRange: 'Market in {{city}}',
  marketSourceLocal: 'Based on {{city}} area rates',
  marketSourcePlatform: 'Based on platform-wide rates',
  editRatesBtn: '✏️ Edit rates',
  editRegistrationInfo: 'Edit Registration Info',
  editRegistrationInfoHint:
    'Update rates, negotiable floor, attachments, financial details, or compliance dates for an approved machine. Changes apply immediately.',
  editRegistrationPickMachine: 'Select machine',
  editRegistrationPickPlaceholder: 'Choose a machine…',
  editRegistrationSelectPrompt: 'Select a machine above to open its registration editors.',
  myMachinesEditRegistrationBtn: '✏️ Edit registration info',
  myMachinesComplianceSummary: 'Insurance status',
  lockedRegistrationFieldsTitle: 'Locked registration fields',
  lockedRegistrationFieldsNote:
    'Contact admin to correct these — locked to prevent identity fraud.',
  lockedFieldRegNo: 'Registration number',
  lockedRegistrationDocuments: 'Documents / photos',
  lockedRegistrationDocumentsNone: 'No document links available in this view.',
  lockedRegistrationDocumentOnFile: 'on file',
  assignOperatorFailed: 'Failed to assign operator.',
  unassignOperatorFailed: 'Failed to unassign operator.',
  genericError: 'Something went wrong.',
  // Admin
  confirmDeactivateOperator: 'Deactivate this operator? They will be auto-unassigned from their machine.',
  inviteGenerateFailed: 'Failed to generate invite code.',
  inviteCodeCopied: 'Invite code copied! Valid for 24 hours.',
  userApprovedPdfDownloaded: 'Approved! Agreement PDF downloaded.',
  userApprovalFailed: 'Approval failed. Please try again.',
  userRejectedSuccess: 'Rejected!',
  userRejectionFailed: 'Rejection failed. Please try again.',
  deactivateFailed: 'Deactivate failed. Try again.',
  reactivateFailed: 'Reactivate failed. Try again.',
  panDocumentUnavailable: 'PAN document not available.',
  sessionExpiredRefresh: 'Session expired. Refresh page or login again.',
  sessionExpiredSignIn: 'Session expired. Please sign in again.',
  sessionRevokedAlert: 'You have been logged in on another device. Please login again.',
  activateBtn: '✓ Activate',
  deactivateBtn: '✕ Deactivate',
  reactivateBtn: 'Reactivate',
  ownerApprovedStatus: 'Owner Approved',
  awaitingOwnerApprovalStatus: 'Awaiting Owner Approval',
  pendingApprovalStatus: 'Pending Approval',
  statusDisputed: 'Disputed',
  statusApproved: 'Approved',
  statusPending: 'Pending',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  statusRejected: 'Rejected',
  statusCompleted: 'Completed',
  statusCancelled: 'Cancelled',
  bookingClosed: 'Closed',
  sectionNew: 'New',
  sectionAccepted: 'Accepted',
  sectionActive: 'Active',
  sectionDispatched: 'Dispatched',
  sectionCompleting: 'Completing',
  sectionDisputed: 'Disputed',
  sectionCompleted: 'Completed',
  sectionClosed: 'Closed',
  gstPdfBtn: 'GST PDF',
  minBooking: 'Min. booking',
  hrsShort: 'hrs',
  machineGstFuelNote: '* GST 18% · Fuel included · Operator included',
  cancelCreditBanner: '{{machine}} Cancelled | ₹{{amount}} Wallet Credit!',
  advanceDeductedFromWallet: 'Advance will be deducted from your Wallet',
  cancelText: 'Cancel',
  machineLabel: 'Machine',
  walletCreditFull: 'Wallet Credit (full advance)',
  escrowNote: 'Before dispatch — advance returns to your wallet (not bank refund).',
  currentWalletBalance: 'Current: ₹{{amount}}',
  bookPayAdvance: 'BOOK — Pay ₹{{amount}} Advance',
  walletLabel: 'Wallet: ₹{{amount}}',
  gstInvoiceHint: '{{count}} GST invoice(s) — download "GST PDF" per completed booking below.',
  totalWithGst: 'Total: ₹{{total}} (GST ₹{{gst}})',
  machineDispatchedAt: 'Machine Dispatched',
  emailLabel: 'Email',
  totalMachines: 'Total Machines',
  activeFleet: 'Active Fleet',
  activeToday: 'Active Today',
  revenueMonth: 'Revenue (Month)',
  liveBookings: 'Live bookings',
  noDataYet: 'No data yet',
  myCommission: 'My Commission',
  commissionPctTotal: '15% of total',
  activeClients: 'Active Clients',
  lowFuelAlert: 'Low Fuel Alert',
  actionNeeded: '⚠ Action needed',
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
  totalBookings: 'Total Bookings',
  activeNow: 'Active Now',
  totalRevenue: 'Total Revenue',
  todayLabel: 'Today',
  loadedBookings: 'Loaded {{count}} bookings',
  moreAvailable: '(more available)',
  allLoaded: '(all loaded)',
  noMachineTelemetry: 'No machine telemetry available.',
  noRevenueData: 'No revenue timeline data.',
  noAlertsInPeriod: 'No alerts in this period.',
  systemRunningNormally: 'System Running Normally',
  deployedLabel: 'Deployed',
  totalBilledMonth: 'Total Billed (Month)',
  totalCollected: 'Total Collected',
  pendingLabel: 'Pending',
  commissionEarned: 'Commission Earned',
  activeOwners: 'Active Owners',
  commissionLabel: 'Commission',
  realtimeRevenue: 'Real-time revenue',
  monthlyBilled: 'Monthly billed',
  karadOpsHub: 'Karad · Satara operations hub',
  viewFullReports: 'View full reports',
  totalMachinesLabel: 'Total machines',
  activeNowSuffix: '{{n}} active now',
  livePipeline: 'Active pipeline',
  yourEarnings: 'Your earnings',
  immediateActionRequired: 'Immediate action required',
  fleetHealthy: 'Fleet healthy',
  liveSignalFeed: 'Live signal feed',
  criticalAlertsHealth: 'Critical alerts & system health',
  streamingLabel: 'Streaming',
  gstSummaryReport: '📊 GST Summary Report',
  loadingLabel: 'Loading...',
  taxableAmount: 'Taxable Amount',
  cgst9pct: 'CGST 9%',
  sgst9pct: 'SGST 9%',
  totalGst: 'Total GST',
  grossTotal: 'Gross Total',
  reconciliationSnapshot: '💾 Reconciliation Snapshot',
  creditsLabel: 'Credits',
  debitsLabel: 'Debits',
  missingRefLabel: 'Missing Ref',
  duplicateRefLabel: 'Duplicate Ref',
  txnVolumeLabel: 'Txn Volume',
  growthVsLastMonth: '+18% vs last month',
  trackingLocation: 'Karad, Satara',
  trackingLastUpdated: 'Last Updated: Just Now',
  ratingNotAvailable: '⭐ N/A',
  utilizationPct: '66% utilization',
  liveMachineStatus: '📊 Live Machine Status',
  revenueTimeline: '📈 Revenue Timeline',
  shareOfRevenue: 'Share of loaded revenue',
  alertsNotifications: '🔔 Alerts & Notifications',
  dlqTotal: 'Total',
  dlqFailed: 'Failed',
  dlqRetried: 'Retried',
  dlqWhatsapp: 'WhatsApp',
  dlqEmail: 'Email',
  dlqAlert: 'Alert',
  // --- Recent feature strings ---
  adminClientName: 'Client Name',
  adminOwnerName: 'Owner Name',
  adminPayoutWallet: 'Payout Wallet',
  adminFooterMachines: 'machines',
  adminFooterClients: 'clients',
  adminFooterOwners: 'owners',
  auditIntroBanner: 'Login, admin actions, and security events. Filters apply to loaded results; use Load more for older rows.',
  auditLoaded: 'loaded',
  auditMoreAvailable: 'more available',
  auditEndOfList: 'end of list',
  auditFilterActive: 'filter active',
  auditFiltersActive: 'filters active',
  auditSeverityBreakdown: 'Severity breakdown (current list)',
  auditPressSlash: 'Press / to focus action filter',
  auditFilters: 'Filters',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'All Roles',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'Search metadata JSON',
  auditFilterFromPlaceholder: 'From date & time',
  auditFilterToPlaceholder: 'To date & time',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'Timezone:',
  auditTimezoneSuffix: '(local)',
  auditHideCsvOptions: 'Hide CSV column options',
  auditShowCsvOptions: 'Show CSV column options',
  auditCsvColCreatedAt: 'Created At',
  auditCsvColAction: 'Action',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'Metadata',
  auditFooterLoaded: 'Loaded',
  auditFooterLogs: 'audit logs',
  auditFooterMoreAvailable: '(more available)',
  auditFooterAllLoaded: '(all loaded)',
  auditActor: 'Actor',
  auditEntity: 'Entity',
  retryLabel: 'Retry',
  // --- Payroll UI ---
  monthlySalaryLabel: 'Monthly Salary (₹/month)',
  monthlySalaryPlaceholder: 'e.g. 25000',
  dailyPayrollHint: 'Daily payroll rate = monthly salary ÷ 26 working days',
  monthlySalaryRequired: 'Monthly salary required (must be greater than zero)',
  advanceBalance: 'Advance balance',
  closeAdvance: 'Close Advance',
  giveAdvance: 'Give Advance',
  validAdvanceRequired: 'Valid advance amount required (greater than zero)',
  failedToRecordAdvance: 'Failed to record advance',
  amountLabel: 'Amount (₹)',
  amountPlaceholder: 'e.g. 5000',
  noteOptional: 'Note (optional)',
  advanceNotePlaceholder: 'e.g. Festival advance',
  outstandingBalance: 'Outstanding balance',
  saving: 'Saving...',
  recordAdvance: 'Record Advance',
  recentTransactions: 'Recent transactions',
  noAdvancesYet: 'No advances recorded yet.',
  advanceTxnLabel: '+ Advance',
  deductionTxnLabel: '− Deduction',
  perMonthSuffix: '/month',
  perDaySuffix: '/day',
  failedToMarkAttendance: 'Failed to mark attendance',
  failedToClockIn: 'Failed to clock in',
  failedToClockOut: 'Failed to clock out',
  loadedAttendanceRows: 'Loaded {{count}} attendance rows',
  hoursShort: 'h',
  payrollPreview: 'Payroll Preview',
  payrollRun: 'Run Payroll',
  payrollAlreadyRun: 'Payroll already run for this month',
  payrollGross: 'Gross Payable',
  payrollNet: 'Net Payable',
  payrollAdvanceDeducted: 'Advance Deducted',
  payrollRunSuccess: 'Payroll run successfully',
  payrollNoAmount: 'No payable amount for this month',
  payrollMonth: 'Payroll Month',
  exportPayrollCsv: 'Export Payroll CSV',
  payrollExportMonth: 'Payroll Export Month',
  payrollDailyRate: 'Daily Rate',
  payrollHistory: 'Payroll History',
  payrollNoHistory: 'No payroll runs yet',
  payrollColMonth: 'Month',
  payrollColGross: 'Gross',
  payrollColDeduction: 'Advance Deducted',
  payrollColNet: 'Net Pay',
  payrollColDate: 'Date',
  downloadPayslip: 'Download Payslip',
  payslipTitle: 'Monthly Payslip',
  payslipEarnings: 'Earnings',
  payslipDeductions: 'Deductions',
  payslipDaysWorked: 'Days Worked',
  payslipGeneratedBy: 'Generated by Development Express',
  operatorPayrollTitle: 'My Payroll',
  payrollMonthlySalary: 'Monthly Salary',
  payrollCurrentMonth: 'Current Month',
  payrollPreviousMonth: 'Previous Month',
  ownerAttendanceTitle: 'Attendance',
  ownerAttendanceEdit: 'Edit',
  ownerAttendanceSave: 'Save',
  ownerAttendanceNoRecords: 'No attendance records for this month',
  ownerAttendanceOverrideSuccess: 'Attendance updated',
  ownerSalaryUpdated: 'Salary updated successfully',
  ownerSalaryEditBtn: 'Edit Salary',
  ownerSalaryNotSet: 'Salary not set — set salary to enable payroll',
  durationLabel: 'Duration',
  plQuotaLabel: 'Paid Leave Quota',
  plUsed: 'used',
  plAllowed: 'allowed',
  plRemaining: 'remaining',
  plQuotaUpdated: 'PL quota updated',
  plQuotaExhausted: 'PL quota exhausted — marked as Unpaid Leave',
  plRemainingLabel: 'PL remaining',
  noAttendanceRecords: 'No attendance records yet',
  noFuelLogs: 'No fuel logs yet',
  noIssuesYet: 'No issues reported yet',
  failedToLoad: 'Failed to load data',
  failedToLoadReport: 'Failed to load report',
  failedToLoadIssues: 'Failed to load issues',
  failedToLoadAlerts: 'Failed to load alerts',
  noRecordsMonth: 'No records for this month',
  underReview: 'Under review',
  issueResolved: 'Resolved',
  presentDaysLabel: 'Present Days',
  halfDaysLabel: 'Half Days',
  absentDaysLabel: 'Absent Days',
  totalHmrLabel: 'Total HMR',
  noActiveBookingIdle: 'No active booking — machine idle',
  siteLocationNotCaptured: 'Site location not captured',
  siteLocationNotAvailable: 'Site location not available',
  bookingRefLabel: 'Booking Ref',
  alertPendingBookings: 'Pending Bookings',
  alertPendingPayouts: 'Pending Payouts',
  alertLowFuel: 'Low Fuel',
  alertOpenIssues: 'Open Issues',
  alertComplianceExpiring: 'Compliance Expiring',
  alertServiceDue: 'Service Due',
  noMachineRunning: 'No machine currently running',
  trackingEmptyHint: 'Your active booking will appear here once the machine is dispatched.',
  trackingUpdatedEvery5s: 'Updated every 5 seconds',
  fuelLastOperatorUpdate: '(last operator update)',
  alertExtensionPending: 'Booking extension pending',
  alertConfirmCompletion: 'Please confirm job completion for',
  alertWalletCredited: 'added to wallet',
  alertFeedbackRequest: 'Job complete — share your feedback for',
  noLogsYet: 'No activity logged yet',
  todayActivityLog: "Today's Activity Log",
  machineLogSubtitle: 'Fuel, attendance, issues — local session log',
  timerPaused: 'Timer Paused',
  liveBookingTitle: 'Live Booking',
  machineLogTimerHint: 'Timer is started by Admin. Log your actual work time below — click Mark Work Complete when done.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'Attendance',
  ownerAlertBookingPending: 'New booking pending your approval —',
  ownerAlertBookingHours: 'hours',
  ownerAlertPayoutPending: 'Payout of ₹{{amount}} pending transfer',
  ownerAlertFuelLow: 'fuel low',
  ownerAlertFuelRemaining: 'remaining',
  ownerAlertIssue: 'Issue reported',
  iotGpsDevicesActive: 'GPS Devices Active',
  iotDashcamsOnline: 'Dashcams Online',
  iotFuelSensorsActive: 'Fuel Sensors Active',
  iotMachinesLocked: 'Machines Locked',
  iotDeviceStatus: 'IoT Device Status',
  iotColMachine: 'Machine',
  iotColGps: 'GPS',
  iotColLocation: 'Location',
  iotColFuel: 'Fuel %',
  iotColDashcam: 'Dashcam',
  iotColIgnition: 'Ignition',
  iotColAction: 'Action',
  iotStatusOnline: 'Online',
  iotStatusNotConnected: 'Not Connected',
  iotStatusLive: 'Live',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'Lock',
  iotNotConnectedBanner: 'IoT hardware not yet installed. GPS, dashcam, and remote lock features will be available after Teltonika device installation.',
  fuelUpdateTitle: 'Fuel Update',
  fuelSensorAccuracyNote: 'Operator logged fuel level · Manual entry',
  bookingsTab: 'Bookings',
  unknownLabel: 'Unknown',
  naLabel: 'N/A',
  baseLabel: 'Base',
  qtyLabel: 'Qty',
  actualHrsLabel: 'Actual Hrs',
  auditStatTotal: 'Total',
  auditStatSecurity: 'Security',
  auditStatActors: 'Actors',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'License',
  kycDocAadhaarFront: 'Aadhaar Front',
  kycDocAadhaarBack: 'Aadhaar Back',
  kycDocPoliceVerification: 'Police Verification',
  kycVerification: 'KYC Verification',
  kycNotSubmitted: 'KYC Not Submitted',
  kycUnderReview: 'KYC Under Review',
  kycVerified: 'KYC Verified',
  kycRejected: 'KYC Rejected',
  kycAadhaarFront: 'Aadhaar Front',
  kycAadhaarBack: 'Aadhaar Back',
  kycSelfie: 'Selfie',
  kycSubmitBtn: 'Submit KYC Documents',
  kycSubmitSuccess: 'Documents submitted — under review',
  kycResubmit: 'Re-submit Documents',
  adminKycTitle: 'Client KYC Reviews',
  adminKycAllFilter: 'All',
  adminKycNoSubmissions: 'No KYC submissions yet',
  adminOwnerKycTitle: 'Owner KYC Reviews',
  adminOwnerKycNoSubmissions: 'No owner KYC submissions yet',
  adminOperatorKycTitle: 'Operator KYC Reviews',
  adminOperatorKycNoSubmissions: 'No operator KYC submissions yet',
  kycRejectedWarning: 'Your KYC was rejected. Please re-submit your documents.',
  kycNotSubmittedHint: 'Complete your KYC verification for a trusted experience.',
  kycPendingHint: 'Your KYC is under review.',
  kycGoToTab: 'Go to KYC',
  adminKycApproveBtn: 'Approve',
  adminKycRejectBtn: 'Reject',
  adminKycViewDocs: 'View Documents',
  adminKycRejectReason: 'Rejection reason',
  adminKycRereviewBtn: 'Re-review',
  kycPan: 'PAN Card',
  kycOwnerSubmitSuccess: 'Documents submitted — your KYC is under review',
  kycLicense: 'Driving License',
  kycPoliceVerification: 'Police Verification',
  kycOperatorSubmitSuccess: 'Documents submitted — your KYC is under review',
  operatorKycRejectedAssign: "This operator's KYC has been rejected — they cannot be assigned until re-approved.",
  operatorsColOperator: 'Operator',
  operatorsColEmail: 'Email',
  operatorsColPhone: 'Phone',
  operatorsColDocuments: 'Documents',
  operatorsColStatus: 'Status',
  operatorsDocumentsBtn: 'Documents ({{count}})',
  operatorsNoResults: 'No operators found',
  operatorsAllTitle: 'All Operators ({{count}})',
  operatorsKycDialogDesc: 'KYC documents',
  bookingsCountLabel: '{{count}} bookings',
  complianceDates: 'Compliance Dates',
  complianceInsurance: 'Insurance',
  complianceRcBook: 'RC Book',
  compliancePuc: 'PUC',
  complianceNotSet: 'Not set',
  complianceExpired: 'Expired',
  complianceExpiringSoon: 'Expiring soon',
  complianceExpiringCritical: 'Expiring in 7 days',
  complianceValid: 'Valid',
  complianceUpdateBtn: 'Update Compliance Dates',
  complianceSaveBtn: 'Save',
  complianceAlertsTitle: 'Compliance Alerts',
  complianceAllCompliant: 'All machines compliant ✅',
  complianceColMachine: 'Machine',
  complianceColOwner: 'Owner',
  complianceColInsurance: 'Insurance',
  complianceColRcBook: 'RC Book',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'Start date',
  complianceEndDate: 'End date',
  complianceExtractBtn: 'Upload document to auto-fill dates',
  complianceExtractSuccess: 'Dates extracted — please verify before saving',
  complianceExtractError: 'Could not extract dates — please enter manually',
  complianceExtracting: 'Reading document...',
  serviceHistory: 'Service History',
  serviceLastService: 'Last service',
  serviceNoRecords: 'No service records yet',
  serviceNextDue: 'Next service due',
  serviceNextHmr: 'Next service at',
  serviceAddLog: 'Add service log',
  serviceDate: 'Service Date',
  serviceType: 'Service Type',
  serviceHmr: 'HMR at Service',
  serviceNextDate: 'Next Service Date',
  serviceWorkDone: 'Work Done',
  serviceNotes: 'Notes',
  serviceTypeRoutine: 'Routine',
  serviceTypeMajor: 'Major',
  serviceTypeBreakdown: 'Breakdown',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'Other',
  serviceOverdue: 'Overdue',
  serviceDueSoon: 'Due Soon',
  fleetAnalytics: 'Fleet Analytics',
  analyticsRevenue: 'Total Revenue',
  analyticsBookings: 'Total Bookings',
  analyticsHours: 'Total Hours',
  analyticsActiveMachines: 'Active Machines',
  analyticsMonthlyTrend: 'Monthly Revenue Trend',
  analyticsMachineTable: 'Revenue by Machine',
  analyticsNoData: 'No completed bookings in this period',
  analyticsLastBooking: 'Last Booking',
  analytics3Months: '3 Months',
  analytics6Months: '6 Months',
  analytics12Months: '12 Months',
  adminAnalytics: 'Analytics',
  adminFleetTitle: 'Fleet Analytics',
  adminFleetPlatformRevenue: 'Platform Revenue',
  adminFleetActiveOwners: 'Active Owners',
  adminFleetOwnerCol: 'Owner',
  adminFleetMonthlyTrend: 'Monthly Revenue Trend',
  adminFleetMachineTable: 'Revenue by Machine',
  adminFleetNoData: 'No completed bookings in this period',
  adminFinancialIntelligence: 'Machine Financial Intelligence',
  adminTotalInvested: 'Total Invested',
  adminTotalEarned: 'Total Earned',
  adminAvgRecovery: 'Avg Recovery',
  adminBreakEvenRate: 'Break-even Rate',
  adminProfitMargin: 'Profit Margin',
  adminNoFinancialData: 'No machines with financial data yet',
  adminMachineDetail: 'Machine Detail',
  adminCallOwner: 'Call Owner',
  adminWhatsappOwner: 'WhatsApp Owner',
  adminMarketRates: 'Market Rate Submissions',
  adminMarketRateDelete: 'Delete',
  adminMarketRateDeleteConfirm: 'Delete this market rate submission?',
  adminMarketRateDeleted: 'Market rate deleted',
  adminMarketRateNoData: 'No market rate submissions yet',
  marketRateApprove: 'Approve',
  marketRateReject: 'Reject',
  marketRateApproved: 'Approved',
  marketRateRejected: 'Rejected',
  marketRatePending: 'Pending',
  marketRateReviewed: 'Market rate reviewed',
  marketRatePendingReview: 'Your rate has been submitted and is pending admin review.',
  marketRateEditApprove: 'Edit & Approve',
  marketRateEditMin: 'Corrected Min Rate (₹/hr)',
  marketRateEditMax: 'Corrected Max Rate (₹/hr)',
  adminPayrollOverview: 'Payroll Overview',
  adminPayrollTotalOperators: 'Total Operators',
  adminPayrollTotalGross: 'Total Gross Payable',
  adminPayrollTotalNet: 'Total Net Payable',
  adminPayrollNoData: 'No payroll data for this month',
  adminNotifLog: 'Notification Log',
  adminNotifColUser: 'User',
  adminNotifColRole: 'Role',
  adminNotifNoData: 'No notifications logged yet',
  subTabSchedule: 'Schedule',
  subTabHistory: 'History',
  subTabAnalytics: 'Analytics',
  clientAnalyticsTitle: 'Booking Analytics',
  clientAnalyticsSpend: 'Total Spend',
  clientAnalyticsHours: 'Total Hours',
  clientAnalyticsBookings: 'Completed Bookings',
  clientAnalyticsMachines: 'Machines Used',
  clientAnalyticsAvgSpend: 'Avg per Booking',
  clientAnalyticsMonthlyTrend: 'Monthly Spending Trend',
  clientAnalyticsTopMachines: 'Top Machines',
  clientAnalyticsNoData: 'No completed bookings in this period',
  operatorAnalyticsTitle: 'Work Analytics',
  operatorAnalyticsPresentDays: 'Present Days',
  operatorAnalyticsHalfDays: 'Half Days',
  operatorAnalyticsHmr: 'Total HMR',
  operatorAnalyticsJobs: 'Jobs Completed',
  operatorAnalyticsIssues: 'Issues Reported',
  operatorAnalyticsAvgHmr: 'Avg HMR/Day',
  operatorAnalyticsMonthlyTrend: 'Monthly Work Trend',
  operatorAnalyticsIssueBreakdown: 'Issues by Type',
  operatorAnalyticsRecentJobs: 'Recent Jobs',
  operatorAnalyticsNoData: 'No work records in this period',
  adminServiceAlertsTitle: 'Service Alerts',
  adminServiceAllOk: 'All machines have up-to-date service records ✅',
  adminServiceNoRecord: 'No records',
  adminServiceColLastService: 'Last Service',
  adminServiceColNextDue: 'Next Due',
  adminServiceColServiceStatus: 'Service Status',
  adminMachinesColMinHrs: 'Min Hrs',
  adminMachinesColRateDay: 'Rate/Day',
  auditSeverityCritical: 'Critical',
  auditSeverityHigh: 'High',
  auditSeverityMedium: 'Medium',
  auditSeverityNormal: 'Normal',
  auditCopyEvent: 'Copy Event',
  auditViewDetails: 'View Details',
  auditHideDetails: 'Hide Details',
  auditCopyJson: 'Copy JSON',
  auditNoLogs: 'No audit logs',
  auditEventLog: 'Event log',
  bookingAttachment: 'Select Attachment',
  bookingAttachmentNone: 'No specific attachment',
  bookingWorkDescription: 'Work Description',
  bookingWorkDescriptionPlaceholder: 'e.g. Foundation excavation, trenching, pipeline work',
  bookingAttachmentLabel: 'Attachment',
  bookingSiteLabel: 'Site',
  bookingWorkLabel: 'Work',
  termsAccept: 'I agree to the Terms & Conditions',
  termsRequired: 'You must accept Terms & Conditions to register',
  termsLink: 'Terms & Conditions',
  clientBlacklisted: 'Blacklisted',
  clientBlacklistReason: 'Reason for blacklisting',
  clientBlacklistConfirm: 'Blacklist this client?',
  clientUnblacklist: 'Remove from blacklist',
  blacklistedClients: 'Blacklisted Clients',
  blacklistedClientsEmpty: 'No blacklisted clients',
  managerAccessRestricted: 'Finance access restricted. Contact Om Chavan.',
  managerSection: 'Managers',
  managerAdd: 'Add Manager',
  managerName: 'Manager Name',
  managerEmail: 'Manager Email',
  managerPassword: 'Temporary Password',
  managerCreated: 'Manager account created',
  managerCredentialsTitle: 'Manager Login Credentials',
  managerCredentialsSubtitle: 'Save these credentials now — password cannot be recovered later',
  managerCredentialsSaved: 'I have saved the credentials',
  managerLoginUrl: 'Login URL',
  managerActivity: 'Manager Activity',
  managerActivityEmpty: 'No activity recorded yet',
  managerActivityViewAll: 'View all activity',
  onboardingTitle: 'Get Started',
  onboardingAccountApproved: 'Account approved',
  onboardingKycComplete: 'KYC verification complete',
  onboardingKycPending: 'Complete KYC verification',
  onboardingKycRejected: 'KYC rejected — please resubmit',
  onboardingWalletFunded: 'Wallet funded',
  onboardingWalletEmpty: 'Add wallet balance to book',
  pushEnablePrompt: 'Enable push notifications for instant updates',
  downloadDisputeStatement: 'Download Dispute Statement',
  downloadInvoice: 'Download Invoice',
  bookAgain: 'Book Again',
  machineNoLongerAvailable: 'Machine no longer available',
  downloadHistoryPdf: 'Download History PDF',
  onboardingFirstBooking: 'Make your first booking',
  onboardingAllDone: 'You are all set!',
  onboardingTrackerTitle: 'Onboarding Progress',
  onboardingTrackerTarget: 'Onboarding target: 48 hours',
  onboardingTrackerInProgress: 'In Progress',
  onboardingTrackerActionRequired: 'Action Required',
  onboardingTrackerComplete: 'Complete',
  onboardingTrackerPending: 'Pending',
  onboardingTrackerPhase1: 'Registration',
  onboardingTrackerPhase2: 'KYC Verification',
  onboardingTrackerPhase3: 'Machine Registration',
  onboardingTrackerPhase4: 'First Booking Ready',
  onboardingTrackerHelper1: 'Upload Aadhaar + Selfie to unlock machine registration',
  onboardingTrackerHelper2: 'KYC under review — usually within 24 hours',
  onboardingTrackerHelper3: 'KYC rejected — resubmit documents',
  onboardingTrackerHelper4: 'KYC approved — add your first machine',
  onboardingTrackerHelper5: 'Machine under admin review',
  onboardingTrackerHelper6: 'Machine live — waiting for first booking',
  onboardingTrackerPhaseLabel: 'Phase',
  alertsAndNotifications: 'Alerts & Notifications',
  duration: 'Duration',
  cycles: 'Cycles',
  txRecharge: 'Wallet Recharge',
  txBookingAdvance: 'Booking Advance',
  txBookingPayment: 'Booking Payment',
  txSettlement: 'Settlement',
  txRefund: 'Refund',
  txPenalty: 'Penalty',
  txCommission: 'Commission',
  filterAll: 'All',
  filterCompleted: 'Completed',
  filterCancelled: 'Closed',
  filterPending: 'Pending',
  filterDisputed: 'Disputed',
  tacTitle: 'Terms & Conditions',
  tacPrivacy: 'Privacy Policy',
  tacRefund: 'Refund Policy',
  tacCancellation: 'Cancellation Policy',
  tacServiceDelivery: 'Service Delivery Policy',
  tacIntro: 'Review our policies before booking',
  tacBannerTitle: 'Terms update available',
  tacBannerOpen: 'Open Terms',
  tacBannerAgree: 'I have read and agree',
  tacBannerLater: 'Later',
  clientPoliciesTitle: 'Client Policies',
  machineGroupAvailable: 'available',
  machineGroupBusy: 'busy',
  dewateringReferral: 'Need dewatering (pump) service? MachineOS will add pump contractor services soon. Contact support for referrals.',
  noActiveWork: 'No active work this month',
  accountTab: 'Account',
  recentActivity: 'Recent Activity',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
};
const HI_BASE = {
  ...TRANSLATIONS.hi,
  confirmDuplicateActiveBooking: 'इस मशीन पर आपकी बुकिंग पहले से active है (#{{ref}}). फिर भी नई बुकिंग करें?',
  experienceNotAvailable: 'अनुभव उपलब्ध नहीं',
  yearsExpShort: '{{n}} वर्ष अनुभव',
  walletStatusOk: 'ठीक',
  walletStatusLow: 'कम',
  liveBadge: 'लाइव',
  ownerBankDetailsIncomplete: 'बैंक विवरण अधूरा',
  ownerPayoutBlockedNoBank: 'भुगतान रुकेगा — कृपया बैंक विवरण जोड़ें',
  ownerAddBankDetailsBtn: 'बैंक विवरण जोड़ें →',
  noAlertsNow: 'कोई अलर्ट नहीं।',
  notificationCenter: 'संदेश लॉग',
  navSectionMachineManagement: 'मशीन प्रबंधन',
  navSectionFinance: 'वित्त',
  navSectionOperations: 'संचालन',
  navSectionAccount: 'खाता',
  notifChannelAll: 'सभी',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ईमेल',
  notifChannelPush: 'पुश',
  notifChannelSms: 'SMS',
  notifStatusSent: 'भेजा गया',
  notifStatusFailed: 'विफल',
  notifStatusPending: 'लंबित',
  notifEmpty: 'अभी कोई सूचना नहीं',
  notifLoadMore: 'और लोड करें',
  machineUpdateFailed: 'अपडेट विफल। पुनः प्रयास करें।',
  editMachineRatesTitle: 'मशीन दर संपादित करें',
  ratePerHourLabel: 'दर/घंटा (₹)',
  minimumHoursLabel: 'न्यूनतम घंटे',
  ratePerDayLabel: 'दर/दिन (₹)',
  fuelCapacityLabel: 'ईंधन क्षमता (L)',
  machineFinancialSection: 'मशीन खरीद विवरण (वैकल्पिक)',
  machineOwnershipType: 'स्वामित्व प्रकार',
  machineOwnershipNew: 'नई मशीन',
  machineOwnershipUsed: 'पहले मालक',
  machineOwnershipSecondHand: 'पूर्व-स्वामित्व',
  machinePurchasePrice: 'खरीद मूल्य (₹)',
  machinePurchasePriceHint: 'इस मशीन के लिए आपने जो राशि चुकाई',
  machinePurchaseDate: 'खरीद तिथि',
  machineYearOfManufacture: 'निर्माण वर्ष',
  machineLoanSection: 'इस मशीन पर मेरा loan है',
  machineLoanAmount: 'Loan राशि (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan अवधि (महीने)',
  machineLoanStartDate: 'Loan शुरू तिथि',
  machineFuelConsumption: 'ईंधन खपत (L/hr)',
  machineMonthlyOperatingExpenses: 'मासिक परिचालन व्यय',
  machineOperatorMonthlySalary: 'ऑपरेटर मासिक वेतन',
  machineServiceMonthly: 'सर्विस / रखरखाव (मासिक)',
  machineBreakdownMonthly: 'ब्रेकडाउन / मरम्मत (मासिक औसत)',
  machineMaterialsMonthly: 'सामग्री / उपभोग्य (मासिक)',
  recoveryPlan: 'रिकवरी प्लान',
  recoveryOnTrack: 'सही रास्ते पर',
  recoveryNeedsAttention: 'ध्यान दें',
  recoveryActionRequired: 'कार्रवाई जरूरी',
  recoveryAddPrice: 'रिकवरी प्लान देखने के लिए खरीद मूल्य जोड़ें',
  recoveryProgress: 'निवेश वसूली',
  recoveryDailyNet: 'दैनिक शुद्ध आय',
  recoveryDays: 'वसूली अवधि',
  recoveryProjectedDate: 'अनुमानित वसूली तिथि',
  recoveryRoi: 'वार्षिक प्रतिफल',
  recoveryCurrentValue: 'वर्तमान मशीन मूल्य',
  recoveryBackfillNudge: 'रिकवरी ट्रैकिंग अनलॉक करने के लिए {{count}} मशीन(ों) में खरीद विवरण जोड़ें',
  editFinancialDetails: 'वित्तीय विवरण संपादित करें',
  financialDetailsSaved: 'वित्तीय विवरण सहेजे गए',
  dieselPriceTitle: 'डीजल की कीमत',
  dieselPriceUpdate: 'डीजल कीमत अपडेट करें',
  dieselPriceLatest: 'नवीनतम कीमत',
  dieselPriceNoRecord: 'कोई डीजल कीमत दर्ज नहीं',
  dieselPricePerLitre: 'प्रति लीटर कीमत (₹)',
  dieselQuantity: 'भरी गई मात्रा (लीटर)',
  dieselTaluka: 'शहर / क्षेत्र',
  dieselFuelCostPerHour: 'प्रति घंटा ईंधन लागत',
  dieselPercentOfRate: 'आपकी प्रति घंटा दर का',
  dieselPriceSaved: 'डीजल कीमत सहेजी गई',
  dieselRateSuggestion: 'दर सुझाव',
  dieselRateIncrease: 'डीजल बढ़ा — दर बढ़ाने पर विचार करें',
  dieselRateDecrease: 'डीजल घटा — बुकिंग के लिए दर कम करें',
  dieselSuggestedRate: 'सुझाई गई दर',
  dieselHistory: 'कीमत इतिहास',
  dieselNoHistory: 'अभी तक कोई डीजल कीमत इतिहास नहीं',
  dieselColDate: 'तारीख',
  dieselColPrice: 'कीमत/लीटर',
  dieselColQty: 'मात्रा',
  dieselColSource: 'स्रोत',
  dieselUploadReceipt: 'रसीद अपलोड करें',
  dieselExtractSuccess: 'रसीद से निकाला गया',
  dieselExtractFailed: 'निकाल नहीं सके — कृपया मैन्युअल दर्ज करें',
  applyRateSuggestion: '₹{{rate}}/घंटा लागू करें',
  rateSuggestionApplied: 'दर सफलतापूर्वक अपडेट हुई',
  marketPosition: 'बाजार स्थिति',
  marketBelowMarket: 'बाजार से नीचे',
  marketCompetitive: 'प्रतिस्पर्धी',
  marketAboveMarket: 'बाजार से ऊपर',
  marketNoData: 'आपके क्षेत्र के लिए अभी कोई बाजार डेटा नहीं',
  marketSubmitRate: 'बाजार दर जमा करें',
  marketCity: 'शहर / क्षेत्र',
  marketMinRate: 'आपके क्षेत्र की न्यूनतम दर (₹/घंटा)',
  marketMaxRate: 'आपके क्षेत्र की अधिकतम दर (₹/घंटा)',
  marketRateSubmitted: 'बाजार दर जमा हो गई — धन्यवाद!',
  marketDataPoints: '{{count}} जमा पर आधारित',
  marketRange: '{{city}} में बाजार',
  marketSourceLocal: '{{city}} क्षेत्र की दरों पर आधारित',
  marketSourcePlatform: 'प्लेटफ़ॉर्म-व्यापी दरों पर आधारित',
  editRatesBtn: '✏️ दर संपादित करें',
  editRegistrationInfo: 'पंजीकरण जानकारी संपादित करें',
  editRegistrationInfoHint:
    'अनुमोदित मशीन के दर, फ्लोर, अटैचमेंट, वित्तीय विवरण या अनुपालन तिथियाँ अपडेट करें। बदलाव तुरंत लागू होते हैं।',
  editRegistrationPickMachine: 'मशीन चुनें',
  editRegistrationPickPlaceholder: 'मशीन चुनें…',
  editRegistrationSelectPrompt: 'पंजीकरण संपादक खोलने के लिए ऊपर मशीन चुनें।',
  myMachinesEditRegistrationBtn: '✏️ पंजीकरण जानकारी संपादित करें',
  myMachinesComplianceSummary: 'बीमा स्थिति',
  lockedRegistrationFieldsTitle: 'लॉक पंजीकरण फ़ील्ड',
  lockedRegistrationFieldsNote:
    'इन्हें सुधारने के लिए एडमिन से संपर्क करें — पहचान धोखाधड़ी रोकने के लिए लॉक हैं।',
  lockedFieldRegNo: 'पंजीकरण संख्या',
  lockedRegistrationDocuments: 'दस्तावेज़ / फ़ोटो',
  lockedRegistrationDocumentsNone: 'इस दृश्य में कोई दस्तावेज़ लिंक उपलब्ध नहीं।',
  lockedRegistrationDocumentOnFile: 'फ़ाइल में',
  assignOperatorFailed: 'ऑपरेटर नियुक्त करना विफल।',
  unassignOperatorFailed: 'ऑपरेटर हटाना विफल।',
  genericError: 'कुछ गलत हो गया।',
  confirmDeactivateOperator: 'इस ऑपरेटर को निष्क्रिय करें? मशीन से auto-unassign होगा।',
  inviteGenerateFailed: 'आमंत्रण कोड बनाना विफल।',
  inviteCodeCopied: 'आमंत्रण कोड कॉपी हुआ! 24 घंटों के लिए वैध।',
  userApprovedPdfDownloaded: 'स्वीकृत! अनुबंध PDF डाउनलोड हुआ।',
  userApprovalFailed: 'स्वीकृति विफल। पुनः प्रयास करें।',
  userRejectedSuccess: 'अस्वीकृत!',
  userRejectionFailed: 'अस्वीकृति विफल। पुनः प्रयास करें।',
  deactivateFailed: 'निष्क्रिय करना विफल। पुनः प्रयास करें।',
  reactivateFailed: 'पुनः सक्रिय करना विफल। पुनः प्रयास करें।',
  panDocumentUnavailable: 'PAN दस्तावेज़ उपलब्ध नहीं।',
  sessionExpiredRefresh: 'सत्र समाप्त। पृष्ठ रिफ्रेश करें या पुनः लॉगिन करें।',
  sessionExpiredSignIn: 'सत्र समाप्त। कृपया पुनः साइन इन करें।',
  sessionRevokedAlert: 'आप किसी अन्य डिवाइस पर लॉग इन हैं। कृपया पुनः लॉगिन करें।',
  activateBtn: '✓ सक्रिय करें',
  deactivateBtn: '✕ निष्क्रिय करें',
  reactivateBtn: 'पुनः सक्रिय करें',
  ownerApprovedStatus: 'मालिक ने स्वीकृत किया',
  awaitingOwnerApprovalStatus: 'मालिक की स्वीकृति की प्रतीक्षा',
  pendingApprovalStatus: 'स्वीकृति लंबित',
  statusDisputed: 'विवादित',
  statusApproved: 'स्वीकृत',
  statusPending: 'लंबित',
  statusActive: 'सक्रिय',
  statusInactive: 'निष्क्रिय',
  statusRejected: 'अस्वीकृत',
  statusCompleted: 'पूर्ण',
  statusCancelled: 'रद्द',
  bookingClosed: 'बंद',
  sectionNew: 'नई',
  sectionAccepted: 'स्वीकृत',
  sectionActive: 'सक्रिय',
  sectionDispatched: 'डिस्पैच',
  sectionCompleting: 'पूर्ण हो रहा',
  sectionDisputed: 'विवादित',
  sectionCompleted: 'पूर्ण',
  sectionClosed: 'बंद',
  gstPdfBtn: 'GST PDF',
  minBooking: 'न्यूनतम बुकिंग',
  hrsShort: 'घंटे',
  machineGstFuelNote: '* GST 18% · ईंधन शामिल · ऑपरेटर शामिल',
  cancelCreditBanner: '{{machine}} रद्द | ₹{{amount}} वॉलेट क्रेडिट!',
  advanceDeductedFromWallet: 'अग्रिम राशि आपके वॉलेट से काटी जाएगी',
  cancelText: 'रद्द करें',
  machineLabel: 'मशीन',
  walletCreditFull: 'वॉलेट क्रेडिट (पूर्ण अग्रिम)',
  escrowNote: 'डिस्पैच से पहले — अग्रिम राशि आपके वॉलेट में वापस आएगी (बैंक रिफंड नहीं)।',
  currentWalletBalance: 'वर्तमान: ₹{{amount}}',
  bookPayAdvance: 'बुक करें — ₹{{amount}} अग्रिम दें',
  walletLabel: 'वॉलेट: ₹{{amount}}',
  gstInvoiceHint: '{{count}} GST चालान — नीचे पूर्ण बुकिंग के लिए "GST PDF" डाउनलोड करें।',
  totalWithGst: 'कुल: ₹{{total}} (GST ₹{{gst}})',
  machineDispatchedAt: 'मशीन भेजी गई',
  emailLabel: 'ईमेल',
  totalMachines: 'कुल मशीन',
  activeFleet: 'सक्रिय बेड़ा',
  activeToday: 'आज सक्रिय',
  revenueMonth: 'राजस्व (माह)',
  liveBookings: 'लाइव बुकिंग',
  noDataYet: 'अभी तक कोई डेटा नहीं',
  myCommission: 'मेरा कमीशन',
  commissionPctTotal: 'कुल का 15%',
  activeClients: 'सक्रिय ग्राहक',
  lowFuelAlert: 'कम ईंधन अलर्ट',
  actionNeeded: '⚠ कार्रवाई आवश्यक',
  thisMonthEarned: 'इस माह की कमाई',
  standardBookings: 'सामान्य बुकिंग',
  activeContracts: 'सक्रिय अनुबंध',
  contractsOngoing: 'अनुबंध जारी हैं',
  noActiveContracts: 'इस अवधि में कोई नहीं',
  quotationsPending: 'उत्तर की प्रतीक्षा में कोटेशन',
  allUpToDate: 'सभी बुकिंग अद्यतन हैं',
  noBookingsInPeriod: 'इस अवधि में कोई बुकिंग नहीं',
  contractBookings: 'अनुबंध बुकिंग',
  noContractsInPeriod: 'इस अवधि में कोई अनुबंध नहीं',
  mobilizationReleased: 'मोबिलाइजेशन जारी',
  pendingRelease: 'जारी होना बाकी',
  raBills: 'आरए-बिल',
  disputed: 'विवादित',
  all: 'सभी',
  completed: 'पूर्ण',
  totalBookings: 'कुल बुकिंग',
  activeNow: 'अभी सक्रिय',
  totalRevenue: 'कुल राजस्व',
  todayLabel: 'आज',
  loadedBookings: '{{count}} बुकिंग लोड हुईं',
  moreAvailable: '(और उपलब्ध)',
  allLoaded: '(सब लोड)',
  noMachineTelemetry: 'मशीन टेलिमेट्री उपलब्ध नहीं।',
  noRevenueData: 'राजस्व डेटा उपलब्ध नहीं।',
  noAlertsInPeriod: 'इस अवधि में कोई अलर्ट नहीं।',
  systemRunningNormally: 'सिस्टम सामान्य रूप से चल रहा है',
  deployedLabel: 'तैनात',
  totalBilledMonth: 'कुल बिल (माह)',
  totalCollected: 'कुल संग्रहित',
  pendingLabel: 'लंबित',
  commissionEarned: 'कमीशन अर्जित',
  activeOwners: 'सक्रिय मालिक',
  commissionLabel: 'कमीशन',
  realtimeRevenue: 'रियल-टाइम राजस्व',
  monthlyBilled: 'मासिक बिल',
  karadOpsHub: 'कराड · सातारा संचालन केंद्र',
  viewFullReports: 'पूरी रिपोर्ट देखें',
  totalMachinesLabel: 'कुल मशीन',
  activeNowSuffix: '{{n}} अभी सक्रिय',
  livePipeline: 'सक्रिय पाइपलाइन',
  yourEarnings: 'आपकी कमाई',
  immediateActionRequired: 'तत्काल कार्रवाई आवश्यक',
  fleetHealthy: 'बेड़ा स्वस्थ',
  liveSignalFeed: 'लाइव सिग्नल फीड',
  criticalAlertsHealth: 'गंभीर अलर्ट और सिस्टम स्वास्थ्य',
  streamingLabel: 'स्ट्रीमिंग',
  gstSummaryReport: '📊 GST सारांश रिपोर्ट',
  loadingLabel: 'लोड हो रहा है...',
  taxableAmount: 'कर योग्य राशि',
  cgst9pct: 'CGST 9%',
  sgst9pct: 'SGST 9%',
  totalGst: 'कुल GST',
  grossTotal: 'कुल राशि',
  reconciliationSnapshot: '💾 समाधान स्नैपशॉट',
  creditsLabel: 'क्रेडिट',
  debitsLabel: 'डेबिट',
  missingRefLabel: 'संदर्भ नहीं',
  duplicateRefLabel: 'डुप्लीकेट संदर्भ',
  txnVolumeLabel: 'लेनदेन मात्रा',
  growthVsLastMonth: '+18% पिछले माह से',
  trackingLocation: 'कराड, सातारा',
  trackingLastUpdated: 'अंतिम अपडेट: अभी',
  ratingNotAvailable: '⭐ उपलब्ध नहीं',
  utilizationPct: '66% उपयोग',
  liveMachineStatus: '📊 लाइव मशीन स्थिति',
  revenueTimeline: '📈 राजस्व टाइमलाइन',
  shareOfRevenue: 'लोड राजस्व का हिस्सा',
  alertsNotifications: '🔔 अलर्ट और सूचनाएं',
  dlqTotal: 'कुल',
  dlqFailed: 'विफल',
  dlqRetried: 'पुनः प्रयास',
  dlqWhatsapp: 'WhatsApp',
  dlqEmail: 'ईमेल',
  dlqAlert: 'अलर्ट',
  // --- Recent feature strings ---
  monthlySalaryLabel: 'मासिक वेतन (₹/माह)',
  monthlySalaryPlaceholder: 'उदा. 25000',
  dailyPayrollHint: 'दैनिक वेतन दर = मासिक वेतन ÷ 26 कार्य दिवस',
  monthlySalaryRequired: 'मासिक वेतन आवश्यक (शून्य से अधिक होना चाहिए)',
  advanceBalance: 'अग्रिम शेष',
  closeAdvance: 'अग्रिम बंद करें',
  giveAdvance: 'अग्रिम दें',
  validAdvanceRequired: 'वैध अग्रिम राशि आवश्यक (शून्य से अधिक)',
  failedToRecordAdvance: 'अग्रिम दर्ज करने में विफल',
  amountLabel: 'राशि (₹)',
  amountPlaceholder: 'उदा. 5000',
  noteOptional: 'टिप्पणी (वैकल्पिक)',
  advanceNotePlaceholder: 'उदा. त्योहार अग्रिम',
  outstandingBalance: 'बकाया शेष',
  saving: 'सहेज रहे हैं...',
  recordAdvance: 'अग्रिम दर्ज करें',
  recentTransactions: 'हालिया लेनदेन',
  noAdvancesYet: 'अभी तक कोई अग्रिम दर्ज नहीं।',
  advanceTxnLabel: '+ अग्रिम',
  deductionTxnLabel: '− कटौती',
  perMonthSuffix: '/माह',
  perDaySuffix: '/दिन',
  failedToMarkAttendance: 'उपस्थिति दर्ज करने में विफल',
  failedToClockIn: 'क्लॉक इन विफल',
  failedToClockOut: 'क्लॉक आउट विफल',
  loadedAttendanceRows: '{{count}} उपस्थिति पंक्तियाँ लोड',
  hoursShort: 'घं',
  payrollPreview: 'पेरोल पूर्वावलोकन',
  payrollRun: 'पेरोल चलाएं',
  payrollAlreadyRun: 'इस महीने के लिए पेरोल पहले ही चल चुका है',
  payrollGross: 'कुल देय',
  payrollNet: 'शुद्ध देय',
  payrollAdvanceDeducted: 'अग्रिम कटौती',
  payrollRunSuccess: 'पेरोल सफलतापूर्वक चला',
  payrollNoAmount: 'इस महीने के लिए कोई देय राशि नहीं',
  payrollMonth: 'पेरोल महीना',
  exportPayrollCsv: 'पेरोल CSV निर्यात',
  payrollExportMonth: 'पेरोल निर्यात महीना',
  payrollDailyRate: 'दैनिक दर',
  payrollHistory: 'पेरोल इतिहास',
  payrollNoHistory: 'अभी तक कोई पेरोल नहीं चला',
  payrollColMonth: 'महीना',
  payrollColGross: 'कुल',
  payrollColDeduction: 'अग्रिम कटौती',
  payrollColNet: 'शुद्ध वेतन',
  payrollColDate: 'तारीख',
  downloadPayslip: 'पे स्लिप डाउनलोड',
  payslipTitle: 'मासिक पे स्लिप',
  payslipEarnings: 'आय',
  payslipDeductions: 'कटौती',
  payslipDaysWorked: 'कार्य दिवस',
  payslipGeneratedBy: 'Development Express द्वारा जनरेट',
  operatorPayrollTitle: 'मेरा पेरोल',
  payrollMonthlySalary: 'मासिक वेतन',
  payrollCurrentMonth: 'वर्तमान महीना',
  payrollPreviousMonth: 'पिछला महीना',
  ownerAttendanceTitle: 'उपस्थिति',
  ownerAttendanceEdit: 'संपादित करें',
  ownerAttendanceSave: 'सहेजें',
  ownerAttendanceNoRecords: 'इस महीने के लिए कोई उपस्थिति रिकॉर्ड नहीं',
  ownerAttendanceOverrideSuccess: 'उपस्थिति अपडेट की गई',
  ownerSalaryUpdated: 'वेतन सफलतापूर्वक अपडेट किया गया',
  ownerSalaryEditBtn: 'वेतन संपादित करें',
  ownerSalaryNotSet: 'वेतन सेट नहीं — पेरोल के लिए वेतन सेट करें',
  plQuotaLabel: 'वेतन सह अवकाश कोटा',
  plUsed: 'उपयोग',
  plAllowed: 'अनुमत',
  plRemaining: 'शेष',
  plQuotaUpdated: 'PL कोटा अपडेट',
  plQuotaExhausted: 'PL कोटा समाप्त — बिन वेतन अवकाश के रूप में दर्ज',
  plRemainingLabel: 'शेष PL',
  retryLabel: 'पुनः प्रयास करें',
  noAttendanceRecords: 'अभी तक कोई उपस्थिति रिकॉर्ड नहीं',
  noFuelLogs: 'अभी तक कोई ईंधन लॉग नहीं',
  noIssuesYet: 'अभी तक कोई समस्या दर्ज नहीं',
  failedToLoad: 'डेटा लोड करने में विफल',
  failedToLoadReport: 'रिपोर्ट लोड करने में विफल',
  failedToLoadIssues: 'समस्याएं लोड करने में विफल',
  failedToLoadAlerts: 'अलर्ट लोड करने में विफल',
  noRecordsMonth: 'इस महीने के लिए कोई रिकॉर्ड नहीं',
  underReview: 'समीक्षाधीन',
  issueResolved: 'समाधान हो गया',
  presentDaysLabel: 'उपस्थित दिन',
  halfDaysLabel: 'आधे दिन',
  absentDaysLabel: 'अनुपस्थित दिन',
  totalHmrLabel: 'कुल HMR',
  noActiveBookingIdle: 'कोई सक्रिय बुकिंग नहीं — मशीन निष्क्रिय',
  siteLocationNotCaptured: 'साइट स्थान दर्ज नहीं हुआ',
  siteLocationNotAvailable: 'साइट स्थान उपलब्ध नहीं',
  bookingRefLabel: 'बुकिंग Ref',
  alertPendingBookings: 'लंबित बुकिंग',
  alertPendingPayouts: 'लंबित भुगतान',
  alertLowFuel: 'कम ईंधन',
  alertOpenIssues: 'खुली समस्याएं',
  alertComplianceExpiring: 'अनुपालन समाप्त हो रहा',
  alertServiceDue: 'सर्विस देय',
  noMachineRunning: 'वर्तमान में कोई मशीन चालू नहीं',
  trackingEmptyHint: 'मशीन डिस्पैच होने पर आपकी सक्रिय बुकिंग यहाँ दिखेगी।',
  trackingUpdatedEvery5s: 'हर 5 सेकंड में अपडेट',
  fuelLastOperatorUpdate: '(ऑपरेटर का अंतिम अपडेट)',
  alertExtensionPending: 'बुकिंग विस्तार लंबित',
  alertConfirmCompletion: 'कृपया कार्य पूर्णता की पुष्टि करें',
  alertWalletCredited: 'वॉलेट में जोड़ा गया',
  alertFeedbackRequest: 'कार्य पूर्ण — अपनी प्रतिक्रिया साझा करें',
  noLogsYet: 'अभी तक कोई गतिविधि दर्ज नहीं',
  todayActivityLog: 'आज की गतिविधि लॉग',
  machineLogSubtitle: 'ईंधन, उपस्थिति, समस्याएं — स्थानीय सत्र लॉग',
  timerPaused: 'टाइमर रोका गया',
  liveBookingTitle: 'लाइव बुकिंग',
  machineLogTimerHint: 'टाइमर Admin द्वारा शुरू किया जाता है। नीचे अपना वास्तविक कार्य समय दर्ज करें — पूर्ण होने पर Mark Work Complete पर क्लिक करें।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'उपस्थिति',
  ownerAlertBookingPending: 'नई बुकिंग आपकी स्वीकृति के लिए लंबित —',
  ownerAlertBookingHours: 'घंटे',
  ownerAlertPayoutPending: '₹{{amount}} का भुगतान ट्रांसफर के लिए लंबित',
  ownerAlertFuelLow: 'ईंधन कम',
  ownerAlertFuelRemaining: 'शेष',
  ownerAlertIssue: 'समस्या दर्ज',
  iotGpsDevicesActive: 'GPS उपकरण सक्रिय',
  iotDashcamsOnline: 'डैशकैम ऑनलाइन',
  iotFuelSensorsActive: 'ईंधन सेंसर सक्रिय',
  iotMachinesLocked: 'मशीनें लॉक',
  iotDeviceStatus: 'IoT उपकरण स्थिति',
  iotColMachine: 'मशीन',
  iotColGps: 'GPS',
  iotColLocation: 'स्थान',
  iotColFuel: 'ईंधन %',
  iotColDashcam: 'डैशकैम',
  iotColIgnition: 'इग्निशन',
  iotColAction: 'कार्रवाई',
  iotStatusOnline: 'ऑनलाइन',
  iotStatusNotConnected: 'कनेक्ट नहीं',
  iotStatusLive: 'लाइव',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'लॉक',
  iotNotConnectedBanner: 'IoT हार्डवेयर अभी स्थापित नहीं है। Teltonika उपकरण स्थापना के बाद GPS, डैशकैम और रिमोट लॉक सुविधाएं उपलब्ध होंगी।',
  fuelUpdateTitle: 'ईंधन अपडेट',
  fuelSensorAccuracyNote: 'ऑपरेटर द्वारा ईंधन स्तर दर्ज · मैन्युअल प्रविष्टि',
  bookingsTab: 'बुकिंग',
  unknownLabel: 'अज्ञात',
  naLabel: 'N/A',
  baseLabel: 'आधार',
  qtyLabel: 'मात्रा',
  actualHrsLabel: 'वास्तविक घंटे',
  auditStatTotal: 'कुल',
  auditStatSecurity: 'सुरक्षा',
  auditStatActors: 'कर्ता',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'गैर-Admin',
  kycDocLicense: 'लाइसेंस',
  kycDocAadhaarFront: 'Aadhaar सामने',
  kycDocAadhaarBack: 'Aadhaar पीछे',
  kycDocPoliceVerification: 'पुलिस सत्यापन',
  kycVerification: 'KYC सत्यापन',
  kycNotSubmitted: 'KYC जमा नहीं',
  kycUnderReview: 'KYC समीक्षाधीन',
  kycVerified: 'KYC सत्यापित',
  kycRejected: 'KYC अस्वीकृत',
  kycAadhaarFront: 'Aadhaar सामने',
  kycAadhaarBack: 'Aadhaar पीछे',
  kycSelfie: 'सेल्फी',
  kycSubmitBtn: 'KYC दस्तावेज़ जमा करें',
  kycSubmitSuccess: 'दस्तावेज़ जमा — समीक्षाधीन',
  kycResubmit: 'दस्तावेज़ फिर जमा करें',
  adminKycTitle: 'क्लाइंट KYC समीक्षा',
  adminKycAllFilter: 'सभी',
  adminKycNoSubmissions: 'अभी तक कोई KYC जमा नहीं',
  adminOwnerKycTitle: 'मालिक KYC समीक्षा',
  adminOwnerKycNoSubmissions: 'अभी तक कोई मालिक KYC जमा नहीं',
  adminOperatorKycTitle: 'ऑपरेटर KYC समीक्षा',
  adminOperatorKycNoSubmissions: 'अभी तक कोई ऑपरेटर KYC जमा नहीं',
  kycRejectedWarning: 'आपका KYC अस्वीकृत हुआ। कृपया दस्तावेज़ फिर जमा करें।',
  kycNotSubmittedHint: 'विश्वसनीय अनुभव के लिए KYC पूरा करें।',
  kycPendingHint: 'आपका KYC समीक्षाधीन है।',
  kycGoToTab: 'KYC पर जाएं',
  adminKycApproveBtn: 'स्वीकृत',
  adminKycRejectBtn: 'अस्वीकृत',
  adminKycViewDocs: 'दस्तावेज़ देखें',
  adminKycRejectReason: 'अस्वीकृति का कारण',
  adminKycRereviewBtn: 'पुनः समीक्षा',
  kycPan: 'PAN कार्ड',
  kycOwnerSubmitSuccess: 'दस्तावेज़ जमा — आपका KYC समीक्षाधीन है',
  kycLicense: 'ड्राइविंग लाइसेंस',
  kycPoliceVerification: 'पुलिस सत्यापन',
  kycOperatorSubmitSuccess: 'दस्तावेज़ जमा — आपका KYC समीक्षाधीन है',
  operatorKycRejectedAssign: 'इस ऑपरेटर का KYC अस्वीकृत हो गया — पुनः स्वीकृत होने तक उन्हें असाइन नहीं किया जा सकता।',
  operatorsColOperator: 'ऑपरेटर',
  operatorsColEmail: 'ईमेल',
  operatorsColPhone: 'फ़ोन',
  operatorsColDocuments: 'दस्तावेज़',
  operatorsColStatus: 'स्थिति',
  operatorsDocumentsBtn: 'दस्तावेज़ ({{count}})',
  operatorsNoResults: 'कोई ऑपरेटर नहीं मिला',
  operatorsAllTitle: 'सभी ऑपरेटर ({{count}})',
  operatorsKycDialogDesc: 'KYC दस्तावेज़',
  bookingsCountLabel: '{{count}} बुकिंग',
  complianceDates: 'अनुपालन तिथियां',
  complianceInsurance: 'बीमा',
  complianceRcBook: 'RC बुक',
  compliancePuc: 'PUC',
  complianceNotSet: 'सेट नहीं',
  complianceExpired: 'समाप्त',
  complianceExpiringSoon: 'जल्द समाप्त',
  complianceExpiringCritical: '7 दिन में समाप्त',
  complianceValid: 'वैध',
  complianceUpdateBtn: 'अनुपालन तिथियां अपडेट करें',
  complianceSaveBtn: 'सेव करें',
  complianceAlertsTitle: 'अनुपालन अलर्ट',
  complianceAllCompliant: 'सभी मशीनें अनुपालित ✅',
  complianceColMachine: 'मशीन',
  complianceColOwner: 'मालिक',
  complianceColInsurance: 'बीमा',
  complianceColRcBook: 'RC बुक',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'प्रारंभ तिथि',
  complianceEndDate: 'समाप्ति तिथि',
  complianceExtractBtn: 'तिथियाँ स्वतः भरने के लिए दस्तावेज़ अपलोड करें',
  complianceExtractSuccess: 'तिथियाँ निकाली गईं — सेव करने से पहले जाँचें',
  complianceExtractError: 'तिथियाँ निकाल नहीं सकी — कृपया मैन्युअल दर्ज करें',
  complianceExtracting: 'दस्तावेज़ पढ़ा जा रहा है...',
  serviceHistory: 'सर्विस इतिहास',
  serviceLastService: 'अंतिम सर्विस',
  serviceNoRecords: 'अभी तक कोई सर्विस रिकॉर्ड नहीं',
  serviceNextDue: 'अगली सर्विस देय',
  serviceNextHmr: 'अगली सर्विस पर',
  serviceAddLog: 'सर्विस लॉग जोड़ें',
  serviceDate: 'सर्विस तिथि',
  serviceType: 'सर्विस प्रकार',
  serviceHmr: 'सर्विस पर HMR',
  serviceNextDate: 'अगली सर्विस तिथि',
  serviceWorkDone: 'किया गया काम',
  serviceNotes: 'नोट्स',
  serviceTypeRoutine: 'नियमित',
  serviceTypeMajor: 'प्रमुख',
  serviceTypeBreakdown: 'खराबी',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'अन्य',
  serviceOverdue: 'अतिदेय',
  serviceDueSoon: 'जल्द देय',
  fleetAnalytics: 'फ्लीट एналिटिक्स',
  analyticsRevenue: 'कुल राजस्व',
  analyticsBookings: 'कुल बुकिंग',
  analyticsHours: 'कुल घंटे',
  analyticsActiveMachines: 'सक्रिय मशीनें',
  analyticsMonthlyTrend: 'मासिक राजस्व रुझान',
  analyticsMachineTable: 'मशीन द्वारा राजस्व',
  analyticsNoData: 'इस अवधि में कोई पूर्ण बुकिंग नहीं',
  analyticsLastBooking: 'अंतिम बुकिंग',
  analytics3Months: '3 महीने',
  analytics6Months: '6 महीने',
  analytics12Months: '12 महीने',
  adminAnalytics: 'एनालिटिक्स',
  adminFleetTitle: 'फ्लीट एनालिटिक्स',
  adminFleetPlatformRevenue: 'प्लेटफ़ॉर्म राजस्व',
  adminFleetActiveOwners: 'सक्रिय मालिक',
  adminFleetOwnerCol: 'मालिक',
  adminFleetMonthlyTrend: 'मासिक राजस्व रुझान',
  adminFleetMachineTable: 'मशीन द्वारा राजस्व',
  adminFleetNoData: 'इस अवधि में कोई पूर्ण बुकिंग नहीं',
  adminFinancialIntelligence: 'मशीन वित्तीय जानकारी',
  adminTotalInvested: 'कुल निवेश',
  adminTotalEarned: 'कुल कमाई',
  adminAvgRecovery: 'औसत वसूली',
  adminBreakEvenRate: 'ब्रेक-ईवन दर',
  adminProfitMargin: 'लाभ मार्जिन',
  adminNoFinancialData: 'अभी तक वित्तीय डेटा वाली कोई मशीन नहीं',
  adminMachineDetail: 'मशीन विवरण',
  adminCallOwner: 'मालिक को कॉल करें',
  adminWhatsappOwner: 'WhatsApp मालिक',
  adminMarketRates: 'मार्केट रेट जमा',
  adminMarketRateDelete: 'हटाएं',
  adminMarketRateDeleteConfirm: 'क्या इस मार्केट रेट जमा को हटाएं?',
  adminMarketRateDeleted: 'मार्केट रेट हटा दी गई',
  adminMarketRateNoData: 'अभी तक कोई मार्केट रेट जमा नहीं',
  marketRateApprove: 'स्वीकृत करें',
  marketRateReject: 'अस्वीकृत करें',
  marketRateApproved: 'स्वीकृत',
  marketRateRejected: 'अस्वीकृत',
  marketRatePending: 'लंबित',
  marketRateReviewed: 'मार्केट रेट की समीक्षा हो गई',
  marketRatePendingReview: 'आपकी दर जमा हो गई है और एडमिन समीक्षा में लंबित है।',
  marketRateEditApprove: 'संपादित करें और स्वीकृत करें',
  marketRateEditMin: 'सही न्यूनतम दर (₹/घंटा)',
  marketRateEditMax: 'सही अधिकतम दर (₹/घंटा)',
  adminPayrollOverview: 'पेरोल अवलोकन',
  adminPayrollTotalOperators: 'कुल ऑपरेटर',
  adminPayrollTotalGross: 'कुल देय राशि',
  adminPayrollTotalNet: 'कुल शुद्ध देय',
  adminPayrollNoData: 'इस महीने के लिए कोई पेरोल डेटा नहीं',
  adminNotifLog: 'सूचना लॉग',
  adminNotifColUser: 'उपयोगकर्ता',
  adminNotifColRole: 'भूमिका',
  adminNotifNoData: 'अभी तक कोई सूचना लॉग नहीं',
  subTabSchedule: 'शेड्यूल',
  subTabHistory: 'इतिहास',
  subTabAnalytics: 'एनालिटिक्स',
  clientAnalyticsTitle: 'बुकिंग एनालिटिक्स',
  clientAnalyticsSpend: 'कुल खर्च',
  clientAnalyticsHours: 'कुल घंटे',
  clientAnalyticsBookings: 'पूर्ण बुकिंग',
  clientAnalyticsMachines: 'उपयोग की गई मशीनें',
  clientAnalyticsAvgSpend: 'प्रति बुकिंग औसत',
  clientAnalyticsMonthlyTrend: 'मासिक खर्च रुझान',
  clientAnalyticsTopMachines: 'शीर्ष मशीनें',
  clientAnalyticsNoData: 'इस अवधि में कोई पूर्ण बुकिंग नहीं',
  operatorAnalyticsTitle: 'कार्य विश्लेषण',
  operatorAnalyticsPresentDays: 'उपस्थित दिन',
  operatorAnalyticsHalfDays: 'आधा दिन',
  operatorAnalyticsHmr: 'कुल HMR',
  operatorAnalyticsJobs: 'पूर्ण कार्य',
  operatorAnalyticsIssues: 'रिपोर्ट किए गए मुद्दे',
  operatorAnalyticsAvgHmr: 'औसत HMR/दिन',
  operatorAnalyticsMonthlyTrend: 'मासिक कार्य रुझान',
  operatorAnalyticsIssueBreakdown: 'प्रकार के अनुसार मुद्दे',
  operatorAnalyticsRecentJobs: 'हाल के कार्य',
  operatorAnalyticsNoData: 'इस अवधि में कोई कार्य रिकॉर्ड नहीं',
  adminServiceAlertsTitle: 'सर्विस अलर्ट',
  adminServiceAllOk: 'सभी मशीनों के सर्विस रिकॉर्ड अप-टू-डेट हैं ✅',
  adminServiceNoRecord: 'कोई रिकॉर्ड नहीं',
  adminServiceColLastService: 'अंतिम सर्विस',
  adminServiceColNextDue: 'अगली देय',
  adminServiceColServiceStatus: 'सर्विस स्थिति',
  adminMachinesColMinHrs: 'न्यूनतम घं.',
  adminMachinesColRateDay: 'दर/दिन',
  adminClientName: 'ग्राहक का नाम',
  adminOwnerName: 'मालिक का नाम',
  adminPayoutWallet: 'भुगतान वॉलेट',
  adminFooterMachines: 'मशीनें',
  adminFooterClients: 'ग्राहक',
  adminFooterOwners: 'मालिक',
  auditIntroBanner: 'लॉगिन, व्यवस्थापक कार्रवाइयाँ और सुरक्षा घटनाएँ। फ़िल्टर लोड किए गए परिणामों पर लागू होते हैं; पुरानी पंक्तियों के लिए और लोड करें।',
  auditLoaded: 'लोड किए गए',
  auditMoreAvailable: 'और उपलब्ध',
  auditEndOfList: 'सूची समाप्त',
  auditFilterActive: 'फ़िल्टर सक्रिय',
  auditFiltersActive: 'फ़िल्टर सक्रिय',
  auditSeverityBreakdown: 'गंभीरता विभाजन (वर्तमान सूची)',
  auditPressSlash: 'कार्रवाई फ़िल्टर पर फ़ोकस करने के लिए / दबाएँ',
  auditFilters: 'फ़िल्टर',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'सभी भूमिकाएँ',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'मेटाडेटा JSON खोजें',
  auditFilterFromPlaceholder: 'प्रारंभ दिनांक और समय',
  auditFilterToPlaceholder: 'समाप्ति दिनांक और समय',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'समय क्षेत्र:',
  auditTimezoneSuffix: '(स्थानीय)',
  auditHideCsvOptions: 'CSV कॉलम विकल्प छिपाएँ',
  auditShowCsvOptions: 'CSV कॉलम विकल्प दिखाएँ',
  auditCsvColCreatedAt: 'निर्माण समय',
  auditCsvColAction: 'कार्रवाई',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'मेटाडेटा',
  auditFooterLoaded: 'लोड किए गए',
  auditFooterLogs: 'ऑडिट लॉग',
  auditFooterMoreAvailable: '(और उपलब्ध)',
  auditFooterAllLoaded: '(सभी लोड किए गए)',
  auditActor: 'एक्टर',
  auditEntity: 'इकाई',
  auditSeverityCritical: 'गंभीर',
  auditSeverityHigh: 'उच्च',
  auditSeverityMedium: 'मध्यम',
  auditSeverityNormal: 'सामान्य',
  auditCopyEvent: 'इवेंट कॉपी करें',
  auditViewDetails: 'विवरण देखें',
  auditHideDetails: 'विवरण छिपाएं',
  auditCopyJson: 'JSON कॉपी करें',
  auditNoLogs: 'कोई ऑडिट लॉग नहीं',
  auditEventLog: 'इवेंट लॉग',
  bookingAttachment: 'अटैचमेंट चुनें',
  bookingAttachmentNone: 'कोई विशिष्ट अटैचमेंट नहीं',
  bookingWorkDescription: 'कार्य विवरण',
  bookingWorkDescriptionPlaceholder: 'उदा. नींव उत्खनन, ट्रेंचिंग, पाइपलाइन कार्य',
  bookingAttachmentLabel: 'अटैचमेंट',
  bookingSiteLabel: 'साइट',
  bookingWorkLabel: 'कार्य',
  termsAccept: 'मैं नियम और शर्तों से सहमत हूँ',
  termsRequired: 'पंजीकरण के लिए नियम और शर्तें स्वीकार करना आवश्यक है',
  termsLink: 'नियम और शर्तें',
  clientBlacklisted: 'ब्लैकलिस्ट',
  clientBlacklistReason: 'ब्लैकलिस्ट का कारण',
  clientBlacklistConfirm: 'इस क्लाइंट को ब्लैकलिस्ट करें?',
  clientUnblacklist: 'ब्लैकलिस्ट से हटाएँ',
  blacklistedClients: 'ब्लैकलिस्ट क्लाइंट',
  blacklistedClientsEmpty: 'कोई ब्लैकलिस्ट क्लाइंट नहीं',
  managerAccessRestricted: 'वित्त पहुँच प्रतिबंधित। ओम चव्हाण से संपर्क करें।',
  managerSection: 'मैनेजर',
  managerAdd: 'मैनेजर जोड़ें',
  managerName: 'मैनेजर का नाम',
  managerEmail: 'मैनेजर ईमेल',
  managerPassword: 'अस्थायी पासवर्ड',
  managerCreated: 'मैनेजर खाता बन गया',
  managerCredentialsTitle: 'मैनेजर लॉगिन विवरण',
  managerCredentialsSubtitle: 'ये विवरण अभी सहेजें — पासवर्ड बाद में वापस नहीं मिल सकता',
  managerCredentialsSaved: 'मैंने विवरण सहेज लिया है',
  managerLoginUrl: 'लॉगिन URL',
  managerActivity: 'मैनेजर गतिविधि',
  managerActivityEmpty: 'अभी तक कोई गतिविधि दर्ज नहीं',
  managerActivityViewAll: 'सभी गतिविधि देखें',
  onboardingTitle: 'शुरू करें',
  onboardingAccountApproved: 'खाता स्वीकृत',
  onboardingKycComplete: 'KYC सत्यापन पूरा',
  onboardingKycPending: 'KYC सत्यापन पूरा करें',
  onboardingKycRejected: 'KYC अस्वीकृत — कृपया फिर से जमा करें',
  onboardingWalletFunded: 'वॉलेट में राशि है',
  onboardingWalletEmpty: 'बुकिंग के लिए वॉलेट में राशि जोड़ें',
  pushEnablePrompt: 'तुरंत अपडेट के लिए पुश सूचनाएँ चालू करें',
  downloadDisputeStatement: 'विवाद बयान डाउनलोड करें',
  downloadInvoice: 'इनवॉइस डाउनलोड करें',
  bookAgain: 'फिर से बुक करें',
  machineNoLongerAvailable: 'मशीन अब उपलब्ध नहीं है',
  downloadHistoryPdf: 'इतिहास PDF डाउनलोड करें',
  onboardingFirstBooking: 'अपनी पहली बुकिंग करें',
  onboardingAllDone: 'आप तैयार हैं!',
  onboardingTrackerTitle: 'ऑनबोर्डिंग प्रगति',
  onboardingTrackerTarget: 'ऑनबोर्डिंग लक्ष्य: 48 घंटे',
  onboardingTrackerInProgress: 'प्रगति में',
  onboardingTrackerActionRequired: 'कार्रवाई आवश्यक',
  onboardingTrackerComplete: 'पूर्ण',
  onboardingTrackerPending: 'लंबित',
  onboardingTrackerPhase1: 'पंजीकरण',
  onboardingTrackerPhase2: 'KYC सत्यापन',
  onboardingTrackerPhase3: 'मशीन पंजीकरण',
  onboardingTrackerPhase4: 'पहली बुकिंग तैयार',
  onboardingTrackerHelper1: 'मशीन पंजीकरण खोलने के लिए आधार + सेल्फी अपलोड करें',
  onboardingTrackerHelper2: 'KYC समीक्षा में — आमतौर पर 24 घंटे में',
  onboardingTrackerHelper3: 'KYC अस्वीकृत — दस्तावेज़ फिर जमा करें',
  onboardingTrackerHelper4: 'KYC स्वीकृत — अपनी पहली मशीन जोड़ें',
  onboardingTrackerHelper5: 'मशीन एडमिन समीक्षा में',
  onboardingTrackerHelper6: 'मशीन लाइव — पहली बुकिंग की प्रतीक्षा',
  onboardingTrackerPhaseLabel: 'चरण',
  alertsAndNotifications: 'अलर्ट और सूचनाएँ',
  duration: 'अवधि',
  cycles: 'चक्र',
  txRecharge: 'वॉलेट रिचार्ज',
  txBookingAdvance: 'बुकिंग अग्रिम',
  txBookingPayment: 'बुकिंग भुगतान',
  txSettlement: 'सेटलमेंट',
  txRefund: 'रिफंड',
  txPenalty: 'जुर्माना',
  txCommission: 'कमीशन',
  filterAll: 'सभी',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'लंबित',
  filterDisputed: 'विवादित',
  tacTitle: 'नियम और शर्तें',
  tacPrivacy: 'गोपनीयता नीति',
  tacRefund: 'रिफंड नीति',
  tacCancellation: 'रद्दीकरण नीति',
  tacServiceDelivery: 'सेवा वितरण नीति',
  tacIntro: 'बुकिंग से पहले हमारी नीतियाँ देखें',
  tacBannerTitle: 'नियम अपडेट उपलब्ध',
  tacBannerOpen: 'नियम खोलें',
  tacBannerAgree: 'मैंने पढ़ लिया है और सहमत हूँ',
  tacBannerLater: 'बाद में',
  clientPoliciesTitle: 'ग्राहक नीतियाँ',
  machineGroupAvailable: 'उपलब्ध',
  machineGroupBusy: 'व्यस्त',
  dewateringReferral: 'डीवाटरिंग (पंप) सेवा चाहिए? MachineOS जल्द पंप ठेकेदार सेवाएँ जोड़ेगा। रेफरल के लिए सपोर्ट से संपर्क करें।',
  noActiveWork: 'इस महीने कोई सक्रिय कार्य नहीं',
  accountTab: 'खाता',
  recentActivity: 'हाल की गतिविधि',
  goodMorning: 'सुप्रभात',
  goodAfternoon: 'शुभ दोपहर',
  goodEvening: 'शुभ संध्या',
};
const MR_BASE = {
  ...TRANSLATIONS.mr,
  confirmDuplicateActiveBooking: 'या मशीनवर तुमची बुकिंग आधीच active आहे (#{{ref}}). तरीही नवीन बुकिंग करायची आहे का?',
  experienceNotAvailable: 'अनुभव उपलब्ध नाही',
  yearsExpShort: '{{n}} वर्षे अनुभव',
  walletStatusOk: 'ठीक',
  walletStatusLow: 'कमी',
  liveBadge: 'लाइव्ह',
  ownerBankDetailsIncomplete: 'बँक तपशील अपूर्ण',
  ownerPayoutBlockedNoBank: 'पेमेंट थांबेल — कृपया बँक तपशील जोडा',
  ownerAddBankDetailsBtn: 'बँक तपशील जोडा →',
  noAlertsNow: 'कोणतेही अलर्ट नाहीत.',
  notificationCenter: 'संदेश नोंद',
  navSectionMachineManagement: 'मशीन व्यवस्थापन',
  navSectionFinance: 'वित्त',
  navSectionOperations: 'कार्यवाही',
  navSectionAccount: 'खाते',
  notifChannelAll: 'सर्व',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ईमेल',
  notifChannelPush: 'पुश',
  notifChannelSms: 'SMS',
  notifStatusSent: 'पाठवले',
  notifStatusFailed: 'अयशस्वी',
  notifStatusPending: 'प्रलंबित',
  notifEmpty: 'अद्याप कोणतीही सूचना नाही',
  notifLoadMore: 'अजून लोड करा',
  machineUpdateFailed: 'अपडेट अयशस्वी. पुन्हा प्रयत्न करा.',
  editMachineRatesTitle: 'मशीन दर संपादित करा',
  ratePerHourLabel: 'दर/तास (₹)',
  minimumHoursLabel: 'किमान तास',
  ratePerDayLabel: 'दर/दिवस (₹)',
  fuelCapacityLabel: 'इंधन क्षमता (L)',
  machineFinancialSection: 'मशीन खरेदी तपशील (ऐच्छिक)',
  machineOwnershipType: 'मालकी प्रकार',
  machineOwnershipNew: 'नवीन मशीन',
  machineOwnershipUsed: 'मूळ मालक',
  machineOwnershipSecondHand: 'पूर्व-स्वामित्व',
  machinePurchasePrice: 'खरेदी किंमत (₹)',
  machinePurchasePriceHint: 'या मशीनसाठी तुम्ही भरलेली रक्कम',
  machinePurchaseDate: 'खरेदी तारीख',
  machineYearOfManufacture: 'उत्पादन वर्ष',
  machineLoanSection: 'या मशीनवर माझे loan आहे',
  machineLoanAmount: 'Loan रक्कम (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan कालावधी (महिने)',
  machineLoanStartDate: 'Loan सुरू तारीख',
  machineFuelConsumption: 'इंधन वापर (L/hr)',
  machineMonthlyOperatingExpenses: 'मासिक परिचालन खर्च',
  machineOperatorMonthlySalary: 'ऑपरेटर मासिक पगार',
  machineServiceMonthly: 'सर्व्हिस / देखभाल (मासिक)',
  machineBreakdownMonthly: 'बिघाड / दुरुस्ती (मासिक सरासरी)',
  machineMaterialsMonthly: 'साहित्य / उपभोग्य वस्तू (मासिक)',
  recoveryPlan: 'रिकव्हरी प्लॅन',
  recoveryOnTrack: 'योग्य मार्गावर',
  recoveryNeedsAttention: 'लक्ष द्या',
  recoveryActionRequired: 'कारवाई आवश्यक',
  recoveryAddPrice: 'रिकव्हरी प्लॅन पाहण्यासाठी खरेदी किंमत जोडा',
  recoveryProgress: 'गुंतवणूक परतफेड',
  recoveryDailyNet: 'दैनिक निव्वळ उत्पन्न',
  recoveryDays: 'परतावा कालावधी',
  recoveryProjectedDate: 'अपेक्षित परतावा तारीख',
  recoveryRoi: 'वार्षिक परतावा',
  recoveryCurrentValue: 'सध्याचे यंत्र मूल्य',
  recoveryBackfillNudge: 'रिकव्हरी ट्रॅकिंग अनलॉक करण्यासाठी {{count}} मशीन(ना) मध्ये खरेदी तपशील जोडा',
  editFinancialDetails: 'आर्थिक तपशील संपादित करा',
  financialDetailsSaved: 'आर्थिक तपशील जतन केले',
  dieselPriceTitle: 'डिझेल किंमत',
  dieselPriceUpdate: 'डिझेल किंमत अपडेट करा',
  dieselPriceLatest: 'नवीनतम किंमत',
  dieselPriceNoRecord: 'डिझेल किंमत नोंदवलेली नाही',
  dieselPricePerLitre: 'प्रति लिटर किंमत (₹)',
  dieselQuantity: 'भरलेले प्रमाण (लिटर)',
  dieselTaluka: 'शहर / भाग',
  dieselFuelCostPerHour: 'प्रति तास इंधन खर्च',
  dieselPercentOfRate: 'तुमच्या तासाच्या दराचा',
  dieselPriceSaved: 'डिझेल किंमत जतन केली',
  dieselRateSuggestion: 'दर सूचना',
  dieselRateIncrease: 'डिझेल वाढले — दर वाढवण्याचा विचार करा',
  dieselRateDecrease: 'डिझेल कमी — बुकिंगसाठी दर कमी करा',
  dieselSuggestedRate: 'सुचवलेली दर',
  dieselHistory: 'किंमत इतिहास',
  dieselNoHistory: 'अद्याप डिझेल किंमत इतिहास नाही',
  dieselColDate: 'तारीख',
  dieselColPrice: 'किंमत/लिटर',
  dieselColQty: 'प्रमाण',
  dieselColSource: 'स्रोत',
  dieselUploadReceipt: 'पावती अपलोड करा',
  dieselExtractSuccess: 'पावतीवरून काढले',
  dieselExtractFailed: 'काढता आले नाही — कृपया स्वहस्ते प्रविष्ट करा',
  applyRateSuggestion: '₹{{rate}}/तास लागू करा',
  rateSuggestionApplied: 'दर यशस्वीरित्या अपडेट झाली',
  marketPosition: 'बाजार स्थिती',
  marketBelowMarket: 'बाजारपेक्षा कमी',
  marketCompetitive: 'स्पर्धात्मक',
  marketAboveMarket: 'बाजारपेक्षा जास्त',
  marketNoData: 'तुमच्या भागासाठी अद्याप बाजार डेटा नाही',
  marketSubmitRate: 'बाजार दर सादर करा',
  marketCity: 'शहर / भाग',
  marketMinRate: 'तुमच्या भागात किमान दर (₹/तास)',
  marketMaxRate: 'तुमच्या भागात कमाल दर (₹/तास)',
  marketRateSubmitted: 'बाजार दर सादर झाली — धन्यवाद!',
  marketDataPoints: '{{count}} सादरांवर आधारित',
  marketRange: '{{city}} मध्ये बाजार',
  marketSourceLocal: '{{city}} भागातील दरांवर आधारित',
  marketSourcePlatform: 'प्लॅटफॉर्म-व्यापी दरांवर आधारित',
  editRatesBtn: '✏️ दर संपादित करा',
  editRegistrationInfo: 'नोंदणी माहिती संपादित करा',
  editRegistrationInfoHint:
    'मंजूर मशीनचे दर, फ्लोर, अॅटॅचमेंट, आर्थिक तपशील किंवा अनुपालन तारखा अपडेट करा. बदल लगेच लागू होतात.',
  editRegistrationPickMachine: 'मशीन निवडा',
  editRegistrationPickPlaceholder: 'मशीन निवडा…',
  editRegistrationSelectPrompt: 'नोंदणी संपादक उघडण्यासाठी वर मशीन निवडा.',
  myMachinesEditRegistrationBtn: '✏️ नोंदणी माहिती संपादित करा',
  myMachinesComplianceSummary: 'विमा स्थिती',
  lockedRegistrationFieldsTitle: 'लॉक नोंदणी फील्ड',
  lockedRegistrationFieldsNote:
    'हे दुरुस्त करण्यासाठी अॅडमिनशी संपर्क साधा — ओळख फसवणूक टाळण्यासाठी लॉक आहेत.',
  lockedFieldRegNo: 'नोंदणी क्रमांक',
  lockedRegistrationDocuments: 'कागदपत्रे / फोटो',
  lockedRegistrationDocumentsNone: 'या दृश्यात कोणतेही कागदपत्र लिंक उपलब्ध नाहीत.',
  lockedRegistrationDocumentOnFile: 'फाइलमध्ये',
  assignOperatorFailed: 'ऑपरेटर नियुक्त करणे अयशस्वी.',
  unassignOperatorFailed: 'ऑपरेटर काढणे अयशस्वी.',
  genericError: 'काहीतरी चूक झाली.',
  confirmDeactivateOperator: 'हा ऑपरेटर निष्क्रिय करायचा? मशीनमधून auto-unassign होईल.',
  inviteGenerateFailed: 'आमंत्रण कोड तयार करणे अयशस्वी.',
  inviteCodeCopied: 'आमंत्रण कोड कॉपी केला! 24 तासांसाठी वैध.',
  userApprovedPdfDownloaded: 'मंजूर! करार PDF डाउनलोड झाला.',
  userApprovalFailed: 'मंजुरी अयशस्वी. पुन्हा प्रयत्न करा.',
  userRejectedSuccess: 'नाकारले!',
  userRejectionFailed: 'नकार अयशस्वी. पुन्हा प्रयत्न करा.',
  deactivateFailed: 'निष्क्रिय करणे अयशस्वी. पुन्हा प्रयत्न करा.',
  reactivateFailed: 'पुन्हा सक्रिय करणे अयशस्वी. पुन्हा प्रयत्न करा.',
  panDocumentUnavailable: 'PAN दस्तऐवज उपलब्ध नाही.',
  sessionExpiredRefresh: 'सत्र संपले. पृष्ठ रिफ्रेश करा किंवा पुन्हा लॉगिन करा.',
  sessionExpiredSignIn: 'सत्र संपले. कृपया पुन्हा साइन इन करा.',
  sessionRevokedAlert: 'तुम्ही दुसऱ्या डिव्हाइसवर लॉग इन आहात. कृपया पुन्हा लॉगिन करा.',
  activateBtn: '✓ सक्रिय करा',
  deactivateBtn: '✕ निष्क्रिय करा',
  reactivateBtn: 'पुन्हा सक्रिय करा',
  ownerApprovedStatus: 'मालकाने मंजूर केले',
  awaitingOwnerApprovalStatus: 'मालकाच्या मंजुरीची प्रतीक्षा',
  pendingApprovalStatus: 'मंजुरी प्रलंबित',
  statusDisputed: 'वाद',
  statusApproved: 'मंजूर',
  statusPending: 'प्रलंबित',
  statusActive: 'सक्रिय',
  statusInactive: 'निष्क्रिय',
  statusRejected: 'नाकारले',
  statusCompleted: 'पूर्ण',
  statusCancelled: 'रद्द',
  bookingClosed: 'बंद',
  sectionNew: 'नवीन',
  sectionAccepted: 'स्वीकृत',
  sectionActive: 'सक्रिय',
  sectionDispatched: 'डिस्पॅच',
  sectionCompleting: 'पूर्ण होत आहे',
  sectionDisputed: 'विवादित',
  sectionCompleted: 'पूर्ण',
  sectionClosed: 'बंद',
  gstPdfBtn: 'GST PDF',
  minBooking: 'किमान बुकिंग',
  hrsShort: 'तास',
  machineGstFuelNote: '* GST 18% · इंधन समाविष्ट · ऑपरेटर समाविष्ट',
  cancelCreditBanner: '{{machine}} रद्द | ₹{{amount}} वॉलेट क्रेडिट!',
  advanceDeductedFromWallet: 'आगाऊ रक्कम तुमच्या वॉलेटमधून कापली जाईल',
  cancelText: 'रद्द करा',
  machineLabel: 'मशीन',
  walletCreditFull: 'वॉलेट क्रेडिट (पूर्ण आगाऊ)',
  escrowNote: 'डिस्पॅचपूर्वी — आगाऊ रक्कम तुमच्या वॉलेटमध्ये परत येईल (बँक परतावा नाही).',
  currentWalletBalance: 'सध्या: ₹{{amount}}',
  bookPayAdvance: 'बुक करा — ₹{{amount}} आगाऊ द्या',
  walletLabel: 'वॉलेट: ₹{{amount}}',
  gstInvoiceHint: '{{count}} GST पावती — खालील पूर्ण बुकिंगसाठी "GST PDF" डाउनलोड करा.',
  totalWithGst: 'एकूण: ₹{{total}} (GST ₹{{gst}})',
  machineDispatchedAt: 'मशीन पाठवली',
  emailLabel: 'ईमेल',
  totalMachines: 'एकूण मशीन',
  activeFleet: 'सक्रिय ताफा',
  activeToday: 'आज सक्रिय',
  revenueMonth: 'महसूल (महिना)',
  liveBookings: 'लाइव्ह बुकिंग',
  noDataYet: 'अद्याप डेटा नाही',
  myCommission: 'माझी कमिशन',
  commissionPctTotal: 'एकूणच्या 15%',
  activeClients: 'सक्रिय ग्राहक',
  lowFuelAlert: 'कमी इंधन सूचना',
  actionNeeded: '⚠ कारवाई आवश्यक',
  thisMonthEarned: 'या महिन्याची कमाई',
  standardBookings: 'सामान्य बुकिंग',
  activeContracts: 'सक्रिय करार',
  contractsOngoing: 'करार सुरू आहेत',
  noActiveContracts: 'या कालावधीत काहीही नाही',
  quotationsPending: 'उत्तराच्या प्रतीक्षेत कोटेशन',
  allUpToDate: 'सर्व बुकिंग अद्ययावत आहेत',
  noBookingsInPeriod: 'या कालावधीत बुकिंग नाही',
  contractBookings: 'करार बुकिंग',
  noContractsInPeriod: 'या कालावधीत करार नाही',
  mobilizationReleased: 'मोबिलायझेशन सोडले',
  pendingRelease: 'प्रलंबित सुटका',
  raBills: 'आरए-बिल',
  disputed: 'वादग्रस्त',
  all: 'सर्व',
  completed: 'पूर्ण',
  totalBookings: 'एकूण बुकिंग',
  activeNow: 'आता सक्रिय',
  totalRevenue: 'एकूण महसूल',
  todayLabel: 'आज',
  loadedBookings: '{{count}} बुकिंग लोड केल्या',
  moreAvailable: '(आणखी उपलब्ध)',
  allLoaded: '(सर्व लोड)',
  noMachineTelemetry: 'मशीन टेलिमेट्री उपलब्ध नाही.',
  noRevenueData: 'महसूल डेटा उपलब्ध नाही.',
  noAlertsInPeriod: 'या कालावधीत कोणतेही अलर्ट नाहीत.',
  systemRunningNormally: 'सिस्टम सामान्यपणे चालू आहे',
  deployedLabel: 'तैनात',
  totalBilledMonth: 'एकूण बिल (महिना)',
  totalCollected: 'एकूण जमा',
  pendingLabel: 'प्रलंबित',
  commissionEarned: 'कमिशन मिळाले',
  activeOwners: 'सक्रिय मालक',
  commissionLabel: 'कमिशन',
  realtimeRevenue: 'रिअल-टाइम महसूल',
  monthlyBilled: 'मासिक बिल',
  karadOpsHub: 'कराड · सातारा ऑपरेशन केंद्र',
  viewFullReports: 'संपूर्ण अहवाल पहा',
  totalMachinesLabel: 'एकूण मशीन',
  activeNowSuffix: '{{n}} आता सक्रिय',
  livePipeline: 'सक्रिय पाइपलाइन',
  yourEarnings: 'तुमची कमाई',
  immediateActionRequired: 'तत्काळ कारवाई आवश्यक',
  fleetHealthy: 'ताफा निरोगी',
  liveSignalFeed: 'लाइव्ह सिग्नल फीड',
  criticalAlertsHealth: 'गंभीर अलर्ट आणि सिस्टम स्थिती',
  streamingLabel: 'स्ट्रीमिंग',
  gstSummaryReport: '📊 GST सारांश अहवाल',
  loadingLabel: 'लोड होत आहे...',
  taxableAmount: 'करपात्र रक्कम',
  cgst9pct: 'CGST 9%',
  sgst9pct: 'SGST 9%',
  totalGst: 'एकूण GST',
  grossTotal: 'एकूण रक्कम',
  reconciliationSnapshot: '💾 जुळवणी स्नॅपशॉट',
  creditsLabel: 'क्रेडिट',
  debitsLabel: 'डेबिट',
  missingRefLabel: 'संदर्भ नाही',
  duplicateRefLabel: 'डुप्लिकेट संदर्भ',
  txnVolumeLabel: 'व्यवहार खंड',
  growthVsLastMonth: '+18% मागील महिन्यापेक्षा',
  trackingLocation: 'कराड, सातारा',
  trackingLastUpdated: 'शेवटचे अपडेट: आत्ता',
  ratingNotAvailable: '⭐ उपलब्ध नाही',
  utilizationPct: '66% वापर',
  liveMachineStatus: '📊 लाइव्ह मशीन स्थिती',
  revenueTimeline: '📈 महसूल टाइमलाइन',
  shareOfRevenue: 'लोड महसुलाचा वाटा',
  alertsNotifications: '🔔 अलर्ट आणि सूचना',
  dlqTotal: 'एकूण',
  dlqFailed: 'अयशस्वी',
  dlqRetried: 'पुन्हा प्रयत्न',
  dlqWhatsapp: 'WhatsApp',
  dlqEmail: 'ईमेल',
  dlqAlert: 'अलर्ट',
  // --- Recent feature strings ---
  monthlySalaryLabel: 'मासिक पगार (₹/महिना)',
  monthlySalaryPlaceholder: 'उदा. 25000',
  dailyPayrollHint: 'दैनिक पगार दर = मासिक पगार ÷ 26 कामाचे दिवस',
  monthlySalaryRequired: 'मासिक पगार आवश्यक (शून्यापेक्षा जास्त)',
  advanceBalance: 'अग्रिम शिल्लक',
  closeAdvance: 'अग्रिम बंद करा',
  giveAdvance: 'अग्रिम द्या',
  validAdvanceRequired: 'वैध अग्रिम रक्कम आवश्यक (शून्यापेक्षा जास्त)',
  failedToRecordAdvance: 'अग्रिम नोंदणी अयशस्वी',
  amountLabel: 'रक्कम (₹)',
  amountPlaceholder: 'उदा. 5000',
  noteOptional: 'टिप्पणी (ऐच्छिक)',
  advanceNotePlaceholder: 'उदा. सण अग्रिम',
  outstandingBalance: 'थकबाकी शिल्लक',
  saving: 'जतन करत आहे...',
  recordAdvance: 'अग्रिम नोंदवा',
  recentTransactions: 'अलीकडील व्यवहार',
  noAdvancesYet: 'अद्याप कोणतेही अग्रिम नोंदलेले नाही.',
  advanceTxnLabel: '+ अग्रिम',
  deductionTxnLabel: '− वजावट',
  perMonthSuffix: '/महिना',
  perDaySuffix: '/दिवस',
  failedToMarkAttendance: 'हजेरी नोंदणी अयशस्वी',
  failedToClockIn: 'क्लॉक इन अयशस्वी',
  failedToClockOut: 'क्लॉक आउट अयशस्वी',
  loadedAttendanceRows: '{{count}} हजेरी नोंदी लोड',
  hoursShort: 'ता',
  payrollPreview: 'पगार पूर्वावलोकन',
  payrollRun: 'पगार चालवा',
  payrollAlreadyRun: 'या महिन्यासाठी पगार आधीच चालवला आहे',
  payrollGross: 'एकूण देय',
  payrollNet: 'निव्वळ देय',
  payrollAdvanceDeducted: 'अग्रिम वजावट',
  payrollRunSuccess: 'पगार यशस्वीरित्या चालवला',
  payrollNoAmount: 'या महिन्यासाठी देय रक्कम नाही',
  payrollMonth: 'पगार महिना',
  exportPayrollCsv: 'पगार CSV निर्यात',
  payrollExportMonth: 'पगार निर्यात महिना',
  payrollDailyRate: 'दैनिक दर',
  payrollHistory: 'पगार इतिहास',
  payrollNoHistory: 'अद्याप कोणताही पगार चालवला नाही',
  payrollColMonth: 'महिना',
  payrollColGross: 'एकूण',
  payrollColDeduction: 'अग्रिम वजावट',
  payrollColNet: 'निव्वळ पगार',
  payrollColDate: 'तारीख',
  downloadPayslip: 'पे स्लिप डाउनलोड',
  payslipTitle: 'मासिक पे स्लिप',
  payslipEarnings: 'उत्पन्न',
  payslipDeductions: 'वजावट',
  payslipDaysWorked: 'कामाचे दिवस',
  payslipGeneratedBy: 'Development Express द्वारे तयार',
  operatorPayrollTitle: 'माझा पगार',
  payrollMonthlySalary: 'मासिक पगार',
  payrollCurrentMonth: 'सध्याचा महिना',
  payrollPreviousMonth: 'मागील महिना',
  ownerAttendanceTitle: 'हजेरी',
  ownerAttendanceEdit: 'संपादन',
  ownerAttendanceSave: 'जतन करा',
  ownerAttendanceNoRecords: 'या महिन्यासाठी हजेरी नोंदी नाहीत',
  ownerAttendanceOverrideSuccess: 'हजेरी अद्यतन केली',
  ownerSalaryUpdated: 'पगार यशस्वीरित्या अद्यतन केला',
  ownerSalaryEditBtn: 'पगार संपादन',
  ownerSalaryNotSet: 'पगार सेट नाही — पगार चालवण्यासाठी पगार सेट करा',
  plQuotaLabel: 'पगारी सुट्टी कोटा',
  plUsed: 'वापरले',
  plAllowed: 'मंजूर',
  plRemaining: 'उरले',
  plQuotaUpdated: 'PL कोटा अद्यतन',
  plQuotaExhausted: 'PL कोटा संपला — बिनपगारी सुट्टी म्हणून नोंद',
  plRemainingLabel: 'उरलेले PL',
  retryLabel: 'पुन्हा प्रयत्न करा',
  noAttendanceRecords: 'अद्याप हजेरी नोंदी नाहीत',
  noFuelLogs: 'अद्याप इंधन नोंदी नाहीत',
  noIssuesYet: 'अद्याप कोणतीही समस्या नोंदलेली नाही',
  failedToLoad: 'डेटा लोड करणे अयशस्वी',
  failedToLoadReport: 'अहवाल लोड करणे अयशस्वी',
  failedToLoadIssues: 'समस्या लोड करणे अयशस्वी',
  failedToLoadAlerts: 'अलर्ट लोड करणे अयशस्वी',
  noRecordsMonth: 'या महिन्यासाठी नोंदी नाहीत',
  underReview: 'पुनरावलोकनाधीन',
  issueResolved: 'सोडवले',
  presentDaysLabel: 'उपस्थित दिवस',
  halfDaysLabel: 'अर्धे दिवस',
  absentDaysLabel: 'अनुपस्थित दिवस',
  totalHmrLabel: 'एकूण HMR',
  noActiveBookingIdle: 'सक्रिय बुकिंग नाही — मशीन निष्क्रिय',
  siteLocationNotCaptured: 'साइट स्थान नोंदलेले नाही',
  siteLocationNotAvailable: 'साइट स्थान उपलब्ध नाही',
  bookingRefLabel: 'बुकिंग Ref',
  alertPendingBookings: 'प्रलंबित बुकिंग',
  alertPendingPayouts: 'प्रलंबित पेमेंट',
  alertLowFuel: 'कमी इंधन',
  alertOpenIssues: 'खुल्या समस्या',
  alertComplianceExpiring: 'अनुपालन कालबाह्य होत आहे',
  alertServiceDue: 'सर्विस देय',
  noMachineRunning: 'सध्या कोणतीही मशीन चालू नाही',
  trackingEmptyHint: 'मशीन डिस्पॅच झाल्यावर तुमची सक्रिय बुकिंग येथे दिसेल.',
  trackingUpdatedEvery5s: 'दर ५ सेकंदांनी अपडेट',
  fuelLastOperatorUpdate: '(ऑपरेटरचे शेवटचे अपडेट)',
  alertExtensionPending: 'बुकिंग विस्तार प्रलंबित',
  alertConfirmCompletion: 'कृपया काम पूर्णतेची पुष्टी करा',
  alertWalletCredited: 'वॉलेटमध्ये जोडले',
  alertFeedbackRequest: 'काम पूर्ण — तुमचा अभिप्राय सामायिक करा',
  noLogsYet: 'अजून कोणतीही क्रिया नोंदलेली नाही',
  todayActivityLog: 'आजचा क्रियाकलाप लॉग',
  machineLogSubtitle: 'इंधन, उपस्थिती, समस्या — स्थानिक सत्र लॉग',
  timerPaused: 'Timer थांबवला',
  liveBookingTitle: 'लाइव्ह बुकिंग',
  machineLogTimerHint: 'Timer Admin सुरू करतो. खाली तुमचा प्रत्यक्ष कामाचा वेळ नोंदवा — पूर्ण झाल्यावर Mark Work Complete वर क्लिक करा.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'उपस्थिती',
  ownerAlertBookingPending: 'नवीन बुकिंग तुमच्या मंजुरीसाठी प्रलंबित —',
  ownerAlertBookingHours: 'तास',
  ownerAlertPayoutPending: '₹{{amount}} चे पेमेंट ट्रान्सफर प्रलंबित',
  ownerAlertFuelLow: 'इंधन कमी',
  ownerAlertFuelRemaining: 'शिल्लक',
  ownerAlertIssue: 'समस्या नोंदवली',
  iotGpsDevicesActive: 'GPS उपकरणे सक्रिय',
  iotDashcamsOnline: 'डॅशकॅम ऑनलाइन',
  iotFuelSensorsActive: 'इंधन सेन्सर सक्रिय',
  iotMachinesLocked: 'मशीन लॉक',
  iotDeviceStatus: 'IoT उपकरण स्थिती',
  iotColMachine: 'मशीन',
  iotColGps: 'GPS',
  iotColLocation: 'स्थान',
  iotColFuel: 'इंधन %',
  iotColDashcam: 'डॅशकॅम',
  iotColIgnition: 'इग्निशन',
  iotColAction: 'कृती',
  iotStatusOnline: 'ऑनलाइन',
  iotStatusNotConnected: 'कनेक्ट नाही',
  iotStatusLive: 'लाइव्ह',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'लॉक',
  iotNotConnectedBanner: 'IoT हार्डवेअर अद्याप स्थापित नाही. Teltonika उपकरण स्थापनेनंतर GPS, डॅशकॅम आणि रिमोट लॉक वैशिष्ट्ये उपलब्ध होतील.',
  fuelUpdateTitle: 'इंधन अपडेट',
  fuelSensorAccuracyNote: 'ऑपरेटरने इंधन पातळी नोंदवली · मॅन्युअल नोंद',
  bookingsTab: 'बुकिंग',
  unknownLabel: 'अज्ञात',
  naLabel: 'N/A',
  baseLabel: 'मूळ',
  qtyLabel: 'प्रमाण',
  actualHrsLabel: 'वास्तविक तास',
  auditStatTotal: 'एकूण',
  auditStatSecurity: 'सुरक्षा',
  auditStatActors: 'कर्ते',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'अ-Admin',
  kycDocLicense: 'परवाना',
  kycDocAadhaarFront: 'Aadhaar समोर',
  kycDocAadhaarBack: 'Aadhaar मागे',
  kycDocPoliceVerification: 'पोलीस पडताळणी',
  kycVerification: 'KYC पडताळणी',
  kycNotSubmitted: 'KYC सादर केले नाही',
  kycUnderReview: 'KYC पुनरावलोकनाधीन',
  kycVerified: 'KYC सत्यापित',
  kycRejected: 'KYC नाकारले',
  kycAadhaarFront: 'Aadhaar समोर',
  kycAadhaarBack: 'Aadhaar मागे',
  kycSelfie: 'सेल्फी',
  kycSubmitBtn: 'KYC कागदपत्रे सादर करा',
  kycSubmitSuccess: 'कागदपत्रे सादर — पुनरावलोकनाधीन',
  kycResubmit: 'कागदपत्रे पुन्हा सादर करा',
  adminKycTitle: 'क्लायंट KYC पुनरावलोकन',
  adminKycAllFilter: 'सर्व',
  adminKycNoSubmissions: 'अद्याप कोणतीही KYC सादर नाही',
  adminOwnerKycTitle: 'मालक KYC पुनरावलोकन',
  adminOwnerKycNoSubmissions: 'अद्याप कोणतेही मालक KYC सादर नाही',
  adminOperatorKycTitle: 'ऑपरेटर KYC पुनरावलोकन',
  adminOperatorKycNoSubmissions: 'अद्याप कोणतेही ऑपरेटर KYC सादर नाही',
  kycRejectedWarning: 'तुमचे KYC नाकारले गेले. कृपया कागदपत्रे पुन्हा सादर करा.',
  kycNotSubmittedHint: 'विश्वासार्ह अनुभवासाठी KYC पूर्ण करा.',
  kycPendingHint: 'तुमचे KYC पुनरावलोकनाधीन आहे.',
  kycGoToTab: 'KYC कडे जा',
  adminKycApproveBtn: 'मंजूर',
  adminKycRejectBtn: 'नाकार',
  adminKycViewDocs: 'कागदपत्रे पहा',
  adminKycRejectReason: 'नकाराचे कारण',
  adminKycRereviewBtn: 'पुन्हा पुनरावलोकन',
  kycPan: 'PAN कार्ड',
  kycOwnerSubmitSuccess: 'कागदपत्रे सादर — तुमचे KYC पुनरावलोकनाधीन आहे',
  kycLicense: 'ड्रायव्हिंग परवाना',
  kycPoliceVerification: 'पोलीस पडताळणी',
  kycOperatorSubmitSuccess: 'कागदपत्रे सादर — तुमचे KYC पुनरावलोकनाधीन आहे',
  operatorKycRejectedAssign: 'या ऑपरेटरचे KYC नाकारले गेले — पुन्हा मंजूर होईपर्यंत त्यांना नियुक्त केले जाऊ शकत नाही.',
  operatorsColOperator: 'ऑपरेटर',
  operatorsColEmail: 'ईमेल',
  operatorsColPhone: 'फोन',
  operatorsColDocuments: 'कागदपत्रे',
  operatorsColStatus: 'स्थिती',
  operatorsDocumentsBtn: 'कागदपत्रे ({{count}})',
  operatorsNoResults: 'कोणतेही ऑपरेटर सापडले नाहीत',
  operatorsAllTitle: 'सर्व ऑपरेटर ({{count}})',
  operatorsKycDialogDesc: 'KYC कागदपत्रे',
  bookingsCountLabel: '{{count}} बुकिंग',
  complianceDates: 'अनुपालन तारखा',
  complianceInsurance: 'विमा',
  complianceRcBook: 'RC बुक',
  compliancePuc: 'PUC',
  complianceNotSet: 'सेट नाही',
  complianceExpired: 'कालबाह्य',
  complianceExpiringSoon: 'लवकरच कालबाह्य',
  complianceExpiringCritical: '७ दिवसात कालबाह्य',
  complianceValid: 'वैध',
  complianceUpdateBtn: 'अनुपालन तारखा अपडेट करा',
  complianceSaveBtn: 'जतन करा',
  complianceAlertsTitle: 'अनुपालन अलर्ट',
  complianceAllCompliant: 'सर्व मशीन अनुपालित ✅',
  complianceColMachine: 'मशीन',
  complianceColOwner: 'मालक',
  complianceColInsurance: 'विमा',
  complianceColRcBook: 'RC बुक',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'सुरुवातीची तारीख',
  complianceEndDate: 'समाप्ती तारीख',
  complianceExtractBtn: 'तारखा स्वयं भरण्यासाठी कागदपत्र अपलोड करा',
  complianceExtractSuccess: 'तारखा काढल्या — जतन करण्यापूर्वी तपासा',
  complianceExtractError: 'तारखा काढता आल्या नाहीत — कृपया स्वहस्ते प्रविष्ट करा',
  complianceExtracting: 'कागदपत्र वाचत आहे...',
  serviceHistory: 'सर्विस इतिहास',
  serviceLastService: 'शेवटची सर्विस',
  serviceNoRecords: 'अद्याप सर्विस नोंदी नाहीत',
  serviceNextDue: 'पुढील सर्विस देय',
  serviceNextHmr: 'पुढील सर्विस येथे',
  serviceAddLog: 'सर्विस लॉग जोडा',
  serviceDate: 'सर्विस तारीख',
  serviceType: 'सर्विस प्रकार',
  serviceHmr: 'सर्विसवर HMR',
  serviceNextDate: 'पुढील सर्विस तारीख',
  serviceWorkDone: 'केलेले काम',
  serviceNotes: 'नोट्स',
  serviceTypeRoutine: 'नियमित',
  serviceTypeMajor: 'मोठी',
  serviceTypeBreakdown: 'बिघाड',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'इतर',
  serviceOverdue: 'थकले',
  serviceDueSoon: 'लवकरच देय',
  fleetAnalytics: 'फ्लीट विश्लेषण',
  analyticsRevenue: 'एकूण महसूल',
  analyticsBookings: 'एकूण बुकिंग',
  analyticsHours: 'एकूण तास',
  analyticsActiveMachines: 'सक्रिय मशीन',
  analyticsMonthlyTrend: 'मासिक महसूल ट्रेंड',
  analyticsMachineTable: 'मशीननुसार महसूल',
  analyticsNoData: 'या कालावधीत पूर्ण झालेल्या बुकिंग नाहीत',
  analyticsLastBooking: 'शेवटची बुकिंग',
  analytics3Months: '3 महिने',
  analytics6Months: '6 महिने',
  analytics12Months: '12 महिने',
  adminAnalytics: 'विश्लेषण',
  adminFleetTitle: 'फ्लीट विश्लेषण',
  adminFleetPlatformRevenue: 'प्लॅटफॉर्म महसूल',
  adminFleetActiveOwners: 'सक्रिय मालक',
  adminFleetOwnerCol: 'मालक',
  adminFleetMonthlyTrend: 'मासिक महसूल ट्रेंड',
  adminFleetMachineTable: 'मशीननुसार महसूल',
  adminFleetNoData: 'या कालावधीत पूर्ण झालेल्या बुकिंग नाहीत',
  adminFinancialIntelligence: 'मशीन आर्थिक माहिती',
  adminTotalInvested: 'एकूण गुंतवणूक',
  adminTotalEarned: 'एकूण कमाई',
  adminAvgRecovery: 'सरासरी वसुली',
  adminBreakEvenRate: 'ब्रेक-ईवन दर',
  adminProfitMargin: 'नफा मार्जिन',
  adminNoFinancialData: 'अद्याप आर्थिक डेटा असलेली मशीन नाही',
  adminMachineDetail: 'मशीन तपशील',
  adminCallOwner: 'मालकाला कॉल करा',
  adminWhatsappOwner: 'WhatsApp मालक',
  adminMarketRates: 'मार्केट रेट सबमिशन',
  adminMarketRateDelete: 'हटवा',
  adminMarketRateDeleteConfirm: 'हा मार्केट रेट सबमिशन हटवायचा?',
  adminMarketRateDeleted: 'मार्केट रेट हटवली',
  adminMarketRateNoData: 'अद्याप कोणतेही मार्केट रेट सबमिशन नाही',
  marketRateApprove: 'मंजूर करा',
  marketRateReject: 'नाकारा',
  marketRateApproved: 'मंजूर',
  marketRateRejected: 'नाकारले',
  marketRatePending: 'प्रलंबित',
  marketRateReviewed: 'मार्केट रेटची समीक्षा झाली',
  marketRatePendingReview: 'तुमचा दर सादर झाला आहे आणि अॅडमिन समीक्षेसाठी प्रलंबित आहे.',
  marketRateEditApprove: 'संपादित करा आणि मंजूर करा',
  marketRateEditMin: 'सुधारित किमान दर (₹/तास)',
  marketRateEditMax: 'सुधारित कमाल दर (₹/तास)',
  adminPayrollOverview: 'पगार विहंगावलोकन',
  adminPayrollTotalOperators: 'एकूण ऑपरेटर',
  adminPayrollTotalGross: 'एकूण देय रक्कम',
  adminPayrollTotalNet: 'एकूण निव्वळ देय',
  adminPayrollNoData: 'या महिन्यासाठी पगार डेटा नाही',
  adminNotifLog: 'सूचना लॉग',
  adminNotifColUser: 'वापरकर्ता',
  adminNotifColRole: 'भूमिका',
  adminNotifNoData: 'अद्याप कोणतीही सूचना लॉग नाही',
  subTabSchedule: 'वेळापत्रक',
  subTabHistory: 'इतिहास',
  subTabAnalytics: 'विश्लेषण',
  clientAnalyticsTitle: 'बुकिंग विश्लेषण',
  clientAnalyticsSpend: 'एकूण खर्च',
  clientAnalyticsHours: 'एकूण तास',
  clientAnalyticsBookings: 'पूर्ण बुकिंग',
  clientAnalyticsMachines: 'वापरलेल्या मशीन',
  clientAnalyticsAvgSpend: 'प्रति बुकिंग सरासरी',
  clientAnalyticsMonthlyTrend: 'मासिक खर्च ट्रेंड',
  clientAnalyticsTopMachines: 'शीर्ष मशीन',
  clientAnalyticsNoData: 'या कालावधीत पूर्ण झालेल्या बुकिंग नाहीत',
  operatorAnalyticsTitle: 'काम विश्लेषण',
  operatorAnalyticsPresentDays: 'हजेरी दिवस',
  operatorAnalyticsHalfDays: 'अर्ध दिवस',
  operatorAnalyticsHmr: 'एकूण HMR',
  operatorAnalyticsJobs: 'पूर्ण केलेली नोकऱ्या',
  operatorAnalyticsIssues: 'नोंदवलेले मुद्दे',
  operatorAnalyticsAvgHmr: 'सरासरी HMR/दिवस',
  operatorAnalyticsMonthlyTrend: 'मासिक काम ट्रेंड',
  operatorAnalyticsIssueBreakdown: 'प्रकारानुसार मुद्दे',
  operatorAnalyticsRecentJobs: 'अलीकडील नोकऱ्या',
  operatorAnalyticsNoData: 'या कालावधीत कार्य रेकॉर्ड नाहीत',
  adminServiceAlertsTitle: 'सर्विस अलर्ट',
  adminServiceAllOk: 'सर्व मशीनांचे सर्विस रेकॉर्ड अप-टू-डेट आहेत ✅',
  adminServiceNoRecord: 'रेकॉर्ड नाही',
  adminServiceColLastService: 'शेवटची सर्विस',
  adminServiceColNextDue: 'पुढील देय',
  adminServiceColServiceStatus: 'सर्विस स्थिती',
  adminMachinesColMinHrs: 'किमान तास',
  adminMachinesColRateDay: 'दर/दिवस',
  adminClientName: 'ग्राहकाचे नाव',
  adminOwnerName: 'मालकाचे नाव',
  adminPayoutWallet: 'पेआउट वॉलेट',
  adminFooterMachines: 'मशीन',
  adminFooterClients: 'ग्राहक',
  adminFooterOwners: 'मालक',
  auditIntroBanner: 'लॉगिन, प्रशासक क्रिया आणि सुरक्षा घटना. फिल्टर लोड केलेल्या निकालांवर लागू होतात; जुन्या ओळींसाठी अधिक लोड करा.',
  auditLoaded: 'लोड केले',
  auditMoreAvailable: 'अधिक उपलब्ध',
  auditEndOfList: 'यादी समाप्त',
  auditFilterActive: 'फिल्टर सक्रिय',
  auditFiltersActive: 'फिल्टर सक्रिय',
  auditSeverityBreakdown: 'गंभीरता विभाजन (सध्याची यादी)',
  auditPressSlash: 'क्रिया फिल्टरवर लक्ष केंद्रित करण्यासाठी / दाबा',
  auditFilters: 'फिल्टर',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'सर्व भूमिका',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'मेटाडेटा JSON शोधा',
  auditFilterFromPlaceholder: 'प्रारंभ तारीख आणि वेळ',
  auditFilterToPlaceholder: 'समाप्ती तारीख आणि वेळ',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'वेळ क्षेत्र:',
  auditTimezoneSuffix: '(स्थानिक)',
  auditHideCsvOptions: 'CSV स्तंभ पर्याय लपवा',
  auditShowCsvOptions: 'CSV स्तंभ पर्याय दाखवा',
  auditCsvColCreatedAt: 'निर्मिती वेळ',
  auditCsvColAction: 'क्रिया',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'मेटाडेटा',
  auditFooterLoaded: 'लोड केले',
  auditFooterLogs: 'ऑडिट लॉग',
  auditFooterMoreAvailable: '(अधिक उपलब्ध)',
  auditFooterAllLoaded: '(सर्व लोड केले)',
  auditActor: 'एक्टर',
  auditEntity: 'घटक',
  auditSeverityCritical: 'गंभीर',
  auditSeverityHigh: 'उच्च',
  auditSeverityMedium: 'मध्यम',
  auditSeverityNormal: 'सामान्य',
  auditCopyEvent: 'इवेंट कॉपी करा',
  auditViewDetails: 'तपशील पहा',
  auditHideDetails: 'तपशील लपवा',
  auditCopyJson: 'JSON कॉपी करा',
  auditNoLogs: 'ऑडिट लॉग नाहीत',
  auditEventLog: 'इवेंट लॉग',
  bookingAttachment: 'अटॅचमेंट निवडा',
  bookingAttachmentNone: 'कोणतेही विशिष्ट अटॅचमेंट नाही',
  bookingWorkDescription: 'कामाचे वर्णन',
  bookingWorkDescriptionPlaceholder: 'उदा. पाया खोदणे, ट्रेंचिंग, पाइपलाइन काम',
  bookingAttachmentLabel: 'अटॅचमेंट',
  bookingSiteLabel: 'साइट',
  bookingWorkLabel: 'काम',
  termsAccept: 'मी अटी व शर्तींना सहमत आहे',
  termsRequired: 'नोंदणीसाठी अटी व शर्ती स्वीकारणे आवश्यक आहे',
  termsLink: 'अटी व शर्ती',
  clientBlacklisted: 'ब्लॅकलिस्ट',
  clientBlacklistReason: 'ब्लॅकलिस्टचे कारण',
  clientBlacklistConfirm: 'हा क्लायंट ब्लॅकलिस्ट करायचा?',
  clientUnblacklist: 'ब्लॅकलिस्टमधून काढा',
  blacklistedClients: 'ब्लॅकलिस्ट क्लायंट',
  blacklistedClientsEmpty: 'ब्लॅकलिस्ट क्लायंट नाहीत',
  managerAccessRestricted: 'वित्त प्रवेश प्रतिबंधित. ओम चव्हाण यांच्याशी संपर्क करा.',
  managerSection: 'मॅनेजर',
  managerAdd: 'मॅनेजर जोडा',
  managerName: 'मॅनेजरचे नाव',
  managerEmail: 'मॅनेजर ईमेल',
  managerPassword: 'तात्पुरता पासवर्ड',
  managerCreated: 'मॅनेजर खाते तयार झाले',
  managerCredentialsTitle: 'मॅनेजर लॉगिन तपशील',
  managerCredentialsSubtitle: 'हे तपशील आता जतन करा — पासवर्ड नंतर परत मिळणार नाही',
  managerCredentialsSaved: 'मी तपशील जतन केले आहेत',
  managerLoginUrl: 'लॉगिन URL',
  managerActivity: 'मॅनेजर क्रियाकलाप',
  managerActivityEmpty: 'अद्याप कोणतीही क्रिया नोंदवलेली नाही',
  managerActivityViewAll: 'सर्व क्रिया पहा',
  onboardingTitle: 'सुरु करा',
  onboardingAccountApproved: 'खाते मंजूर',
  onboardingKycComplete: 'KYC पडताळणी पूर्ण',
  onboardingKycPending: 'KYC पडताळणी पूर्ण करा',
  onboardingKycRejected: 'KYC नाकारले — कृपया पुन्हा सबमिट करा',
  onboardingWalletFunded: 'वॉलेटमध्ये रक्कम आहे',
  onboardingWalletEmpty: 'बुकिंगसाठी वॉलेटमध्ये रक्कम भरा',
  pushEnablePrompt: 'त्वरित अपडेटसाठी पुश सूचना सुरू करा',
  downloadDisputeStatement: 'विवाद विधान डाउनलोड करा',
  downloadInvoice: 'इनव्हॉइस डाउनलोड करा',
  bookAgain: 'पुन्हा बुक करा',
  machineNoLongerAvailable: 'मशीन आता उपलब्ध नाही',
  downloadHistoryPdf: 'इतिहास PDF डाउनलोड करा',
  onboardingFirstBooking: 'तुमची पहिली बुकिंग करा',
  onboardingAllDone: 'तुम्ही तयार आहात!',
  onboardingTrackerTitle: 'ऑनबोर्डिंग प्रगती',
  onboardingTrackerTarget: 'ऑनबोर्डिंग लक्ष्य: 48 तास',
  onboardingTrackerInProgress: 'प्रगतीपथावर',
  onboardingTrackerActionRequired: 'कृती आवश्यक',
  onboardingTrackerComplete: 'पूर्ण',
  onboardingTrackerPending: 'प्रलंबित',
  onboardingTrackerPhase1: 'नोंदणी',
  onboardingTrackerPhase2: 'KYC पडताळणी',
  onboardingTrackerPhase3: 'मशीन नोंदणी',
  onboardingTrackerPhase4: 'पहिली बुकिंग तयार',
  onboardingTrackerHelper1: 'मशीन नोंदणी उघडण्यासाठी आधार + सेल्फी अपलोड करा',
  onboardingTrackerHelper2: 'KYC तपासणीत — सामान्यतः 24 तासांत',
  onboardingTrackerHelper3: 'KYC नाकारले — कागदपत्रे पुन्हा सबमिट करा',
  onboardingTrackerHelper4: 'KYC मंजूर — तुमची पहिली मशीन जोडा',
  onboardingTrackerHelper5: 'मशीन ॲडमिन तपासणीत',
  onboardingTrackerHelper6: 'मशीन लाइव्ह — पहिल्या बुकिंगची प्रतीक्षा',
  onboardingTrackerPhaseLabel: 'टप्पा',
  alertsAndNotifications: 'अलर्ट आणि सूचना',
  duration: 'कालावधी',
  cycles: 'सायकल',
  txRecharge: 'वॉलेट रिचार्ज',
  txBookingAdvance: 'बुकिंग आगाऊ',
  txBookingPayment: 'बुकिंग पेमेंट',
  txSettlement: 'सेटलमेंट',
  txRefund: 'रिफंड',
  txPenalty: 'दंड',
  txCommission: 'कमिशन',
  filterAll: 'सर्व',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'प्रलंबित',
  filterDisputed: 'विवादित',
  tacTitle: 'अटी आणि शर्ती',
  tacPrivacy: 'गोपनीयता धोरण',
  tacRefund: 'परतावा धोरण',
  tacCancellation: 'रद्दीकरण धोरण',
  tacServiceDelivery: 'सेवा वितरण धोरण',
  tacIntro: 'बुकिंगपूर्वी आमची धोरणे पहा',
  tacBannerTitle: 'अटी अपडेट उपलब्ध',
  tacBannerOpen: 'अटी उघडा',
  tacBannerAgree: 'मी वाचले आहे आणि सहमत आहे',
  tacBannerLater: 'नंतर',
  clientPoliciesTitle: 'ग्राहक धोरणे',
  machineGroupAvailable: 'उपलब्ध',
  machineGroupBusy: 'व्यस्त',
  dewateringReferral: 'डीवॉटरिंग (पंप) सेवा हवी आहे? MachineOS लवकरच पंप कंत्राटदार सेवा जोडेल. रेफरलसाठी सपोर्टशी संपर्क साधा.',
  noActiveWork: 'या महिन्यात सक्रिय काम नाही',
  accountTab: 'खाते',
  recentActivity: 'अलीकडील क्रियाकलाप',
  goodMorning: 'सुप्रभात',
  goodAfternoon: 'शुभ दुपार',
  goodEvening: 'शुभ संध्याकाळ',
};

const PURE_NATIVE = {
  te: TE_NATIVE,
  kn: KN_NATIVE,
  ta: TA_NATIVE,
  gu: GU_NATIVE,
  bn: BN_NATIVE,
  ml: ML_NATIVE,
  pa: PA_NATIVE,
  or: OR_NATIVE,
  as: AS_NATIVE,
  ne: NE_NATIVE,
  kok: KOK_NATIVE,
  sat: SAT_NATIVE,
  mai: MAI_NATIVE,
  doi: DOI_NATIVE,
  bho: BHO_NATIVE,
  raj: RAJ_NATIVE,
  cg: CG_NATIVE,
  har: HAR_NATIVE,
};

LANGUAGES.forEach(({ code }) => {
  if (code === 'en') return;
  const locale = TRANSLATIONS[code] || {};
  if (code === 'mr') {
    TRANSLATIONS[code] = { ...EN_BASE, ...MR_BASE };
  } else if (code === 'hi') {
    TRANSLATIONS[code] = { ...EN_BASE, ...HI_BASE };
  } else if (PURE_NATIVE[code]) {
    TRANSLATIONS[code] = buildPureLocale(EN_BASE, PURE_NATIVE[code]);
  } else {
    TRANSLATIONS[code] = { ...EN_BASE, ...HI_BASE, ...locale };
  }
});

Object.assign(TRANSLATIONS.en, {
  iotGpsDevicesActive: EN_BASE.iotGpsDevicesActive,
  iotDashcamsOnline: EN_BASE.iotDashcamsOnline,
  iotFuelSensorsActive: EN_BASE.iotFuelSensorsActive,
  iotMachinesLocked: EN_BASE.iotMachinesLocked,
  iotDeviceStatus: EN_BASE.iotDeviceStatus,
  iotColMachine: EN_BASE.iotColMachine,
  iotColGps: EN_BASE.iotColGps,
  iotColLocation: EN_BASE.iotColLocation,
  iotColFuel: EN_BASE.iotColFuel,
  iotColDashcam: EN_BASE.iotColDashcam,
  iotColIgnition: EN_BASE.iotColIgnition,
  iotColAction: EN_BASE.iotColAction,
  iotStatusOnline: EN_BASE.iotStatusOnline,
  iotStatusNotConnected: EN_BASE.iotStatusNotConnected,
  iotStatusLive: EN_BASE.iotStatusLive,
  iotStatusOn: EN_BASE.iotStatusOn,
  iotStatusOff: EN_BASE.iotStatusOff,
  iotLockBtn: EN_BASE.iotLockBtn,
  iotNotConnectedBanner: EN_BASE.iotNotConnectedBanner,
  fuelUpdateTitle: EN_BASE.fuelUpdateTitle,
  fuelSensorAccuracyNote: EN_BASE.fuelSensorAccuracyNote,
  bookingsTab: EN_BASE.bookingsTab,
  unknownLabel: EN_BASE.unknownLabel,
  naLabel: EN_BASE.naLabel,
  baseLabel: EN_BASE.baseLabel,
  qtyLabel: EN_BASE.qtyLabel,
  actualHrsLabel: EN_BASE.actualHrsLabel,
  auditStatTotal: EN_BASE.auditStatTotal,
  auditStatSecurity: EN_BASE.auditStatSecurity,
  auditStatActors: EN_BASE.auditStatActors,
  auditStatAdmin: EN_BASE.auditStatAdmin,
  auditStatNonAdmin: EN_BASE.auditStatNonAdmin,
  kycDocLicense: EN_BASE.kycDocLicense,
  kycDocAadhaarFront: EN_BASE.kycDocAadhaarFront,
  kycDocAadhaarBack: EN_BASE.kycDocAadhaarBack,
  kycDocPoliceVerification: EN_BASE.kycDocPoliceVerification,
  operatorsColOperator: EN_BASE.operatorsColOperator,
  operatorsColEmail: EN_BASE.operatorsColEmail,
  operatorsColPhone: EN_BASE.operatorsColPhone,
  operatorsColDocuments: EN_BASE.operatorsColDocuments,
  operatorsColStatus: EN_BASE.operatorsColStatus,
  operatorsDocumentsBtn: EN_BASE.operatorsDocumentsBtn,
  operatorsNoResults: EN_BASE.operatorsNoResults,
  operatorsAllTitle: EN_BASE.operatorsAllTitle,
  operatorsKycDialogDesc: EN_BASE.operatorsKycDialogDesc,
  bookingsCountLabel: EN_BASE.bookingsCountLabel,
  complianceDates: EN_BASE.complianceDates,
  complianceInsurance: EN_BASE.complianceInsurance,
  complianceRcBook: EN_BASE.complianceRcBook,
  compliancePuc: EN_BASE.compliancePuc,
  complianceNotSet: EN_BASE.complianceNotSet,
  complianceExpired: EN_BASE.complianceExpired,
  complianceExpiringSoon: EN_BASE.complianceExpiringSoon,
  complianceExpiringCritical: EN_BASE.complianceExpiringCritical,
  complianceValid: EN_BASE.complianceValid,
  complianceUpdateBtn: EN_BASE.complianceUpdateBtn,
  complianceSaveBtn: EN_BASE.complianceSaveBtn,
  complianceAlertsTitle: EN_BASE.complianceAlertsTitle,
  complianceAllCompliant: EN_BASE.complianceAllCompliant,
  complianceColMachine: EN_BASE.complianceColMachine,
  complianceColOwner: EN_BASE.complianceColOwner,
  complianceColInsurance: EN_BASE.complianceColInsurance,
  complianceColRcBook: EN_BASE.complianceColRcBook,
  complianceColPuc: EN_BASE.complianceColPuc,
  complianceNa: EN_BASE.complianceNa,
  complianceStartDate: EN_BASE.complianceStartDate,
  complianceEndDate: EN_BASE.complianceEndDate,
  complianceExtractBtn: EN_BASE.complianceExtractBtn,
  complianceExtractSuccess: EN_BASE.complianceExtractSuccess,
  complianceExtractError: EN_BASE.complianceExtractError,
  complianceExtracting: EN_BASE.complianceExtracting,
  adminServiceAlertsTitle: EN_BASE.adminServiceAlertsTitle,
  adminServiceAllOk: EN_BASE.adminServiceAllOk,
  adminServiceNoRecord: EN_BASE.adminServiceNoRecord,
  adminServiceColLastService: EN_BASE.adminServiceColLastService,
  adminServiceColNextDue: EN_BASE.adminServiceColNextDue,
  adminServiceColServiceStatus: EN_BASE.adminServiceColServiceStatus,
  serviceHistory: EN_BASE.serviceHistory,
  serviceLastService: EN_BASE.serviceLastService,
  serviceNoRecords: EN_BASE.serviceNoRecords,
  serviceNextDue: EN_BASE.serviceNextDue,
  serviceNextHmr: EN_BASE.serviceNextHmr,
  serviceAddLog: EN_BASE.serviceAddLog,
  serviceDate: EN_BASE.serviceDate,
  serviceType: EN_BASE.serviceType,
  serviceHmr: EN_BASE.serviceHmr,
  serviceNextDate: EN_BASE.serviceNextDate,
  serviceWorkDone: EN_BASE.serviceWorkDone,
  serviceNotes: EN_BASE.serviceNotes,
  serviceTypeRoutine: EN_BASE.serviceTypeRoutine,
  serviceTypeMajor: EN_BASE.serviceTypeMajor,
  serviceTypeBreakdown: EN_BASE.serviceTypeBreakdown,
  serviceTypePdi: EN_BASE.serviceTypePdi,
  serviceTypeOther: EN_BASE.serviceTypeOther,
  serviceOverdue: EN_BASE.serviceOverdue,
  serviceDueSoon: EN_BASE.serviceDueSoon,
  failedToLoadAlerts: EN_BASE.failedToLoadAlerts,
  retryLabel: EN_BASE.retryLabel,
  notificationCenter: EN_BASE.notificationCenter,
  navSectionMachineManagement: EN_BASE.navSectionMachineManagement,
  navSectionFinance: EN_BASE.navSectionFinance,
  navSectionOperations: EN_BASE.navSectionOperations,
  navSectionAccount: EN_BASE.navSectionAccount,
  notifChannelAll: EN_BASE.notifChannelAll,
  notifChannelWhatsapp: EN_BASE.notifChannelWhatsapp,
  notifChannelEmail: EN_BASE.notifChannelEmail,
  notifChannelPush: EN_BASE.notifChannelPush,
  notifChannelSms: EN_BASE.notifChannelSms,
  notifStatusSent: EN_BASE.notifStatusSent,
  notifStatusFailed: EN_BASE.notifStatusFailed,
  notifStatusPending: EN_BASE.notifStatusPending,
  notifEmpty: EN_BASE.notifEmpty,
  notifLoadMore: EN_BASE.notifLoadMore,
  adminNotifLog: EN_BASE.adminNotifLog,
  adminNotifColUser: EN_BASE.adminNotifColUser,
  adminNotifColRole: EN_BASE.adminNotifColRole,
  adminNotifNoData: EN_BASE.adminNotifNoData,
  alertPendingBookings: EN_BASE.alertPendingBookings,
  alertPendingPayouts: EN_BASE.alertPendingPayouts,
  alertLowFuel: EN_BASE.alertLowFuel,
  alertOpenIssues: EN_BASE.alertOpenIssues,
  alertComplianceExpiring: EN_BASE.alertComplianceExpiring,
  alertServiceDue: EN_BASE.alertServiceDue,
  ownerBankDetailsIncomplete: EN_BASE.ownerBankDetailsIncomplete,
  ownerPayoutBlockedNoBank: EN_BASE.ownerPayoutBlockedNoBank,
  ownerAddBankDetailsBtn: EN_BASE.ownerAddBankDetailsBtn,
  ownerAlertBookingPending: EN_BASE.ownerAlertBookingPending,
  ownerAlertBookingHours: EN_BASE.ownerAlertBookingHours,
  ownerAlertPayoutPending: EN_BASE.ownerAlertPayoutPending,
  ownerAlertFuelLow: EN_BASE.ownerAlertFuelLow,
  ownerAlertFuelRemaining: EN_BASE.ownerAlertFuelRemaining,
  ownerAlertIssue: EN_BASE.ownerAlertIssue,
  adminMachinesColMinHrs: EN_BASE.adminMachinesColMinHrs,
  adminMachinesColRateDay: EN_BASE.adminMachinesColRateDay,
  adminClientName: EN_BASE.adminClientName,
  adminOwnerName: EN_BASE.adminOwnerName,
  adminPayoutWallet: EN_BASE.adminPayoutWallet,
  adminFooterMachines: EN_BASE.adminFooterMachines,
  adminFooterClients: EN_BASE.adminFooterClients,
  adminFooterOwners: EN_BASE.adminFooterOwners,
  auditIntroBanner: EN_BASE.auditIntroBanner,
  auditLoaded: EN_BASE.auditLoaded,
  auditMoreAvailable: EN_BASE.auditMoreAvailable,
  auditEndOfList: EN_BASE.auditEndOfList,
  auditFilterActive: EN_BASE.auditFilterActive,
  auditFiltersActive: EN_BASE.auditFiltersActive,
  auditSeverityBreakdown: EN_BASE.auditSeverityBreakdown,
  auditPressSlash: EN_BASE.auditPressSlash,
  auditFilters: EN_BASE.auditFilters,
  auditFilterActionPlaceholder: EN_BASE.auditFilterActionPlaceholder,
  auditFilterActorPlaceholder: EN_BASE.auditFilterActorPlaceholder,
  auditAllRoles: EN_BASE.auditAllRoles,
  auditFilterEntityPlaceholder: EN_BASE.auditFilterEntityPlaceholder,
  auditFilterMetaPlaceholder: EN_BASE.auditFilterMetaPlaceholder,
  auditFilterFromPlaceholder: EN_BASE.auditFilterFromPlaceholder,
  auditFilterToPlaceholder: EN_BASE.auditFilterToPlaceholder,
  audit24h: EN_BASE.audit24h,
  audit7d: EN_BASE.audit7d,
  auditTimezonePrefix: EN_BASE.auditTimezonePrefix,
  auditTimezoneSuffix: EN_BASE.auditTimezoneSuffix,
  auditHideCsvOptions: EN_BASE.auditHideCsvOptions,
  auditShowCsvOptions: EN_BASE.auditShowCsvOptions,
  auditCsvColCreatedAt: EN_BASE.auditCsvColCreatedAt,
  auditCsvColAction: EN_BASE.auditCsvColAction,
  auditCsvColActorId: EN_BASE.auditCsvColActorId,
  auditCsvColActorRole: EN_BASE.auditCsvColActorRole,
  auditCsvColEntityType: EN_BASE.auditCsvColEntityType,
  auditCsvColEntityId: EN_BASE.auditCsvColEntityId,
  auditCsvColMetadata: EN_BASE.auditCsvColMetadata,
  auditFooterLoaded: EN_BASE.auditFooterLoaded,
  auditFooterLogs: EN_BASE.auditFooterLogs,
  auditFooterMoreAvailable: EN_BASE.auditFooterMoreAvailable,
  auditFooterAllLoaded: EN_BASE.auditFooterAllLoaded,
  auditActor: EN_BASE.auditActor,
  auditEntity: EN_BASE.auditEntity,
  auditSeverityCritical: EN_BASE.auditSeverityCritical,
  auditSeverityHigh: EN_BASE.auditSeverityHigh,
  auditSeverityMedium: EN_BASE.auditSeverityMedium,
  auditSeverityNormal: EN_BASE.auditSeverityNormal,
  auditCopyEvent: EN_BASE.auditCopyEvent,
  auditViewDetails: EN_BASE.auditViewDetails,
  auditHideDetails: EN_BASE.auditHideDetails,
  auditCopyJson: EN_BASE.auditCopyJson,
  auditNoLogs: EN_BASE.auditNoLogs,
  auditEventLog: EN_BASE.auditEventLog,
});

// English skips LANGUAGES.forEach merge — sync all EN_BASE keys (editRatesBtn, owner alerts, etc.)
Object.assign(TRANSLATIONS.en, EN_BASE);

Object.keys(UI_EXTRAS).forEach((code) => {
  if (TRANSLATIONS[code]) {
    Object.assign(TRANSLATIONS[code], UI_EXTRAS[code]);
  }
});

Object.assign(TRANSLATIONS.en, {
  trustStatOwners: 'Owners',
  trustStatClients: 'Clients',
});

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const detectInitialLang = () => {
    try {
      const stored = localStorage.getItem('developmentexpress_lang');
      if (stored && TRANSLATIONS[stored]) return stored;
    } catch (_err) { /* ignore */ }
    const browser = (navigator.language || 'en').split('-')[0].toLowerCase();
    return TRANSLATIONS[browser] ? browser : 'en';
  };
  const [lang, setLangState] = useState(detectInitialLang);
  const setLang = (next) => {
    if (!TRANSLATIONS[next]) return;
    setLangState(next);
    // Save to DB if user is logged in
    try {
      const token = localStorage.getItem(
        'developmentexpress_token',
      );
      if (token) {
        fetch('/api/auth/preferred-lang', {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ lang: next }),
        }).catch(() => {});
      }
    } catch (_) { /* ignore */ }
  };
  const t = useCallback(
    (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.en[key] ?? key,
    [lang],
  );
  const isRTL = lang === 'ur';
  const value = useMemo(() => ({ lang, setLang, t, LANGUAGES, isRTL }), [lang, t, isRTL]);
  useEffect(() => {
    try {
      localStorage.setItem('developmentexpress_lang', lang);
    } catch (_err) { /* ignore */ }
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  }, [lang, isRTL]);
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;